export default [
	"ABRUD (ALBA)"
	,
	"ABRUD-SAT (ALBA)"
	,
	"ACHIMETESTI (ALBA)"
	,
	"ACMARIU (ALBA)"
	,
	"AIUD (ALBA)"
	,
	"AIUDUL DE SUS (ALBA)"
	,
	"ALBA IULIA (ALBA)"
	,
	"ALBAC (ALBA)"
	,
	"ALECUS (ALBA)"
	,
	"ALMASU DE MIJLOC (ALBA)"
	,
	"ALMASU MARE (ALBA)"
	,
	"AMPOITA (ALBA)"
	,
	"ANGHELESTI (ALBA)"
	,
	"ARIESENI (ALBA)"
	,
	"ARONESTI (ALBA)"
	,
	"ARTI (ALBA)"
	,
	"ASINIP (ALBA)"
	,
	"AVRAM IANCU (ALBA)"
	,
	"AVRAMESTI (ARIESENI) (ALBA)"
	,
	"AVRAMESTI (AVRAM IANCU) (ALBA)"
	,
	"BABA (ALBA)"
	,
	"BACAINTI (ALBA)"
	,
	"BADAI (ALBA)"
	,
	"BAGAU (ALBA)"
	,
	"BAI (ALBA)"
	,
	"BAIA DE ARIES (ALBA)"
	,
	"BALCACIU (ALBA)"
	,
	"BALESTI (ALBA)"
	,
	"BALESTI-CATUN (ALBA)"
	,
	"BALMOSESTI (ALBA)"
	,
	"BALOMIRU DE CAMP (ALBA)"
	,
	"BARABANT (ALBA)"
	,
	"BARASTI (ALBA)"
	,
	"BARBESTI (ALBA)"
	,
	"BARDESTI (ALBA)"
	,
	"BARLESTI (BISTRA) (ALBA)"
	,
	"BARLESTI (MOGOS) (ALBA)"
	,
	"BARLESTI (SCARISOARA) (ALBA)"
	,
	"BARLESTI-CATUN (ALBA)"
	,
	"BARSANA (ALBA)"
	,
	"BARZAN (ALBA)"
	,
	"BARZOGANI (ALBA)"
	,
	"BAZESTI (ALBA)"
	,
	"BELDIU (ALBA)"
	,
	"BENIC (ALBA)"
	,
	"BERGHIN (ALBA)"
	,
	"BETA (ALBA)"
	,
	"BIDIGESTI (ALBA)"
	,
	"BIHARIA (ALBA)"
	,
	"BIIA (ALBA)"
	,
	"BILANESTI (ALBA)"
	,
	"BISERICANI (ALBA)"
	,
	"BISTRA (ALBA)"
	,
	"BLAJ (ALBA)"
	,
	"BLANDIANA (ALBA)"
	,
	"BLIDESTI (ALBA)"
	,
	"BOBARESTI (SOHODOL) (ALBA)"
	,
	"BOBARESTI (VIDRA) (ALBA)"
	,
	"BOCESTI (ALBA)"
	,
	"BOCSITURA (ALBA)"
	,
	"BODESTI (ALBA)"
	,
	"BODRESTI (ALBA)"
	,
	"BOGDANESTI (MOGOS) (ALBA)"
	,
	"BOGDANESTI (VIDRA) (ALBA)"
	,
	"BOGLESTI (ALBA)"
	,
	"BOLDESTI (ALBA)"
	,
	"BOLOVANESTI (ALBA)"
	,
	"BONCESTI (ALBA)"
	,
	"BORDESTII POIENI (ALBA)"
	,
	"BORLESTI (ALBA)"
	,
	"BOTANI (ALBA)"
	,
	"BOTESTI (CAMPENI) (ALBA)"
	,
	"BOTESTI (SCARISOARA) (ALBA)"
	,
	"BOTESTI (ZLATNA) (ALBA)"
	,
	"BOZ (ALBA)"
	,
	"BRADEANA (ALBA)"
	,
	"BRADESTI (ALBA)"
	,
	"BRADET (ALBA)"
	,
	"BRAZESTI (ALBA)"
	,
	"BUBESTI (ALBA)"
	,
	"BUCERDEA GRANOASA (ALBA)"
	,
	"BUCERDEA VINOASA (ALBA)"
	,
	"BUCIUM (ALBA)"
	,
	"BUCIUM-SAT (ALBA)"
	,
	"BUCURU (ALBA)"
	,
	"BUDAIESTI (ALBA)"
	,
	"BUDENI (ALBA)"
	,
	"BULBUC (ALBA)"
	,
	"BUNINGINEA (ALBA)"
	,
	"BUNTA (ALBA)"
	,
	"BURZESTI (ALBA)"
	,
	"BURZONESTI (ALBA)"
	,
	"BUTESTI (HOREA) (ALBA)"
	,
	"BUTESTI (MOGOS) (ALBA)"
	,
	"CALENE (ALBA)"
	,
	"CALNIC (ALBA)"
	,
	"CALUGARESTI (ALBA)"
	,
	"CAMPENI (ALBA)"
	,
	"CAMPU GOBLII (ALBA)"
	,
	"CANDESTI (ALBA)"
	,
	"CAPALNA (ALBA)"
	,
	"CAPALNA DE JOS (ALBA)"
	,
	"CAPTALAN (ALBA)"
	,
	"CAPU DEALULUI (ALBA)"
	,
	"CAPUD (ALBA)"
	,
	"CARASTI (ALBA)"
	,
	"CARPEN (ALBA)"
	,
	"CARPENII DE SUS (ALBA)"
	,
	"CARPINIS (GARBOVA) (ALBA)"
	,
	"CARPINIS (ROSIA MONTANA) (ALBA)"
	,
	"CARTULESTI (ALBA)"
	,
	"CASA DE PIATRA (ALBA)"
	,
	"CASOAIA (ALBA)"
	,
	"CENADE (ALBA)"
	,
	"CERBU (ALBA)"
	,
	"CERGAU (ALBA)"
	,
	"CERGAU MARE (ALBA)"
	,
	"CERGAU MIC (ALBA)"
	,
	"CERTEGE (ALBA)"
	,
	"CERU-BACAINTI (ALBA)"
	,
	"CETATEA DE BALTA (ALBA)"
	,
	"CETEA (ALBA)"
	,
	"CHEIA (ALBA)"
	,
	"CHEILE CIBULUI (ALBA)"
	,
	"CHELETENI (ALBA)"
	,
	"CIB (ALBA)"
	,
	"CICARD (ALBA)"
	,
	"CICAU (ALBA)"
	,
	"CIOARA DE SUS (ALBA)"
	,
	"CIOCASU (ALBA)"
	,
	"CIONESTI (ALBA)"
	,
	"CISTEI (ALBA)"
	,
	"CISTEIU DE MURES (ALBA)"
	,
	"CIUCULESTI (ALBA)"
	,
	"CIUGUD (ALBA)"
	,
	"CIUGUDU DE JOS (ALBA)"
	,
	"CIUGUDU DE SUS (ALBA)"
	,
	"CIUGUZEL (ALBA)"
	,
	"CIULDESTI (ALBA)"
	,
	"CIUMBRUD (ALBA)"
	,
	"CIURULEASA (ALBA)"
	,
	"COASTA HENTII (ALBA)"
	,
	"COASTA VASCULUI (ALBA)"
	,
	"COBLES (ALBA)"
	,
	"COCESTI (ALBA)"
	,
	"COCOSESTI (ALBA)"
	,
	"COJOCANI (ALBA)"
	,
	"COLESENI (ALBA)"
	,
	"COLIBI (ALBA)"
	,
	"COLTESTI (ALBA)"
	,
	"COPAND (ALBA)"
	,
	"CORNA (ALBA)"
	,
	"CORNU (ALBA)"
	,
	"COROIESTI (ALBA)"
	,
	"CORTESTI (ALBA)"
	,
	"COSLARIU (ALBA)"
	,
	"COSLARIU NOU (ALBA)"
	,
	"COSTESTI (ALBAC) (ALBA)"
	,
	"COSTESTI (POIANA VADULUI) (ALBA)"
	,
	"COTORASTI (ALBA)"
	,
	"CRACIUNELU DE JOS (ALBA)"
	,
	"CRACIUNELU DE SUS (ALBA)"
	,
	"CRAIVA (ALBA)"
	,
	"CRETESTI (ALBA)"
	,
	"CRICAU (ALBA)"
	,
	"CRISENI (ALBA)"
	,
	"CRISTESTI (ALBA)"
	,
	"CUCUTA (ALBA)"
	,
	"CUGIR (ALBA)"
	,
	"CULDESTI (ALBA)"
	,
	"CUNTA (ALBA)"
	,
	"CURATURI (ALBA)"
	,
	"CURMATURA (ALBA)"
	,
	"CURPENI (ALBA)"
	,
	"CUT (ALBA)"
	,
	"DAIA ROMANA (ALBA)"
	,
	"DAMBURENI (ALBA)"
	,
	"DANDUT (ALBA)"
	,
	"DARLESTI (ALBA)"
	,
	"DAROAIA (ALBA)"
	,
	"DEAL (ALBA)"
	,
	"DEALU BAJULUI (ALBA)"
	,
	"DEALU BISTRII (ALBA)"
	,
	"DEALU CAPSEI (ALBA)"
	,
	"DEALU CASELOR (ALBA)"
	,
	"DEALU CRISULUI (ALBA)"
	,
	"DEALU DOSTATULUI (ALBA)"
	,
	"DEALU FERULUI (ALBA)"
	,
	"DEALU FRUMOS (GARDA DE SUS) (ALBA)"
	,
	"DEALU FRUMOS (VADU MOTILOR) (ALBA)"
	,
	"DEALU GEOAGIULUI (ALBA)"
	,
	"DEALU GOIESTI (ALBA)"
	,
	"DEALU LAMASOI (ALBA)"
	,
	"DEALU MUNTELUI (ALBA)"
	,
	"DEALU ORDANCUSII (ALBA)"
	,
	"DEALU ROATEI (ALBA)"
	,
	"DECEA (ALBA)"
	,
	"DELENI-OBARSIE (ALBA)"
	,
	"DEONCESTI (ALBA)"
	,
	"DEVE (ALBA)"
	,
	"DILIMANI (ALBA)"
	,
	"DOBRA (ALBA)"
	,
	"DOBRESTI (ALBA)"
	,
	"DOBROT (ALBA)"
	,
	"DOGARESTI (ALBA)"
	,
	"DOLESTI (ALBA)"
	,
	"DOPTAU (ALBA)"
	,
	"DOS (ALBA)"
	,
	"DOSTAT (ALBA)"
	,
	"DOSU LUNCII (ALBA)"
	,
	"DOSU VASESTI (ALBA)"
	,
	"DRAGOIESTI-LUNCA (ALBA)"
	,
	"DRAMBAR (ALBA)"
	,
	"DRASOV (ALBA)"
	,
	"DRIC (ALBA)"
	,
	"DUDUIENI (ALBA)"
	,
	"DUMACESTI (ALBA)"
	,
	"DUMBRAVA (CIUGUD) (ALBA)"
	,
	"DUMBRAVA (SASCIORI) (ALBA)"
	,
	"DUMBRAVA (UNIREA) (ALBA)"
	,
	"DUMBRAVA (ZLATNA) (ALBA)"
	,
	"DUMBRAVITA (ALBA)"
	,
	"DUMESTI (ALBA)"
	,
	"DUMITRA (ALBA)"
	,
	"DUPA DEAL (LUPSA) (ALBA)"
	,
	"DUPA DEAL (PONOR) (ALBA)"
	,
	"DUPA PLESE (ALBA)"
	,
	"DURASTI (ALBA)"
	,
	"FAGET (ALBA)"
	,
	"FAGETU DE JOS (ALBA)"
	,
	"FAGETU DE SUS (ALBA)"
	,
	"FANTANELE (ALBA)"
	,
	"FARAU (ALBA)"
	,
	"FATA (ALBA)"
	,
	"FATA ABRUDULUI (ALBA)"
	,
	"FATA CRISTESEI (ALBA)"
	,
	"FATA LAPUSULUI (ALBA)"
	,
	"FATA PIETRII (ALBA)"
	,
	"FATA-LAZESTI (ALBA)"
	,
	"FEISA (ALBA)"
	,
	"FENES (ALBA)"
	,
	"FERESTI (ALBA)"
	,
	"FERICET (ALBA)"
	,
	"FETENI (ALBA)"
	,
	"FICARESTI (ALBA)"
	,
	"FLITESTI (ALBA)"
	,
	"FLORESTI (BUCIUM) (ALBA)"
	,
	"FLORESTI (CAMPENI) (ALBA)"
	,
	"FLORESTI (RAMET) (ALBA)"
	,
	"FLORESTI (SCARISOARA) (ALBA)"
	,
	"FURDUIESTI (CAMPENI) (ALBA)"
	,
	"FURDUIESTI (SOHODOL) (ALBA)"
	,
	"GABUD (ALBA)"
	,
	"GALATI (ALBA)"
	,
	"GALBENA (ALBA)"
	,
	"GALDA DE JOS (ALBA)"
	,
	"GALDA DE SUS (ALBA)"
	,
	"GALTIU (ALBA)"
	,
	"GAMBAS (ALBA)"
	,
	"GANESTI (ALBA)"
	,
	"GARBOVA (ALBA)"
	,
	"GARBOVA DE JOS (ALBA)"
	,
	"GARBOVA DE SUS (ALBA)"
	,
	"GARBOVITA (ALBA)"
	,
	"GARDA DE SUS (ALBA)"
	,
	"GARDA SEACA (ALBA)"
	,
	"GARDA-BARBULESTI (ALBA)"
	,
	"GARDE (ALBA)"
	,
	"GEAMANA (ALBA)"
	,
	"GEOAGIU DE SUS (ALBA)"
	,
	"GEOGEL (ALBA)"
	,
	"GEOMAL (ALBA)"
	,
	"GHEDULESTI (ALBA)"
	,
	"GHETARI (ALBA)"
	,
	"GHIONCANI (ALBA)"
	,
	"GHIRBOM (ALBA)"
	,
	"GIURGIUT (ALBA)"
	,
	"GLIGORESTI (ALBA)"
	,
	"GLOD (ALBA)"
	,
	"GLOGOVET (ALBA)"
	,
	"GOASELE (ALBA)"
	,
	"GOIESTI (ALBA)"
	,
	"GOJEIESTI (ALBA)"
	,
	"GORGAN (ALBA)"
	,
	"GROSI (ALBA)"
	,
	"GURA ARIESULUI (ALBA)"
	,
	"GURA CORNEI (ALBA)"
	,
	"GURA CUTULUI (ALBA)"
	,
	"GURA IZBITEI (ALBA)"
	,
	"GURA ROSIEI (ALBA)"
	,
	"GURA SOHODOL (ALBA)"
	,
	"HADARAU (ALBA)"
	,
	"HAIDUCESTI (ALBA)"
	,
	"HANASESTI (GARDA DE SUS) (ALBA)"
	,
	"HANASESTI (POIANA VADULUI) (ALBA)"
	,
	"HANES MINA (ALBA)"
	,
	"HAPRIA (ALBA)"
	,
	"HARASTI (ALBA)"
	,
	"HATEGANA (ALBA)"
	,
	"HELERESTI (ALBA)"
	,
	"HELESTI (ALBA)"
	,
	"HENIG (ALBA)"
	,
	"HERIA (ALBA)"
	,
	"HOANCA (SOHODOL) (ALBA)"
	,
	"HOANCA (VIDRA) (ALBA)"
	,
	"HODISESTI (ALBA)"
	,
	"HODOBANA (ALBA)"
	,
	"HOLOBANI (ALBA)"
	,
	"HOPARTA (ALBA)"
	,
	"HOREA (ALBA)"
	,
	"HUDRICESTI (ALBA)"
	,
	"HUZARESTI (ALBA)"
	,
	"IACOBESTI (ALBA)"
	,
	"IBRU (ALBA)"
	,
	"ICLOD (ALBA)"
	,
	"IGHIEL (ALBA)"
	,
	"IGHIU (ALBA)"
	,
	"IGNATESTI (ALBA)"
	,
	"ILIESTI (ALBA)"
	,
	"INCESTI (AVRAM IANCU) (ALBA)"
	,
	"INCESTI (POSAGA) (ALBA)"
	,
	"INOC (ALBA)"
	,
	"INTREGALDE (ALBA)"
	,
	"INURI (ALBA)"
	,
	"ISCA (ALBA)"
	,
	"IVANIS (ALBA)"
	,
	"IZBICIOARA (ALBA)"
	,
	"IZBITA (ALBA)"
	,
	"IZLAZ (ALBA)"
	,
	"IZVOARELE (BLAJ) (ALBA)"
	,
	"IZVOARELE (GARDA DE SUS) (ALBA)"
	,
	"IZVOARELE (LIVEZILE) (ALBA)"
	,
	"IZVORU AMPOIULUI (ALBA)"
	,
	"JEFLESTI (ALBA)"
	,
	"JIDOSTINA (ALBA)"
	,
	"JIDVEI (ALBA)"
	,
	"JOJEI (ALBA)"
	,
	"JOLDISESTI (ALBA)"
	,
	"JURCUIESTI (ALBA)"
	,
	"LANCRAM (ALBA)"
	,
	"LAZ (SASCIORI) (ALBA)"
	,
	"LAZ (VINTU DE JOS) (ALBA)"
	,
	"LAZESTI (SCARISOARA) (ALBA)"
	,
	"LAZESTI (VADU MOTILOR) (ALBA)"
	,
	"LAZURI (LUPSA) (ALBA)"
	,
	"LAZURI (SOHODOL) (ALBA)"
	,
	"LEHESTI (ALBA)"
	,
	"LEORINT (ALBA)"
	,
	"LESPEZEA (ALBA)"
	,
	"LIPAIA (ALBA)"
	,
	"LIVEZILE (ALBA)"
	,
	"LODROMAN (ALBA)"
	,
	"LOMAN (ALBA)"
	,
	"LOPADEA NOUA (ALBA)"
	,
	"LOPADEA VECHE (ALBA)"
	,
	"LUMINESTI (ALBA)"
	,
	"LUNCA (LUPSA) (ALBA)"
	,
	"LUNCA (POSAGA) (ALBA)"
	,
	"LUNCA (VALEA LUNGA) (ALBA)"
	,
	"LUNCA (VIDRA) (ALBA)"
	,
	"LUNCA AMPOITEI (ALBA)"
	,
	"LUNCA BISERICII (ALBA)"
	,
	"LUNCA DE JOS (ALBA)"
	,
	"LUNCA GOIESTI (ALBA)"
	,
	"LUNCA LARGA (BISTRA) (ALBA)"
	,
	"LUNCA LARGA (OCOLIS) (ALBA)"
	,
	"LUNCA MERILOR (ALBA)"
	,
	"LUNCA METESULUI (ALBA)"
	,
	"LUNCA MURESULUI (ALBA)"
	,
	"LUNCA TARNAVEI (ALBA)"
	,
	"LUNCA VESESTI (ALBA)"
	,
	"LUPAIESTI (ALBA)"
	,
	"LUPSA (ALBA)"
	,
	"LUPSENI (ALBA)"
	,
	"LUPU (ALBA)"
	,
	"LUPULESTI (ALBA)"
	,
	"MACARESTI (ALBA)"
	,
	"MAGHIERAT (ALBA)"
	,
	"MAGINA (ALBA)"
	,
	"MAGURA (BUCIUM) (ALBA)"
	,
	"MAGURA (GALDA DE JOS) (ALBA)"
	,
	"MAHACENI (ALBA)"
	,
	"MAMALIGANI (ALBA)"
	,
	"MANARADE (ALBA)"
	,
	"MANASTIRE (ALBA)"
	,
	"MANCESTI (ALBA)"
	,
	"MARGAIA (ALBA)"
	,
	"MARGINENI (ALBA)"
	,
	"MARINESTI (ALBA)"
	,
	"MARTESTI (ALBA)"
	,
	"MARTINIE (ALBA)"
	,
	"MATACINA (ALBA)"
	,
	"MATEI (ALBA)"
	,
	"MATISESTI (CIURULEASA) (ALBA)"
	,
	"MATISESTI (HOREA) (ALBA)"
	,
	"MEDRESTI (ALBA)"
	,
	"MEDVES (ALBA)"
	,
	"MERETEU (ALBA)"
	,
	"MESCREAC (ALBA)"
	,
	"MESENTEA (ALBA)"
	,
	"METES (ALBA)"
	,
	"MICESTI (ALBA)"
	,
	"MICOSLACA (ALBA)"
	,
	"MIHAIESTI (ALBA)"
	,
	"MIHALT (ALBA)"
	,
	"MIHOESTI (ALBA)"
	,
	"MIRASLAU (ALBA)"
	,
	"MODOLESTI (INTREGALDE) (ALBA)"
	,
	"MODOLESTI (VIDRA) (ALBA)"
	,
	"MOGOS (ALBA)"
	,
	"MORARESTI (CIURULEASA) (ALBA)"
	,
	"MORARESTI (SOHODOL) (ALBA)"
	,
	"MORCANESTI (ALBA)"
	,
	"MOTORASTI (ALBA)"
	,
	"MUGESTI (ALBA)"
	,
	"MUNCELU (ALBA)"
	,
	"MUNESTI (ALBA)"
	,
	"MUNTARI (ALBA)"
	,
	"MUNUNA (ALBA)"
	,
	"MUSCA (ALBA)"
	,
	"NADASTIA (ALBA)"
	,
	"NAMAS (ALBA)"
	,
	"NAPAIESTI (ALBA)"
	,
	"NECRILESTI (ALBA)"
	,
	"NECSESTI (ALBA)"
	,
	"NEGESTI (ALBA)"
	,
	"NEGRESTI (ALBA)"
	,
	"NELEGESTI (ALBA)"
	,
	"NEMESI (ALBA)"
	,
	"NICORESTI (ALBA)"
	,
	"NICULESTI (ALBA)"
	,
	"NOSLAC (ALBA)"
	,
	"NOVACESTI (ALBA)"
	,
	"OARDA (ALBA)"
	,
	"OBREJA (ALBA)"
	,
	"OCNA MURES (ALBA)"
	,
	"OCNISOARA (ALBA)"
	,
	"OCOALE (ALBA)"
	,
	"OCOLIS (ALBA)"
	,
	"ODVEREM (ALBA)"
	,
	"OHABA (ALBA)"
	,
	"OIDESTI (ALBA)"
	,
	"OIEJDEA (ALBA)"
	,
	"OLTENI (ALBA)"
	,
	"ONCESTI (ALBA)"
	,
	"ORASTI (ALBA)"
	,
	"ORGESTI (ALBA)"
	,
	"ORMENIS (ALBA)"
	,
	"PACLISA (ALBA)"
	,
	"PADURE (ALBA)"
	,
	"PADUREA (ALBA)"
	,
	"PAGIDA (ALBA)"
	,
	"PANADE (ALBA)"
	,
	"PANCA (ALBA)"
	,
	"PANTESTI (ALBA)"
	,
	"PARAU GRUIULUI (ALBA)"
	,
	"PARAU LUI MIHAI (ALBA)"
	,
	"PARAU-CARBUNARI (ALBA)"
	,
	"PASTESTI (ALBA)"
	,
	"PATRAHAITESTI (ALBA)"
	,
	"PATRANGENI (ALBA)"
	,
	"PATRUSESTI (ALBA)"
	,
	"PATRUTESTI (ALBA)"
	,
	"PELES (ALBA)"
	,
	"PERJESTI (ALBA)"
	,
	"PESTE VALEA BISTRII (ALBA)"
	,
	"PETELCA (ALBA)"
	,
	"PETELEI (ALBA)"
	,
	"PETREASA (ALBA)"
	,
	"PETRENI (ALBA)"
	,
	"PETRESTI (ALBA)"
	,
	"PETRISAT (ALBA)"
	,
	"PIANU (ALBA)"
	,
	"PIANU DE JOS (ALBA)"
	,
	"PIANU DE SUS (ALBA)"
	,
	"PIRITA (ALBA)"
	,
	"PITARCESTI (ALBA)"
	,
	"PITIGA (ALBA)"
	,
	"PLAI (AVRAM IANCU) (ALBA)"
	,
	"PLAI (GARDA DE SUS) (ALBA)"
	,
	"PLAIURI (ALBA)"
	,
	"PLESCUTA (ALBA)"
	,
	"PLESESTI (ALBA)"
	,
	"PLESI (ALBA)"
	,
	"PLISTI (ALBA)"
	,
	"PODU LUI PAUL (ALBA)"
	,
	"PODURI (ALBA)"
	,
	"PODURI-BRICESTI (ALBA)"
	,
	"POIANA (BISTRA) (ALBA)"
	,
	"POIANA (BUCIUM) (ALBA)"
	,
	"POIANA (SOHODOL) (ALBA)"
	,
	"POIANA AIUDULUI (ALBA)"
	,
	"POIANA AMPOIULUI (ALBA)"
	,
	"POIANA GALDEI (ALBA)"
	,
	"POIANA URSULUI (ALBA)"
	,
	"POIANA VADULUI (ALBA)"
	,
	"POIENI (BLANDIANA) (ALBA)"
	,
	"POIENI (BUCIUM) (ALBA)"
	,
	"POIENI (VIDRA) (ALBA)"
	,
	"POIENILE-MOGOS (ALBA)"
	,
	"POIENITA (ARIESENI) (ALBA)"
	,
	"POIENITA (VINTU DE JOS) (ALBA)"
	,
	"POIU (ALBA)"
	,
	"PONOR (ALBA)"
	,
	"PONOREL (ALBA)"
	,
	"POPESTI (ALBA)"
	,
	"POPESTII DE JOS (ALBA)"
	,
	"POPESTII DE SUS (ALBA)"
	,
	"POSAGA (ALBA)"
	,
	"POSAGA DE JOS (ALBA)"
	,
	"POSAGA DE SUS (ALBA)"
	,
	"POSOGANI (ALBA)"
	,
	"POTIONCI (ALBA)"
	,
	"PRELUCA (ALBA)"
	,
	"PRESACA AMPOIULUI (ALBA)"
	,
	"PUIULETESTI (ALBA)"
	,
	"PURCARETI (ALBA)"
	,
	"PUSELESTI (ALBA)"
	,
	"RACATAU (ALBA)"
	,
	"RACHIS (ALBA)"
	,
	"RACHITA (ALBA)"
	,
	"RADESTI (ALBA)"
	,
	"RAHAU (ALBA)"
	,
	"RAICANI (ALBA)"
	,
	"RAMET (ALBA)"
	,
	"RATITIS (ALBA)"
	,
	"RAVICESTI (ALBA)"
	,
	"RAZBOIENI-CETATE (ALBA)"
	,
	"RECIU (ALBA)"
	,
	"REMETEA (ALBA)"
	,
	"RIMETEA (ALBA)"
	,
	"ROBESTI (ALBA)"
	,
	"ROGOZ (ALBA)"
	,
	"ROSESTI (ALBA)"
	,
	"ROSIA DE SECAS (ALBA)"
	,
	"ROSIA MONTANA (ALBA)"
	,
	"RUNC (OCOLIS) (ALBA)"
	,
	"RUNC (SCARISOARA) (ALBA)"
	,
	"RUNC (VIDRA) (ALBA)"
	,
	"RUNC (ZLATNA) (ALBA)"
	,
	"RUNCURI (ALBA)"
	,
	"RUSESTI (ALBA)"
	,
	"RUSI (ALBA)"
	,
	"SAGAGEA (ALBA)"
	,
	"SALAGESTI (ALBA)"
	,
	"SALCIUA (ALBA)"
	,
	"SALCIUA DE JOS (ALBA)"
	,
	"SALCIUA DE SUS (ALBA)"
	,
	"SALISTEA (ALBA)"
	,
	"SALISTEA-DEAL (ALBA)"
	,
	"SANBENEDIC (ALBA)"
	,
	"SANCEL (ALBA)"
	,
	"SANCRAI (ALBA)"
	,
	"SANMICLAUS (ALBA)"
	,
	"SANTAMARIE (ALBA)"
	,
	"SANTIMBRU (ALBA)"
	,
	"SARACSAU (ALBA)"
	,
	"SARD (ALBA)"
	,
	"SARTAS (ALBA)"
	,
	"SASA (ALBA)"
	,
	"SASCIORI (ALBA)"
	,
	"SCARISOARA (ALBA)"
	,
	"SCOARTA (ALBA)"
	,
	"SEBES (ALBA)"
	,
	"SEBESEL (ALBA)"
	,
	"SEBISESTI (ALBA)"
	,
	"SECASEL (ALBA)"
	,
	"SEGAJ (ALBA)"
	,
	"SEUSA (ALBA)"
	,
	"SFARCEA (ALBA)"
	,
	"SFOARTEA (ALBA)"
	,
	"SIBOT (ALBA)"
	,
	"SICOIESTI (ALBA)"
	,
	"SILEA (ALBA)"
	,
	"SILIVAS (ALBA)"
	,
	"SIMOCESTI (ALBA)"
	,
	"SIMULESTI (ALBA)"
	,
	"SNIDE (ALBA)"
	,
	"SOAL (ALBA)"
	,
	"SOHARU (ALBA)"
	,
	"SOHODOL (ALBA)"
	,
	"SOHODOL (ALBAC) (ALBA)"
	,
	"SOICESTI (ALBA)"
	,
	"SOIMUS (ALBA)"
	,
	"SONA (ALBA)"
	,
	"SORLITA (ALBA)"
	,
	"SPALNACA (ALBA)"
	,
	"SPATAC (ALBA)"
	,
	"SPRING (ALBA)"
	,
	"STALNISOARA (ALBA)"
	,
	"STANA DE MURES (ALBA)"
	,
	"STANESTI (ALBA)"
	,
	"STAUINI (ALBA)"
	,
	"STEFANCA (ALBA)"
	,
	"STEI-ARIESENI (ALBA)"
	,
	"STERTESTI (ALBA)"
	,
	"STIULETI (ALBA)"
	,
	"STRAJA (ALBA)"
	,
	"STREMT (ALBA)"
	,
	"STRUNGARI (ALBA)"
	,
	"STURU (ALBA)"
	,
	"SUB PIATRA (ALBA)"
	,
	"SUCESTI (ALBA)"
	,
	"SUGAG (ALBA)"
	,
	"SURDESTI (ALBA)"
	,
	"SUSENI (ALBA)"
	,
	"TAMBORESTI (ALBA)"
	,
	"TARANESTI (ALBA)"
	,
	"TARINA (ALBA)"
	,
	"TARSA (ALBA)"
	,
	"TARSA-PLAI (ALBA)"
	,
	"TARTARIA (ALBA)"
	,
	"TATARLAUA (ALBA)"
	,
	"TAU (ALBA)"
	,
	"TAU BISTRA (ALBA)"
	,
	"TAUNI (ALBA)"
	,
	"TAUTI (ALBA)"
	,
	"TECSESTI (ALBA)"
	,
	"TEIU (ALBA)"
	,
	"TEIUS (ALBA)"
	,
	"TELEAC (ALBA)"
	,
	"TELNA (ALBA)"
	,
	"TIBRU (ALBA)"
	,
	"TIFRA (ALBA)"
	,
	"TIUR (ALBA)"
	,
	"TOCI (ALBA)"
	,
	"TOLACESTI (ALBA)"
	,
	"TOMESTI (ALBA)"
	,
	"TOMNATEC (ALBA)"
	,
	"TOMUSESTI (ALBA)"
	,
	"TOMUTESTI (ALBA)"
	,
	"TONEA (ALBA)"
	,
	"TOTESTI (ALBA)"
	,
	"TOTOI (ALBA)"
	,
	"TRAMPOIELE (ALBA)"
	,
	"TRANCESTI (ALBA)"
	,
	"TRIFESTI (HOREA) (ALBA)"
	,
	"TRIFESTI (LUPSA) (ALBA)"
	,
	"TRISORESTI (ALBA)"
	,
	"TURDAS (ALBA)"
	,
	"UIOARA DE JOS (ALBA)"
	,
	"UIOARA DE SUS (ALBA)"
	,
	"UNGUREI (ALBA)"
	,
	"UNIREA (ALBA)"
	,
	"URDES (ALBA)"
	,
	"VADU MOTILOR (ALBA)"
	,
	"VAI (ALBA)"
	,
	"VALCANEASA (ALBA)"
	,
	"VALCEA (ALBA)"
	,
	"VALCESTI (ALBA)"
	,
	"VALE ÎN JOS (ALBA)"
	,
	"VALEA ABRUZEL (ALBA)"
	,
	"VALEA ALBA (ALBA)"
	,
	"VALEA BARLUTESTI (ALBA)"
	,
	"VALEA BARNII (ALBA)"
	,
	"VALEA BISTRII (ALBA)"
	,
	"VALEA BUCURULUI (ALBA)"
	,
	"VALEA CASELOR (ALBA)"
	,
	"VALEA CERBULUI (ALBA)"
	,
	"VALEA CIUCIULUI (ALBA)"
	,
	"VALEA COCESTI (ALBA)"
	,
	"VALEA FAGETULUI (ALBA)"
	,
	"VALEA GIOGESTI (ALBA)"
	,
	"VALEA GOBLII (ALBA)"
	,
	"VALEA HOLHORII (ALBA)"
	,
	"VALEA INZELULUI (ALBA)"
	,
	"VALEA LARGA (ALBA)"
	,
	"VALEA LUI MIHAI (ALBA)"
	,
	"VALEA LUNGA (ALBA)"
	,
	"VALEA LUPSII (ALBA)"
	,
	"VALEA MACIULUI (ALBA)"
	,
	"VALEA MANASTIRII (ALBA)"
	,
	"VALEA MARE (ALBA)"
	,
	"VALEA MICA (ALBA)"
	,
	"VALEA MLACII (ALBA)"
	,
	"VALEA MORII (ALBA)"
	,
	"VALEA NEGRILESII (ALBA)"
	,
	"VALEA POIENII (BUCIUM) (ALBA)"
	,
	"VALEA POIENII (RAMET) (ALBA)"
	,
	"VALEA SASULUI (ALBA)"
	,
	"VALEA SESII (BUCIUM) (ALBA)"
	,
	"VALEA SESII (LUPSA) (ALBA)"
	,
	"VALEA TUPILOR (ALBA)"
	,
	"VALEA UTULUI (ALBA)"
	,
	"VALEA UZEI (ALBA)"
	,
	"VALEA VERDE (ALBA)"
	,
	"VALEA VINTULUI (ALBA)"
	,
	"VALENI (BUCIUM) (ALBA)"
	,
	"VALENI (METES) (ALBA)"
	,
	"VALISOARA (ALBA)"
	,
	"VALTORI (VADU MOTILOR) (ALBA)"
	,
	"VALTORI (ZLATNA) (ALBA)"
	,
	"VAMA SEACA (ALBA)"
	,
	"VANVUCESTI (ALBA)"
	,
	"VARSI (ALBA)"
	,
	"VARSII MARI (ALBA)"
	,
	"VARSII MICI (ALBA)"
	,
	"VARSI-RONTU (ALBA)"
	,
	"VARTANESTI (ALBA)"
	,
	"VARTOP (ALBA)"
	,
	"VASESTI (ALBA)"
	,
	"VERDESTI (ALBA)"
	,
	"VESEUS (ALBA)"
	,
	"VEZA (ALBA)"
	,
	"VIDOLM (ALBA)"
	,
	"VIDRA (ALBA)"
	,
	"VIDRISOARA (ALBA)"
	,
	"VIEZURI (ALBA)"
	,
	"VINEREA (ALBA)"
	,
	"VINGARD (ALBA)"
	,
	"VINTA (ALBA)"
	,
	"VINTU DE JOS (ALBA)"
	,
	"VLADESTI (ALBA)"
	,
	"VLADOSESTI (ALBA)"
	,
	"VULCAN (ALBA)"
	,
	"VURPAR (ALBA)"
	,
	"ZAGRIS (ALBA)"
	,
	"ZANZESTI (ALBA)"
	,
	"ZARIES (ALBA)"
	,
	"ZLATNA (ALBA)"
	,
	"ACIUTA (ARAD)"
	,
	"ADEA (ARAD)"
	,
	"AGRISU MARE (ARAD)"
	,
	"AGRISU MIC (ARAD)"
	,
	"ALDESTI (ARAD)"
	,
	"ALMAS (ARAD)"
	,
	"ALUNIS (ARAD)"
	,
	"ANDREI SAGUNA (ARAD)"
	,
	"APATEU (ARAD)"
	,
	"ARAD (ARAD)"
	,
	"ARANEAG (ARAD)"
	,
	"ARCHIS (ARAD)"
	,
	"AVRAM IANCU (CERMEI) (ARAD)"
	,
	"AVRAM IANCU (VARFURILE) (ARAD)"
	,
	"BACAU DE MIJLOC (ARAD)"
	,
	"BAIA (ARAD)"
	,
	"BANESTI (ARAD)"
	,
	"BARATCA (ARAD)"
	,
	"BARSA (ARAD)"
	,
	"BARZAVA (ARAD)"
	,
	"BARZESTI (ARAD)"
	,
	"BATA (ARAD)"
	,
	"BATUTA (ARAD)"
	,
	"BELIU (ARAD)"
	,
	"BELOTINT (ARAD)"
	,
	"BENESTI (ARAD)"
	,
	"BERECHIU (ARAD)"
	,
	"BERINDIA (ARAD)"
	,
	"BIRCHIS (ARAD)"
	,
	"BOCHIA (ARAD)"
	,
	"BOCSIG (ARAD)"
	,
	"BODESTI (ARAD)"
	,
	"BODROGU NOU (ARAD)"
	,
	"BODROGU VECHI (ARAD)"
	,
	"BONTESTI (ARAD)"
	,
	"BOTFEI (ARAD)"
	,
	"BRAZII (ARAD)"
	,
	"BRUSTURI (ARAD)"
	,
	"BRUZNIC (ARAD)"
	,
	"BUCEAVA-SOIMUS (ARAD)"
	,
	"BUDESTI (ARAD)"
	,
	"BUHANI (ARAD)"
	,
	"BULCI (ARAD)"
	,
	"BUTENI (ARAD)"
	,
	"CALUGARENI (ARAD)"
	,
	"CAMNA (ARAD)"
	,
	"CAPALNAS (ARAD)"
	,
	"CAPORAL ALEXA (ARAD)"
	,
	"CAPRIOARA (ARAD)"
	,
	"CAPRUTA (ARAD)"
	,
	"CARAND (ARAD)"
	,
	"CERMEI (ARAD)"
	,
	"CHELMAC (ARAD)"
	,
	"CHERELUS (ARAD)"
	,
	"CHESINT (ARAD)"
	,
	"CHIER (ARAD)"
	,
	"CHISINDIA (ARAD)"
	,
	"CHISINEU-CRIS (ARAD)"
	,
	"CHISLACA (ARAD)"
	,
	"CICIR (ARAD)"
	,
	"CIL (ARAD)"
	,
	"CINTEI (ARAD)"
	,
	"CIUNTESTI (ARAD)"
	,
	"CLADOVA (ARAD)"
	,
	"CLIT (ARAD)"
	,
	"COCIUBA (ARAD)"
	,
	"COMANESTI (ARAD)"
	,
	"CONOP (ARAD)"
	,
	"CORBESTI (ARAD)"
	,
	"COROI (ARAD)"
	,
	"COVASINT (ARAD)"
	,
	"CRAIVA (ARAD)"
	,
	"CRISTESTI (ARAD)"
	,
	"CROCNA (ARAD)"
	,
	"CRUCENI (ARAD)"
	,
	"CUIAS (ARAD)"
	,
	"CUIED (ARAD)"
	,
	"CURTICI (ARAD)"
	,
	"CUVESDIA (ARAD)"
	,
	"CUVIN (ARAD)"
	,
	"DEZNA (ARAD)"
	,
	"DIECI (ARAD)"
	,
	"DONCENI (ARAD)"
	,
	"DORGOS (ARAD)"
	,
	"DOROBANTI (ARAD)"
	,
	"DRAUT (ARAD)"
	,
	"DUD (ARAD)"
	,
	"DULCELE (ARAD)"
	,
	"DUMBRAVA (ARAD)"
	,
	"DUMBRAVITA (ARAD)"
	,
	"FANTANELE (ARAD)"
	,
	"FELNAC (ARAD)"
	,
	"FENIS (ARAD)"
	,
	"FIRITEAZ (ARAD)"
	,
	"FISCUT (ARAD)"
	,
	"FRUMUSENI (ARAD)"
	,
	"GALSA (ARAD)"
	,
	"GHIOROC (ARAD)"
	,
	"GRANICERI (ARAD)"
	,
	"GROSENI (ARAD)"
	,
	"GROSI (ARAD)"
	,
	"GROSII NOI (ARAD)"
	,
	"GURA VAII (ARAD)"
	,
	"GURAHONT (ARAD)"
	,
	"GURBA (ARAD)"
	,
	"HALALIS (ARAD)"
	,
	"HALMAGEL (ARAD)"
	,
	"HALMAGIU (ARAD)"
	,
	"HASMAS (ARAD)"
	,
	"HODIS (ARAD)"
	,
	"HONTISOR (ARAD)"
	,
	"HORIA (ARAD)"
	,
	"HUNEDOARA TIMISANA (ARAD)"
	,
	"IACOBINI (ARAD)"
	,
	"IERCOSENI (ARAD)"
	,
	"IERMATA (ARAD)"
	,
	"IERMATA NEAGRA (ARAD)"
	,
	"IGNESTI (ARAD)"
	,
	"ILTEU (ARAD)"
	,
	"INEU (ARAD)"
	,
	"IONESTI (ARAD)"
	,
	"IOSAS (ARAD)"
	,
	"IRATOSU (ARAD)"
	,
	"JOIA MARE (ARAD)"
	,
	"JULITA (ARAD)"
	,
	"LABASINT (ARAD)"
	,
	"LALASINT (ARAD)"
	,
	"LAZ (ARAD)"
	,
	"LAZURI (ARAD)"
	,
	"LEASA (ARAD)"
	,
	"LESTIOARA (ARAD)"
	,
	"LIPOVA (ARAD)"
	,
	"LIVADA (ARAD)"
	,
	"LUGUZAU (ARAD)"
	,
	"LUNCSOARA (ARAD)"
	,
	"LUPESTI (ARAD)"
	,
	"MACEA (ARAD)"
	,
	"MADERAT (ARAD)"
	,
	"MADRIGESTI (ARAD)"
	,
	"MAGULICEA (ARAD)"
	,
	"MAILAT (ARAD)"
	,
	"MANASTUR (ARAD)"
	,
	"MANDRULOC (ARAD)"
	,
	"MANERAU (ARAD)"
	,
	"MARAUS (ARAD)"
	,
	"MASCA (ARAD)"
	,
	"MERMESTI (ARAD)"
	,
	"MILOVA (ARAD)"
	,
	"MINEAD (ARAD)"
	,
	"MINIS (ARAD)"
	,
	"MINISEL (ARAD)"
	,
	"MINISU DE SUS (ARAD)"
	,
	"MISCA (ARAD)"
	,
	"MOCREA (ARAD)"
	,
	"MONEASA (ARAD)"
	,
	"MONOROSTIA (ARAD)"
	,
	"MORODA (ARAD)"
	,
	"MOTIORI (ARAD)"
	,
	"MUNAR (ARAD)"
	,
	"MUSTESTI (ARAD)"
	,
	"NADAB (ARAD)"
	,
	"NADALBESTI (ARAD)"
	,
	"NADAS (ARAD)"
	,
	"NADLAC (ARAD)"
	,
	"NEAGRA (ARAD)"
	,
	"NERMIS (ARAD)"
	,
	"NEUDORF (ARAD)"
	,
	"NICOLAE BALCESCU (ARAD)"
	,
	"OBARSIA (ARAD)"
	,
	"ODVOS (ARAD)"
	,
	"OLARI (ARAD)"
	,
	"OSTROV (ARAD)"
	,
	"PAIUSENI (ARAD)"
	,
	"PANCOTA (ARAD)"
	,
	"PARNESTI (ARAD)"
	,
	"PATARS (ARAD)"
	,
	"PAULIAN (ARAD)"
	,
	"PAULIS (ARAD)"
	,
	"PECICA (ARAD)"
	,
	"PEREGU MARE (ARAD)"
	,
	"PEREGU MIC (ARAD)"
	,
	"PESCARI (ARAD)"
	,
	"PETRIS (ARAD)"
	,
	"PILU (ARAD)"
	,
	"PLESCUTA (ARAD)"
	,
	"POIANA (ARAD)"
	,
	"POIENARI (ARAD)"
	,
	"PRUNISOR (ARAD)"
	,
	"RADESTI (ARAD)"
	,
	"RADNA (ARAD)"
	,
	"RANUSA (ARAD)"
	,
	"RAPSIG (ARAD)"
	,
	"REVETIS (ARAD)"
	,
	"ROGOZ DE BELIU (ARAD)"
	,
	"ROSIA (ARAD)"
	,
	"ROSIA NOUA (ARAD)"
	,
	"ROSTOCI (ARAD)"
	,
	"SAGU (ARAD)"
	,
	"SALAJENI (ARAD)"
	,
	"SAMBATENI (ARAD)"
	,
	"SANLEANI (ARAD)"
	,
	"SANMARTIN (ARAD)"
	,
	"SANPAUL (ARAD)"
	,
	"SANPETRU GERMAN (ARAD)"
	,
	"SANTANA (ARAD)"
	,
	"SARBI (ARAD)"
	,
	"SATU MARE (ARAD)"
	,
	"SATU MIC (ARAD)"
	,
	"SATU NOU (ARAD)"
	,
	"SAVARSIN (ARAD)"
	,
	"SEBIS (ARAD)"
	,
	"SECACI (ARAD)"
	,
	"SECAS (ARAD)"
	,
	"SECUSIGIU (ARAD)"
	,
	"SEDERHAT (ARAD)"
	,
	"SEITIN (ARAD)"
	,
	"SELEUS (ARAD)"
	,
	"SELISTE (ARAD)"
	,
	"SELISTEA (ARAD)"
	,
	"SEMLAC (ARAD)"
	,
	"SEPREUS (ARAD)"
	,
	"SIAD (ARAD)"
	,
	"SICLAU (ARAD)"
	,
	"SICULA (ARAD)"
	,
	"SILINDIA (ARAD)"
	,
	"SIMAND (ARAD)"
	,
	"SINTEA MARE (ARAD)"
	,
	"SINTEA MICA (ARAD)"
	,
	"SIRIA (ARAD)"
	,
	"SISTAROVAT (ARAD)"
	,
	"SLATINA DE CRIS (ARAD)"
	,
	"SLATINA DE MURES (ARAD)"
	,
	"SOCODOR (ARAD)"
	,
	"SOFRONEA (ARAD)"
	,
	"SOIMOS (ARAD)"
	,
	"SOMOSCHES (ARAD)"
	,
	"STEJAR (ARAD)"
	,
	"STOINESTI (ARAD)"
	,
	"SUSAG (ARAD)"
	,
	"SUSANI (ARAD)"
	,
	"TAGADAU (ARAD)"
	,
	"TALAGIU (ARAD)"
	,
	"TALMACI (ARAD)"
	,
	"TARMURE (ARAD)"
	,
	"TARNAVITA (ARAD)"
	,
	"TARNOVA (ARAD)"
	,
	"TAUT (ARAD)"
	,
	"TELA (ARAD)"
	,
	"TEMESESTI (ARAD)"
	,
	"TIPAR (ARAD)"
	,
	"TISA (ARAD)"
	,
	"TISA NOUA (ARAD)"
	,
	"TOC (ARAD)"
	,
	"TOHESTI (ARAD)"
	,
	"TROAS (ARAD)"
	,
	"TURNU (ARAD)"
	,
	"URVISU DE BELIU (ARAD)"
	,
	"USUSAU (ARAD)"
	,
	"VALEA MARE (GURAHONT) (ARAD)"
	,
	"VALEA MARE (SAVARSIN) (ARAD)"
	,
	"VANATORI (ARAD)"
	,
	"VARADIA DE MURES (ARAD)"
	,
	"VARFURILE (ARAD)"
	,
	"VARIASU MARE (ARAD)"
	,
	"VARIASU MIC (ARAD)"
	,
	"VARNITA (ARAD)"
	,
	"VARSAND (ARAD)"
	,
	"VASILE GOLDIS (ARAD)"
	,
	"VASOAIA (ARAD)"
	,
	"VIDRA (ARAD)"
	,
	"VINGA (ARAD)"
	,
	"VIRISMORT (ARAD)"
	,
	"VLADIMIRESCU (ARAD)"
	,
	"VOIVODENI (ARAD)"
	,
	"ZABALT (ARAD)"
	,
	"ZABRANI (ARAD)"
	,
	"ZADARENI (ARAD)"
	,
	"ZARAND (ARAD)"
	,
	"ZERIND (ARAD)"
	,
	"ZERINDU MIC (ARAD)"
	,
	"ZIMANDCUZ (ARAD)"
	,
	"ZIMANDU NOU (ARAD)"
	,
	"ZIMBRU (ARAD)"
	,
	"ADUNATI (ARGES)"
	,
	"AFRIMESTI (ARGES)"
	,
	"ALBESTI (ARGES)"
	,
	"ALBESTII DE ARGES (ARGES)"
	,
	"ALBESTII DE MUSCEL (ARGES)"
	,
	"ALBESTII PAMANTENI (ARGES)"
	,
	"ALBESTII UNGURENI (ARGES)"
	,
	"ALBOTA (ARGES)"
	,
	"ALBOTELE (ARGES)"
	,
	"ALUNIS (ARGES)"
	,
	"ALUNISU (BAICULESTI) (ARGES)"
	,
	"ALUNISU (BRADULET) (ARGES)"
	,
	"ANGHINESTI (ARGES)"
	,
	"ANINOASA (ARGES)"
	,
	"AREFU (ARGES)"
	,
	"ARGESANI (ARGES)"
	,
	"ARGESELU (ARGES)"
	,
	"BABANA (ARGES)"
	,
	"BABAROAGA (ARGES)"
	,
	"BACESTI (ARGES)"
	,
	"BADENI (ARGES)"
	,
	"BADESTI (BARLA) (ARGES)"
	,
	"BADESTI (PIETROSANI) (ARGES)"
	,
	"BADICEA (ARGES)"
	,
	"BADILA (ARGES)"
	,
	"BADISLAVA (ARGES)"
	,
	"BADULESTI (ARGES)"
	,
	"BAICULESTI (ARGES)"
	,
	"BAILA (ARGES)"
	,
	"BAJANESTI (ARGES)"
	,
	"BAJESTI (ARGES)"
	,
	"BALABANI (ARGES)"
	,
	"BALILESTI (ARGES)"
	,
	"BALILESTI (TIGVENI) (ARGES)"
	,
	"BALOTEASCA (ARGES)"
	,
	"BALTATA (ARGES)"
	,
	"BALTENI (ARGES)"
	,
	"BANARESTI (ARGES)"
	,
	"BANICESTI (ARGES)"
	,
	"BANTAU (ARGES)"
	,
	"BARANESTI (ARGES)"
	,
	"BARASTI (ARGES)"
	,
	"BARBALANI (ARGES)"
	,
	"BARBALATESTI (ARGES)"
	,
	"BARBATESTI (ARGES)"
	,
	"BARLA (ARGES)"
	,
	"BARLOGU (ARGES)"
	,
	"BARLOI (ARGES)"
	,
	"BARSESTII DE JOS (ARGES)"
	,
	"BARSESTII DE SUS (ARGES)"
	,
	"BARZESTI (ARGES)"
	,
	"BASCOV (ARGES)"
	,
	"BASCOVELE (ARGES)"
	,
	"BATRANI (ARGES)"
	,
	"BECULESTI (ARGES)"
	,
	"BELETI (ARGES)"
	,
	"BELETI-NEGRESTI (ARGES)"
	,
	"BEREVOESTI (ARGES)"
	,
	"BERINDESTI (ARGES)"
	,
	"BILCESTI (ARGES)"
	,
	"BLAJU (ARGES)"
	,
	"BLEJANI (ARGES)"
	,
	"BOGATI (ARGES)"
	,
	"BOLCULESTI (ARGES)"
	,
	"BOLOVANESTI (ARGES)"
	,
	"BORDEIENI (ARGES)"
	,
	"BORLESTI (ARGES)"
	,
	"BOROBANESTI (ARGES)"
	,
	"BOROVINESTI (ARGES)"
	,
	"BOTARCANI (ARGES)"
	,
	"BOTENI (ARGES)"
	,
	"BOTESTI (ARGES)"
	,
	"BRABETI (ARGES)"
	,
	"BRADETU (ARGES)"
	,
	"BRADU (ARGES)"
	,
	"BRADULET (ARGES)"
	,
	"BRAILENI (ARGES)"
	,
	"BRANISTEA (ARGES)"
	,
	"BRANZARI (ARGES)"
	,
	"BRATEASCA (ARGES)"
	,
	"BRATESTI (ARGES)"
	,
	"BRATIA (BEREVOESTI) (ARGES)"
	,
	"BRATIA (CIOMAGESTI) (ARGES)"
	,
	"BROSTENI (ANINOASA) (ARGES)"
	,
	"BROSTENI (COSTESTI) (ARGES)"
	,
	"BUCOV (ARGES)"
	,
	"BUCSENESTI (ARGES)"
	,
	"BUCSENESTI-LOTASI (ARGES)"
	,
	"BUDEASA (ARGES)"
	,
	"BUDEASA MARE (ARGES)"
	,
	"BUDEASA MICA (ARGES)"
	,
	"BUDISTENI (ARGES)"
	,
	"BUGHEA DE JOS (ARGES)"
	,
	"BUGHEA DE SUS (ARGES)"
	,
	"BUJOI (ARGES)"
	,
	"BUJORENI (ARGES)"
	,
	"BUMBUENI (ARGES)"
	,
	"BUNESTI (COTMEANA) (ARGES)"
	,
	"BUNESTI (MALURENI) (ARGES)"
	,
	"BURDEA (ARGES)"
	,
	"BURDESTI (ARGES)"
	,
	"BURETESTI (ARGES)"
	,
	"BURLUSI (ARGES)"
	,
	"BURNESTI (ARGES)"
	,
	"BUTA (ARGES)"
	,
	"BUZOESTI (ARGES)"
	,
	"CALDARARU (ARGES)"
	,
	"CALINESTI (ARGES)"
	,
	"CALOTESTI (ARGES)"
	,
	"CAMPULUNG (ARGES)"
	,
	"CANDESTI (ARGES)"
	,
	"CAPATANENII PAMANTENI (ARGES)"
	,
	"CAPATANENII UNGURENI (ARGES)"
	,
	"CAPU PISCULUI (GODENI) (ARGES)"
	,
	"CAPU PISCULUI (MERISANI) (ARGES)"
	,
	"CARCESTI (ARGES)"
	,
	"CARCIUMARESTI (ARGES)"
	,
	"CARPENIS (ARGES)"
	,
	"CARSTIENI (ARGES)"
	,
	"CATANE (ARGES)"
	,
	"CATANELE (ARGES)"
	,
	"CATEASCA (ARGES)"
	,
	"CATUNASI (ARGES)"
	,
	"CEAURESTI (ARGES)"
	,
	"CEAUSESTI (ARGES)"
	,
	"CEPARI (ARGES)"
	,
	"CEPARI (POIANA LACULUI) (ARGES)"
	,
	"CEPARII PAMANTENI (ARGES)"
	,
	"CEPARII UNGURENI (ARGES)"
	,
	"CERBU (ARGES)"
	,
	"CERBURENI (ARGES)"
	,
	"CERSANI (ARGES)"
	,
	"CETATENI (ARGES)"
	,
	"CHILII (ARGES)"
	,
	"CHIRITESTI (SUSENI) (ARGES)"
	,
	"CHIRITESTI (UDA) (ARGES)"
	,
	"CHIRITESTI (VEDEA) (ARGES)"
	,
	"CHITANI (ARGES)"
	,
	"CHITESTI (ARGES)"
	,
	"CICANESTI (ARGES)"
	,
	"CIESTI (ARGES)"
	,
	"CIOBANESTI (ARGES)"
	,
	"CIOBANI (ARGES)"
	,
	"CIOCANAI (ARGES)"
	,
	"CIOCANESTI (ARGES)"
	,
	"CIOCANU (ARGES)"
	,
	"CIOCESTI (ARGES)"
	,
	"CIOFRANGENI (ARGES)"
	,
	"CIOLCESTI (ARGES)"
	,
	"CIOMAGESTI (ARGES)"
	,
	"CIRESU (ARGES)"
	,
	"CISMEA (ARGES)"
	,
	"CIULNITA (ARGES)"
	,
	"CIUPA-MANCIULESCU (ARGES)"
	,
	"CIURESTI (ARGES)"
	,
	"CLUCEREASA (ARGES)"
	,
	"COCENESTI (ARGES)"
	,
	"COCHINESTI (ARGES)"
	,
	"COCU (ARGES)"
	,
	"COLIBASI (ARGES)"
	,
	"COLNIC (ARGES)"
	,
	"COLTU (ARGES)"
	,
	"CONTESTI (ARGES)"
	,
	"CORBENI (ARGES)"
	,
	"CORBI (ARGES)"
	,
	"CORBSORI (ARGES)"
	,
	"CORNATEL (ARGES)"
	,
	"COSACI (ARGES)"
	,
	"COSERI (ARGES)"
	,
	"COSESTI (ARGES)"
	,
	"COSTESTI (ARGES)"
	,
	"COSTESTI (COTMEANA) (ARGES)"
	,
	"COSTESTI-VALSAN (ARGES)"
	,
	"COSTITA (ARGES)"
	,
	"COTEASCA (ARGES)"
	,
	"COTENESTI (ARGES)"
	,
	"COTESTI (ARGES)"
	,
	"COTMEANA (ARGES)"
	,
	"COTMEANA (STOLNICI) (ARGES)"
	,
	"COTMENITA (ARGES)"
	,
	"COTU (CUCA) (ARGES)"
	,
	"COTU (UDA) (ARGES)"
	,
	"COTU MALULUI (ARGES)"
	,
	"CRAMPOTANI (ARGES)"
	,
	"CRINTESTI (ARGES)"
	,
	"CRIVATU (ARGES)"
	,
	"CRUCISOARA (ARGES)"
	,
	"CUCA (ARGES)"
	,
	"CUNGREA (ARGES)"
	,
	"CURTEA DE ARGES (ARGES)"
	,
	"CURTEANCA (ARGES)"
	,
	"DAMBOVICIOARA (ARGES)"
	,
	"DARMANESTI (ARGES)"
	,
	"DAVIDESTI (ARGES)"
	,
	"DEAGU DE JOS (ARGES)"
	,
	"DEAGU DE SUS (ARGES)"
	,
	"DEALU (ARGES)"
	,
	"DEALU BISERICII (ARGES)"
	,
	"DEALU BRADULUI (ARGES)"
	,
	"DEALU FRUMOS (ARGES)"
	,
	"DEALU OBEJDEANULUI (ARGES)"
	,
	"DEALU ORASULUI (ARGES)"
	,
	"DEALU PADURII (ARGES)"
	,
	"DEALU TOLCESII (ARGES)"
	,
	"DEALU VIILOR (MOSOAIA) (ARGES)"
	,
	"DEALU VIILOR (POIANA LACULUI) (ARGES)"
	,
	"DEDULESTI (ARGES)"
	,
	"DICONESTI (ARGES)"
	,
	"DINCANI (ARGES)"
	,
	"DINCULESTI (ARGES)"
	,
	"DOBLEA (ARGES)"
	,
	"DOBRESTI (ARGES)"
	,
	"DOBROGOSTEA (ARGES)"
	,
	"DOBROTU (ARGES)"
	,
	"DOGARI (ARGES)"
	,
	"DOMNESTI (ARGES)"
	,
	"DRAGANU (ARGES)"
	,
	"DRAGANU-OLTENI (ARGES)"
	,
	"DRAGHESCU (ARGES)"
	,
	"DRAGHICESTI (ARGES)"
	,
	"DRAGHICI (ARGES)"
	,
	"DRAGOLESTI (ARGES)"
	,
	"DRAGOSLAVELE (ARGES)"
	,
	"DUMBRAVA (ARGES)"
	,
	"DUMBRAVESTI (ARGES)"
	,
	"DUMIRESTI (ARGES)"
	,
	"ENCULESTI (ARGES)"
	,
	"FACALETESTI (ARGES)"
	,
	"FAGETU (ARGES)"
	,
	"FALFANI (ARGES)"
	,
	"FANTANEA (ARGES)"
	,
	"FATA (ARGES)"
	,
	"FEDELESOIU (ARGES)"
	,
	"FLORIENI (ARGES)"
	,
	"FRATESTI (ARGES)"
	,
	"FRATICI (ARGES)"
	,
	"FURDUESTI (ARGES)"
	,
	"FURESTI (ARGES)"
	,
	"FURNICOSI (ARGES)"
	,
	"GAINUSA (ARGES)"
	,
	"GALASESTI (BUDEASA) (ARGES)"
	,
	"GALASESTI (SUSENI) (ARGES)"
	,
	"GALCESTI (ARGES)"
	,
	"GALESU (ARGES)"
	,
	"GALETEANU (ARGES)"
	,
	"GAMACESTI (ARGES)"
	,
	"GANESTI (ARGES)"
	,
	"GARDINESTI (ARGES)"
	,
	"GAUJANI (ARGES)"
	,
	"GEAMANA (ARGES)"
	,
	"GIUCLANI (ARGES)"
	,
	"GLAMBOCATA (ARGES)"
	,
	"GLAMBOCATA-DEAL (ARGES)"
	,
	"GLAMBOCEL (ARGES)"
	,
	"GLAMBOCELU (ARGES)"
	,
	"GLAMBOCU (ARGES)"
	,
	"GLAVACIOC (ARGES)"
	,
	"GLIGANU DE JOS (ARGES)"
	,
	"GLIGANU DE SUS (ARGES)"
	,
	"GLODU (CALINESTI) (ARGES)"
	,
	"GLODU (LEORDENI) (ARGES)"
	,
	"GODENI (ARGES)"
	,
	"GOIA (ARGES)"
	,
	"GOLEASCA (ARGES)"
	,
	"GOLESTI (BALILESTI) (ARGES)"
	,
	"GOLESTI (STEFANESTI) (ARGES)"
	,
	"GORANESTI (ARGES)"
	,
	"GORANI (ARGES)"
	,
	"GORGANU (ARGES)"
	,
	"GREABAN (ARGES)"
	,
	"GREABANU (ARGES)"
	,
	"GROSANI (ARGES)"
	,
	"GROSI (ARGES)"
	,
	"GRUIU (CATEASCA) (ARGES)"
	,
	"GRUIU (NUCSOARA) (ARGES)"
	,
	"GURA PRAVAT (ARGES)"
	,
	"GURA VAII (ARGES)"
	,
	"HARSESTI (ARGES)"
	,
	"HARTIESTI (ARGES)"
	,
	"HINTESTI (ARGES)"
	,
	"HULUBA (ARGES)"
	,
	"HUMELE (ARGES)"
	,
	"IANCULESTI (ARGES)"
	,
	"IOANICESTI (ARGES)"
	,
	"IONESTI (ARGES)"
	,
	"IZBASESTI (ARGES)"
	,
	"IZVORANI (ARGES)"
	,
	"IZVORU (ARGES)"
	,
	"IZVORU DE JOS (ARGES)"
	,
	"IZVORU DE SUS (ARGES)"
	,
	"JGHEABURI (ARGES)"
	,
	"JUGUR (ARGES)"
	,
	"JUPANESTI (ARGES)"
	,
	"LACENI (ARGES)"
	,
	"LACURILE (ARGES)"
	,
	"LAICAI (ARGES)"
	,
	"LANGESTI (ARGES)"
	,
	"LAPUSANI (ARGES)"
	,
	"LAUNELE DE SUS (ARGES)"
	,
	"LAZARESTI (MOSOAIA) (ARGES)"
	,
	"LAZARESTI (SCHITU GOLESTI) (ARGES)"
	,
	"LEICESTI (ARGES)"
	,
	"LENTEA (ARGES)"
	,
	"LEORDENI (ARGES)"
	,
	"LERESTI (ARGES)"
	,
	"LESILE (ARGES)"
	,
	"LESPEZI (ARGES)"
	,
	"LINTESTI (ARGES)"
	,
	"LIPIA (ARGES)"
	,
	"LIVEZENI (ARGES)"
	,
	"LOTURI (ARGES)"
	,
	"LUCIENI (ARGES)"
	,
	"LUMINILE (ARGES)"
	,
	"LUNCA (ARGES)"
	,
	"LUNCA CORBULUI (ARGES)"
	,
	"LUNCA GARTII (ARGES)"
	,
	"LUNGANI (ARGES)"
	,
	"LUNGULESTI (ARGES)"
	,
	"LUPUENI (ARGES)"
	,
	"MACAI (ARGES)"
	,
	"MALU (BARLA) (ARGES)"
	,
	"MALU (GODENI) (ARGES)"
	,
	"MALU VANAT (ARGES)"
	,
	"MALURENI (ARGES)"
	,
	"MANCIOIU (ARGES)"
	,
	"MANDRA (ARGES)"
	,
	"MANESTI (ARGES)"
	,
	"MANICESTI (ARGES)"
	,
	"MARACINENI (ARGES)"
	,
	"MARES (ARGES)"
	,
	"MARGHIA DE JOS (ARGES)"
	,
	"MARGHIA DE SUS (ARGES)"
	,
	"MARTALOGI (ARGES)"
	,
	"MARTESTI (ARGES)"
	,
	"MATAU (ARGES)"
	,
	"MAVRODOLU (ARGES)"
	,
	"MERISANI (ARGES)"
	,
	"METOFU (ARGES)"
	,
	"MICA (ARGES)"
	,
	"MICESTI (ARGES)"
	,
	"MIERCANI (ARGES)"
	,
	"MIHAESTI (ARGES)"
	,
	"MIOARELE (ARGES)"
	,
	"MIOARELE (CICANESTI) (ARGES)"
	,
	"MIOVENI (ARGES)"
	,
	"MIROSI (ARGES)"
	,
	"MOARA MOCANULUI (ARGES)"
	,
	"MOGOSESTI (ARGES)"
	,
	"MORARESTI (ARGES)"
	,
	"MORASTI (ARGES)"
	,
	"MOSOAIA (ARGES)"
	,
	"MOSTENI-GRECI (ARGES)"
	,
	"MOZACENI (ARGES)"
	,
	"MOZACENII-VALE (ARGES)"
	,
	"MOZACU (ARGES)"
	,
	"MUSATESTI (ARGES)"
	,
	"MUSCEL (ARGES)"
	,
	"MUSTATESTI (ARGES)"
	,
	"NAMAESTI (ARGES)"
	,
	"NEGESTI (ARGES)"
	,
	"NEGRASI (ARGES)"
	,
	"NEGRENI (ARGES)"
	,
	"NEGRESTI (ARGES)"
	,
	"NEJLOVELU (ARGES)"
	,
	"NIGRISOARA (ARGES)"
	,
	"NOAPTES (ARGES)"
	,
	"NUCSOARA (ARGES)"
	,
	"OARJA (ARGES)"
	,
	"ODAENI (ARGES)"
	,
	"OESTII PAMANTENI (ARGES)"
	,
	"OESTII UNGURENI (ARGES)"
	,
	"OGREZEA (ARGES)"
	,
	"OPRESTI (ARGES)"
	,
	"ORODEL (ARGES)"
	,
	"OTELU (ARGES)"
	,
	"PACIOIU (ARGES)"
	,
	"PADURENI (ARGES)"
	,
	"PADURETI (ARGES)"
	,
	"PADUROIU DIN DEAL (ARGES)"
	,
	"PADUROIU DIN VALE (ARGES)"
	,
	"PALANGA (ARGES)"
	,
	"PALTENU (ARGES)"
	,
	"PARASCHIVESTI (ARGES)"
	,
	"PARVU ROSU (ARGES)"
	,
	"PATULENI (ARGES)"
	,
	"PAULEASCA (MALURENI) (ARGES)"
	,
	"PAULEASCA (MICESTI) (ARGES)"
	,
	"PAULENI (ARGES)"
	,
	"PAUNESTI (ARGES)"
	,
	"PETRESTI (ARGES)"
	,
	"PIATRA (BRADULET) (ARGES)"
	,
	"PIATRA (CIOFRANGENI) (ARGES)"
	,
	"PIATRA (STOENESTI) (ARGES)"
	,
	"PIELESTI (ARGES)"
	,
	"PIETROASA (ARGES)"
	,
	"PIETROSANI (ARGES)"
	,
	"PISCANI (ARGES)"
	,
	"PITESTI (ARGES)"
	,
	"PITIGAIA (ARGES)"
	,
	"PITOI (ARGES)"
	,
	"PODENI (ARGES)"
	,
	"PODISORU (ARGES)"
	,
	"PODU BROSTENI (ARGES)"
	,
	"PODU DAMBOVITEI (ARGES)"
	,
	"PODURI (ARGES)"
	,
	"POIANA LACULUI (ARGES)"
	,
	"POIENAREI (ARGES)"
	,
	"POIENARI (CORBENI) (ARGES)"
	,
	"POIENARI (POIENARII DE ARGES) (ARGES)"
	,
	"POIENARI (POIENARII DE MUSCEL) (ARGES)"
	,
	"POIENARII DE ARGES (ARGES)"
	,
	"POIENARII DE MUSCEL (ARGES)"
	,
	"POIENITA (ARGES)"
	,
	"POJORATA (ARGES)"
	,
	"POPESTI (ARGES)"
	,
	"POPESTI (COCU) (ARGES)"
	,
	"POPESTI (SAPATA) (ARGES)"
	,
	"PRIBOAIA (ARGES)"
	,
	"PRIBOIENI (ARGES)"
	,
	"PRISEACA (ARGES)"
	,
	"PRISLOPU MARE (ARGES)"
	,
	"PRISLOPU MIC (ARGES)"
	,
	"PRODANI (ARGES)"
	,
	"PROSIA (ARGES)"
	,
	"PURCARENI (MICESTI) (ARGES)"
	,
	"PURCARENI (POPESTI) (ARGES)"
	,
	"PUTINA (ARGES)"
	,
	"RACA (ARGES)"
	,
	"RACHITELE DE JOS (ARGES)"
	,
	"RACHITELE DE SUS (ARGES)"
	,
	"RACOVITA (ARGES)"
	,
	"RADESTI (ARGES)"
	,
	"RADU NEGRU (ARGES)"
	,
	"RADUTESTI (ARGES)"
	,
	"RAJLETU-GOVORA (ARGES)"
	,
	"RANCACIOV (ARGES)"
	,
	"RATESTI (ARGES)"
	,
	"RATOI (ARGES)"
	,
	"RECEA (ARGES)"
	,
	"RECEA (CATEASCA) (ARGES)"
	,
	"REDEA (ARGES)"
	,
	"RETEVOIESTI (ARGES)"
	,
	"ROBAIA (ARGES)"
	,
	"ROCIU (ARGES)"
	,
	"ROGOJINA (ARGES)"
	,
	"ROMANA (ARGES)"
	,
	"ROTUNDA (ARGES)"
	,
	"RUCAR (ARGES)"
	,
	"RUDENI (MIHAESTI) (ARGES)"
	,
	"RUDENI (SUICI) (ARGES)"
	,
	"RUGINOASA (ARGES)"
	,
	"SALATRUCU (ARGES)"
	,
	"SALISTEA (ARGES)"
	,
	"SAMAILA (ARGES)"
	,
	"SAMARA (ARGES)"
	,
	"SANDULESTI (ARGES)"
	,
	"SAPATA (ARGES)"
	,
	"SAPUNARI (ARGES)"
	,
	"SATIC (ARGES)"
	,
	"SATU NOU (ARGES)"
	,
	"SBOGHITESTI (ARGES)"
	,
	"SCHIAU (ARGES)"
	,
	"SCHITU GOLESTI (ARGES)"
	,
	"SCHITU SCOICESTI (ARGES)"
	,
	"SCHITU-MATEI (ARGES)"
	,
	"SELAREASCA (ARGES)"
	,
	"SELARI (ARGES)"
	,
	"SENDRULESTI (ARGES)"
	,
	"SERBANESTI (POIENARII DE MUSCEL) (ARGES)"
	,
	"SERBANESTI (ROCIU) (ARGES)"
	,
	"SERBOENI (ARGES)"
	,
	"SILISTEA (ARGES)"
	,
	"SILISTENI (ARGES)"
	,
	"SINESTI (ARGES)"
	,
	"SLAMNESTI (ARGES)"
	,
	"SLANIC (ARGES)"
	,
	"SLATINA (ARGES)"
	,
	"SLATIOARELE (ARGES)"
	,
	"SLOBOZIA (ARGES)"
	,
	"SLOBOZIA (POPESTI) (ARGES)"
	,
	"SLOBOZIA (STOENESTI) (ARGES)"
	,
	"SMEI (ARGES)"
	,
	"SMEURA (ARGES)"
	,
	"SPIRIDONI (ARGES)"
	,
	"STALPENI (ARGES)"
	,
	"STANESTI (ARGES)"
	,
	"STANICEI (ARGES)"
	,
	"STARCI (ARGES)"
	,
	"STEFAN CEL MARE (ARGES)"
	,
	"STEFANESTI (ARGES)"
	,
	"STEFANESTI (SUSENI) (ARGES)"
	,
	"STEFANESTII NOI (ARGES)"
	,
	"STEJARI (ARGES)"
	,
	"STOENESTI (ARGES)"
	,
	"STOLNICI (ARGES)"
	,
	"STRAMBENI (CALDARARU) (ARGES)"
	,
	"STRAMBENI (SUSENI) (ARGES)"
	,
	"STROESTI (ARGES)"
	,
	"SUICI (ARGES)"
	,
	"SURDULESTI (ARGES)"
	,
	"SUSENI (ARGES)"
	,
	"SUSENI (BOGATI) (ARGES)"
	,
	"SUSLANESTI (ARGES)"
	,
	"TEIU (ARGES)"
	,
	"TEODORESTI (ARGES)"
	,
	"TIGANESTI (ARGES)"
	,
	"TIGVENI (ARGES)"
	,
	"TIGVENI (RATESTI) (ARGES)"
	,
	"TITESTI (ARGES)"
	,
	"TOMSANCA (ARGES)"
	,
	"TOMULESTI (ARGES)"
	,
	"TOPLITA (ARGES)"
	,
	"TOPOLOVENI (ARGES)"
	,
	"TURBUREA (ARGES)"
	,
	"TURCESTI (ARGES)"
	,
	"TUTANA (ARGES)"
	,
	"TUTULESTI (ARGES)"
	,
	"UDA (ARGES)"
	,
	"UDENI-ZAVOI (ARGES)"
	,
	"UIASCA (ARGES)"
	,
	"ULENI (ARGES)"
	,
	"ULITA (ARGES)"
	,
	"UNGHENI (ARGES)"
	,
	"UNGURENI (BRADULET) (ARGES)"
	,
	"UNGURENI (VALEA IASULUI) (ARGES)"
	,
	"URECHESTI (ARGES)"
	,
	"URLUCEA (ARGES)"
	,
	"URLUENI (ARGES)"
	,
	"URLUIESTI (ARGES)"
	,
	"URSOAIA (ARGES)"
	,
	"VACAREA (ARGES)"
	,
	"VALCELELE (ARGES)"
	,
	"VALEA BADENILOR (ARGES)"
	,
	"VALEA BRADULUI (ARGES)"
	,
	"VALEA BRAZILOR (ARGES)"
	,
	"VALEA CALULUI (ARGES)"
	,
	"VALEA CETATUIA (ARGES)"
	,
	"VALEA CORBULUI (ARGES)"
	,
	"VALEA CUCII (ARGES)"
	,
	"VALEA DANULUI (ARGES)"
	,
	"VALEA FAURULUI (ARGES)"
	,
	"VALEA HOTARULUI (ARGES)"
	,
	"VALEA IASULUI (ARGES)"
	,
	"VALEA INDARAT (ARGES)"
	,
	"VALEA LUI ENACHE (ARGES)"
	,
	"VALEA LUI MAS (ARGES)"
	,
	"VALEA MAGUREI (ARGES)"
	,
	"VALEA MANASTIRII (ARGES)"
	,
	"VALEA MARE (ARGES)"
	,
	"VALEA MARE-BRATIA (ARGES)"
	,
	"VALEA MARE-PODGORIA (ARGES)"
	,
	"VALEA MARE-PRAVAT (ARGES)"
	,
	"VALEA MARULUI (ARGES)"
	,
	"VALEA MUSCELULUI (ARGES)"
	,
	"VALEA NANDRII (ARGES)"
	,
	"VALEA NENII (ARGES)"
	,
	"VALEA PECHII (ARGES)"
	,
	"VALEA POPII (MIHAESTI) (ARGES)"
	,
	"VALEA POPII (PRIBOIENI) (ARGES)"
	,
	"VALEA RIZII (ARGES)"
	,
	"VALEA RUMANESTILOR (ARGES)"
	,
	"VALEA SILISTII (ARGES)"
	,
	"VALEA STANII (ARGES)"
	,
	"VALEA ULEIULUI (ARGES)"
	,
	"VALEA URSULUI (ARGES)"
	,
	"VALENI (ARGES)"
	,
	"VALENI-PODGORIA (ARGES)"
	,
	"VALSANESTI (ARGES)"
	,
	"VARLOVENI (ARGES)"
	,
	"VARSESTI (ARGES)"
	,
	"VARZAROAIA (ARGES)"
	,
	"VARZARU (ARGES)"
	,
	"VATA (ARGES)"
	,
	"VEDEA (ARGES)"
	,
	"VERNESTI (ARGES)"
	,
	"VETISOARA (ARGES)"
	,
	"VIISOARA (ARGES)"
	,
	"VLADESTI (ARGES)"
	,
	"VLADESTI (TIGVENI) (ARGES)"
	,
	"VLADUTA (ARGES)"
	,
	"VLASCUTA (ARGES)"
	,
	"VOINESTI (ARGES)"
	,
	"VONIGEASA (ARGES)"
	,
	"VOROVENI (ARGES)"
	,
	"VRANESTI (ARGES)"
	,
	"VULPESTI (ARGES)"
	,
	"VULTURESTI (ARGES)"
	,
	"ZAMFIRESTI (CEPARI) (ARGES)"
	,
	"ZAMFIRESTI (COTMEANA) (ARGES)"
	,
	"ZARNESTI (ARGES)"
	,
	"ZAVOI (ARGES)"
	,
	"ZGRIPCESTI (ARGES)"
	,
	"ZIDURILE (ARGES)"
	,
	"ZIGONENI (ARGES)"
	,
	"ZUVELCATI (ARGES)"
	,
	"AGAS (BACAU)"
	,
	"ALBELE (BACAU)"
	,
	"ANTOHESTI (BACAU)"
	,
	"APA ASAU (BACAU)"
	,
	"ARDEOANI (BACAU)"
	,
	"ARINI (BACAU)"
	,
	"ASAU (BACAU)"
	,
	"BACAU (BACAU)"
	,
	"BACIOIU (BACAU)"
	,
	"BACLESTI (BACAU)"
	,
	"BAHNA (BACAU)"
	,
	"BAHNASENI (BACAU)"
	,
	"BAIMAC (BACAU)"
	,
	"BALAIA (BACAU)"
	,
	"BALANEASA (BACAU)"
	,
	"BALANESTI (DEALU MORII) (BACAU)"
	,
	"BALANESTI (PODU TURCULUI) (BACAU)"
	,
	"BALCA (BACAU)"
	,
	"BALCANI (BACAU)"
	,
	"BALOTESTI (BACAU)"
	,
	"BALTATA (BACAU)"
	,
	"BALUSA (BACAU)"
	,
	"BANCA (BACAU)"
	,
	"BARATI (BACAU)"
	,
	"BARBOASA (BACAU)"
	,
	"BARCANA (BACAU)"
	,
	"BARNA (BACAU)"
	,
	"BARNESTI (BACAU)"
	,
	"BARSANESTI (BACAU)"
	,
	"BARTASESTI (BACAU)"
	,
	"BARZULESTI (BACAU)"
	,
	"BASASTI (BACAU)"
	,
	"BAZGA (BACAU)"
	,
	"BELCIUNEASA (BACAU)"
	,
	"BELEGHET (BACAU)"
	,
	"BENESTI (BACAU)"
	,
	"BERBINCENI (BACAU)"
	,
	"BERESTI (BACAU)"
	,
	"BERESTI-BISTRITA (BACAU)"
	,
	"BERESTI-TAZLAU (BACAU)"
	,
	"BERZUNTI (BACAU)"
	,
	"BIBIRESTI (BACAU)"
	,
	"BIJGHIR (BACAU)"
	,
	"BLAGA (BACAU)"
	,
	"BLAGESTI (BACAU)"
	,
	"BLIDARI (BACAU)"
	,
	"BOANTA (BACAU)"
	,
	"BOBOS (BACAU)"
	,
	"BODEASA (BACAU)"
	,
	"BOGATA (BACAU)"
	,
	"BOGDAN VODA (BACAU)"
	,
	"BOGDANA (BACAU)"
	,
	"BOGDANESTI (BACAU)"
	,
	"BOGDANESTI (SCORTENI) (BACAU)"
	,
	"BOGDANESTI (TRAIAN) (BACAU)"
	,
	"BOISTEA (BACAU)"
	,
	"BOISTEA DE JOS (BACAU)"
	,
	"BOLATAU (BACAU)"
	,
	"BOLOVANIS (BACAU)"
	,
	"BORSANI (BACAU)"
	,
	"BORZESTI (BACAU)"
	,
	"BOSIA (BACAU)"
	,
	"BOSOTENI (BACAU)"
	,
	"BOSTANESTI (BACAU)"
	,
	"BOTA (BACAU)"
	,
	"BOTESTI (BACAU)"
	,
	"BRAD (BERESTI-BISTRITA) (BACAU)"
	,
	"BRAD (FILIPENI) (BACAU)"
	,
	"BRAD (NEGRI) (BACAU)"
	,
	"BRATESTI (BACAU)"
	,
	"BRATILA (BACAU)"
	,
	"BRUSTUROASA (BACAU)"
	,
	"BUCHILA (BACAU)"
	,
	"BUCIUMI (BACAU)"
	,
	"BUCSA (BACAU)"
	,
	"BUCSESTI (BACAU)"
	,
	"BUDA (BERZUNTI) (BACAU)"
	,
	"BUDA (BLAGESTI) (BACAU)"
	,
	"BUDA (RACHITOASA) (BACAU)"
	,
	"BUDESTI (BACAU)"
	,
	"BUHOCEL (BACAU)"
	,
	"BUHOCI (BACAU)"
	,
	"BUHUSI (BACAU)"
	,
	"BURDUSACI (BACAU)"
	,
	"BURUIENIS (BACAU)"
	,
	"BURUIENISU DE SUS (BACAU)"
	,
	"CABESTI (BACAU)"
	,
	"CADARESTI (BACAU)"
	,
	"CAIUTI (BACAU)"
	,
	"CALAPODESTI (BACAU)"
	,
	"CALCAI (BACAU)"
	,
	"CALINESTI (BACAU)"
	,
	"CALINI (BACAU)"
	,
	"CALUGARENI (BACAU)"
	,
	"CAMENCA (BACAU)"
	,
	"CAMPENI (BACAU)"
	,
	"CAPATA (BACAU)"
	,
	"CAPOTESTI (BACAU)"
	,
	"CARACLAU (BACAU)"
	,
	"CARLIGI (BACAU)"
	,
	"CASIN (BACAU)"
	,
	"CAUIA (BACAU)"
	,
	"CERDAC (BACAU)"
	,
	"CERNU (BACAU)"
	,
	"CETATUIA (BACAU)"
	,
	"CHETRENI (BACAU)"
	,
	"CHETRIS (BACAU)"
	,
	"CHICEREA (BACAU)"
	,
	"CHILIA BENEI (BACAU)"
	,
	"CHITICENI (BACAU)"
	,
	"CIOBANUS (BACAU)"
	,
	"CIRESOAIA (BACAU)"
	,
	"CIUCANI (BACAU)"
	,
	"CIUGHES (BACAU)"
	,
	"CIUMASI (BACAU)"
	,
	"CIUTURESTI (BACAU)"
	,
	"CLEJA (BACAU)"
	,
	"CLIMESTI (BACAU)"
	,
	"COCIU (BACAU)"
	,
	"COLONESTI (BACAU)"
	,
	"COMAN (BACAU)"
	,
	"COMANESTI (BACAU)"
	,
	"CONTESTI (BACAU)"
	,
	"CORBASCA (BACAU)"
	,
	"CORNATEL (BACAU)"
	,
	"CORNATELU (BACAU)"
	,
	"CORNESTI (BACAU)"
	,
	"CORNET (BACAU)"
	,
	"CORNII DE JOS (BACAU)"
	,
	"CORNII DE SUS (BACAU)"
	,
	"COSNEA (BACAU)"
	,
	"COSTEI (BACAU)"
	,
	"COTENI (BACAU)"
	,
	"COTOFANESTI (BACAU)"
	,
	"COTU GROSULUI (BACAU)"
	,
	"COTUMBA (BACAU)"
	,
	"CRAIESTI (BACAU)"
	,
	"CRIHAN (BACAU)"
	,
	"CUCHINIS (BACAU)"
	,
	"CUCOVA (BACAU)"
	,
	"CUCUIETI (DOFTEANA) (BACAU)"
	,
	"CUCUIETI (SOLONT) (BACAU)"
	,
	"CURITA (BACAU)"
	,
	"DADESTI (BACAU)"
	,
	"DAMIENESTI (BACAU)"
	,
	"DANAILA (BACAU)"
	,
	"DARMANEASCA (BACAU)"
	,
	"DARMANESTI (BACAU)"
	,
	"DEALU MARE (BACAU)"
	,
	"DEALU MORII (BACAU)"
	,
	"DEALU PERJULUI (BACAU)"
	,
	"DELENI (BACAU)"
	,
	"DIACONESTI (BACAU)"
	,
	"DIENET (BACAU)"
	,
	"DOFTEANA (BACAU)"
	,
	"DORNENI (PLOPANA) (BACAU)"
	,
	"DORNENI (VULTURENI) (BACAU)"
	,
	"DOROFEI (BACAU)"
	,
	"DOSPINESTI (BACAU)"
	,
	"DRAGESTI (DAMIENESTI) (BACAU)"
	,
	"DRAGESTI (TATARASTI) (BACAU)"
	,
	"DRAGOMIR (BACAU)"
	,
	"DRAGUGESTI (BACAU)"
	,
	"DRAGUSANI (BACAU)"
	,
	"DUMBRAVA (BERESTI-BISTRITA) (BACAU)"
	,
	"DUMBRAVA (GURA VAII) (BACAU)"
	,
	"DUMBRAVA (RACHITOASA) (BACAU)"
	,
	"ENACHESTI (BACAU)"
	,
	"FAGET (BACAU)"
	,
	"FAGETEL (BACAU)"
	,
	"FAGETU DE SUS (BACAU)"
	,
	"FAGHIENI (BACAU)"
	,
	"FANTANELE (HEMEIUS) (BACAU)"
	,
	"FANTANELE (MOTOSENI) (BACAU)"
	,
	"FARAOANI (BACAU)"
	,
	"FARCASA (BACAU)"
	,
	"FERESTRAU-OITUZ (BACAU)"
	,
	"FICHITESTI (BACAU)"
	,
	"FILIPENI (BACAU)"
	,
	"FILIPESTI (BACAU)"
	,
	"FILIPESTI (BOGDANESTI) (BACAU)"
	,
	"FLORESTI (CAIUTI) (BACAU)"
	,
	"FLORESTI (HURUIESTI) (BACAU)"
	,
	"FLORESTI (SCORTENI) (BACAU)"
	,
	"FRUMOASA (BACAU)"
	,
	"FRUMUSELU (BACAU)"
	,
	"FRUNTESTI (BACAU)"
	,
	"FULGERIS (BACAU)"
	,
	"FUNDATURA (BACAU)"
	,
	"FUNDATURA RACHITOASA (BACAU)"
	,
	"FUNDENI (BACAU)"
	,
	"FUNDOAIA (BACAU)"
	,
	"FUNDU RACACIUNI (BACAU)"
	,
	"FUNDU TUTOVEI (BACAU)"
	,
	"FUNDU VAII (BACAU)"
	,
	"FURNICARI (BACAU)"
	,
	"GAICEANA (BACAU)"
	,
	"GALBENI (FILIPESTI) (BACAU)"
	,
	"GALBENI (NICOLAE BALCESCU) (BACAU)"
	,
	"GALERI (BACAU)"
	,
	"GARLA ANEI (BACAU)"
	,
	"GARLENI (BACAU)"
	,
	"GARLENII DE SUS (BACAU)"
	,
	"GASTENI (BACAU)"
	,
	"GAZARIE (BACAU)"
	,
	"GHEORGHE DOJA (BACAU)"
	,
	"GHERDANA (BACAU)"
	,
	"GHILAVESTI (BACAU)"
	,
	"GHIMES (BACAU)"
	,
	"GHIMES-FAGET (BACAU)"
	,
	"GHIONOAIA (BACAU)"
	,
	"GIOSENI (BACAU)"
	,
	"GIURGENI (BACAU)"
	,
	"GIURGIOANA (BACAU)"
	,
	"GLAVANESTI (BACAU)"
	,
	"GLODISOARELE (BACAU)"
	,
	"GODINESTII DE JOS (BACAU)"
	,
	"GODINESTII DE SUS (BACAU)"
	,
	"GOIOASA (BACAU)"
	,
	"GORGHESTI (BACAU)"
	,
	"GRADESTI (BACAU)"
	,
	"GRIGORENI (BACAU)"
	,
	"GURA CRAIESTI (BACAU)"
	,
	"GURA VAII (BACAU)"
	,
	"GURA VAII (RACOVA) (BACAU)"
	,
	"GUTINAS (BACAU)"
	,
	"HAGHIAC (DOFTEANA) (BACAU)"
	,
	"HAGHIAC (RACHITOASA) (BACAU)"
	,
	"HAINEALA (BACAU)"
	,
	"HALMACIOAIA (BACAU)"
	,
	"HANGANESTI (BACAU)"
	,
	"HANTA (BACAU)"
	,
	"HARJA (BACAU)"
	,
	"HARLESTI (BACAU)"
	,
	"HELEGIU (BACAU)"
	,
	"HELTIU (BACAU)"
	,
	"HEMEIUS (BACAU)"
	,
	"HERTIOANA DE JOS (BACAU)"
	,
	"HERTIOANA-RAZESI (BACAU)"
	,
	"HOLT (BACAU)"
	,
	"HORGESTI (BACAU)"
	,
	"HURUIESTI (BACAU)"
	,
	"HUTU (BACAU)"
	,
	"IAZ (BACAU)"
	,
	"ILIESI (BACAU)"
	,
	"ITCANI (BACAU)"
	,
	"ITESTI (BACAU)"
	,
	"IZVORU BERHECIULUI (BACAU)"
	,
	"LAPOS (BACAU)"
	,
	"LARGA (BACAU)"
	,
	"LARGUTA (BACAU)"
	,
	"LEHANCEA (BACAU)"
	,
	"LEONTINESTI (BACAU)"
	,
	"LESPEZI (BACAU)"
	,
	"LETEA VECHE (BACAU)"
	,
	"LICHITISENI (BACAU)"
	,
	"LILIECI (BACAU)"
	,
	"LIPOVA (BACAU)"
	,
	"LIVEZI (BACAU)"
	,
	"LUDASI (BACAU)"
	,
	"LUIZI-CALUGARA (BACAU)"
	,
	"LUNCA ASAU (BACAU)"
	,
	"LUNCA DOCHIEI (BACAU)"
	,
	"LUNCANI (BACAU)"
	,
	"LUPESTI (BACAU)"
	,
	"MAGAZIA (BACAU)"
	,
	"MAGIRESTI (BACAU)"
	,
	"MAGLA (BACAU)"
	,
	"MAGURA (BACAU)"
	,
	"MALOSU (BACAU)"
	,
	"MANASTIREA CASIN (BACAU)"
	,
	"MARASCU (BACAU)"
	,
	"MARASTI (BACAU)"
	,
	"MARCESTI (BACAU)"
	,
	"MARGINEA (BUHUSI) (BACAU)"
	,
	"MARGINEA (OITUZ) (BACAU)"
	,
	"MARGINENI (BACAU)"
	,
	"MARVILA (BACAU)"
	,
	"MATEIESTI (BACAU)"
	,
	"MEDELENI (BACAU)"
	,
	"MILESTII DE JOS (BACAU)"
	,
	"MILESTII DE SUS (BACAU)"
	,
	"MISIHANESTI (BACAU)"
	,
	"MOINESTI (BACAU)"
	,
	"MOTOC (BACAU)"
	,
	"MOTOCESTI (BACAU)"
	,
	"MOTOSENI (BACAU)"
	,
	"MOVILITA (BACAU)"
	,
	"MUNCELU (BACAU)"
	,
	"NADISA (BACAU)"
	,
	"NANESTI (BACAU)"
	,
	"NASTASENI (BACAU)"
	,
	"NAZARIOAIA (BACAU)"
	,
	"NEGOIESTI (BACAU)"
	,
	"NEGRENI (BACAU)"
	,
	"NEGRI (BACAU)"
	,
	"NEGULESTI (BACAU)"
	,
	"NEGUSENI (BACAU)"
	,
	"NICOLAE BALCESCU (BACAU)"
	,
	"NICORESTI (BACAU)"
	,
	"OBARSIA (BACAU)"
	,
	"OCHENI (BACAU)"
	,
	"ODOBESTI (BACAU)"
	,
	"OITUZ (BACAU)"
	,
	"ONCESTI (BACAU)"
	,
	"ONCESTII VECHI (BACAU)"
	,
	"ONESTI (BACAU)"
	,
	"ONISCANI (BACAU)"
	,
	"OPRISESTI (BACAU)"
	,
	"ORASA (BACAU)"
	,
	"ORBENI (BACAU)"
	,
	"OSEBITI (BACAU)"
	,
	"OTELESTI (BACAU)"
	,
	"PADURENI (BERESTI-BISTRITA) (BACAU)"
	,
	"PADURENI (DAMIENESTI) (BACAU)"
	,
	"PADURENI (FILIPENI) (BACAU)"
	,
	"PADURENI (IZVORU BERHECIULUI) (BACAU)"
	,
	"PADURENI (MARGINENI) (BACAU)"
	,
	"PAGUBENI (BACAU)"
	,
	"PAJISTEA (BACAU)"
	,
	"PALANCA (BACAU)"
	,
	"PALTINATA (BACAU)"
	,
	"PALTINIS (BACAU)"
	,
	"PANCESTI (BACAU)"
	,
	"PARAU BOGHII (BACAU)"
	,
	"PARAVA (BACAU)"
	,
	"PARGARESTI (BACAU)"
	,
	"PARINCEA (BACAU)"
	,
	"PARJOL (BACAU)"
	,
	"PARVULESTI (BACAU)"
	,
	"PERCHIU (BACAU)"
	,
	"PETRESTI (BACAU)"
	,
	"PETRICICA (BACAU)"
	,
	"PLOPANA (BACAU)"
	,
	"PLOPU (DARMANESTI) (BACAU)"
	,
	"PLOPU (PODU TURCULUI) (BACAU)"
	,
	"PODEI (BACAU)"
	,
	"PODIS (BACAU)"
	,
	"PODU TURCULUI (BACAU)"
	,
	"PODURI (BACAU)"
	,
	"POGLET (BACAU)"
	,
	"POIANA (COLONESTI) (BACAU)"
	,
	"POIANA (LIVEZI) (BACAU)"
	,
	"POIANA (MARGINENI) (BACAU)"
	,
	"POIANA (MOTOSENI) (BACAU)"
	,
	"POIANA (NEGRI) (BACAU)"
	,
	"POIANA NEGUSTORULUI (BACAU)"
	,
	"POIANA SARATA (BACAU)"
	,
	"POIENI (PARINCEA) (BACAU)"
	,
	"POIENI (ROSIORI) (BACAU)"
	,
	"POIENI (TARGU OCNA) (BACAU)"
	,
	"POPENI (BACAU)"
	,
	"POPESTI (BACAU)"
	,
	"POPOIU (BACAU)"
	,
	"PRADAIS (BACAU)"
	,
	"PRAJA (BACAU)"
	,
	"PRAJESTI (MAGIRESTI) (BACAU)"
	,
	"PRAJESTI (TRAIAN) (BACAU)"
	,
	"PRAJOAIA (BACAU)"
	,
	"PRALEA (BACAU)"
	,
	"PRELUCI (BACAU)"
	,
	"PRISACA (BACAU)"
	,
	"PROHOZESTI (BACAU)"
	,
	"PUSTIANA (BACAU)"
	,
	"PUTINI (BACAU)"
	,
	"PUTREDENI (BACAU)"
	,
	"RACACIUNI (BACAU)"
	,
	"RACATAU DE JOS (BACAU)"
	,
	"RACATAU-RAZESI (BACAU)"
	,
	"RACAUTI (BACAU)"
	,
	"RACHITIS (BACAU)"
	,
	"RACHITISU (BACAU)"
	,
	"RACHITOASA (BACAU)"
	,
	"RACOVA (BACAU)"
	,
	"RACUSANA (BACAU)"
	,
	"RADEANA (BACAU)"
	,
	"RADOAIA (BACAU)"
	,
	"RADOMIRESTI (BACAU)"
	,
	"RASTOACA (BACAU)"
	,
	"RAZESU (BACAU)"
	,
	"RECEA (BACAU)"
	,
	"REPRIVAT (BACAU)"
	,
	"ROGOAZA (BACAU)"
	,
	"ROMANESTI (BACAU)"
	,
	"ROSIORI (BACAU)"
	,
	"ROTARIA (BACAU)"
	,
	"RUNCU (BACAU)"
	,
	"RUSENII DE SUS (BACAU)"
	,
	"RUSENII RAZESI (BACAU)"
	,
	"RUSI-CIUTEA (BACAU)"
	,
	"SALATRUC (BACAU)"
	,
	"SANDULENI (BACAU)"
	,
	"SARATA (NICOLAE BALCESCU) (BACAU)"
	,
	"SARATA (SOLONT) (BACAU)"
	,
	"SARBI (BACAU)"
	,
	"SASCUT (BACAU)"
	,
	"SASCUT-SAT (BACAU)"
	,
	"SATU NOU (COLONESTI) (BACAU)"
	,
	"SATU NOU (LIPOVA) (BACAU)"
	,
	"SATU NOU (ONCESTI) (BACAU)"
	,
	"SATU NOU (PARGARESTI) (BACAU)"
	,
	"SATU NOU (PARINCEA) (BACAU)"
	,
	"SATU NOU (URECHESTI) (BACAU)"
	,
	"SAUCESTI (BACAU)"
	,
	"SCARIGA (BACAU)"
	,
	"SCARISOARA (BACAU)"
	,
	"SCHINENI (SASCUT) (BACAU)"
	,
	"SCHINENI (SAUCESTI) (BACAU)"
	,
	"SCHITU FRUMOASA (BACAU)"
	,
	"SCORTENI (BACAU)"
	,
	"SCURTA (BACAU)"
	,
	"SCUTARU (BACAU)"
	,
	"SEACA (BACAU)"
	,
	"SECUIENI (BACAU)"
	,
	"SENDRESTI (BACAU)"
	,
	"SERBESTI (BACAU)"
	,
	"SERPENI (BACAU)"
	,
	"SESURI (BACAU)"
	,
	"SIRETU (LETEA VECHE) (BACAU)"
	,
	"SIRETU (SAUCESTI) (BACAU)"
	,
	"SLANIC-MOLDOVA (BACAU)"
	,
	"SLOBOZIA (FILIPENI) (BACAU)"
	,
	"SLOBOZIA (ONESTI) (BACAU)"
	,
	"SLOBOZIA (STANISESTI) (BACAU)"
	,
	"SLOBOZIA (URECHESTI) (BACAU)"
	,
	"SLOBOZIA NOUA (BACAU)"
	,
	"SOCI (BACAU)"
	,
	"SOHODOL (BACAU)"
	,
	"SOHODOR (BACAU)"
	,
	"SOLONT (BACAU)"
	,
	"SOMUSCA (BACAU)"
	,
	"SPRIA (BACAU)"
	,
	"STANESTI (BACAU)"
	,
	"STANISESTI (BACAU)"
	,
	"STEFAN CEL MARE (BACAU)"
	,
	"STEFAN VODA (BACAU)"
	,
	"STEJARU (BACAU)"
	,
	"STRAJA (BACAU)"
	,
	"STRAMINOASA (BACAU)"
	,
	"STRUGARI (BACAU)"
	,
	"STUFU (BACAU)"
	,
	"SULTA (BACAU)"
	,
	"SURINA (BACAU)"
	,
	"TAGARA (BACAU)"
	,
	"TAMASI (BACAU)"
	,
	"TAMASOAIA (BACAU)"
	,
	"TARATA (BACAU)"
	,
	"TARDENII MARI (BACAU)"
	,
	"TARGU OCNA (BACAU)"
	,
	"TARGU TROTUS (BACAU)"
	,
	"TARHAUSI (BACAU)"
	,
	"TARNITA (BACAU)"
	,
	"TATARASTI (BACAU)"
	,
	"TAULA (BACAU)"
	,
	"TAVADARESTI (BACAU)"
	,
	"TEIUS (BACAU)"
	,
	"TEMELIA (BACAU)"
	,
	"TEPOAIA (BACAU)"
	,
	"TESCANI (BACAU)"
	,
	"TIGANESTI (BACAU)"
	,
	"TISA (BACAU)"
	,
	"TISA-SILVESTRI (BACAU)"
	,
	"TOCHILEA (BACAU)"
	,
	"TOMOZIA (BACAU)"
	,
	"TRAIAN (BACAU)"
	,
	"TREBES (BACAU)"
	,
	"TURLUIANU (BACAU)"
	,
	"TUTA (BACAU)"
	,
	"UNGURENI (BACAU)"
	,
	"UNGURENI (TATARASTI) (BACAU)"
	,
	"URECHESTI (BACAU)"
	,
	"URSOAIA (BACAU)"
	,
	"VALCELE (CORBASCA) (BACAU)"
	,
	"VALCELE (TARGU OCNA) (BACAU)"
	,
	"VALEA ARINILOR (BACAU)"
	,
	"VALEA BOTULUI (BACAU)"
	,
	"VALEA BUDULUI (BACAU)"
	,
	"VALEA CASELOR (BACAU)"
	,
	"VALEA FANATULUI (BACAU)"
	,
	"VALEA HOGEI (BACAU)"
	,
	"VALEA LUI ION (BACAU)"
	,
	"VALEA LUPULUI (BACAU)"
	,
	"VALEA MARE (COLONESTI) (BACAU)"
	,
	"VALEA MARE (ROSIORI) (BACAU)"
	,
	"VALEA MARULUI (BACAU)"
	,
	"VALEA MERILOR (BACAU)"
	,
	"VALEA MICA (CLEJA) (BACAU)"
	,
	"VALEA MICA (ROSIORI) (BACAU)"
	,
	"VALEA MOSNEAGULUI (BACAU)"
	,
	"VALEA NACULUI (BACAU)"
	,
	"VALEA SALCIEI (BACAU)"
	,
	"VALEA SEACA (BACAU)"
	,
	"VALEA SEACA (NICOLAE BALCESCU) (BACAU)"
	,
	"VALEA SOSII (BACAU)"
	,
	"VALENI (PARINCEA) (BACAU)"
	,
	"VALENI (SECUIENI) (BACAU)"
	,
	"VALENI (STANISESTI) (BACAU)"
	,
	"VERMESTI (BACAU)"
	,
	"VERSESTI (BACAU)"
	,
	"VIFORENI (BACAU)"
	,
	"VIISOARA (STEFAN CEL MARE) (BACAU)"
	,
	"VIISOARA (TARGU TROTUS) (BACAU)"
	,
	"VLADNIC (BACAU)"
	,
	"VRANCENI (BACAU)"
	,
	"VULTURENI (BACAU)"
	,
	"ZAPODIA (COLONESTI) (BACAU)"
	,
	"ZAPODIA (TRAIAN) (BACAU)"
	,
	"ZEMES (BACAU)"
	,
	"ZLATARI (BACAU)"
	,
	"ABRAM (BIHOR)"
	,
	"ABRAMUT (BIHOR)"
	,
	"ADONI (BIHOR)"
	,
	"ALBESTI (BIHOR)"
	,
	"ALBIS (BIHOR)"
	,
	"ALESD (BIHOR)"
	,
	"ALMASU MARE (BIHOR)"
	,
	"ALMASU MIC (BALC) (BIHOR)"
	,
	"ALMASU MIC (SARBI) (BIHOR)"
	,
	"ALPAREA (BIHOR)"
	,
	"ANT (BIHOR)"
	,
	"APATEU (BIHOR)"
	,
	"ARPASEL (BIHOR)"
	,
	"ASTILEU (BIHOR)"
	,
	"ATEAS (BIHOR)"
	,
	"AUSEU (BIHOR)"
	,
	"AVRAM IANCU (BIHOR)"
	,
	"BAILE 1 MAI (BIHOR)"
	,
	"BAILE FELIX (BIHOR)"
	,
	"BAITA (BIHOR)"
	,
	"BAITA-PLAI (BIHOR)"
	,
	"BALAIA (BIHOR)"
	,
	"BALC (BIHOR)"
	,
	"BALENI (BIHOR)"
	,
	"BALNACA (BIHOR)"
	,
	"BALNACA-GROSI (BIHOR)"
	,
	"BARAJ LESU (BIHOR)"
	,
	"BATAR (BIHOR)"
	,
	"BEIUS (BIHOR)"
	,
	"BEIUSELE (BIHOR)"
	,
	"BELEJENI (BIHOR)"
	,
	"BELFIR (BIHOR)"
	,
	"BERECHIU (BIHOR)"
	,
	"BETFIA (BIHOR)"
	,
	"BEZNEA (BIHOR)"
	,
	"BICACEL (BIHOR)"
	,
	"BICACI (BIHOR)"
	,
	"BIHARIA (BIHOR)"
	,
	"BIRTIN (BIHOR)"
	,
	"BISTRA (BIHOR)"
	,
	"BOGEI (BIHOR)"
	,
	"BOIANU MARE (BIHOR)"
	,
	"BOIU (BIHOR)"
	,
	"BOROD (BIHOR)"
	,
	"BOROZEL (BIHOR)"
	,
	"BORS (BIHOR)"
	,
	"BORSA (BIHOR)"
	,
	"BORUMLACA (BIHOR)"
	,
	"BORZ (BIHOR)"
	,
	"BOTEAN (BIHOR)"
	,
	"BRADET (BIHOR)"
	,
	"BRATCA (BIHOR)"
	,
	"BRATESTI (BIHOR)"
	,
	"BRIHENI (BIHOR)"
	,
	"BRUSTURI (BIHOR)"
	,
	"BRUSTURI (FINIS) (BIHOR)"
	,
	"BUCIUM (BIHOR)"
	,
	"BUCUROAIA (BIHOR)"
	,
	"BUDOI (BIHOR)"
	,
	"BUDUREASA (BIHOR)"
	,
	"BUDUSLAU (BIHOR)"
	,
	"BULZ (BIHOR)"
	,
	"BUNTESTI (BIHOR)"
	,
	"BURDA (BIHOR)"
	,
	"BURZUC (BIHOR)"
	,
	"BUTANI (BIHOR)"
	,
	"CABESTI (BIHOR)"
	,
	"CACUCIU NOU (BIHOR)"
	,
	"CACUCIU VECHI (BIHOR)"
	,
	"CADEA (BIHOR)"
	,
	"CALACEA (BIHOR)"
	,
	"CALATANI (BIHOR)"
	,
	"CALATEA (BIHOR)"
	,
	"CALEA MARE (BIHOR)"
	,
	"CALUGARI (BIHOR)"
	,
	"CAMP (BIHOR)"
	,
	"CAMPANI (BIHOR)"
	,
	"CAMPANI DE POMEZEU (BIHOR)"
	,
	"CAMP-MOTI (BIHOR)"
	,
	"CAPALNA (BIHOR)"
	,
	"CARANDENI (BIHOR)"
	,
	"CARANZEL (BIHOR)"
	,
	"CARASAU (BIHOR)"
	,
	"CARPINET (BIHOR)"
	,
	"CAUACEU (BIHOR)"
	,
	"CAUASD (BIHOR)"
	,
	"CEFA (BIHOR)"
	,
	"CEICA (BIHOR)"
	,
	"CEISOARA (BIHOR)"
	,
	"CENALOS (BIHOR)"
	,
	"CETARIU (BIHOR)"
	,
	"CETEA (BIHOR)"
	,
	"CHERECHIU (BIHOR)"
	,
	"CHERESIG (BIHOR)"
	,
	"CHERIU (BIHOR)"
	,
	"CHESA (BIHOR)"
	,
	"CHESEREU (BIHOR)"
	,
	"CHET (BIHOR)"
	,
	"CHIJIC (BIHOR)"
	,
	"CHIOAG (BIHOR)"
	,
	"CHIRALEU (BIHOR)"
	,
	"CHIRIBIS (BIHOR)"
	,
	"CHISCAU (BIHOR)"
	,
	"CHISIRID (BIHOR)"
	,
	"CHISLAZ (BIHOR)"
	,
	"CHISTAG (BIHOR)"
	,
	"CIHEI (BIHOR)"
	,
	"CIOCAIA (BIHOR)"
	,
	"CIUHOI (BIHOR)"
	,
	"CIULESTI (BIHOR)"
	,
	"CIUMEGHIU (BIHOR)"
	,
	"CIUTELEC (BIHOR)"
	,
	"COCIUBA MARE (BIHOR)"
	,
	"COCIUBA MICA (BIHOR)"
	,
	"CODRISORU (BIHOR)"
	,
	"CODRU (BIHOR)"
	,
	"COHANI (BIHOR)"
	,
	"COLESTI (BIHOR)"
	,
	"COPACEL (BIHOR)"
	,
	"COPACENI (BIHOR)"
	,
	"CORBESTI (BIHOR)"
	,
	"CORBOAIA (BIHOR)"
	,
	"CORDAU (BIHOR)"
	,
	"CORNISESTI (BIHOR)"
	,
	"CORNITEL (BIHOR)"
	,
	"COSDENI (BIHOR)"
	,
	"COTIGLET (BIHOR)"
	,
	"CRANCESTI (BIHOR)"
	,
	"CRESTUR (BIHOR)"
	,
	"CRESUIA (BIHOR)"
	,
	"CRISTIORU DE JOS (BIHOR)"
	,
	"CRISTIORU DE SUS (BIHOR)"
	,
	"CUBULCUT (BIHOR)"
	,
	"CUCUCENI (BIHOR)"
	,
	"CUIESD (BIHOR)"
	,
	"CURATELE (BIHOR)"
	,
	"CURTUISENI (BIHOR)"
	,
	"CUSUIUS (BIHOR)"
	,
	"CUZAP (BIHOR)"
	,
	"DAMIS (BIHOR)"
	,
	"DELANI (BIHOR)"
	,
	"DERNA (BIHOR)"
	,
	"DERNISOARA (BIHOR)"
	,
	"DICANESTI (BIHOR)"
	,
	"DIJIR (BIHOR)"
	,
	"DIOSIG (BIHOR)"
	,
	"DOBRESTI (BIHOR)"
	,
	"DOBRICIONESTI (BIHOR)"
	,
	"DOLEA (BIHOR)"
	,
	"DRAGANESTI (BIHOR)"
	,
	"DRAGESTI (BIHOR)"
	,
	"DRAGOTENI (BIHOR)"
	,
	"DUMBRAVA (BIHOR)"
	,
	"DUMBRAVANI (BIHOR)"
	,
	"DUMBRAVITA (BIHOR)"
	,
	"DUMBRAVITA DE CODRU (BIHOR)"
	,
	"DUSESTI (BIHOR)"
	,
	"FANATE (BIHOR)"
	,
	"FANCICA (BIHOR)"
	,
	"FASCA (BIHOR)"
	,
	"FEGERNIC (BIHOR)"
	,
	"FEGERNICU NOU (BIHOR)"
	,
	"FELCHERIU (BIHOR)"
	,
	"FENERIS (BIHOR)"
	,
	"FERICE (BIHOR)"
	,
	"FINIS (BIHOR)"
	,
	"FIZIS (BIHOR)"
	,
	"FOGLAS (BIHOR)"
	,
	"FONAU (BIHOR)"
	,
	"FORAU (BIHOR)"
	,
	"FOROSIG (BIHOR)"
	,
	"FUGHIU (BIHOR)"
	,
	"GALASENI (BIHOR)"
	,
	"GALOSPETREU (BIHOR)"
	,
	"GEPIS (BIHOR)"
	,
	"GEPIU (BIHOR)"
	,
	"GHEGHIE (BIHOR)"
	,
	"GHENETEA (BIHOR)"
	,
	"GHIDA (BIHOR)"
	,
	"GHIGHISENI (BIHOR)"
	,
	"GHIORAC (BIHOR)"
	,
	"GINTA (BIHOR)"
	,
	"GIRISU DE CRIS (BIHOR)"
	,
	"GIRISU NEGRU (BIHOR)"
	,
	"GIULESTI (BIHOR)"
	,
	"GOILA (BIHOR)"
	,
	"GRADINARI (BIHOR)"
	,
	"GROSI (BIHOR)"
	,
	"GRUILUNG (BIHOR)"
	,
	"GURANI (BIHOR)"
	,
	"GURBEDIU (BIHOR)"
	,
	"GURBESTI (CABESTI) (BIHOR)"
	,
	"GURBESTI (SPINUS) (BIHOR)"
	,
	"HAIEU (BIHOR)"
	,
	"HARSESTI (BIHOR)"
	,
	"HAUCESTI (BIHOR)"
	,
	"HIDIS (BIHOR)"
	,
	"HIDISEL (BIHOR)"
	,
	"HIDISELU DE JOS (BIHOR)"
	,
	"HIDISELU DE SUS (BIHOR)"
	,
	"HINCHIRIS (BIHOR)"
	,
	"HODIS (BIHOR)"
	,
	"HODISEL (BIHOR)"
	,
	"HODOS (BIHOR)"
	,
	"HOLOD (BIHOR)"
	,
	"HOMOROG (BIHOR)"
	,
	"HOTAR (BIHOR)"
	,
	"HOTAREL (BIHOR)"
	,
	"HUSASAU DE CRIS (BIHOR)"
	,
	"HUSASAU DE TINCA (BIHOR)"
	,
	"HUTA (BIHOR)"
	,
	"HUTA VOIVOZI (BIHOR)"
	,
	"IANCA (BIHOR)"
	,
	"IANOSDA (BIHOR)"
	,
	"INAND (BIHOR)"
	,
	"INCESTI (BIHOR)"
	,
	"INEU (BIHOR)"
	,
	"IOANIS (BIHOR)"
	,
	"ITEU (BIHOR)"
	,
	"ITEU NOU (BIHOR)"
	,
	"IZBUC (BIHOR)"
	,
	"IZVOARELE (BIHOR)"
	,
	"JOSANI (CABESTI) (BIHOR)"
	,
	"JOSANI (MAGESTI) (BIHOR)"
	,
	"LACU SARAT (BIHOR)"
	,
	"LAZARENI (BIHOR)"
	,
	"LAZURI (BIHOR)"
	,
	"LAZURI DE BEIUS (BIHOR)"
	,
	"LEHECENI (BIHOR)"
	,
	"LELESTI (BIHOR)"
	,
	"LES (BIHOR)"
	,
	"LIVADA BEIUSULUI (BIHOR)"
	,
	"LIVADA DE BIHOR (BIHOR)"
	,
	"LORANTA (BIHOR)"
	,
	"LORAU (BIHOR)"
	,
	"LUGASU DE JOS (BIHOR)"
	,
	"LUGASU DE SUS (BIHOR)"
	,
	"LUNCA (BIHOR)"
	,
	"LUNCASPRIE (BIHOR)"
	,
	"LUNCSOARA (BIHOR)"
	,
	"LUPOAIA (BIHOR)"
	,
	"MADARAS (BIHOR)"
	,
	"MAGESTI (BIHOR)"
	,
	"MAGURA (BIHOR)"
	,
	"MARGHITA (BIHOR)"
	,
	"MARGINE (BIHOR)"
	,
	"MARTIHAZ (BIHOR)"
	,
	"MEZIAD (BIHOR)"
	,
	"MIERAG (BIHOR)"
	,
	"MIERLAU (BIHOR)"
	,
	"MIERSIG (BIHOR)"
	,
	"MIHAI BRAVU (BIHOR)"
	,
	"MIHELEU (BIHOR)"
	,
	"MISCA (BIHOR)"
	,
	"MIZIES (BIHOR)"
	,
	"MOTESTI (BIHOR)"
	,
	"MUNTENI (BIHOR)"
	,
	"NADAR (BIHOR)"
	,
	"NIMAIESTI (BIHOR)"
	,
	"NIUVED (BIHOR)"
	,
	"NOJORID (BIHOR)"
	,
	"NUCET (BIHOR)"
	,
	"OGESTI (BIHOR)"
	,
	"OLCEA (BIHOR)"
	,
	"OLOSIG (BIHOR)"
	,
	"ORADEA (BIHOR)"
	,
	"ORTITEAG (BIHOR)"
	,
	"ORVISELE (BIHOR)"
	,
	"OSAND (BIHOR)"
	,
	"OSORHEI (BIHOR)"
	,
	"OTOMANI (BIHOR)"
	,
	"PADUREA NEAGRA (BIHOR)"
	,
	"PADURENI (BIHOR)"
	,
	"PAGAIA (BIHOR)"
	,
	"PALEU (BIHOR)"
	,
	"PALOTA (BIHOR)"
	,
	"PANTASESTI (BIHOR)"
	,
	"PARHIDA (BIHOR)"
	,
	"PAULESTI (BIHOR)"
	,
	"PAUSA (BIHOR)"
	,
	"PESTERE (BIHOR)"
	,
	"PESTIS (BIHOR)"
	,
	"PETID (BIHOR)"
	,
	"PETRANI (BIHOR)"
	,
	"PETREASA (BIHOR)"
	,
	"PETREU (BIHOR)"
	,
	"PETRILENI (BIHOR)"
	,
	"PICLEU (BIHOR)"
	,
	"PIETROASA (BIHOR)"
	,
	"POCIOVELISTE (BIHOR)"
	,
	"POCLUSA DE BARCAU (BIHOR)"
	,
	"POCLUSA DE BEIUS (BIHOR)"
	,
	"POCOLA (BIHOR)"
	,
	"POIANA (CRISTIORU DE JOS) (BIHOR)"
	,
	"POIANA (TAUTEU) (BIHOR)"
	,
	"POIANA TASAD (BIHOR)"
	,
	"POIENII DE JOS (BIHOR)"
	,
	"POIENII DE SUS (BIHOR)"
	,
	"POIETARI (BIHOR)"
	,
	"POMEZEU (BIHOR)"
	,
	"PONOARA (BIHOR)"
	,
	"POPESTI (BIHOR)"
	,
	"POSOLOACA (BIHOR)"
	,
	"PRISACA (BIHOR)"
	,
	"RABAGANI (BIHOR)"
	,
	"RACAS (BIHOR)"
	,
	"RAPA (BIHOR)"
	,
	"REGHEA (BIHOR)"
	,
	"REMETEA (BIHOR)"
	,
	"REMETI (BIHOR)"
	,
	"RIENI (BIHOR)"
	,
	"ROGOZ (BIHOR)"
	,
	"ROHANI (BIHOR)"
	,
	"ROIT (BIHOR)"
	,
	"RONTAU (BIHOR)"
	,
	"ROSIA (BIHOR)"
	,
	"ROSIORI (BIHOR)"
	,
	"ROTARESTI (BIHOR)"
	,
	"RUGEA (BIHOR)"
	,
	"SABOLCIU (BIHOR)"
	,
	"SACA (BIHOR)"
	,
	"SACADAT (BIHOR)"
	,
	"SACALASAU (BIHOR)"
	,
	"SACALASAU NOU (BIHOR)"
	,
	"SACUENI (BIHOR)"
	,
	"SALACEA (BIHOR)"
	,
	"SALARD (BIHOR)"
	,
	"SALDABAGIU DE BARCAU (BIHOR)"
	,
	"SALDABAGIU DE MUNTE (BIHOR)"
	,
	"SALDABAGIU MIC (BIHOR)"
	,
	"SALISTE (BIHOR)"
	,
	"SALISTE DE BEIUS (BIHOR)"
	,
	"SALISTE DE POMEZEU (BIHOR)"
	,
	"SALISTE DE VASCAU (BIHOR)"
	,
	"SALONTA (BIHOR)"
	,
	"SAMBATA (BIHOR)"
	,
	"SANIOB (BIHOR)"
	,
	"SANLAZAR (BIHOR)"
	,
	"SANMARTIN (BIHOR)"
	,
	"SANMARTIN DE BEIUS (BIHOR)"
	,
	"SANNICOLAU DE BEIUS (BIHOR)"
	,
	"SANNICOLAU DE MUNTE (BIHOR)"
	,
	"SANNICOLAU ROMAN (BIHOR)"
	,
	"SANTANDREI (BIHOR)"
	,
	"SANTAUL MARE (BIHOR)"
	,
	"SANTAUL MIC (BIHOR)"
	,
	"SANTELEC (BIHOR)"
	,
	"SANTIMREU (BIHOR)"
	,
	"SANTION (BIHOR)"
	,
	"SARAND (BIHOR)"
	,
	"SARBESTI (BIHOR)"
	,
	"SARBI (BIHOR)"
	,
	"SARCAU (BIHOR)"
	,
	"SARSIG (BIHOR)"
	,
	"SATU BARBA (BIHOR)"
	,
	"SATU NOU (BIHOR)"
	,
	"SAUAIEU (BIHOR)"
	,
	"SAUCANI (BIHOR)"
	,
	"SAUD (BIHOR)"
	,
	"SEBIS (BIHOR)"
	,
	"SEGHISTE (BIHOR)"
	,
	"SERANI (BIHOR)"
	,
	"SERGHIS (BIHOR)"
	,
	"SFARNAS (BIHOR)"
	,
	"SIGHISTEL (BIHOR)"
	,
	"SILINDRU (BIHOR)"
	,
	"SIMIAN (BIHOR)"
	,
	"SINTEU (BIHOR)"
	,
	"SISTEREA (BIHOR)"
	,
	"SITANI (BIHOR)"
	,
	"SITITELEC (BIHOR)"
	,
	"SOCET (BIHOR)"
	,
	"SOHODOL (BIHOR)"
	,
	"SOIMI (BIHOR)"
	,
	"SOIMUS (BIHOR)"
	,
	"SPINUS (BIHOR)"
	,
	"SPINUS DE POMEZEU (BIHOR)"
	,
	"STANCESTI (BIHOR)"
	,
	"STEI (BIHOR)"
	,
	"STRACOS (BIHOR)"
	,
	"SUBPIATRA (BIHOR)"
	,
	"SUDRIGIU (BIHOR)"
	,
	"SUIUG (BIHOR)"
	,
	"SUMUGIU (BIHOR)"
	,
	"SUNCUIS (BIHOR)"
	,
	"SUNCUIUS (BIHOR)"
	,
	"SUPLACU DE BARCAU (BIHOR)"
	,
	"SUPLACU DE TINCA (BIHOR)"
	,
	"SURDUC (BIHOR)"
	,
	"SURDUCEL (BIHOR)"
	,
	"SUSTIU (BIHOR)"
	,
	"SUSTUROGI (BIHOR)"
	,
	"TALPE (BIHOR)"
	,
	"TALPOS (BIHOR)"
	,
	"TAMASDA (BIHOR)"
	,
	"TAMASEU (BIHOR)"
	,
	"TARCAIA (BIHOR)"
	,
	"TARCAITA (BIHOR)"
	,
	"TARCEA (BIHOR)"
	,
	"TARGUSOR (BIHOR)"
	,
	"TARIAN (BIHOR)"
	,
	"TASAD (BIHOR)"
	,
	"TAUT (BIHOR)"
	,
	"TAUTELEC (BIHOR)"
	,
	"TAUTEU (BIHOR)"
	,
	"TELEAC (BIHOR)"
	,
	"TELECHIU (BIHOR)"
	,
	"TETCHEA (BIHOR)"
	,
	"TIGANESTII DE BEIUS (BIHOR)"
	,
	"TIGANESTII DE CRIS (BIHOR)"
	,
	"TILEAGD (BIHOR)"
	,
	"TILECUS (BIHOR)"
	,
	"TINAUD (BIHOR)"
	,
	"TINCA (BIHOR)"
	,
	"TOBOLIU (BIHOR)"
	,
	"TOMNATIC (BIHOR)"
	,
	"TOPA DE CRIS (BIHOR)"
	,
	"TOPA DE JOS (BIHOR)"
	,
	"TOPA DE SUS (BIHOR)"
	,
	"TOPESTI (BIHOR)"
	,
	"TOTORENI (BIHOR)"
	,
	"TRIA (BIHOR)"
	,
	"TULCA (BIHOR)"
	,
	"UCURIS (BIHOR)"
	,
	"UILEACU DE BEIUS (BIHOR)"
	,
	"UILEACU DE CRIS (BIHOR)"
	,
	"UILEACU DE MUNTE (BIHOR)"
	,
	"URSAD (BIHOR)"
	,
	"URVIND (BIHOR)"
	,
	"URVIS DE BEIUS (BIHOR)"
	,
	"VADU CRISULUI (BIHOR)"
	,
	"VAIDA (BIHOR)"
	,
	"VALANI DE POMEZEU (BIHOR)"
	,
	"VALANII DE BEIUS (BIHOR)"
	,
	"VALCELELE (BIHOR)"
	,
	"VALEA CERULUI (BIHOR)"
	,
	"VALEA CRISULUI (BIHOR)"
	,
	"VALEA DE JOS (BIHOR)"
	,
	"VALEA DE SUS (BIHOR)"
	,
	"VALEA IADULUI (BIHOR)"
	,
	"VALEA LUI MIHAI (BIHOR)"
	,
	"VALEA MARE DE CODRU (BIHOR)"
	,
	"VALEA MARE DE CRIS (BIHOR)"
	,
	"VALEA TARNEI (BIHOR)"
	,
	"VARASAU (BIHOR)"
	,
	"VARASENI (BIHOR)"
	,
	"VARCIOROG (BIHOR)"
	,
	"VARVIZ (BIHOR)"
	,
	"VARZARI (BIHOR)"
	,
	"VARZARII DE JOS (BIHOR)"
	,
	"VARZARII DE SUS (BIHOR)"
	,
	"VASAD (BIHOR)"
	,
	"VASCAU (BIHOR)"
	,
	"VIISOARA (BIHOR)"
	,
	"VINTERE (BIHOR)"
	,
	"VOIVOZI (POPESTI) (BIHOR)"
	,
	"VOIVOZI (SIMIAN) (BIHOR)"
	,
	"ZAVOIU (BIHOR)"
	,
	"ZECE HOTARE (BIHOR)"
	,
	"AGRIES (BISTRITA NASAUD)"
	,
	"AGRIESEL (BISTRITA NASAUD)"
	,
	"AGRISU DE JOS (BISTRITA NASAUD)"
	,
	"AGRISU DE SUS (BISTRITA NASAUD)"
	,
	"ALBESTII BISTRITEI (BISTRITA NASAUD)"
	,
	"ALUNISUL (BISTRITA NASAUD)"
	,
	"ANIES (BISTRITA NASAUD)"
	,
	"APATIU (BISTRITA NASAUD)"
	,
	"ARCALIA (BISTRITA NASAUD)"
	,
	"ARCHIUD (BISTRITA NASAUD)"
	,
	"ARDAN (BISTRITA NASAUD)"
	,
	"ARSITA (BISTRITA NASAUD)"
	,
	"BARLA (BISTRITA NASAUD)"
	,
	"BATA (BISTRITA NASAUD)"
	,
	"BECLEAN (BISTRITA NASAUD)"
	,
	"BEUDIU (BISTRITA NASAUD)"
	,
	"BICHIGIU (BISTRITA NASAUD)"
	,
	"BIDIU (BISTRITA NASAUD)"
	,
	"BISTRITA BARGAULUI (BISTRITA NASAUD)"
	,
	"BISTRITA BARGAULUI FABRICI (BISTRITA NASAUD)"
	,
	"BLAJENII DE JOS (BISTRITA NASAUD)"
	,
	"BLAJENII DE SUS (BISTRITA NASAUD)"
	,
	"BORLEASA (BISTRITA NASAUD)"
	,
	"BOZIES (BISTRITA NASAUD)"
	,
	"BRANISTEA (BISTRITA NASAUD)"
	,
	"BRATENI (BISTRITA NASAUD)"
	,
	"BREAZA (BISTRITA NASAUD)"
	,
	"BRETEA (BISTRITA NASAUD)"
	,
	"BUDACU DE JOS (BISTRITA NASAUD)"
	,
	"BUDACU DE SUS (BISTRITA NASAUD)"
	,
	"BUDESTI (BISTRITA NASAUD)"
	,
	"BUDESTI-FANATE (BISTRITA NASAUD)"
	,
	"BUDURLENI (BISTRITA NASAUD)"
	,
	"BUDUS (BISTRITA NASAUD)"
	,
	"BUNGARD (BISTRITA NASAUD)"
	,
	"BUZA CATUN (BISTRITA NASAUD)"
	,
	"CAIANU MARE (BISTRITA NASAUD)"
	,
	"CAIANU MIC (BISTRITA NASAUD)"
	,
	"CAILA (BISTRITA NASAUD)"
	,
	"CAMP (BISTRITA NASAUD)"
	,
	"CEPARI (BISTRITA NASAUD)"
	,
	"CETATE (BISTRITA NASAUD)"
	,
	"CHETIU (BISTRITA NASAUD)"
	,
	"CHINTELNIC (BISTRITA NASAUD)"
	,
	"CHIOCHIS (BISTRITA NASAUD)"
	,
	"CHIRALES (BISTRITA NASAUD)"
	,
	"CHIUZA (BISTRITA NASAUD)"
	,
	"CICEU-CORABIA (BISTRITA NASAUD)"
	,
	"CICEU-GIURGESTI (BISTRITA NASAUD)"
	,
	"CICEU-MIHAIESTI (BISTRITA NASAUD)"
	,
	"CICEU-POIENI (BISTRITA NASAUD)"
	,
	"CIOSA (BISTRITA NASAUD)"
	,
	"CIREASI (BISTRITA NASAUD)"
	,
	"CIRESOAIA (BISTRITA NASAUD)"
	,
	"COASTA (BISTRITA NASAUD)"
	,
	"COCIU (BISTRITA NASAUD)"
	,
	"COLDAU (BISTRITA NASAUD)"
	,
	"COLIBITA (BISTRITA NASAUD)"
	,
	"COMLOD (BISTRITA NASAUD)"
	,
	"CORMAIA (BISTRITA NASAUD)"
	,
	"CORVINESTI (BISTRITA NASAUD)"
	,
	"COSBUC (BISTRITA NASAUD)"
	,
	"COSERIU (BISTRITA NASAUD)"
	,
	"CRAINIMAT (BISTRITA NASAUD)"
	,
	"CRISTESTII CICEULUI (BISTRITA NASAUD)"
	,
	"CRISTUR-SIEU (BISTRITA NASAUD)"
	,
	"CUSMA (BISTRITA NASAUD)"
	,
	"DEALU STEFANITEI (BISTRITA NASAUD)"
	,
	"DELURENI (BISTRITA NASAUD)"
	,
	"DIPSA (BISTRITA NASAUD)"
	,
	"DOBRIC (BISTRITA NASAUD)"
	,
	"DOBRICEL (BISTRITA NASAUD)"
	,
	"DOMNESTI (BISTRITA NASAUD)"
	,
	"DOROLEA (BISTRITA NASAUD)"
	,
	"DRAGA (BISTRITA NASAUD)"
	,
	"DUMBRAVA (LIVEZILE) (BISTRITA NASAUD)"
	,
	"DUMBRAVA (NUSENI) (BISTRITA NASAUD)"
	,
	"DUMBRAVENI (BISTRITA NASAUD)"
	,
	"DUMBRAVITA (BISTRITA NASAUD)"
	,
	"DUMITRA (BISTRITA NASAUD)"
	,
	"DUMITRITA (BISTRITA NASAUD)"
	,
	"DUPA DEAL (BISTRITA NASAUD)"
	,
	"ENCIU (BISTRITA NASAUD)"
	,
	"FANATE (BISTRITA NASAUD)"
	,
	"FANATELE SILIVASULUI (BISTRITA NASAUD)"
	,
	"FANTANELE (BISTRITA NASAUD)"
	,
	"FANTANITA (BISTRITA NASAUD)"
	,
	"FELDRU (BISTRITA NASAUD)"
	,
	"FELEAC (BISTRITA NASAUD)"
	,
	"FIAD (BISTRITA NASAUD)"
	,
	"FIGA (BISTRITA NASAUD)"
	,
	"FLORESTI (BISTRITA NASAUD)"
	,
	"GALATII BISTRITEI (BISTRITA NASAUD)"
	,
	"GERSA I (BISTRITA NASAUD)"
	,
	"GERSA II (BISTRITA NASAUD)"
	,
	"GHEMES (BISTRITA NASAUD)"
	,
	"GHINDA (BISTRITA NASAUD)"
	,
	"GLEDIN (BISTRITA NASAUD)"
	,
	"HALMASAU (BISTRITA NASAUD)"
	,
	"HASMASU CICEULUI (BISTRITA NASAUD)"
	,
	"HERINA (BISTRITA NASAUD)"
	,
	"HIREAN (BISTRITA NASAUD)"
	,
	"ILISUA (BISTRITA NASAUD)"
	,
	"ILVA MARE (BISTRITA NASAUD)"
	,
	"ILVA MICA (BISTRITA NASAUD)"
	,
	"IVANEASA (BISTRITA NASAUD)"
	,
	"JEICA (BISTRITA NASAUD)"
	,
	"JELNA (BISTRITA NASAUD)"
	,
	"JIMBOR (BISTRITA NASAUD)"
	,
	"JOSENII BARGAULUI (BISTRITA NASAUD)"
	,
	"LA CURTE (BISTRITA NASAUD)"
	,
	"LECHINTA (BISTRITA NASAUD)"
	,
	"LELESTI (BISTRITA NASAUD)"
	,
	"LESU (BISTRITA NASAUD)"
	,
	"LIVEZILE (BISTRITA NASAUD)"
	,
	"LIVIU REBREANU (BISTRITA NASAUD)"
	,
	"LUNCA (BISTRITA NASAUD)"
	,
	"LUNCA BORLESEI (BISTRITA NASAUD)"
	,
	"LUNCA ILVEI (BISTRITA NASAUD)"
	,
	"LUNCA LESULUI (BISTRITA NASAUD)"
	,
	"LUNCA SATEASCA (BISTRITA NASAUD)"
	,
	"LUSCA (BISTRITA NASAUD)"
	,
	"MAGURA ILVEI (BISTRITA NASAUD)"
	,
	"MAGURELE (BISTRITA NASAUD)"
	,
	"MAIERU (BISTRITA NASAUD)"
	,
	"MALIN (BISTRITA NASAUD)"
	,
	"MALUT (BISTRITA NASAUD)"
	,
	"MANIC (BISTRITA NASAUD)"
	,
	"MARISELU (BISTRITA NASAUD)"
	,
	"MATEI (BISTRITA NASAUD)"
	,
	"MICESTII DE CAMPIE (BISTRITA NASAUD)"
	,
	"MIJLOCENII BARGAULUI (BISTRITA NASAUD)"
	,
	"MILAS (BISTRITA NASAUD)"
	,
	"MINTIU (BISTRITA NASAUD)"
	,
	"MIRES (BISTRITA NASAUD)"
	,
	"MITITEI (BISTRITA NASAUD)"
	,
	"MOCOD (BISTRITA NASAUD)"
	,
	"MOGOSENI (BISTRITA NASAUD)"
	,
	"MOLISET (BISTRITA NASAUD)"
	,
	"MONARIU (BISTRITA NASAUD)"
	,
	"MONOR (BISTRITA NASAUD)"
	,
	"MORUT (BISTRITA NASAUD)"
	,
	"MURESENII BARGAULUI (BISTRITA NASAUD)"
	,
	"NASAUD (BISTRITA NASAUD)"
	,
	"NEGRILESTI (BISTRITA NASAUD)"
	,
	"NEPOS (BISTRITA NASAUD)"
	,
	"NETENI (BISTRITA NASAUD)"
	,
	"NIMIGEA (BISTRITA NASAUD)"
	,
	"NIMIGEA DE JOS (BISTRITA NASAUD)"
	,
	"NIMIGEA DE SUS (BISTRITA NASAUD)"
	,
	"NUSENI (BISTRITA NASAUD)"
	,
	"OARZINA (BISTRITA NASAUD)"
	,
	"OCNITA (BISTRITA NASAUD)"
	,
	"ORHEIU BISTRITEI (BISTRITA NASAUD)"
	,
	"OROSFAIA (BISTRITA NASAUD)"
	,
	"PALTINEASA (BISTRITA NASAUD)"
	,
	"PARVA (BISTRITA NASAUD)"
	,
	"PERISOR (BISTRITA NASAUD)"
	,
	"PETRIS (BISTRITA NASAUD)"
	,
	"PETRU RARES (BISTRITA NASAUD)"
	,
	"PIATRA (BISTRITA NASAUD)"
	,
	"PIATRA FANTANELE (BISTRITA NASAUD)"
	,
	"PINTICU (BISTRITA NASAUD)"
	,
	"PODENII (BISTRITA NASAUD)"
	,
	"PODEREI (BISTRITA NASAUD)"
	,
	"PODIREI (BISTRITA NASAUD)"
	,
	"POIANA ILVEI (BISTRITA NASAUD)"
	,
	"POIENILE ZAGREI (BISTRITA NASAUD)"
	,
	"PORUMBENII (BISTRITA NASAUD)"
	,
	"POSMUS (BISTRITA NASAUD)"
	,
	"PRUNDU BARGAULUI (BISTRITA NASAUD)"
	,
	"PURCARETE (BISTRITA NASAUD)"
	,
	"RACATESU (BISTRITA NASAUD)"
	,
	"RAGLA (BISTRITA NASAUD)"
	,
	"REBRA (BISTRITA NASAUD)"
	,
	"REBRISOARA (BISTRITA NASAUD)"
	,
	"RETEAG (BISTRITA NASAUD)"
	,
	"RODNA (BISTRITA NASAUD)"
	,
	"ROMULI (BISTRITA NASAUD)"
	,
	"RUNCU SALVEI (BISTRITA NASAUD)"
	,
	"RUSTIOR (BISTRITA NASAUD)"
	,
	"RUSU BARGAULUI (BISTRITA NASAUD)"
	,
	"RUSU DE JOS (BISTRITA NASAUD)"
	,
	"RUSU DE SUS (BISTRITA NASAUD)"
	,
	"SALCUTA (BISTRITA NASAUD)"
	,
	"SALVA (BISTRITA NASAUD)"
	,
	"SANGEORZ-BAI (BISTRITA NASAUD)"
	,
	"SANGEORZU NOU (BISTRITA NASAUD)"
	,
	"SANIACOB (BISTRITA NASAUD)"
	,
	"SANMIHAIU DE CAMPIE (BISTRITA NASAUD)"
	,
	"SANNICOARA (BISTRITA NASAUD)"
	,
	"SANT (BISTRITA NASAUD)"
	,
	"SANTIOANA (BISTRITA NASAUD)"
	,
	"SARATA (BISTRITA NASAUD)"
	,
	"SARATEL (BISTRITA NASAUD)"
	,
	"SASARM (BISTRITA NASAUD)"
	,
	"SATU NOU (BISTRITA NASAUD)"
	,
	"SCOABE (BISTRITA NASAUD)"
	,
	"SEBIS (BISTRITA NASAUD)"
	,
	"SENDROAIA (BISTRITA NASAUD)"
	,
	"SESURI SPERMEZEU-VALE (BISTRITA NASAUD)"
	,
	"SIEU (BISTRITA NASAUD)"
	,
	"SIEU-MAGHERUS (BISTRITA NASAUD)"
	,
	"SIEU-ODORHEI (BISTRITA NASAUD)"
	,
	"SIEU-SFANTU (BISTRITA NASAUD)"
	,
	"SIEUT (BISTRITA NASAUD)"
	,
	"SIGMIR (BISTRITA NASAUD)"
	,
	"SILIVASU DE CAMPIE (BISTRITA NASAUD)"
	,
	"SIMIONESTI (BISTRITA NASAUD)"
	,
	"SINTEREAG (BISTRITA NASAUD)"
	,
	"SINTEREAG-GARA (BISTRITA NASAUD)"
	,
	"SIRIOARA (BISTRITA NASAUD)"
	,
	"SITA (BISTRITA NASAUD)"
	,
	"SLATINITA (BISTRITA NASAUD)"
	,
	"SOIMUS (BISTRITA NASAUD)"
	,
	"SOPTERIU (BISTRITA NASAUD)"
	,
	"SPERMEZEU (BISTRITA NASAUD)"
	,
	"STRAMBA (BISTRITA NASAUD)"
	,
	"STRUGURENI (BISTRITA NASAUD)"
	,
	"STUPINI (BISTRITA NASAUD)"
	,
	"SUPLAI (BISTRITA NASAUD)"
	,
	"SUSENII BARGAULUI (BISTRITA NASAUD)"
	,
	"TAGSORU (BISTRITA NASAUD)"
	,
	"TAGU (BISTRITA NASAUD)"
	,
	"TARLISUA (BISTRITA NASAUD)"
	,
	"TARPIU (BISTRITA NASAUD)"
	,
	"TAURE (BISTRITA NASAUD)"
	,
	"TEACA (BISTRITA NASAUD)"
	,
	"TELCISOR (BISTRITA NASAUD)"
	,
	"TELCIU (BISTRITA NASAUD)"
	,
	"TENTEA (BISTRITA NASAUD)"
	,
	"TIGAU (BISTRITA NASAUD)"
	,
	"TIHA BARGAULUI (BISTRITA NASAUD)"
	,
	"TONCIU (BISTRITA NASAUD)"
	,
	"TUREAC (BISTRITA NASAUD)"
	,
	"UNIREA (BISTRITA NASAUD)"
	,
	"URIU (BISTRITA NASAUD)"
	,
	"URMENIS (BISTRITA NASAUD)"
	,
	"VALEA (BISTRITA NASAUD)"
	,
	"VALEA BORCUTULUI (BISTRITA NASAUD)"
	,
	"VALEA MAGHERUSULUI (BISTRITA NASAUD)"
	,
	"VALEA MARE (SANT) (BISTRITA NASAUD)"
	,
	"VALEA MARE (URMENIS) (BISTRITA NASAUD)"
	,
	"VALEA POENII (BISTRITA NASAUD)"
	,
	"VALEA VINULUI (BISTRITA NASAUD)"
	,
	"VERMES (BISTRITA NASAUD)"
	,
	"VIILE TECII (BISTRITA NASAUD)"
	,
	"VIISOARA (BISTRITA NASAUD)"
	,
	"VISUIA (BISTRITA NASAUD)"
	,
	"VITA (BISTRITA NASAUD)"
	,
	"ZAGRA (BISTRITA NASAUD)"
	,
	"ZORENI (BISTRITA NASAUD)"
	,
	"ADASENI (BOTOSANI)"
	,
	"AGAFTON (BOTOSANI)"
	,
	"ALBA (BOTOSANI)"
	,
	"ALBESTI (BOTOSANI)"
	,
	"ARBOREA (BOTOSANI)"
	,
	"AUREL VLAICU (BOTOSANI)"
	,
	"AVRAM IANCU (BOTOSANI)"
	,
	"AVRAMENI (BOTOSANI)"
	,
	"BABICENI (BOTOSANI)"
	,
	"BADARAI (BOTOSANI)"
	,
	"BADIUTI (BOTOSANI)"
	,
	"BAICENI (BOTOSANI)"
	,
	"BAISA (BOTOSANI)"
	,
	"BAJURA (BOTOSANI)"
	,
	"BALINTI (BOTOSANI)"
	,
	"BALTA ARSA (BOTOSANI)"
	,
	"BALUSENI (BOTOSANI)"
	,
	"BALUSENII NOI (BOTOSANI)"
	,
	"BARANCA (CRISTINESTI) (BOTOSANI)"
	,
	"BARANCA (HUDESTI) (BOTOSANI)"
	,
	"BARSANESTI (BOTOSANI)"
	,
	"BATRANESTI (BOTOSANI)"
	,
	"BELCEA (BOTOSANI)"
	,
	"BERZA (BOTOSANI)"
	,
	"BIVOLARI (BOTOSANI)"
	,
	"BLANDESTI (BOTOSANI)"
	,
	"BOBULESTI (BOTOSANI)"
	,
	"BODEASA (BOTOSANI)"
	,
	"BOGDANESTI (BOTOSANI)"
	,
	"BOHOGHINA (BOTOSANI)"
	,
	"BOLD (BOTOSANI)"
	,
	"BOROLEA (BOTOSANI)"
	,
	"BORZESTI (BOTOSANI)"
	,
	"BOSCOTENI (BOTOSANI)"
	,
	"BOTOSANI (BOTOSANI)"
	,
	"BOZIENI (BOTOSANI)"
	,
	"BRAESTI (BOTOSANI)"
	,
	"BRATENI (BOTOSANI)"
	,
	"BREHUIESTI (BOTOSANI)"
	,
	"BROSCAUTI (BOTOSANI)"
	,
	"BROSTENI (BOTOSANI)"
	,
	"BUCECEA (BOTOSANI)"
	,
	"BUDA (BOTOSANI)"
	,
	"BUHACENI (BOTOSANI)"
	,
	"BUIMACENI (BOTOSANI)"
	,
	"BURLA (BOTOSANI)"
	,
	"BURLESTI (BOTOSANI)"
	,
	"BUZENI (BOTOSANI)"
	,
	"CALARASI (BOTOSANI)"
	,
	"CALINESTI (BUCECEA) (BOTOSANI)"
	,
	"CALINESTI (MIHAILENI) (BOTOSANI)"
	,
	"CALUGARENI (BOTOSANI)"
	,
	"CALUGARENII NOI (BOTOSANI)"
	,
	"CAMPENI (BOTOSANI)"
	,
	"CANDESTI (BOTOSANI)"
	,
	"CARAIMAN (BOTOSANI)"
	,
	"CARASA (BOTOSANI)"
	,
	"CATAMARESTI (BOTOSANI)"
	,
	"CATAMARESTI-DEAL (BOTOSANI)"
	,
	"CERBU (BOTOSANI)"
	,
	"CERCHEJENI (BOTOSANI)"
	,
	"CERNESTI (BOTOSANI)"
	,
	"CERVICESTI (BOTOSANI)"
	,
	"CERVICESTI-DEAL (BOTOSANI)"
	,
	"CHELIS (BOTOSANI)"
	,
	"CHISCARENI (BOTOSANI)"
	,
	"CHITOVENI (BOTOSANI)"
	,
	"CINGHINIIA (BOTOSANI)"
	,
	"CIRITEI (BOTOSANI)"
	,
	"CISMANESTI (BOTOSANI)"
	,
	"CISMEA (BOTOSANI)"
	,
	"CODRENI (BOTOSANI)"
	,
	"CONCESTI (BOTOSANI)"
	,
	"COPALAU (BOTOSANI)"
	,
	"CORDARENI (BOTOSANI)"
	,
	"CORJAUTI (BOTOSANI)"
	,
	"CORLATENI (BOTOSANI)"
	,
	"CORNI (BOTOSANI)"
	,
	"COSTESTI (BOTOSANI)"
	,
	"COSTINESTI (BOTOSANI)"
	,
	"COSTIUGENI (BOTOSANI)"
	,
	"COSULA (BOTOSANI)"
	,
	"COSULENI (BOTOSANI)"
	,
	"COTARGACI (BOTOSANI)"
	,
	"COTU (BOTOSANI)"
	,
	"COTU MICULINTI (BOTOSANI)"
	,
	"COTUSCA (BOTOSANI)"
	,
	"CRASNALEUCA (BOTOSANI)"
	,
	"CRISTESTI (BOTOSANI)"
	,
	"CRISTINESTI (BOTOSANI)"
	,
	"CUCORANI (BOTOSANI)"
	,
	"CUCUTENI (BOTOSANI)"
	,
	"CURTESTI (BOTOSANI)"
	,
	"CUZA VODA (BOTOSANI)"
	,
	"CUZLAU (BOTOSANI)"
	,
	"DACIA (BOTOSANI)"
	,
	"DAMIDENI (BOTOSANI)"
	,
	"DANGENI (BOTOSANI)"
	,
	"DARABANI (BOTOSANI)"
	,
	"DAVIDOAIA (BOTOSANI)"
	,
	"DEALU CRUCII (BOTOSANI)"
	,
	"DEALU MARE (BOTOSANI)"
	,
	"DERSCA (BOTOSANI)"
	,
	"DIMACHENI (BOTOSANI)"
	,
	"DIMITRIE CANTEMIR (BOTOSANI)"
	,
	"DOBARCENI (BOTOSANI)"
	,
	"DOINA (BOTOSANI)"
	,
	"DOLINA (BOTOSANI)"
	,
	"DOROBANTI (BOTOSANI)"
	,
	"DOROHOI (BOTOSANI)"
	,
	"DRACSANI (BOTOSANI)"
	,
	"DRAGALINA (CRISTINESTI) (BOTOSANI)"
	,
	"DRAGALINA (HLIPICENI) (BOTOSANI)"
	,
	"DRAGUSENI (BOTOSANI)"
	,
	"DRAXINI (BOTOSANI)"
	,
	"DRISLEA (BOTOSANI)"
	,
	"DUMBRAVITA (BOTOSANI)"
	,
	"DUMENI (BOTOSANI)"
	,
	"DURNESTI (BOTOSANI)"
	,
	"DURNESTI (SANTA MARE) (BOTOSANI)"
	,
	"DURNESTI (UNGURENI) (BOTOSANI)"
	,
	"ESANCA (BOTOSANI)"
	,
	"FLAMANZI (BOTOSANI)"
	,
	"FLONDORA (BOTOSANI)"
	,
	"FLORESTI (BOTOSANI)"
	,
	"FRUMUSICA (BOTOSANI)"
	,
	"FUNDU HERTII (BOTOSANI)"
	,
	"GALBENI (BOTOSANI)"
	,
	"GARBENI (BOTOSANI)"
	,
	"GARBESTI (BOTOSANI)"
	,
	"GEORGE COSBUC (BOTOSANI)"
	,
	"GEORGE ENESCU (BOTOSANI)"
	,
	"GHIRENI (BOTOSANI)"
	,
	"GORBANESTI (BOTOSANI)"
	,
	"GOROVEI (BOTOSANI)"
	,
	"GRIVITA (BOTOSANI)"
	,
	"GURANDA (BOTOSANI)"
	,
	"HANESTI (BOTOSANI)"
	,
	"HAVARNA (BOTOSANI)"
	,
	"HILISEU-CLOSCA (BOTOSANI)"
	,
	"HILISEU-CRISAN (BOTOSANI)"
	,
	"HILISEU-HORIA (BOTOSANI)"
	,
	"HLIPICENI (BOTOSANI)"
	,
	"HORIA (BOTOSANI)"
	,
	"HORLACENI (BOTOSANI)"
	,
	"HORODISTEA (BOTOSANI)"
	,
	"HRISCANI (BOTOSANI)"
	,
	"HUDESTI (BOTOSANI)"
	,
	"HUDUM (BOTOSANI)"
	,
	"HULUB (BOTOSANI)"
	,
	"HULUBESTI (BOTOSANI)"
	,
	"HUTANI (BOTOSANI)"
	,
	"IACOBENI (BOTOSANI)"
	,
	"IBANEASA (BOTOSANI)"
	,
	"IBANESTI (BOTOSANI)"
	,
	"ICHIMENI (BOTOSANI)"
	,
	"ICUSENI (BOTOSANI)"
	,
	"IEZER (BOTOSANI)"
	,
	"ILISENI (BOTOSANI)"
	,
	"IONASENI (TRUSESTI) (BOTOSANI)"
	,
	"IONASENI (VARFU CAMPULUI) (BOTOSANI)"
	,
	"IORGA (BOTOSANI)"
	,
	"IPOTESTI (BOTOSANI)"
	,
	"IURESTI (BOTOSANI)"
	,
	"IZVOARE (BOTOSANI)"
	,
	"JIJIA (BOTOSANI)"
	,
	"JOLDESTI (BOTOSANI)"
	,
	"LEHNESTI (BOTOSANI)"
	,
	"LEORDA (BOTOSANI)"
	,
	"LIBERTATEA (BOTOSANI)"
	,
	"LISMANITA (BOTOSANI)"
	,
	"LISNA (BOTOSANI)"
	,
	"LIVADA (BOTOSANI)"
	,
	"LIVENI (BOTOSANI)"
	,
	"LOTURI (BOTOSANI)"
	,
	"LOTURI ENESCU (BOTOSANI)"
	,
	"LOZNA (BOTOSANI)"
	,
	"LUNCA (BOTOSANI)"
	,
	"LUNCA (VARFU CAMPULUI) (BOTOSANI)"
	,
	"LUPARIA (BOTOSANI)"
	,
	"MANASTIREA DOAMNEI (BOTOSANI)"
	,
	"MANASTIRENI (BOTOSANI)"
	,
	"MANDRESTI (UNGURENI) (BOTOSANI)"
	,
	"MANDRESTI (VLADENI) (BOTOSANI)"
	,
	"MANOLEASA (BOTOSANI)"
	,
	"MANOLEASA-PRUT (BOTOSANI)"
	,
	"MANOLESTI (BOTOSANI)"
	,
	"MASCATENI (BOTOSANI)"
	,
	"MATEIENI (BOTOSANI)"
	,
	"MESTEACAN (BOTOSANI)"
	,
	"MIHAI EMINESCU (BOTOSANI)"
	,
	"MIHAI EMINESCU (GORBANESTI) (BOTOSANI)"
	,
	"MIHAI VITEAZU (BOTOSANI)"
	,
	"MIHAIL KOGALNICEANU (BOTOSANI)"
	,
	"MIHAILENI (BOTOSANI)"
	,
	"MIHALASENI (BOTOSANI)"
	,
	"MILEANCA (BOTOSANI)"
	,
	"MILETIN (BOTOSANI)"
	,
	"MIORCANI (BOTOSANI)"
	,
	"MIRON COSTIN (BOTOSANI)"
	,
	"MITOC (BOTOSANI)"
	,
	"MITOC (LEORDA) (BOTOSANI)"
	,
	"MLENAUTI (BOTOSANI)"
	,
	"MOARA JORII (BOTOSANI)"
	,
	"MOVILA RUPTA (BOTOSANI)"
	,
	"MOVILENI (BOTOSANI)"
	,
	"MURGUTA (BOTOSANI)"
	,
	"NASTASE (BOTOSANI)"
	,
	"NEGRENI (BOTOSANI)"
	,
	"NEGRESTI (BOTOSANI)"
	,
	"NICHITENI (BOTOSANI)"
	,
	"NICOLAE BALCESCU (COTUSCA) (BOTOSANI)"
	,
	"NICOLAE BALCESCU (FLAMANZI) (BOTOSANI)"
	,
	"NICSENI (BOTOSANI)"
	,
	"NICULCEA (BOTOSANI)"
	,
	"ONEAGA (BOTOSANI)"
	,
	"ORASENI-DEAL (BOTOSANI)"
	,
	"ORASENI-VALE (BOTOSANI)"
	,
	"OROFTIANA (BOTOSANI)"
	,
	"PADURENI (COPALAU) (BOTOSANI)"
	,
	"PADURENI (SENDRICENI) (BOTOSANI)"
	,
	"PALTINIS (BOTOSANI)"
	,
	"PANAITOAIA (BOTOSANI)"
	,
	"PARAU NEGRU (BOTOSANI)"
	,
	"PASATENI (BOTOSANI)"
	,
	"PAUN (BOTOSANI)"
	,
	"PETRICANI (BOTOSANI)"
	,
	"PLESANI (BOTOSANI)"
	,
	"PLEVNA (BOTOSANI)"
	,
	"PLOPENII MARI (BOTOSANI)"
	,
	"PLOPENII MICI (BOTOSANI)"
	,
	"PODENI (BOTOSANI)"
	,
	"PODRIGA (BOTOSANI)"
	,
	"POGORASTI (BOTOSANI)"
	,
	"POIANA (BRAESTI) (BOTOSANI)"
	,
	"POIANA (CRISTINESTI) (BOTOSANI)"
	,
	"POIANA (FLAMANZI) (BOTOSANI)"
	,
	"POIANA (VORONA) (BOTOSANI)"
	,
	"POMARLA (BOTOSANI)"
	,
	"POPENI (BRAESTI) (BOTOSANI)"
	,
	"POPENI (GEORGE ENESCU) (BOTOSANI)"
	,
	"POPOAIA (BOTOSANI)"
	,
	"PRAJENI (BOTOSANI)"
	,
	"PRISACANI (BOTOSANI)"
	,
	"PROGRESUL (BOTOSANI)"
	,
	"PUTURENI (BOTOSANI)"
	,
	"RACHITI (BOTOSANI)"
	,
	"RACOVAT (BOTOSANI)"
	,
	"RADAUTI-PRUT (BOTOSANI)"
	,
	"RADENI (BOTOSANI)"
	,
	"RANGHILESTI (BOTOSANI)"
	,
	"RANGHILESTI-DEAL (BOTOSANI)"
	,
	"RASCA (BOTOSANI)"
	,
	"RAUSENI (BOTOSANI)"
	,
	"RECIA-VERBIA (BOTOSANI)"
	,
	"REDIU (RADAUTI-PRUT) (BOTOSANI)"
	,
	"REDIU (RAUSENI) (BOTOSANI)"
	,
	"RIPICENI (BOTOSANI)"
	,
	"RIPICENII VECHI (BOTOSANI)"
	,
	"ROGOJESTI (BOTOSANI)"
	,
	"ROMA (BOTOSANI)"
	,
	"ROMANESTI (BOTOSANI)"
	,
	"ROMANESTI-VALE (BOTOSANI)"
	,
	"ROSIORI (BOTOSANI)"
	,
	"SADOVENI (BOTOSANI)"
	,
	"SANTA MARE (BOTOSANI)"
	,
	"SARAFINESTI (BOTOSANI)"
	,
	"SARATA (BOTOSANI)"
	,
	"SARATA-BASARAB (BOTOSANI)"
	,
	"SARATA-DRAGUSENI (BOTOSANI)"
	,
	"SARBI (BOTOSANI)"
	,
	"SAT NOU (BOTOSANI)"
	,
	"SAUCENITA (BOTOSANI)"
	,
	"SAVENI (BOTOSANI)"
	,
	"SCHIT-ORASENI (BOTOSANI)"
	,
	"SCUTARI (BOTOSANI)"
	,
	"SELISTEA (BOTOSANI)"
	,
	"SENDRENI (BOTOSANI)"
	,
	"SENDRICENI (BOTOSANI)"
	,
	"SERPENITA (BOTOSANI)"
	,
	"SILISCANI (BOTOSANI)"
	,
	"SILISTEA (BOTOSANI)"
	,
	"SLOBOZIA (BROSCAUTI) (BOTOSANI)"
	,
	"SLOBOZIA (PALTINIS) (BOTOSANI)"
	,
	"SLOBOZIA HANESTI (BOTOSANI)"
	,
	"SLOBOZIA SILISCANI (BOTOSANI)"
	,
	"SMARDAN (BOTOSANI)"
	,
	"SOCRUJENI (BOTOSANI)"
	,
	"SOLDANESTI (BOTOSANI)"
	,
	"SOROCENI (BOTOSANI)"
	,
	"STANCA (GEORGE ENESCU) (BOTOSANI)"
	,
	"STANCA (STEFANESTI) (BOTOSANI)"
	,
	"STANCESTI (BOTOSANI)"
	,
	"STAUCENI (BOTOSANI)"
	,
	"STEFANESTI (BOTOSANI)"
	,
	"STEFANESTI-SAT (BOTOSANI)"
	,
	"STIUBIENI (BOTOSANI)"
	,
	"STOLNICENI (BOTOSANI)"
	,
	"STORESTI (BOTOSANI)"
	,
	"STRAHOTIN (BOTOSANI)"
	,
	"STRATENI (BOTOSANI)"
	,
	"STROIESTI (BOTOSANI)"
	,
	"SUHARAU (BOTOSANI)"
	,
	"SULITA (BOTOSANI)"
	,
	"SUPITCA (BOTOSANI)"
	,
	"TALPA (BOTOSANI)"
	,
	"TATARASENI (BOTOSANI)"
	,
	"TAUTESTI (BOTOSANI)"
	,
	"TIMUS (BOTOSANI)"
	,
	"TOCILENI (BOTOSANI)"
	,
	"TODIRENI (BOTOSANI)"
	,
	"TRUSESTI (BOTOSANI)"
	,
	"TUDOR VLADIMIRESCU (ALBESTI) (BOTOSANI)"
	,
	"TUDOR VLADIMIRESCU (AVRAMENI) (BOTOSANI)"
	,
	"TUDORA (BOTOSANI)"
	,
	"UNGURENI (BOTOSANI)"
	,
	"UNGUROAIA (BOTOSANI)"
	,
	"UNTENI (BOTOSANI)"
	,
	"VACULESTI (BOTOSANI)"
	,
	"VALCELELE (BOTOSANI)"
	,
	"VALEA GRAJDULUI (BOTOSANI)"
	,
	"VANATORI (BOTOSANI)"
	,
	"VARFU CAMPULUI (BOTOSANI)"
	,
	"VICOLENI (BOTOSANI)"
	,
	"VICTORIA (HLIPICENI) (BOTOSANI)"
	,
	"VICTORIA (STAUCENI) (BOTOSANI)"
	,
	"VIFORENI (BOTOSANI)"
	,
	"VIISOARA (BOTOSANI)"
	,
	"VIISOARA MICA (BOTOSANI)"
	,
	"VITCANI (BOTOSANI)"
	,
	"VLADENI (BOTOSANI)"
	,
	"VLADENI (CORLATENI) (BOTOSANI)"
	,
	"VLADENI-DEAL (BOTOSANI)"
	,
	"VLASINESTI (BOTOSANI)"
	,
	"VORNICENI (BOTOSANI)"
	,
	"VORONA (BOTOSANI)"
	,
	"VORONA MARE (BOTOSANI)"
	,
	"VORONA-TEODORU (BOTOSANI)"
	,
	"VULTURENI (BOTOSANI)"
	,
	"ZAHORENI (BOTOSANI)"
	,
	"ZAICESTI (BOTOSANI)"
	,
	"ZLATUNOAIA (BOTOSANI)"
	,
	"ZOITANI (BOTOSANI)"
	,
	"AGAUA (BRAILA)"
	,
	"ALBINA (BRAILA)"
	,
	"ARICIU (BRAILA)"
	,
	"BALDOVINESTI (BRAILA)"
	,
	"BANDOIU (BRAILA)"
	,
	"BARAGANUL (BRAILA)"
	,
	"BATOGU (BRAILA)"
	,
	"BERLESTI (BRAILA)"
	,
	"BERTESTII DE JOS (BRAILA)"
	,
	"BERTESTII DE SUS (BRAILA)"
	,
	"BOARCA (BRAILA)"
	,
	"BORDEI VERDE (BRAILA)"
	,
	"BRADEANCA (BRAILA)"
	,
	"BRAILA (BRAILA)"
	,
	"BRATESU VECHI (BRAILA)"
	,
	"BUMBACARI (BRAILA)"
	,
	"CAINENI-BAI (BRAILA)"
	,
	"CALDARUSA (BRAILA)"
	,
	"CAZASU (BRAILA)"
	,
	"CHICHINETU (BRAILA)"
	,
	"CHIOIBASESTI (BRAILA)"
	,
	"CHISCANI (BRAILA)"
	,
	"CIOCILE (BRAILA)"
	,
	"CIRESU (BRAILA)"
	,
	"CISTIA (BRAILA)"
	,
	"COLTEA (BRAILA)"
	,
	"COMANEASCA (BRAILA)"
	,
	"CONSTANTIN GABRIELESCU (BRAILA)"
	,
	"CONSTANTINESTI (BRAILA)"
	,
	"CORBENI (BRAILA)"
	,
	"CORBU NOU (BRAILA)"
	,
	"CORBU VECHI (BRAILA)"
	,
	"COTU LUNG (BRAILA)"
	,
	"COTU MIHALEA (BRAILA)"
	,
	"CUSTURA (BRAILA)"
	,
	"CUZA VODA (SALCIA TUDOR) (BRAILA)"
	,
	"CUZA VODA (STANCUTA) (BRAILA)"
	,
	"DEDULESTI (BRAILA)"
	,
	"DESIRATI (BRAILA)"
	,
	"DROGU (BRAILA)"
	,
	"DUDESCU (BRAILA)"
	,
	"DUDESTI (BRAILA)"
	,
	"ESNA (BRAILA)"
	,
	"FAUREI (BRAILA)"
	,
	"FAUREI-SAT (BRAILA)"
	,
	"FILIPESTI (BRAILA)"
	,
	"FILIU (BRAILA)"
	,
	"FLORICA (BRAILA)"
	,
	"FRECATEI (BRAILA)"
	,
	"GALBENU (BRAILA)"
	,
	"GARA IANCA (BRAILA)"
	,
	"GAVANI (BRAILA)"
	,
	"GEMENELE (BRAILA)"
	,
	"GRADISTEA (BRAILA)"
	,
	"GROPENI (BRAILA)"
	,
	"GULIANCA (BRAILA)"
	,
	"GURA CALMATUI (BRAILA)"
	,
	"GURA GARLUTEI (BRAILA)"
	,
	"GURGUIETI (BRAILA)"
	,
	"HORIA (BRAILA)"
	,
	"IANCA (BRAILA)"
	,
	"IBRIANU (BRAILA)"
	,
	"INSURATEI (BRAILA)"
	,
	"IONESTI (BRAILA)"
	,
	"JIRLAU (BRAILA)"
	,
	"JUGUREANU (BRAILA)"
	,
	"LACU REZII (BRAILA)"
	,
	"LACU SARAT (BRAILA)"
	,
	"LANURILE (BRAILA)"
	,
	"LATINU (BRAILA)"
	,
	"LISCOTEANCA (BRAILA)"
	,
	"MAGURENI (BRAILA)"
	,
	"MARALOIU (BRAILA)"
	,
	"MARASU (BRAILA)"
	,
	"MARTACESTI (BRAILA)"
	,
	"MARU ROSU (BRAILA)"
	,
	"MAXINENI (BRAILA)"
	,
	"MIHAI BRAVU (BRAILA)"
	,
	"MIHAIL KOGALNICEANU (RAMNICELU) (BRAILA)"
	,
	"MIHAIL KOGALNICEANU (SUTESTI) (BRAILA)"
	,
	"MIRCEA VODA (BRAILA)"
	,
	"MOROTESTI (BRAILA)"
	,
	"MOVILA MIRESII (BRAILA)"
	,
	"MUCHEA (BRAILA)"
	,
	"NEDELCU (BRAILA)"
	,
	"NICOLAE BALCESCU (BRAILA)"
	,
	"NICOLESTI (BRAILA)"
	,
	"OANCEA (BRAILA)"
	,
	"ODAIENI (BRAILA)"
	,
	"OLANEASCA (BRAILA)"
	,
	"OPRISENESTI (BRAILA)"
	,
	"PANTECANI (BRAILA)"
	,
	"PERISORU (BRAILA)"
	,
	"PIETROIU (BRAILA)"
	,
	"PITULATI (BRAILA)"
	,
	"PLASOIU (BRAILA)"
	,
	"PLOPI (BRAILA)"
	,
	"PLOPU (BRAILA)"
	,
	"POLIZESTI (BRAILA)"
	,
	"PRIBEAGU (BRAILA)"
	,
	"RACOVITA (BRAILA)"
	,
	"RAMNICELU (BRAILA)"
	,
	"ROMANU (BRAILA)"
	,
	"ROSIORI (BRAILA)"
	,
	"SALCIA (BRAILA)"
	,
	"SALCIA TUDOR (BRAILA)"
	,
	"SATUC (BRAILA)"
	,
	"SCARLATESTI (BRAILA)"
	,
	"SCORTARU NOU (BRAILA)"
	,
	"SCORTARU VECHI (BRAILA)"
	,
	"SIHLEANU (BRAILA)"
	,
	"SILISTEA (BRAILA)"
	,
	"SILISTRARU (BRAILA)"
	,
	"SPIRU HARET (BRAILA)"
	,
	"STANCA (BRAILA)"
	,
	"STANCUTA (BRAILA)"
	,
	"STOIENESTI (BRAILA)"
	,
	"SURDILA-GAISEANCA (BRAILA)"
	,
	"SURDILA-GRECI (BRAILA)"
	,
	"SUTESTI (BRAILA)"
	,
	"TACAU (BRAILA)"
	,
	"TARLELE FILIU (BRAILA)"
	,
	"TATARU (BRAILA)"
	,
	"TEPES VODA (BRAILA)"
	,
	"TICHILESTI (BRAILA)"
	,
	"TITCOV (BRAILA)"
	,
	"TRAIAN (BRAILA)"
	,
	"TUDOR VLADIMIRESCU (BRAILA)"
	,
	"TUFESTI (BRAILA)"
	,
	"ULMU (BRAILA)"
	,
	"UNIREA (BRAILA)"
	,
	"URLEASCA (BRAILA)"
	,
	"VADENI (BRAILA)"
	,
	"VALEA CALMATUIULUI (BRAILA)"
	,
	"VALEA CANEPII (BRAILA)"
	,
	"VAMESU (BRAILA)"
	,
	"VARSATURA (BRAILA)"
	,
	"VICTORIA (BRAILA)"
	,
	"VISANI (BRAILA)"
	,
	"VIZIRU (BRAILA)"
	,
	"VOINESTI (BRAILA)"
	,
	"VULTURENI (BRAILA)"
	,
	"ZAMFIRESTI (BRAILA)"
	,
	"ZAVOAIA (BRAILA)"
	,
	"ACRIS (BRASOV)"
	,
	"APATA (BRASOV)"
	,
	"ARINI (BRASOV)"
	,
	"AUGUSTIN (BRASOV)"
	,
	"BARCUT (BRASOV)"
	,
	"BECLEAN (BRASOV)"
	,
	"BEIA (BRASOV)"
	,
	"BERIVOI (BRASOV)"
	,
	"BOD (BRASOV)"
	,
	"BOGATA OLTEANA (BRASOV)"
	,
	"BOHOLT (BRASOV)"
	,
	"BRAN (BRASOV)"
	,
	"BRASOV (BRASOV)"
	,
	"BREAZA (BRASOV)"
	,
	"BUCIUM (BRASOV)"
	,
	"BUDILA (BRASOV)"
	,
	"BUNESTI (BRASOV)"
	,
	"BUZAIEL (BRASOV)"
	,
	"CALBOR (BRASOV)"
	,
	"CARPINIS (BRASOV)"
	,
	"CATA (BRASOV)"
	,
	"CHEIA (BRASOV)"
	,
	"CINCSOR (BRASOV)"
	,
	"CINCU (BRASOV)"
	,
	"COBOR (BRASOV)"
	,
	"CODLEA (BRASOV)"
	,
	"COLONIA 1 MAI (BRASOV)"
	,
	"COLONIA BOD (BRASOV)"
	,
	"COLONIA RECONSTRUCTIA (BRASOV)"
	,
	"COMANA (BRASOV)"
	,
	"COMANA DE JOS (BRASOV)"
	,
	"COMANA DE SUS (BRASOV)"
	,
	"COPACEL (BRASOV)"
	,
	"CORBI (BRASOV)"
	,
	"CRIHALMA (BRASOV)"
	,
	"CRISTIAN (BRASOV)"
	,
	"CRIT (BRASOV)"
	,
	"CRIZBAV (BRASOV)"
	,
	"CUCIULATA (BRASOV)"
	,
	"CUTUS (BRASOV)"
	,
	"DACIA (BRASOV)"
	,
	"DAISOARA (BRASOV)"
	,
	"DALGHIU (BRASOV)"
	,
	"DEJANI (BRASOV)"
	,
	"DOPCA (BRASOV)"
	,
	"DRAGUS (BRASOV)"
	,
	"DRAUSENI (BRASOV)"
	,
	"DRIDIF (BRASOV)"
	,
	"DRUMUL CARULUI (BRASOV)"
	,
	"DUMBRAVITA (BRASOV)"
	,
	"FAGARAS (BRASOV)"
	,
	"FANTANA (BRASOV)"
	,
	"FELDIOARA (BRASOV)"
	,
	"FELDIOARA (UCEA) (BRASOV)"
	,
	"FELMER (BRASOV)"
	,
	"FISER (BRASOV)"
	,
	"FUNDATA (BRASOV)"
	,
	"FUNDATICA (BRASOV)"
	,
	"GHIMBAV (BRASOV)"
	,
	"GRANARI (BRASOV)"
	,
	"GRID (BRASOV)"
	,
	"GURA VAII (BRASOV)"
	,
	"HALCHIU (BRASOV)"
	,
	"HALMEAG (BRASOV)"
	,
	"HARMAN (BRASOV)"
	,
	"HARSENI (BRASOV)"
	,
	"HOGHIZ (BRASOV)"
	,
	"HOLBAV (BRASOV)"
	,
	"HOMOROD (BRASOV)"
	,
	"HUREZ (BRASOV)"
	,
	"IASI (BRASOV)"
	,
	"ILENI (BRASOV)"
	,
	"IONESTI (BRASOV)"
	,
	"JIBERT (BRASOV)"
	,
	"JIMBOR (BRASOV)"
	,
	"LISA (BRASOV)"
	,
	"LOVNIC (BRASOV)"
	,
	"LUDISOR (BRASOV)"
	,
	"LUNCA CALNICULUI (BRASOV)"
	,
	"LUPSA (BRASOV)"
	,
	"LUTA (BRASOV)"
	,
	"MAGURA (BRASOV)"
	,
	"MAIERUS (BRASOV)"
	,
	"MALINIS (BRASOV)"
	,
	"MANDRA (BRASOV)"
	,
	"MARGINENI (BRASOV)"
	,
	"MATEIAS (BRASOV)"
	,
	"MERCHEASA (BRASOV)"
	,
	"MESENDORF (BRASOV)"
	,
	"MOIECIU (BRASOV)"
	,
	"MOIECIU DE JOS (BRASOV)"
	,
	"MOIECIU DE SUS (BRASOV)"
	,
	"OHABA (BRASOV)"
	,
	"OLTET (BRASOV)"
	,
	"ORMENIS (BRASOV)"
	,
	"PALOS (BRASOV)"
	,
	"PALTIN (BRASOV)"
	,
	"PARAU (BRASOV)"
	,
	"PARAUL RECE (BRASOV)"
	,
	"PERSANI (BRASOV)"
	,
	"PESTERA (BRASOV)"
	,
	"PODU OLTULUI (BRASOV)"
	,
	"POIANA BRASOV (BRASOV)"
	,
	"POIANA MARULUI (BRASOV)"
	,
	"POJORTA (BRASOV)"
	,
	"PREDEAL (BRASOV)"
	,
	"PREDELUT (BRASOV)"
	,
	"PREJMER (BRASOV)"
	,
	"PURCARENI (BRASOV)"
	,
	"RACOS (BRASOV)"
	,
	"RASNOV (BRASOV)"
	,
	"RASNOV ROMACRIL (BRASOV)"
	,
	"RAUSOR (BRASOV)"
	,
	"RECEA (BRASOV)"
	,
	"ROADES (BRASOV)"
	,
	"RODBAV (BRASOV)"
	,
	"ROTBAV (BRASOV)"
	,
	"RUCAR (BRASOV)"
	,
	"RUPEA (BRASOV)"
	,
	"SACELE (BRASOV)"
	,
	"SAMBATA DE JOS (BRASOV)"
	,
	"SAMBATA DE SUS (BRASOV)"
	,
	"SANPETRU (BRASOV)"
	,
	"SASCIORI (BRASOV)"
	,
	"SATU NOU (BRASOV)"
	,
	"SAVASTRENI (BRASOV)"
	,
	"SEBES (BRASOV)"
	,
	"SELISTAT (BRASOV)"
	,
	"SERCAIA (BRASOV)"
	,
	"SERCAITA (BRASOV)"
	,
	"SIMON (BRASOV)"
	,
	"SINCA (BRASOV)"
	,
	"SINCA NOUA (BRASOV)"
	,
	"SINCA VECHE (BRASOV)"
	,
	"SIRNEA (BRASOV)"
	,
	"SOARS (BRASOV)"
	,
	"SOHODOL (BRASOV)"
	,
	"SONA (BRASOV)"
	,
	"STATIUNEA CLIMATERICA SAMBATA (BRASOV)"
	,
	"STUPINII PREJMERULUI (BRASOV)"
	,
	"TARLUNGENI (BRASOV)"
	,
	"TELIU (BRASOV)"
	,
	"TICUSU (BRASOV)"
	,
	"TICUSU NOU (BRASOV)"
	,
	"TICUSU VECHI (BRASOV)"
	,
	"TIMISU DE JOS (BRASOV)"
	,
	"TIMISU DE SUS (BRASOV)"
	,
	"TOARCLA (BRASOV)"
	,
	"TODERITA (BRASOV)"
	,
	"TOHANU NOU (BRASOV)"
	,
	"UCEA (BRASOV)"
	,
	"UCEA DE JOS (BRASOV)"
	,
	"UCEA DE SUS (BRASOV)"
	,
	"UNGRA (BRASOV)"
	,
	"VAD (BRASOV)"
	,
	"VALCEA (BRASOV)"
	,
	"VALENI (BRASOV)"
	,
	"VAMA BUZAULUI (BRASOV)"
	,
	"VENETIA DE JOS (BRASOV)"
	,
	"VENETIA DE SUS (BRASOV)"
	,
	"VICTORIA (BRASOV)"
	,
	"VISCRI (BRASOV)"
	,
	"VISTEA (BRASOV)"
	,
	"VISTEA DE JOS (BRASOV)"
	,
	"VISTEA DE SUS (BRASOV)"
	,
	"VISTISOARA (BRASOV)"
	,
	"VLADENI (BRASOV)"
	,
	"VOILA (BRASOV)"
	,
	"VOIVODENI (BRASOV)"
	,
	"VULCAN (BRASOV)"
	,
	"ZARNESTI (BRASOV)"
	,
	"ZIZIN (BRASOV)"
	,
	"SECTORUL 2 (BUCURESTI)"
	,
	"SECTORUL 1 (BUCURESTI)"
	,
	"SECTORUL 6 (BUCURESTI)"
	,
	"SECTORUL 5 (BUCURESTI)"
	,
	"SECTORUL 3 (BUCURESTI)"
	,
	"SECTORUL 4 (BUCURESTI)"
	,
	"ALBESTI (BUZAU)"
	,
	"ALDENI (BUZAU)"
	,
	"ALEXANDRU ODOBESCU (BUZAU)"
	,
	"ALICENI (BUZAU)"
	,
	"ALUNIS (BUZAU)"
	,
	"AMARA (BUZAU)"
	,
	"AMARU (BUZAU)"
	,
	"ANINI (BUZAU)"
	,
	"ARBANASI (BUZAU)"
	,
	"ARCANU (BUZAU)"
	,
	"BABENI (BUZAU)"
	,
	"BACENI (BUZAU)"
	,
	"BADENI (BUZAU)"
	,
	"BADILA (BUZAU)"
	,
	"BAESTI (BUZAU)"
	,
	"BAILE (BUZAU)"
	,
	"BAJANI (BUZAU)"
	,
	"BALACEANU (BUZAU)"
	,
	"BALAIA (BUZAU)"
	,
	"BALANESTI (BUZAU)"
	,
	"BALHACU (BUZAU)"
	,
	"BALTA ALBA (BUZAU)"
	,
	"BALTA TOCILA (BUZAU)"
	,
	"BALTAGARI (BUZAU)"
	,
	"BALTARETI (BUZAU)"
	,
	"BALTENI (BUZAU)"
	,
	"BANITA (BUZAU)"
	,
	"BARASTI (BUZAU)"
	,
	"BARBUNCESTI (BUZAU)"
	,
	"BASCA CHIOJDULUI (BUZAU)"
	,
	"BASCA ROZILEI (BUZAU)"
	,
	"BASCENII DE JOS (BUZAU)"
	,
	"BASCENII DE SUS (BUZAU)"
	,
	"BATOGU (BUZAU)"
	,
	"BECENI (BUZAU)"
	,
	"BECIU (BUZAU)"
	,
	"BEGU (BUZAU)"
	,
	"BEILIC (BUZAU)"
	,
	"BENTU (BUZAU)"
	,
	"BERCA (BUZAU)"
	,
	"BERCESTI (BUZAU)"
	,
	"BESLII (BUZAU)"
	,
	"BISOCA (BUZAU)"
	,
	"BLAJANI (BUZAU)"
	,
	"BOBOC (BUZAU)"
	,
	"BODINESTI (BUZAU)"
	,
	"BOLDU (BUZAU)"
	,
	"BORDUSANI (BUZAU)"
	,
	"BOZIORU (BUZAU)"
	,
	"BRADEANCA (BUZAU)"
	,
	"BRADEANU (BUZAU)"
	,
	"BRAESTI (BUZAU)"
	,
	"BRAGAREASA (BUZAU)"
	,
	"BRATILESTI (BUZAU)"
	,
	"BREAZA (BUZAU)"
	,
	"BREBU (BUZAU)"
	,
	"BUDA (BUZAU)"
	,
	"BUDA CRACIUNESTI (BUZAU)"
	,
	"BUDESTI (BUZAU)"
	,
	"BUDISTENI (BUZAU)"
	,
	"BUDREA (BUZAU)"
	,
	"BUDUILE (BUZAU)"
	,
	"BUSTEA (BUZAU)"
	,
	"BUZAU (BUZAU)"
	,
	"C.A. ROSETTI (BUZAU)"
	,
	"CALDARASTI (BUZAU)"
	,
	"CALDARUSA (BUZAU)"
	,
	"CALDARUSEANCA (BUZAU)"
	,
	"CALEA CHIOJDULUI (BUZAU)"
	,
	"CALTESTI (BUZAU)"
	,
	"CALTUNA (BUZAU)"
	,
	"CALVINI (BUZAU)"
	,
	"CAMPENI (BUZAU)"
	,
	"CAMPULUNGEANCA (BUZAU)"
	,
	"CANDESTI (BUZAU)"
	,
	"CANESTI (BUZAU)"
	,
	"CAPATANESTI (BUZAU)"
	,
	"CAPU SATULUI (BUZAU)"
	,
	"CARAGELE (BUZAU)"
	,
	"CARATNAU DE JOS (BUZAU)"
	,
	"CARATNAU DE SUS (BUZAU)"
	,
	"CARLIGU MARE (BUZAU)"
	,
	"CARLIGU MIC (BUZAU)"
	,
	"CARLOMANESTI (BUZAU)"
	,
	"CARPINISTEA (BUZAU)"
	,
	"CASOCA (BUZAU)"
	,
	"CASOTA (BUZAU)"
	,
	"CATIASU (BUZAU)"
	,
	"CATINA (BUZAU)"
	,
	"CEAIRU (BUZAU)"
	,
	"CERNATESTI (BUZAU)"
	,
	"CHILIILE (BUZAU)"
	,
	"CHIOJDU (BUZAU)"
	,
	"CHIPERU (BUZAU)"
	,
	"CHIRLESTI (BUZAU)"
	,
	"CILIBIA (BUZAU)"
	,
	"CIOBANOAIA (BUZAU)"
	,
	"CIOCANESTI (BUZAU)"
	,
	"CIORANCA (BUZAU)"
	,
	"CIRESU (BUZAU)"
	,
	"CISLAU (BUZAU)"
	,
	"CIUTA (BUZAU)"
	,
	"CLONDIRU (BUZAU)"
	,
	"CLONDIRU DE SUS (BUZAU)"
	,
	"COCA-ANTIMIRESTI (BUZAU)"
	,
	"COCA-NICULESTI (BUZAU)"
	,
	"COCARCENI (BUZAU)"
	,
	"COCHIRLEANCA (BUZAU)"
	,
	"COCONARI (BUZAU)"
	,
	"COJANU (BUZAU)"
	,
	"COLIBASI (BUZAU)"
	,
	"COLTANENI (BUZAU)"
	,
	"COLTENI (BUZAU)"
	,
	"COLTI (BUZAU)"
	,
	"COLTII DE JOS (BUZAU)"
	,
	"COLTU PIETRII (BUZAU)"
	,
	"COMISOAIA (BUZAU)"
	,
	"CORBU (CATINA) (BUZAU)"
	,
	"CORBU (GLODEANU-SILISTEA) (BUZAU)"
	,
	"CORNEANU (BUZAU)"
	,
	"COSTESTI (BUZAU)"
	,
	"COSTIENI (BUZAU)"
	,
	"COSTOMIRU (BUZAU)"
	,
	"COTATCU (BUZAU)"
	,
	"COTORCA (BUZAU)"
	,
	"COTU CIORII (BUZAU)"
	,
	"COZIENI (BUZAU)"
	,
	"CRANG (BUZAU)"
	,
	"CREVELESTI (BUZAU)"
	,
	"CUCULEASA (BUZAU)"
	,
	"CURCANESTI (BUZAU)"
	,
	"CURMATURA (BUZAU)"
	,
	"DALMA (BUZAU)"
	,
	"DAMBROCA (BUZAU)"
	,
	"DANULESTI (BUZAU)"
	,
	"DARA (BUZAU)"
	,
	"DASCALESTI (BUZAU)"
	,
	"DEALU VIEI (BUZAU)"
	,
	"DEDULESTI (BUZAU)"
	,
	"DELENI (BUZAU)"
	,
	"DOBRILESTI (BUZAU)"
	,
	"DOGARI (BUZAU)"
	,
	"DULBANU (BUZAU)"
	,
	"FANTANELE (MARGARITESTI) (BUZAU)"
	,
	"FANTANELE (NAENI) (BUZAU)"
	,
	"FATA LUI NAN (BUZAU)"
	,
	"FINTESTI (BUZAU)"
	,
	"FISICI (BUZAU)"
	,
	"FLORESTI (BUZAU)"
	,
	"FLORICA (BUZAU)"
	,
	"FOCSANEI (BUZAU)"
	,
	"FOTIN (BUZAU)"
	,
	"FRASINET (BUZAU)"
	,
	"FULGA (BUZAU)"
	,
	"FUNDATA (BUZAU)"
	,
	"FUNDATURILE (BUZAU)"
	,
	"FUNDENI (BUZAU)"
	,
	"FURTUNESTI (BUZAU)"
	,
	"GAGENI (BUZAU)"
	,
	"GALBINASI (BUZAU)"
	,
	"GARA BOBOCU (BUZAU)"
	,
	"GARA CILIBIA (BUZAU)"
	,
	"GAVANELE (BUZAU)"
	,
	"GAVANESTI (BUZAU)"
	,
	"GHERASENI (BUZAU)"
	,
	"GHERGHEASA (BUZAU)"
	,
	"GHIOCARI (BUZAU)"
	,
	"GHIZDITA (BUZAU)"
	,
	"GLODEANU SARAT (BUZAU)"
	,
	"GLODEANU-SILISTEA (BUZAU)"
	,
	"GLODU-PETCARI (BUZAU)"
	,
	"GLODURILE (BUZAU)"
	,
	"GOICELU (BUZAU)"
	,
	"GOIDESTI (BUZAU)"
	,
	"GOLU GRABICINA (BUZAU)"
	,
	"GOMOESTI (BUZAU)"
	,
	"GONTESTI (BUZAU)"
	,
	"GORANI (BUZAU)"
	,
	"GORNET (BUZAU)"
	,
	"GRABICINA DE JOS (BUZAU)"
	,
	"GRABICINA DE SUS (BUZAU)"
	,
	"GRAJDANA (BUZAU)"
	,
	"GREBANU (BUZAU)"
	,
	"GRECEANCA (BUZAU)"
	,
	"GRESIA (BUZAU)"
	,
	"GROSANI (BUZAU)"
	,
	"GURA BADICULUI (BUZAU)"
	,
	"GURA BASCEI (BUZAU)"
	,
	"GURA CALNAULUI (BUZAU)"
	,
	"GURA DIMIENII (BUZAU)"
	,
	"GURA FAGETULUI (BUZAU)"
	,
	"GURA SARATII (BUZAU)"
	,
	"GURA SIRIULUI (BUZAU)"
	,
	"GURA TEGHII (BUZAU)"
	,
	"GURA VAII (BUZAU)"
	,
	"HALES (BUZAU)"
	,
	"HELIADE RADULESCU (BUZAU)"
	,
	"HOMESTI (BUZAU)"
	,
	"ILEANA (BUZAU)"
	,
	"ISTRITA DE JOS (BUZAU)"
	,
	"IVANETU (BUZAU)"
	,
	"IZVOARELE (BUZAU)"
	,
	"IZVORANU (BUZAU)"
	,
	"IZVORU (COZIENI) (BUZAU)"
	,
	"IZVORU (TISAU) (BUZAU)"
	,
	"IZVORU DULCE (BECENI) (BUZAU)"
	,
	"IZVORU DULCE (MEREI) (BUZAU)"
	,
	"JGHIAB (BUZAU)"
	,
	"JOSENI (BUZAU)"
	,
	"LACU (BUZAU)"
	,
	"LACU CU ANINI (BUZAU)"
	,
	"LACU SINAIA (BUZAU)"
	,
	"LACURILE (BUZAU)"
	,
	"LANURILE (BUZAU)"
	,
	"LARGU (BUZAU)"
	,
	"LEICULESTI (BUZAU)"
	,
	"LERA (BUZAU)"
	,
	"LIMPEZIS (BUZAU)"
	,
	"LIPANESCU (BUZAU)"
	,
	"LIPIA (BUZAU)"
	,
	"LIVADA (BUZAU)"
	,
	"LIVADA MICA (BUZAU)"
	,
	"LOPATAREASA (BUZAU)"
	,
	"LOPATARI (BUZAU)"
	,
	"LUCIU (BUZAU)"
	,
	"LUNCA (AMARU) (BUZAU)"
	,
	"LUNCA (C.A. ROSETTI) (BUZAU)"
	,
	"LUNCA (PATARLAGELE) (BUZAU)"
	,
	"LUNCA (PUIESTI) (BUZAU)"
	,
	"LUNCA FRUMOASA (BUZAU)"
	,
	"LUNCA JARISTEI (BUZAU)"
	,
	"LUNCA PRIPORULUI (BUZAU)"
	,
	"LUNCILE (BUZAU)"
	,
	"LUNGESTI (BUZAU)"
	,
	"MACRINA (BUZAU)"
	,
	"MAGURA (BUZAU)"
	,
	"MAGURICEA (BUZAU)"
	,
	"MANASIA (BUZAU)"
	,
	"MANASTIREA (BUZAU)"
	,
	"MANASTIREA RATESTI (BUZAU)"
	,
	"MANZALESTI (BUZAU)"
	,
	"MANZU (BUZAU)"
	,
	"MARACINENI (BUZAU)"
	,
	"MARGARITESTI (BUZAU)"
	,
	"MARGARITI (BUZAU)"
	,
	"MARGINEANU (BUZAU)"
	,
	"MARUNTISU (BUZAU)"
	,
	"MATESTI (BUZAU)"
	,
	"MAXENU (BUZAU)"
	,
	"MEREI (BUZAU)"
	,
	"MIEREA (BUZAU)"
	,
	"MIHAILESTI (BUZAU)"
	,
	"MITROPOLIA (BUZAU)"
	,
	"MLAJET (BUZAU)"
	,
	"MODRENI (BUZAU)"
	,
	"MOISICA (BUZAU)"
	,
	"MOSESTI (BUZAU)"
	,
	"MOVILA BANULUI (BUZAU)"
	,
	"MOVILA OII (BUZAU)"
	,
	"MOVILITA (BUZAU)"
	,
	"MUCESTI-DANULESTI (BUZAU)"
	,
	"MURGESTI (BUZAU)"
	,
	"MUSCEL (BUZAU)"
	,
	"MUSCELU CARAMANESTI (BUZAU)"
	,
	"MUSCELUSA (BUZAU)"
	,
	"NAENI (BUZAU)"
	,
	"NEGOSINA (BUZAU)"
	,
	"NEHOIASU (BUZAU)"
	,
	"NEHOIU (BUZAU)"
	,
	"NEMERTEA (BUZAU)"
	,
	"NENCIU (BUZAU)"
	,
	"NENCIULESTI (BUZAU)"
	,
	"NICOLESTI (BUZAU)"
	,
	"NICULESTI (BUZAU)"
	,
	"NISCOV (BUZAU)"
	,
	"NISTORESTI (BUZAU)"
	,
	"NUCU (BUZAU)"
	,
	"ODAIA BANULUI (BUZAU)"
	,
	"ODAILE (BUZAU)"
	,
	"OGRAZILE (BUZAU)"
	,
	"OLARI (BUZAU)"
	,
	"OLESESTI (BUZAU)"
	,
	"ORATIA (BUZAU)"
	,
	"OREAVU (BUZAU)"
	,
	"PACLELE (BUZAU)"
	,
	"PACURILE (BUZAU)"
	,
	"PADINA (BUZAU)"
	,
	"PADURENII (BUZAU)"
	,
	"PALICI (BUZAU)"
	,
	"PALTINENI (BUZAU)"
	,
	"PALTINIS (BUZAU)"
	,
	"PANATAU (BUZAU)"
	,
	"PARDOSI (BUZAU)"
	,
	"PARJOLESTI (BUZAU)"
	,
	"PARSCOV (BUZAU)"
	,
	"PARSCOVELU (BUZAU)"
	,
	"PATARLAGELE (BUZAU)"
	,
	"PESTRITU (BUZAU)"
	,
	"PETRACHESTI (BUZAU)"
	,
	"PETRISORU (BUZAU)"
	,
	"PIATRA ALBA (BUZAU)"
	,
	"PIETRARU (BUZAU)"
	,
	"PIETROASA MICA (BUZAU)"
	,
	"PIETROASELE (BUZAU)"
	,
	"PIETROSU (BUZAU)"
	,
	"PINU (BUZAU)"
	,
	"PITULICEA (BUZAU)"
	,
	"PLAISOR (BUZAU)"
	,
	"PLAIU NUCULUI (BUZAU)"
	,
	"PLAVATU (BUZAU)"
	,
	"PLESCIOARA (BUZAU)"
	,
	"PLESCOI (BUZAU)"
	,
	"PLESESTI (BERCA) (BUZAU)"
	,
	"PLESESTI (PODGORIA) (BUZAU)"
	,
	"PLESI (BUZAU)"
	,
	"PLEVNA (BUZAU)"
	,
	"PLOPEASA (BUZAU)"
	,
	"PLOPI (BUZAU)"
	,
	"PLOSTINA (BUZAU)"
	,
	"PODGORIA (BUZAU)"
	,
	"PODU MUNCII (BUZAU)"
	,
	"POENITELE (BUZAU)"
	,
	"POGOANELE (BUZAU)"
	,
	"POGONELE (BUZAU)"
	,
	"POIANA PLETARI (BUZAU)"
	,
	"POIANA VALCULUI (BUZAU)"
	,
	"POIENILE (BUZAU)"
	,
	"POLICIORI (BUZAU)"
	,
	"POSOBESTI (BUZAU)"
	,
	"POSTA (CILIBIA) (BUZAU)"
	,
	"POSTA (TOPLICENI) (BUZAU)"
	,
	"POSTA CALNAU (BUZAU)"
	,
	"POTARNICHESTI (BUZAU)"
	,
	"POTECU (BUZAU)"
	,
	"POTOCENI (BUZAU)"
	,
	"PROSCA (BUZAU)"
	,
	"PRUNENI (BUZAU)"
	,
	"PUIESTI (BUZAU)"
	,
	"PUIESTII DE JOS (BUZAU)"
	,
	"PUIESTII DE SUS (BUZAU)"
	,
	"PUNGA (BUZAU)"
	,
	"RACOVITENI (BUZAU)"
	,
	"RADUCESTI (BUZAU)"
	,
	"RAMNICELU (BUZAU)"
	,
	"RAMNICU SARAT (BUZAU)"
	,
	"RAPILE (BUZAU)"
	,
	"RATESTI (BUZAU)"
	,
	"RECEA (BUZAU)"
	,
	"ROBEASCA (BUZAU)"
	,
	"ROBESTI (BUZAU)"
	,
	"ROSIORU (BUZAU)"
	,
	"RUBLA (BUZAU)"
	,
	"RUGINOASA (BUZAU)"
	,
	"RUNCU (BUZAU)"
	,
	"RUSAVAT (BUZAU)"
	,
	"RUSETU (BUZAU)"
	,
	"SAGEATA (BUZAU)"
	,
	"SAHATENI (BUZAU)"
	,
	"SALCIA (BUZAU)"
	,
	"SALCIOARA (BUZAU)"
	,
	"SAPOCA (BUZAU)"
	,
	"SARANGA (BUZAU)"
	,
	"SARATA (BUZAU)"
	,
	"SARATA-MONTEORU (BUZAU)"
	,
	"SARBESTI (BUZAU)"
	,
	"SARENI (BUZAU)"
	,
	"SARILE (BUZAU)"
	,
	"SARILE-CATUN (BUZAU)"
	,
	"SARULESTI (BUZAU)"
	,
	"SASENII NOI (BUZAU)"
	,
	"SASENII PE VALE (BUZAU)"
	,
	"SASENII VECHI (BUZAU)"
	,
	"SATU NOU (GLODEANU-SILISTEA) (BUZAU)"
	,
	"SATU NOU (MIHAILESTI) (BUZAU)"
	,
	"SATU VECHI (BUZAU)"
	,
	"SATUC (BUZAU)"
	,
	"SCAENI (BUZAU)"
	,
	"SCARISOARA (BUZAU)"
	,
	"SCARLATESTI (BUZAU)"
	,
	"SCOROSESTI (BUZAU)"
	,
	"SCORTEANCA (BUZAU)"
	,
	"SCORTOASA (BUZAU)"
	,
	"SCURTESTI (BUZAU)"
	,
	"SCUTELNICI (BUZAU)"
	,
	"SECUIU (BUZAU)"
	,
	"SERGENT IONEL STEFAN (BUZAU)"
	,
	"SIBICIU DE JOS (BUZAU)"
	,
	"SIBICIU DE SUS (BUZAU)"
	,
	"SINDRILA (BUZAU)"
	,
	"SIRIU (BUZAU)"
	,
	"SLOBOZIA (BUZAU)"
	,
	"SMARDAN (BUZAU)"
	,
	"SMEENI (BUZAU)"
	,
	"SMEESTI (BUZAU)"
	,
	"SORESTI (BUZAU)"
	,
	"SPATARU (BUZAU)"
	,
	"SPIDELE (BUZAU)"
	,
	"STALPU (BUZAU)"
	,
	"STANCESTI (BUZAU)"
	,
	"STANILA (BUZAU)"
	,
	"STAVARASTI (BUZAU)"
	,
	"STIUBEI (BUZAU)"
	,
	"STREZENI (BUZAU)"
	,
	"STROESTI (BUZAU)"
	,
	"SUCHEA (BUZAU)"
	,
	"SUDITI (GHERASENI) (BUZAU)"
	,
	"SUDITI (POSTA CALNAU) (BUZAU)"
	,
	"TABACARI (BUZAU)"
	,
	"TABARASTI (BUZAU)"
	,
	"TARCOV (BUZAU)"
	,
	"TARLELE (BUZAU)"
	,
	"TATARLIGU (BUZAU)"
	,
	"TATULESTI (BUZAU)"
	,
	"TEGA (BUZAU)"
	,
	"TEISU (BUZAU)"
	,
	"TERCA (BUZAU)"
	,
	"TINTESTI (BUZAU)"
	,
	"TISAU (BUZAU)"
	,
	"TOCILENI (BUZAU)"
	,
	"TOPLICENI (BUZAU)"
	,
	"TOROPALESTI (BUZAU)"
	,
	"TRESTIA (BUZAU)"
	,
	"TRESTIENI (BUZAU)"
	,
	"TRESTIOARA (CHILIILE) (BUZAU)"
	,
	"TRESTIOARA (MANZALESTI) (BUZAU)"
	,
	"TRONARI (BUZAU)"
	,
	"TULBUREA (BUZAU)"
	,
	"UDATI-LUCIENI (BUZAU)"
	,
	"UDATI-MANZU (BUZAU)"
	,
	"ULMENI (BUZAU)"
	,
	"ULMET (BUZAU)"
	,
	"UNGURIU (BUZAU)"
	,
	"URSOAIA (BUZAU)"
	,
	"VACAREASCA (BUZAU)"
	,
	"VADU OII (BUZAU)"
	,
	"VADU PASII (BUZAU)"
	,
	"VADU SORESTI (BUZAU)"
	,
	"VALCELE (BUZAU)"
	,
	"VALCELELE (BUZAU)"
	,
	"VALEA BANULUI (BUZAU)"
	,
	"VALEA CATINEI (BUZAU)"
	,
	"VALEA COTOAREI (BUZAU)"
	,
	"VALEA FANTANEI (BUZAU)"
	,
	"VALEA LARGA (BUZAU)"
	,
	"VALEA LARGA-SARULESTI (BUZAU)"
	,
	"VALEA LUI LALU (BUZAU)"
	,
	"VALEA LUPULUI (BUZAU)"
	,
	"VALEA NUCULUI (BUZAU)"
	,
	"VALEA PARULUI (BUZAU)"
	,
	"VALEA PURCARULUI (BUZAU)"
	,
	"VALEA PUTULUI MEREI (BUZAU)"
	,
	"VALEA RAMNICULUI (BUZAU)"
	,
	"VALEA RATEI (BUZAU)"
	,
	"VALEA ROATEI (BUZAU)"
	,
	"VALEA SALCIEI (BUZAU)"
	,
	"VALEA SALCIEI-CATUN (BUZAU)"
	,
	"VALEA SALCIILOR (BUZAU)"
	,
	"VALEA SCHIOPULUI (BUZAU)"
	,
	"VALEA SIBICIULUI (BUZAU)"
	,
	"VALEA STANEI (BUZAU)"
	,
	"VALEA STEFANULUI (BUZAU)"
	,
	"VALEA URSULUI (BUZAU)"
	,
	"VALEA VERZEI (BUZAU)"
	,
	"VALEA VIEI (BUZAU)"
	,
	"VALEANCA-VILANESTI (BUZAU)"
	,
	"VARF (BUZAU)"
	,
	"VARLAAM (BUZAU)"
	,
	"VARTEJU (BUZAU)"
	,
	"VAVALUCILE (BUZAU)"
	,
	"VERNESTI (BUZAU)"
	,
	"VIFORATA (BUZAU)"
	,
	"VINETISU (BUZAU)"
	,
	"VINTILA VODA (BUZAU)"
	,
	"VINTILEANCA (BUZAU)"
	,
	"VIPERESTI (BUZAU)"
	,
	"VISPESTI (BUZAU)"
	,
	"VIZIRENI (BUZAU)"
	,
	"VLADENI (BUZAU)"
	,
	"ZAHARESTI (BUZAU)"
	,
	"ZAPLAZI (BUZAU)"
	,
	"ZAPODIA (BUZAU)"
	,
	"ZARNESTI (BUZAU)"
	,
	"ZARNESTII DE SLANIC (BUZAU)"
	,
	"ZELETIN (BUZAU)"
	,
	"ZIDURI (BUZAU)"
	,
	"ZILISTEANCA (BUZAU)"
	,
	"ZOITA (BUZAU)"
	,
	"ZORESTI (BUZAU)"
	,
	"ALEXANDRU I. CUZA (CALARASI)"
	,
	"ALEXANDRU ODOBESCU (CALARASI)"
	,
	"APROZI (CALARASI)"
	,
	"ARTARI (CALARASI)"
	,
	"BELCIUGATELE (CALARASI)"
	,
	"BOGATA (CALARASI)"
	,
	"BOGDANA (CALARASI)"
	,
	"BORCEA (CALARASI)"
	,
	"BOSNEAGU (CALARASI)"
	,
	"BUCIUMENI (CALARASI)"
	,
	"BUDESTI (CALARASI)"
	,
	"BUZOENI (CALARASI)"
	,
	"CALARASI (CALARASI)"
	,
	"CALARASII VECHI (CALARASI)"
	,
	"CALARETI (CALARASI)"
	,
	"CANDEASCA (CALARASI)"
	,
	"CASCIOARELE (CALARASI)"
	,
	"CEACU (CALARASI)"
	,
	"CETATEA VECHE (CALARASI)"
	,
	"CHIRNOGI (CALARASI)"
	,
	"CHIRNOGI (ULMU) (CALARASI)"
	,
	"CHISELET (CALARASI)"
	,
	"CIOCANESTI (CALARASI)"
	,
	"CIULNITA-GARA (CALARASI)"
	,
	"CLATESTI (CALARASI)"
	,
	"COCONI (CALARASI)"
	,
	"CODRENI (CALARASI)"
	,
	"COJESTI (CALARASI)"
	,
	"CONSTANTIN BRANCOVEANU (CALARASI)"
	,
	"COSLOGENI (CALARASI)"
	,
	"COTOFANCA (CALARASI)"
	,
	"CRIVAT (CALARASI)"
	,
	"CUCUIETI (CALARASI)"
	,
	"CUNESTI (CALARASI)"
	,
	"CURATESTI (CALARASI)"
	,
	"CURCANI (CALARASI)"
	,
	"CUZA VODA (CALARASI)"
	,
	"DALGA (CALARASI)"
	,
	"DALGA-GARA (CALARASI)"
	,
	"DANESTI (CALARASI)"
	,
	"DARVARI (CALARASI)"
	,
	"DICHISENI (CALARASI)"
	,
	"DOR MARUNT (CALARASI)"
	,
	"DOROBANTU (CALARASI)"
	,
	"DOROBANTU (PLATARESTI) (CALARASI)"
	,
	"DRAGALINA (CALARASI)"
	,
	"DRAGOS VODA (CALARASI)"
	,
	"DRAJNA NOUA (CALARASI)"
	,
	"FANTANA DOAMNEI (CALARASI)"
	,
	"FAUREI (CALARASI)"
	,
	"FLORICA (CALARASI)"
	,
	"FLOROAICA (CALARASI)"
	,
	"FRASINET (CALARASI)"
	,
	"FRASINETU DE JOS (CALARASI)"
	,
	"FRUMUSENI (CALARASI)"
	,
	"FUNDENI (CALARASI)"
	,
	"FUNDULEA (CALARASI)"
	,
	"GALATUI (CALARASI)"
	,
	"GALBINASI (CALARASI)"
	,
	"GALDAU (CALARASI)"
	,
	"GOSTILELE (CALARASI)"
	,
	"GRADISTEA (CALARASI)"
	,
	"GRUIU (CALARASI)"
	,
	"GURBANESTI (CALARASI)"
	,
	"IEZERU (CALARASI)"
	,
	"ILEANA (CALARASI)"
	,
	"INDEPENDENTA (CALARASI)"
	,
	"INFRATIREA (CALARASI)"
	,
	"JEGALIA (CALARASI)"
	,
	"LEHLIU (CALARASI)"
	,
	"LEHLIU-GARA (CALARASI)"
	,
	"LIBERTATEA (CALARASI)"
	,
	"LUICA (CALARASI)"
	,
	"LUNCA (CALARASI)"
	,
	"LUPSANU (CALARASI)"
	,
	"LUPTATORI (CALARASI)"
	,
	"MAGURENI (CALARASI)"
	,
	"MANASTIREA (CALARASI)"
	,
	"MARCULESTI-GARA (CALARASI)"
	,
	"MARIUTA (CALARASI)"
	,
	"MATARAUA (CALARASI)"
	,
	"MIHAI VITEAZU (CALARASI)"
	,
	"MITRENI (CALARASI)"
	,
	"MODELU (CALARASI)"
	,
	"NANA (CALARASI)"
	,
	"NEGOESTI (CALARASI)"
	,
	"NICOLAE BALCESCU (CALARASI)"
	,
	"NICOLAE BALCESCU (ALEXANDRU ODOBESCU) (CALARASI)"
	,
	"NUCETU (CALARASI)"
	,
	"NUCI (CALARASI)"
	,
	"OGORU (CALARASI)"
	,
	"OLTENITA (CALARASI)"
	,
	"OLTINA (CALARASI)"
	,
	"ORASTI (CALARASI)"
	,
	"OSTROVU (CALARASI)"
	,
	"PADURISU (CALARASI)"
	,
	"PAICU (CALARASI)"
	,
	"PASAREA (CALARASI)"
	,
	"PELINU (CALARASI)"
	,
	"PERISORU (CALARASI)"
	,
	"PITIGAIA (CALARASI)"
	,
	"PLATARESTI (CALARASI)"
	,
	"PLEVNA (CALARASI)"
	,
	"PLUMBUITA (CALARASI)"
	,
	"PODARI (CALARASI)"
	,
	"PODU PITARULUI (CALARASI)"
	,
	"POLCESTI (CALARASI)"
	,
	"POPESTI (CALARASI)"
	,
	"POSTAVARI (CALARASI)"
	,
	"POTCOAVA (CALARASI)"
	,
	"PREASNA (CALARASI)"
	,
	"PREASNA VECHE (CALARASI)"
	,
	"PROGRESU (CALARASI)"
	,
	"RADOVANU (CALARASI)"
	,
	"RADU NEGRU (CALARASI)"
	,
	"RADU VODA (CALARASI)"
	,
	"RASA (CALARASI)"
	,
	"RASURILE (CALARASI)"
	,
	"RAZOARELE (CALARASI)"
	,
	"RAZVANI (CALARASI)"
	,
	"ROSETI (CALARASI)"
	,
	"SACELE (CALARASI)"
	,
	"SALCIOARA (CALARASI)"
	,
	"SANDULITA (CALARASI)"
	,
	"SAPUNARI (CALARASI)"
	,
	"SARULESTI (CALARASI)"
	,
	"SARULESTI-GARA (CALARASI)"
	,
	"SATNOENI (CALARASI)"
	,
	"SATU NOU (CALARASI)"
	,
	"SATUCU (CALARASI)"
	,
	"SEINOIU (CALARASI)"
	,
	"SILISTEA (CALARASI)"
	,
	"SOCOALELE (CALARASI)"
	,
	"SOHATU (CALARASI)"
	,
	"SOLACOLU (CALARASI)"
	,
	"SOLDANU (CALARASI)"
	,
	"SPANTOV (CALARASI)"
	,
	"STANCEA (CALARASI)"
	,
	"STEFAN CEL MARE (CALARASI)"
	,
	"STEFAN VODA (CALARASI)"
	,
	"STEFANESTI (CALARASI)"
	,
	"STOENESTI (CALARASI)"
	,
	"SULTANA (CALARASI)"
	,
	"TAMADAU MARE (CALARASI)"
	,
	"TAMADAU MIC (CALARASI)"
	,
	"TARICENI (CALARASI)"
	,
	"TONEA (CALARASI)"
	,
	"TUDOR VLADIMIRESCU (CALARASI)"
	,
	"ULMENI (CALARASI)"
	,
	"ULMU (CALARASI)"
	,
	"UNIREA (CALARASI)"
	,
	"VALCELELE (CALARASI)"
	,
	"VALEA ARGOVEI (CALARASI)"
	,
	"VALEA POPII (CALARASI)"
	,
	"VALEA PRESNEI (CALARASI)"
	,
	"VALEA ROSIE (CALARASI)"
	,
	"VALEA RUSULUI (CALARASI)"
	,
	"VALEA SEACA (CALARASI)"
	,
	"VALEA STANII (CALARASI)"
	,
	"VARASTI (CALARASI)"
	,
	"VASILATI (CALARASI)"
	,
	"VISINII (CALARASI)"
	,
	"VLAD TEPES (CALARASI)"
	,
	"VLADICEASCA (CALARASI)"
	,
	"VLAICULESTI (CALARASI)"
	,
	"ZIMBRU (CALARASI)"
	,
	"23 AUGUST (CARAS SEVERIN)"
	,
	"AGADICI (CARAS SEVERIN)"
	,
	"ANINA (CARAS SEVERIN)"
	,
	"APADIA (CARAS SEVERIN)"
	,
	"ARMENIS (CARAS SEVERIN)"
	,
	"ARSURI (CARAS SEVERIN)"
	,
	"BAILE HERCULANE (CARAS SEVERIN)"
	,
	"BANIA (CARAS SEVERIN)"
	,
	"BARBOSU (CARAS SEVERIN)"
	,
	"BARZ (CARAS SEVERIN)"
	,
	"BARZA (CARAS SEVERIN)"
	,
	"BAUTAR (CARAS SEVERIN)"
	,
	"BAZIAS (CARAS SEVERIN)"
	,
	"BELOBRESCA (CARAS SEVERIN)"
	,
	"BERLISTE (CARAS SEVERIN)"
	,
	"BERZASCA (CARAS SEVERIN)"
	,
	"BERZOVIA (CARAS SEVERIN)"
	,
	"BIGAR (CARAS SEVERIN)"
	,
	"BINIS (CARAS SEVERIN)"
	,
	"BOCSA (CARAS SEVERIN)"
	,
	"BOGALTIN (CARAS SEVERIN)"
	,
	"BOGODINT (CARAS SEVERIN)"
	,
	"BOINA (CARAS SEVERIN)"
	,
	"BOINITA (CARAS SEVERIN)"
	,
	"BOJIA (CARAS SEVERIN)"
	,
	"BOLVASNITA (CARAS SEVERIN)"
	,
	"BORLOVA (CARAS SEVERIN)"
	,
	"BORLOVENII NOI (CARAS SEVERIN)"
	,
	"BORLOVENII VECHI (CARAS SEVERIN)"
	,
	"BORUGI (CARAS SEVERIN)"
	,
	"BOZOVICI (CARAS SEVERIN)"
	,
	"BRADISORU DE JOS (CARAS SEVERIN)"
	,
	"BRATOVA (CARAS SEVERIN)"
	,
	"BREBU (CARAS SEVERIN)"
	,
	"BREBU NOU (CARAS SEVERIN)"
	,
	"BRESTELNIC (CARAS SEVERIN)"
	,
	"BREZON (CARAS SEVERIN)"
	,
	"BROSTENI (CARAS SEVERIN)"
	,
	"BUCHIN (CARAS SEVERIN)"
	,
	"BUCOSNITA (CARAS SEVERIN)"
	,
	"BUCOVA (CARAS SEVERIN)"
	,
	"CALINA (CARAS SEVERIN)"
	,
	"CALNIC (CARAS SEVERIN)"
	,
	"CAMENA (CARAS SEVERIN)"
	,
	"CAMENITA (CARAS SEVERIN)"
	,
	"CAMPIA (CARAS SEVERIN)"
	,
	"CANICEA (CARAS SEVERIN)"
	,
	"CARANSEBES (CARAS SEVERIN)"
	,
	"CARASOVA (CARAS SEVERIN)"
	,
	"CARBUNARI (CARAS SEVERIN)"
	,
	"CARNECEA (CARAS SEVERIN)"
	,
	"CARSA ROSIE (CARAS SEVERIN)"
	,
	"CARSIE (CARAS SEVERIN)"
	,
	"CAVARAN (CARAS SEVERIN)"
	,
	"CICLENI (CARAS SEVERIN)"
	,
	"CICLOVA MONTANA (CARAS SEVERIN)"
	,
	"CICLOVA ROMANA (CARAS SEVERIN)"
	,
	"CIORTEA (CARAS SEVERIN)"
	,
	"CIRESA (CARAS SEVERIN)"
	,
	"CIRESEL (CARAS SEVERIN)"
	,
	"CIUCHICI (CARAS SEVERIN)"
	,
	"CIUDANOVITA (CARAS SEVERIN)"
	,
	"CIUTA (CARAS SEVERIN)"
	,
	"CLOCOTICI (CARAS SEVERIN)"
	,
	"COMORASTE (CARAS SEVERIN)"
	,
	"CONSTANTIN DAICOVICIU (CARAS SEVERIN)"
	,
	"COPACELE (CARAS SEVERIN)"
	,
	"CORNEA (CARAS SEVERIN)"
	,
	"CORNEREVA (CARAS SEVERIN)"
	,
	"CORNISORU (CARAS SEVERIN)"
	,
	"CORNUTEL (CARAS SEVERIN)"
	,
	"CORONINI (CARAS SEVERIN)"
	,
	"COSTIS (CARAS SEVERIN)"
	,
	"COZIA (CARAS SEVERIN)"
	,
	"COZLA (CARAS SEVERIN)"
	,
	"CRACU ALMAJ (CARAS SEVERIN)"
	,
	"CRACU MARE (CARAS SEVERIN)"
	,
	"CRACU TEIULUI (CARAS SEVERIN)"
	,
	"CRUSOVAT (CARAS SEVERIN)"
	,
	"CRUSOVITA (CARAS SEVERIN)"
	,
	"CUPTOARE (CORNEA) (CARAS SEVERIN)"
	,
	"CUPTOARE (RESITA) (CARAS SEVERIN)"
	,
	"CURMATURA (CARAS SEVERIN)"
	,
	"DALBOSET (CARAS SEVERIN)"
	,
	"DALCI (CARAS SEVERIN)"
	,
	"DELINESTI (CARAS SEVERIN)"
	,
	"DEZESTI (CARAS SEVERIN)"
	,
	"DIVICI (CARAS SEVERIN)"
	,
	"DOBRAIA (CARAS SEVERIN)"
	,
	"DOCLIN (CARAS SEVERIN)"
	,
	"DOGNECEA (CARAS SEVERIN)"
	,
	"DOLINA (CARAS SEVERIN)"
	,
	"DOMAN (CARAS SEVERIN)"
	,
	"DOMASNEA (CARAS SEVERIN)"
	,
	"DRENCOVA (CARAS SEVERIN)"
	,
	"DRISTIE (CARAS SEVERIN)"
	,
	"DULEU (CARAS SEVERIN)"
	,
	"EFTIMIE MURGU (CARAS SEVERIN)"
	,
	"ERSIG (CARAS SEVERIN)"
	,
	"EZERIS (CARAS SEVERIN)"
	,
	"FARLIUG (CARAS SEVERIN)"
	,
	"FENES (CARAS SEVERIN)"
	,
	"FIZES (CARAS SEVERIN)"
	,
	"FOROTIC (CARAS SEVERIN)"
	,
	"FRASINIS (CARAS SEVERIN)"
	,
	"GARANA (CARAS SEVERIN)"
	,
	"GARBOVAT (CARAS SEVERIN)"
	,
	"GARLISTE (CARAS SEVERIN)"
	,
	"GARNIC (CARAS SEVERIN)"
	,
	"GHERTENIS (CARAS SEVERIN)"
	,
	"GIURGIOVA (CARAS SEVERIN)"
	,
	"GLIMBOCA (CARAS SEVERIN)"
	,
	"GLOBU CRAIOVEI (CARAS SEVERIN)"
	,
	"GLOBURAU (CARAS SEVERIN)"
	,
	"GOLET (CARAS SEVERIN)"
	,
	"GORNEA (CARAS SEVERIN)"
	,
	"GORUIA (CARAS SEVERIN)"
	,
	"GRADINARI (CARAS SEVERIN)"
	,
	"GREONI (CARAS SEVERIN)"
	,
	"GRUNI (CARAS SEVERIN)"
	,
	"HORA MARE (CARAS SEVERIN)"
	,
	"HORA MICA (CARAS SEVERIN)"
	,
	"IABALCEA (CARAS SEVERIN)"
	,
	"IABLANITA (CARAS SEVERIN)"
	,
	"IAM (CARAS SEVERIN)"
	,
	"IAZ (CARAS SEVERIN)"
	,
	"IERTOF (CARAS SEVERIN)"
	,
	"ILIDIA (CARAS SEVERIN)"
	,
	"ILOVA (CARAS SEVERIN)"
	,
	"INELET (CARAS SEVERIN)"
	,
	"IZGAR (CARAS SEVERIN)"
	,
	"IZVOR (CARAS SEVERIN)"
	,
	"JITIN (CARAS SEVERIN)"
	,
	"JUPA (CARAS SEVERIN)"
	,
	"LAPUSNICEL (CARAS SEVERIN)"
	,
	"LAPUSNICU MARE (CARAS SEVERIN)"
	,
	"LESCOVITA (CARAS SEVERIN)"
	,
	"LIBORAJDEA (CARAS SEVERIN)"
	,
	"LINDENFELD (CARAS SEVERIN)"
	,
	"LIUBCOVA (CARAS SEVERIN)"
	,
	"LUCACEVAT (CARAS SEVERIN)"
	,
	"LUNCA FLORII (CARAS SEVERIN)"
	,
	"LUNCA ZAICII (CARAS SEVERIN)"
	,
	"LUNCAVITA (CARAS SEVERIN)"
	,
	"LUPAC (CARAS SEVERIN)"
	,
	"MACESTI (CARAS SEVERIN)"
	,
	"MACIOVA (CARAS SEVERIN)"
	,
	"MACOVISTE (CIUCHICI) (CARAS SEVERIN)"
	,
	"MACOVISTE (CORNEA) (CARAS SEVERIN)"
	,
	"MAGURA (CARAS SEVERIN)"
	,
	"MAL (CARAS SEVERIN)"
	,
	"MARGA (CARAS SEVERIN)"
	,
	"MARILA (CARAS SEVERIN)"
	,
	"MARTINOVAT (CARAS SEVERIN)"
	,
	"MARU (CARAS SEVERIN)"
	,
	"MATNICU MARE (CARAS SEVERIN)"
	,
	"MAURENI (CARAS SEVERIN)"
	,
	"MEHADIA (CARAS SEVERIN)"
	,
	"MEHADICA (CARAS SEVERIN)"
	,
	"MERCINA (CARAS SEVERIN)"
	,
	"MESTEACAN (CARAS SEVERIN)"
	,
	"MILCOVENI (CARAS SEVERIN)"
	,
	"MOCERIS (CARAS SEVERIN)"
	,
	"MOLDOVA NOUA (CARAS SEVERIN)"
	,
	"MOLDOVA VECHE (CARAS SEVERIN)"
	,
	"MOLDOVITA (CARAS SEVERIN)"
	,
	"MONIOM (CARAS SEVERIN)"
	,
	"NAIDAS (CARAS SEVERIN)"
	,
	"NEGIUDIN (CARAS SEVERIN)"
	,
	"NERMED (CARAS SEVERIN)"
	,
	"NICOLINT (CARAS SEVERIN)"
	,
	"OBITA (CARAS SEVERIN)"
	,
	"OBREJA (CARAS SEVERIN)"
	,
	"OCNA DE FIER (CARAS SEVERIN)"
	,
	"OGASU PODULUI (CARAS SEVERIN)"
	,
	"OHABA-MATNIC (CARAS SEVERIN)"
	,
	"OHABITA (CARAS SEVERIN)"
	,
	"ORAVITA (CARAS SEVERIN)"
	,
	"OTELU ROSU (CARAS SEVERIN)"
	,
	"PADINA MATEI (CARAS SEVERIN)"
	,
	"PALTINIS (CARAS SEVERIN)"
	,
	"PARNEAURA (CARAS SEVERIN)"
	,
	"PARVOVA (CARAS SEVERIN)"
	,
	"PATAS (CARAS SEVERIN)"
	,
	"PECINISCA (CARAS SEVERIN)"
	,
	"PESTERE (CARAS SEVERIN)"
	,
	"PETNIC (CARAS SEVERIN)"
	,
	"PETRILOVA (CARAS SEVERIN)"
	,
	"PETROSNITA (CARAS SEVERIN)"
	,
	"PLOPU (CARAS SEVERIN)"
	,
	"PLUGOVA (CARAS SEVERIN)"
	,
	"POGARA (CARAS SEVERIN)"
	,
	"POGARA DE SUS (CARAS SEVERIN)"
	,
	"POIANA (CARAS SEVERIN)"
	,
	"POIANA LUNGA (CARAS SEVERIN)"
	,
	"POIANA MARULUI (CARAS SEVERIN)"
	,
	"POIENILE BOINEI (CARAS SEVERIN)"
	,
	"POJEJENA (CARAS SEVERIN)"
	,
	"PONEASCA (CARAS SEVERIN)"
	,
	"POTOC (CARAS SEVERIN)"
	,
	"PREVECIORI (CARAS SEVERIN)"
	,
	"PRIGOR (CARAS SEVERIN)"
	,
	"PRILIPET (CARAS SEVERIN)"
	,
	"PRISACA (CARAS SEVERIN)"
	,
	"PRISACINA (CARAS SEVERIN)"
	,
	"PRISIAN (CARAS SEVERIN)"
	,
	"PRISLOP (CORNEREVA) (CARAS SEVERIN)"
	,
	"PRISLOP (DALBOSET) (CARAS SEVERIN)"
	,
	"PUTNA (CARAS SEVERIN)"
	,
	"RACASDIA (CARAS SEVERIN)"
	,
	"RACHITA (CARAS SEVERIN)"
	,
	"RACHITOVA (CARAS SEVERIN)"
	,
	"RADIMNA (CARAS SEVERIN)"
	,
	"RAFNIC (CARAS SEVERIN)"
	,
	"RAMNA (CARAS SEVERIN)"
	,
	"RAVENSCA (CARAS SEVERIN)"
	,
	"REMETEA-POGANICI (CARAS SEVERIN)"
	,
	"RESITA MICA (CARAS SEVERIN)"
	,
	"RUGI (CARAS SEVERIN)"
	,
	"RUGINOSU (CARAS SEVERIN)"
	,
	"RUSCA (CARAS SEVERIN)"
	,
	"RUSCA MONTANA (CARAS SEVERIN)"
	,
	"RUSCHITA (CARAS SEVERIN)"
	,
	"RUSOVA NOUA (CARAS SEVERIN)"
	,
	"RUSOVA VECHE (CARAS SEVERIN)"
	,
	"RUSTIN (CARAS SEVERIN)"
	,
	"SACU (CARAS SEVERIN)"
	,
	"SADOVA NOUA (CARAS SEVERIN)"
	,
	"SADOVA VECHE (CARAS SEVERIN)"
	,
	"SALBAGELU NOU (CARAS SEVERIN)"
	,
	"SASCA MONTANA (CARAS SEVERIN)"
	,
	"SASCA ROMANA (CARAS SEVERIN)"
	,
	"SAT BATRAN (CARAS SEVERIN)"
	,
	"SCAIUS (CARAS SEVERIN)"
	,
	"SCARISOARA (CARAS SEVERIN)"
	,
	"SECASENI (CARAS SEVERIN)"
	,
	"SECU (CARAS SEVERIN)"
	,
	"SFANTA ELENA (CARAS SEVERIN)"
	,
	"SICHEVITA (CARAS SEVERIN)"
	,
	"SLATINA-NERA (CARAS SEVERIN)"
	,
	"SLATINA-TIMIS (CARAS SEVERIN)"
	,
	"SOCENI (CARAS SEVERIN)"
	,
	"SOCOL (CARAS SEVERIN)"
	,
	"SOCOLARI (CARAS SEVERIN)"
	,
	"SOPOTU NOU (CARAS SEVERIN)"
	,
	"SOPOTU VECHI (CARAS SEVERIN)"
	,
	"SOSDEA (CARAS SEVERIN)"
	,
	"STANCILOVA (CARAS SEVERIN)"
	,
	"STEIERDORF (CARAS SEVERIN)"
	,
	"STINAPARI (CARAS SEVERIN)"
	,
	"STRENEAC (CARAS SEVERIN)"
	,
	"STRUGASCA (CARAS SEVERIN)"
	,
	"STUDENA (CARAS SEVERIN)"
	,
	"SUB CRANG (CARAS SEVERIN)"
	,
	"SUB MARGINE (CARAS SEVERIN)"
	,
	"SUB PLAI (CARAS SEVERIN)"
	,
	"SUMITA (CARAS SEVERIN)"
	,
	"SURDUCU MARE (CARAS SEVERIN)"
	,
	"SUSCA (CARAS SEVERIN)"
	,
	"TARNOVA (CARAS SEVERIN)"
	,
	"TATU (CARAS SEVERIN)"
	,
	"TEREGOVA (CARAS SEVERIN)"
	,
	"TEROVA (CARAS SEVERIN)"
	,
	"TICVANIU MARE (CARAS SEVERIN)"
	,
	"TICVANIU MIC (CARAS SEVERIN)"
	,
	"TINCOVA (CARAS SEVERIN)"
	,
	"TIROL (CARAS SEVERIN)"
	,
	"TOPLA (CARAS SEVERIN)"
	,
	"TOPLET (CARAS SEVERIN)"
	,
	"TURNU RUIENI (CARAS SEVERIN)"
	,
	"URCU (CARAS SEVERIN)"
	,
	"VALEA BISTREI (CARAS SEVERIN)"
	,
	"VALEA BOLVASNITA (CARAS SEVERIN)"
	,
	"VALEA MARE (CARAS SEVERIN)"
	,
	"VALEA MINISULUI (CARAS SEVERIN)"
	,
	"VALEA OREVITA (CARAS SEVERIN)"
	,
	"VALEA RACHITEI (CARAS SEVERIN)"
	,
	"VALEA RAVENSCA (CARAS SEVERIN)"
	,
	"VALEA ROSIE (CARAS SEVERIN)"
	,
	"VALEA SICHEVITEI (CARAS SEVERIN)"
	,
	"VALEA TIMISULUI (CARAS SEVERIN)"
	,
	"VALEADENI (CARAS SEVERIN)"
	,
	"VALEAPAI (CARAS SEVERIN)"
	,
	"VALISOARA (CARAS SEVERIN)"
	,
	"VALIUG (CARAS SEVERIN)"
	,
	"VAMA MARGA (CARAS SEVERIN)"
	,
	"VAR (CARAS SEVERIN)"
	,
	"VARADIA (CARAS SEVERIN)"
	,
	"VARCIOROVA (CARAS SEVERIN)"
	,
	"VERENDIN (CARAS SEVERIN)"
	,
	"VERMES (CARAS SEVERIN)"
	,
	"VODNIC (CARAS SEVERIN)"
	,
	"VOISLOVA (CARAS SEVERIN)"
	,
	"VRANI (CARAS SEVERIN)"
	,
	"VRANIUT (CARAS SEVERIN)"
	,
	"ZAGUJENI (CARAS SEVERIN)"
	,
	"ZANOGI (CARAS SEVERIN)"
	,
	"ZANOU (CARAS SEVERIN)"
	,
	"ZASLOANE (CARAS SEVERIN)"
	,
	"ZAVOI (CARAS SEVERIN)"
	,
	"ZBEGU (CARAS SEVERIN)"
	,
	"ZERVESTI (CARAS SEVERIN)"
	,
	"ZLAGNA (CARAS SEVERIN)"
	,
	"ZLATITA (CARAS SEVERIN)"
	,
	"ZMOGOTIN (CARAS SEVERIN)"
	,
	"ZOINA (CARAS SEVERIN)"
	,
	"ZORILE (CARAS SEVERIN)"
	,
	"ZORLENCIOR (CARAS SEVERIN)"
	,
	"ZORLENTU MARE (CARAS SEVERIN)"
	,
	"AGARBICIU (CLUJ)"
	,
	"AGHIRESU (CLUJ)"
	,
	"AGHIRESU-FABRICI (CLUJ)"
	,
	"AGRIS (CLUJ)"
	,
	"AITON (CLUJ)"
	,
	"ALUNIS (CLUJ)"
	,
	"ALUNISU (CLUJ)"
	,
	"ANDICI (CLUJ)"
	,
	"ANTAS (CLUJ)"
	,
	"APAHIDA (CLUJ)"
	,
	"ARDEOVA (CLUJ)"
	,
	"ARGHISU (CLUJ)"
	,
	"ARUNCUTA (CLUJ)"
	,
	"ASCHILEU (CLUJ)"
	,
	"ASCHILEU MARE (CLUJ)"
	,
	"ASCHILEU MIC (CLUJ)"
	,
	"BABDIU (CLUJ)"
	,
	"BABUTIU (CLUJ)"
	,
	"BACIU (CLUJ)"
	,
	"BADENI (CLUJ)"
	,
	"BADESTI (CLUJ)"
	,
	"BAGACIU (CLUJ)"
	,
	"BAGARA (CLUJ)"
	,
	"BAISOARA (CLUJ)"
	,
	"BAITA (CLUJ)"
	,
	"BALCESTI (BELIS) (CLUJ)"
	,
	"BALCESTI (CAPUSU MARE) (CLUJ)"
	,
	"BARAI (CLUJ)"
	,
	"BARLEA (CLUJ)"
	,
	"BATIN (CLUJ)"
	,
	"BEDECIU (CLUJ)"
	,
	"BELIS (CLUJ)"
	,
	"BERCHIESU (CLUJ)"
	,
	"BERINDU (CLUJ)"
	,
	"BICA (CLUJ)"
	,
	"BICALATU (CLUJ)"
	,
	"BLIDARESTI (CLUJ)"
	,
	"BOBALNA (CLUJ)"
	,
	"BOCIU (CLUJ)"
	,
	"BODROG (CLUJ)"
	,
	"BOGATA (CLUJ)"
	,
	"BOGATA DE JOS (CLUJ)"
	,
	"BOGATA DE SUS (CLUJ)"
	,
	"BOIAN (CLUJ)"
	,
	"BOJ-CATUN (CLUJ)"
	,
	"BOJU (CLUJ)"
	,
	"BOLDUT (CLUJ)"
	,
	"BOLOGA (CLUJ)"
	,
	"BONT (CLUJ)"
	,
	"BONTIDA (CLUJ)"
	,
	"BORSA (CLUJ)"
	,
	"BORSA-CATUN (CLUJ)"
	,
	"BORSA-CRESTAIA (CLUJ)"
	,
	"BORZESTI (CLUJ)"
	,
	"BOTENI (CLUJ)"
	,
	"BRAISORU (CLUJ)"
	,
	"BUCEA (CLUJ)"
	,
	"BUNESTI (CLUJ)"
	,
	"BURU (CLUJ)"
	,
	"BUTENI (CLUJ)"
	,
	"BUZA (CLUJ)"
	,
	"CACOVA IERII (CLUJ)"
	,
	"CAIANU (CLUJ)"
	,
	"CAIANU MIC (CLUJ)"
	,
	"CAIANU-VAMA (CLUJ)"
	,
	"CALARASI (CLUJ)"
	,
	"CALARASI-GARA (CLUJ)"
	,
	"CALATA (CLUJ)"
	,
	"CALATELE (CLUJ)"
	,
	"CALNA (CLUJ)"
	,
	"CAMARASU (CLUJ)"
	,
	"CAMPENESTI (CLUJ)"
	,
	"CAMPIA TURZII (CLUJ)"
	,
	"CAPRIOARA (CLUJ)"
	,
	"CAPUSU MARE (CLUJ)"
	,
	"CAPUSU MIC (CLUJ)"
	,
	"CARA (CLUJ)"
	,
	"CASEIU (CLUJ)"
	,
	"CASELE MICESTI (CLUJ)"
	,
	"CATALINA (CLUJ)"
	,
	"CATCAU (CLUJ)"
	,
	"CATINA (CLUJ)"
	,
	"CEABA (CLUJ)"
	,
	"CEANU MARE (CLUJ)"
	,
	"CEANU MIC (CLUJ)"
	,
	"CERBESTI (CLUJ)"
	,
	"CERC (CLUJ)"
	,
	"CETAN (CLUJ)"
	,
	"CHEIA (CLUJ)"
	,
	"CHESAU (CLUJ)"
	,
	"CHIDEA (CLUJ)"
	,
	"CHINTENI (CLUJ)"
	,
	"CHIRIS (CLUJ)"
	,
	"CHIUIESTI (CLUJ)"
	,
	"CIUBANCA (CLUJ)"
	,
	"CIUBANCUTA (CLUJ)"
	,
	"CIUCEA (CLUJ)"
	,
	"CIULENI (CLUJ)"
	,
	"CIUMAFAIA (CLUJ)"
	,
	"CIURGAU (CLUJ)"
	,
	"CIURILA (CLUJ)"
	,
	"CLAPA (CLUJ)"
	,
	"CLUJ-NAPOCA (CLUJ)"
	,
	"COASTA (CLUJ)"
	,
	"CODOR (CLUJ)"
	,
	"COJOCNA (CLUJ)"
	,
	"COLONIA (CLUJ)"
	,
	"COMORATA (CLUJ)"
	,
	"COMSESTI (CLUJ)"
	,
	"COPACENI (CLUJ)"
	,
	"COPLEAN (CLUJ)"
	,
	"COPRU (CLUJ)"
	,
	"CORNENI (CLUJ)"
	,
	"CORNESTI (CLUJ)"
	,
	"CORNESTI (GARBAU) (CLUJ)"
	,
	"CORNESTI (MIHAI VITEAZU) (CLUJ)"
	,
	"CORPADEA (CLUJ)"
	,
	"CORUSU (CLUJ)"
	,
	"CRAESTI (CLUJ)"
	,
	"CRAIRAT (CLUJ)"
	,
	"CREMENEA (CLUJ)"
	,
	"CRISENI (CLUJ)"
	,
	"CRISTOREL (CLUJ)"
	,
	"CUBLESU SOMESAN (CLUJ)"
	,
	"CURTUIUSU DEJULUI (CLUJ)"
	,
	"CUSTURA (CLUJ)"
	,
	"CUTCA (CLUJ)"
	,
	"CUZDRIOARA (CLUJ)"
	,
	"DABACA (CLUJ)"
	,
	"DAMBU MARE (CLUJ)"
	,
	"DAMBURILE (CLUJ)"
	,
	"DANCU (CLUJ)"
	,
	"DANGAU MARE (CLUJ)"
	,
	"DANGAU MIC (CLUJ)"
	,
	"DARJA (CLUJ)"
	,
	"DAROT (CLUJ)"
	,
	"DEALU BOTII (CLUJ)"
	,
	"DEALU MARE (CLUJ)"
	,
	"DEALU NEGRU (CLUJ)"
	,
	"DEJ (CLUJ)"
	,
	"DELENI (CLUJ)"
	,
	"DEUSU (CLUJ)"
	,
	"DEZMIR (CLUJ)"
	,
	"DIVICIORII MARI (CLUJ)"
	,
	"DIVICIORII MICI (CLUJ)"
	,
	"DOMOSU (CLUJ)"
	,
	"DORNA (CLUJ)"
	,
	"DOROLTU (CLUJ)"
	,
	"DOSU BRICII (CLUJ)"
	,
	"DOSU NAPULUI (CLUJ)"
	,
	"DRETEA (CLUJ)"
	,
	"DUMBRAVA (CLUJ)"
	,
	"ELCIU (CLUJ)"
	,
	"ESCU (CLUJ)"
	,
	"FAGETU IERII (CLUJ)"
	,
	"FALCA (CLUJ)"
	,
	"FANATE (CLUJ)"
	,
	"FAURENI (CLUJ)"
	,
	"FEIURDENI (CLUJ)"
	,
	"FELDIOARA (CLUJ)"
	,
	"FELEACU (CLUJ)"
	,
	"FILEA DE JOS (CLUJ)"
	,
	"FILEA DE SUS (CLUJ)"
	,
	"FINCIU (CLUJ)"
	,
	"FINISEL (CLUJ)"
	,
	"FIZESU GHERLII (CLUJ)"
	,
	"FLORESTI (CLUJ)"
	,
	"FODORA (CLUJ)"
	,
	"FRASINET (CLUJ)"
	,
	"FRATA (CLUJ)"
	,
	"FUNDATURA (CLUJ)"
	,
	"GADALIN (CLUJ)"
	,
	"GARBAU (CLUJ)"
	,
	"GARBAU DEJULUI (CLUJ)"
	,
	"GEACA (CLUJ)"
	,
	"GHEORGHIENI (CLUJ)"
	,
	"GHERLA (CLUJ)"
	,
	"GHIRISU ROMAN (CLUJ)"
	,
	"GHIROLT (CLUJ)"
	,
	"GILAU (CLUJ)"
	,
	"GIULA (CLUJ)"
	,
	"GIURCUTA DE JOS (CLUJ)"
	,
	"GIURCUTA DE SUS (CLUJ)"
	,
	"GLIGORESTI (CLUJ)"
	,
	"GUGA (CLUJ)"
	,
	"HAGAU (CLUJ)"
	,
	"HASDATE (GHERLA) (CLUJ)"
	,
	"HASDATE (SAVADISLA) (CLUJ)"
	,
	"HODAI-BOIAN (CLUJ)"
	,
	"HODAIE (CLUJ)"
	,
	"HODISU (CLUJ)"
	,
	"HORLACEA (CLUJ)"
	,
	"HUCI (CLUJ)"
	,
	"HUEDIN (CLUJ)"
	,
	"HUTA (CLUJ)"
	,
	"IACOBENI (CLUJ)"
	,
	"IARA (CLUJ)"
	,
	"ICLOD (CLUJ)"
	,
	"ICLOZEL (CLUJ)"
	,
	"IGRITIA (CLUJ)"
	,
	"INUCU (CLUJ)"
	,
	"IURIU DE CAMPIE (CLUJ)"
	,
	"IZVORU CRISULUI (CLUJ)"
	,
	"JICHISU DE JOS (CLUJ)"
	,
	"JICHISU DE SUS (CLUJ)"
	,
	"JUC-HERGHELIE (CLUJ)"
	,
	"JUCU (CLUJ)"
	,
	"JUCU DE MIJLOC (CLUJ)"
	,
	"JUCU DE SUS (CLUJ)"
	,
	"JURCA (CLUJ)"
	,
	"LACU (CLUJ)"
	,
	"LAPUSTESTI (CLUJ)"
	,
	"LEGHIA (CLUJ)"
	,
	"LEGII (CLUJ)"
	,
	"LEURDA (CLUJ)"
	,
	"LITA (CLUJ)"
	,
	"LITENI (CLUJ)"
	,
	"LIVADA (ICLOD) (CLUJ)"
	,
	"LIVADA (PETRESTII DE JOS) (CLUJ)"
	,
	"LOBODAS (CLUJ)"
	,
	"LUJERDIU (CLUJ)"
	,
	"LUNA (CLUJ)"
	,
	"LUNA DE JOS (CLUJ)"
	,
	"LUNA DE SUS (CLUJ)"
	,
	"LUNCA BONTULUI (CLUJ)"
	,
	"LUNCA VISAGULUI (CLUJ)"
	,
	"LUNCANI (CLUJ)"
	,
	"LUNGESTI (CLUJ)"
	,
	"MACAU (CLUJ)"
	,
	"MACICASU (CLUJ)"
	,
	"MAGOAJA (CLUJ)"
	,
	"MAGURA IERII (CLUJ)"
	,
	"MAGURI (CLUJ)"
	,
	"MAGURI-RACATAU (CLUJ)"
	,
	"MAHAL (CLUJ)"
	,
	"MAIA (CLUJ)"
	,
	"MANASTIREA (CLUJ)"
	,
	"MANASTIRENI (CLUJ)"
	,
	"MANASTUREL (CLUJ)"
	,
	"MANASTURU ROMANESC (CLUJ)"
	,
	"MARCESTI (CLUJ)"
	,
	"MARGAU (CLUJ)"
	,
	"MARISEL (CLUJ)"
	,
	"MARTINESTI (CLUJ)"
	,
	"MASCA (CLUJ)"
	,
	"MERA (CLUJ)"
	,
	"MICA (CLUJ)"
	,
	"MICESTI (CLUJ)"
	,
	"MIHAI VITEAZU (CLUJ)"
	,
	"MIHAIESTI (CLUJ)"
	,
	"MINTIU GHERLII (CLUJ)"
	,
	"MOARA DE PADURE (CLUJ)"
	,
	"MOCIU (CLUJ)"
	,
	"MOLDOVENESTI (CLUJ)"
	,
	"MORAU (CLUJ)"
	,
	"MORISTI (CLUJ)"
	,
	"MORLACA (CLUJ)"
	,
	"MORTESTI (CLUJ)"
	,
	"MUNCEL (CLUJ)"
	,
	"MUNTELE BAISORII (CLUJ)"
	,
	"MUNTELE BOCULUI (CLUJ)"
	,
	"MUNTELE CACOVEI (CLUJ)"
	,
	"MUNTELE FILII (CLUJ)"
	,
	"MUNTELE RECE (CLUJ)"
	,
	"MUNTELE SACELULUI (CLUJ)"
	,
	"MURESENII DE CAMPIE (CLUJ)"
	,
	"NADASELU (CLUJ)"
	,
	"NADASU (CLUJ)"
	,
	"NAOIU (CLUJ)"
	,
	"NASAL (CLUJ)"
	,
	"NEARSOVA (CLUJ)"
	,
	"NEGRENI (CLUJ)"
	,
	"NICULA (CLUJ)"
	,
	"NIMA (CLUJ)"
	,
	"NIRES (CLUJ)"
	,
	"OAS (CLUJ)"
	,
	"OCNA DEJULUI (CLUJ)"
	,
	"OCOLISEL (CLUJ)"
	,
	"OLARIU (CLUJ)"
	,
	"ORMAN (CLUJ)"
	,
	"OSOI (CLUJ)"
	,
	"OSORHEL (CLUJ)"
	,
	"PADUREA IACOBENI (CLUJ)"
	,
	"PADURENI (CHINTENI) (CLUJ)"
	,
	"PADURENI (CIURILA) (CLUJ)"
	,
	"PADURENII (MINTIU GHERLII) (CLUJ)"
	,
	"PADURENII (TRITENII DE JOS) (CLUJ)"
	,
	"PAGLISA (CLUJ)"
	,
	"PALATCA (CLUJ)"
	,
	"PANICENI (CLUJ)"
	,
	"PANTICEU (CLUJ)"
	,
	"PATA (CLUJ)"
	,
	"PESTERA (CLUJ)"
	,
	"PETEA (CLUJ)"
	,
	"PETRESTI (CLUJ)"
	,
	"PETRESTII DE JOS (CLUJ)"
	,
	"PETRESTII DE MIJLOC (CLUJ)"
	,
	"PETRESTII DE SUS (CLUJ)"
	,
	"PIETROASA (CLUJ)"
	,
	"PINTIC (CLUJ)"
	,
	"PLAIESTI (CLUJ)"
	,
	"PLAIURI (CLUJ)"
	,
	"PLOPI (CLUJ)"
	,
	"PLOSCOS (CLUJ)"
	,
	"PODENI (CLUJ)"
	,
	"POIANA FRATII (CLUJ)"
	,
	"POIANA HOREA (CLUJ)"
	,
	"POIENI (CLUJ)"
	,
	"POPESTI (CLUJ)"
	,
	"PRELUCELE (CLUJ)"
	,
	"PRUNENI (CLUJ)"
	,
	"PRUNI (CLUJ)"
	,
	"PRUNIS (CLUJ)"
	,
	"PUINI (CLUJ)"
	,
	"PUSTUTA (CLUJ)"
	,
	"RACHITELE (CLUJ)"
	,
	"RADAIA (CLUJ)"
	,
	"RASCRUCI (CLUJ)"
	,
	"RAZBUNENI (CLUJ)"
	,
	"RAZOARE (CLUJ)"
	,
	"RECEA-CRISTUR (CLUJ)"
	,
	"REDIU (CLUJ)"
	,
	"RISCA (CLUJ)"
	,
	"ROGOJEL (CLUJ)"
	,
	"ROSIENI (CLUJ)"
	,
	"ROTUNDA (CLUJ)"
	,
	"RUGASESTI (CLUJ)"
	,
	"SACALAIA (CLUJ)"
	,
	"SACEL (CLUJ)"
	,
	"SACUIEU (CLUJ)"
	,
	"SALATIU (CLUJ)"
	,
	"SALATRUC (CLUJ)"
	,
	"SALICEA (CLUJ)"
	,
	"SALISCA (CLUJ)"
	,
	"SALISTE (CLUJ)"
	,
	"SALISTEA NOUA (CLUJ)"
	,
	"SALISTEA VECHE (CLUJ)"
	,
	"SAMBOIENI (CLUJ)"
	,
	"SAMBOLENI (CLUJ)"
	,
	"SANCRAIU (CLUJ)"
	,
	"SANDULESTI (CLUJ)"
	,
	"SANMARGHITA (CLUJ)"
	,
	"SANMARTIN (CLUJ)"
	,
	"SANNICOARA (CLUJ)"
	,
	"SANPAUL (CLUJ)"
	,
	"SANTEJUDE (CLUJ)"
	,
	"SANTEJUDE-VALE (CLUJ)"
	,
	"SANTIOANA (CLUJ)"
	,
	"SARADIS (CLUJ)"
	,
	"SARATA (CLUJ)"
	,
	"SARDU (CLUJ)"
	,
	"SATU LUNG (CLUJ)"
	,
	"SAULA (CLUJ)"
	,
	"SAVA (CLUJ)"
	,
	"SAVADISLA (CLUJ)"
	,
	"SCRIND-FRASINET (CLUJ)"
	,
	"SIC (CLUJ)"
	,
	"SICFA (CLUJ)"
	,
	"SIGAU (CLUJ)"
	,
	"SILIVAS (CLUJ)"
	,
	"SMIDA (CLUJ)"
	,
	"SOIMENI (CLUJ)"
	,
	"SOMCUTU MIC (CLUJ)"
	,
	"SOMESU CALD (CLUJ)"
	,
	"SOMESU RECE (CLUJ)"
	,
	"SOPORU DE CAMPIE (CLUJ)"
	,
	"STARCU (CLUJ)"
	,
	"STEJERIS (CLUJ)"
	,
	"STOIANA (CLUJ)"
	,
	"STOLNA (CLUJ)"
	,
	"STRAJA (CAPUSU MARE) (CLUJ)"
	,
	"STRAJA (COJOCNA) (CLUJ)"
	,
	"STRAMBU (CLUJ)"
	,
	"STRUCUT (CLUJ)"
	,
	"SUARAS (CLUJ)"
	,
	"SUATU (CLUJ)"
	,
	"SUB COASTA (CLUJ)"
	,
	"SUCEAGU (CLUJ)"
	,
	"SUCUTARD (CLUJ)"
	,
	"SUMURDUCU (CLUJ)"
	,
	"SURDUC (CLUJ)"
	,
	"SUTU (CLUJ)"
	,
	"TAGA (CLUJ)"
	,
	"TARGUSOR (CLUJ)"
	,
	"TARNITA (CLUJ)"
	,
	"TARPIU (CLUJ)"
	,
	"TAUSENI (CLUJ)"
	,
	"TAUTI (CLUJ)"
	,
	"TICU (CLUJ)"
	,
	"TICU-COLONIE (CLUJ)"
	,
	"TIOCU DE JOS (CLUJ)"
	,
	"TIOCU DE SUS (CLUJ)"
	,
	"TIOLTIUR (CLUJ)"
	,
	"TOPA MICA (CLUJ)"
	,
	"TRANISU (CLUJ)"
	,
	"TRITENII DE JOS (CLUJ)"
	,
	"TRITENII DE SUS (CLUJ)"
	,
	"TRITENII-HOTAR (CLUJ)"
	,
	"TURDA (CLUJ)"
	,
	"TUREA (CLUJ)"
	,
	"TURENI (CLUJ)"
	,
	"TURMASI (CLUJ)"
	,
	"UNGURAS (CLUJ)"
	,
	"URCA (CLUJ)"
	,
	"URISOR (CLUJ)"
	,
	"VAD (CLUJ)"
	,
	"VAIDA-CAMARAS (CLUJ)"
	,
	"VALCELE (CLUJ)"
	,
	"VALCELELE (CLUJ)"
	,
	"VALE (CLUJ)"
	,
	"VALEA AGRISULUI (CLUJ)"
	,
	"VALEA CALDA (CLUJ)"
	,
	"VALEA CASEIELULUI (CLUJ)"
	,
	"VALEA CIRESOII (CLUJ)"
	,
	"VALEA DRAGANULUI (CLUJ)"
	,
	"VALEA FLORILOR (CLUJ)"
	,
	"VALEA GARBOULUI (CLUJ)"
	,
	"VALEA GROSILOR (CLUJ)"
	,
	"VALEA IERII (CLUJ)"
	,
	"VALEA LUI CATI (CLUJ)"
	,
	"VALEA LUI OPRIS (CLUJ)"
	,
	"VALEA LUNCII (CLUJ)"
	,
	"VALEA UNGURASULUI (CLUJ)"
	,
	"VALEA VADULUI (CLUJ)"
	,
	"VALENI (CAIANU) (CLUJ)"
	,
	"VALENI (CALATELE) (CLUJ)"
	,
	"VALISOARA (CLUJ)"
	,
	"VANATORI (CLUJ)"
	,
	"VECHEA (CLUJ)"
	,
	"VIISOARA (CLUJ)"
	,
	"VISAGU (CLUJ)"
	,
	"VISEA (CLUJ)"
	,
	"VISTEA (CLUJ)"
	,
	"VLAHA (CLUJ)"
	,
	"VULTURENI (CLUJ)"
	,
	"ZORENII DE VALE (CLUJ)"
	,
	"2 MAI (CONSTANTA)"
	,
	"23 AUGUST (CONSTANTA)"
	,
	"ABRUD (CONSTANTA)"
	,
	"ADAMCLISI (CONSTANTA)"
	,
	"AGIGEA (CONSTANTA)"
	,
	"ALBESTI (CONSTANTA)"
	,
	"ALIMAN (CONSTANTA)"
	,
	"ALMALAU (CONSTANTA)"
	,
	"AMZACEA (CONSTANTA)"
	,
	"ARSA (CONSTANTA)"
	,
	"AURORA (CONSTANTA)"
	,
	"BALTAGESTI (CONSTANTA)"
	,
	"BANEASA (CONSTANTA)"
	,
	"BARAGANU (CONSTANTA)"
	,
	"BASARABI (CONSTANTA)"
	,
	"BIRUINTA (CONSTANTA)"
	,
	"BREBENI (CONSTANTA)"
	,
	"BUGEAC (CONSTANTA)"
	,
	"CALUGARENI (CONSTANTA)"
	,
	"CANLIA (CONSTANTA)"
	,
	"CAPIDAVA (CONSTANTA)"
	,
	"CARVAN (CONSTANTA)"
	,
	"CASCIOARELE (CONSTANTA)"
	,
	"CASIAN (CONSTANTA)"
	,
	"CASICEA (CONSTANTA)"
	,
	"CASTELU (CONSTANTA)"
	,
	"CERCHEZU (CONSTANTA)"
	,
	"CERNAVODA (CONSTANTA)"
	,
	"CETATEA (CONSTANTA)"
	,
	"CHEIA (CONSTANTA)"
	,
	"CHIRNOGENI (CONSTANTA)"
	,
	"CIOBANITA (CONSTANTA)"
	,
	"CIOBANU (CONSTANTA)"
	,
	"CIOCARLIA (CONSTANTA)"
	,
	"CIOCARLIA DE SUS (CONSTANTA)"
	,
	"CLOSCA (CONSTANTA)"
	,
	"COBADIN (CONSTANTA)"
	,
	"COCHIRLENI (CONSTANTA)"
	,
	"COGEALAC (CONSTANTA)"
	,
	"COMANA (CONSTANTA)"
	,
	"CONACU (CONSTANTA)"
	,
	"CONSTANTA (CONSTANTA)"
	,
	"CORBU (CONSTANTA)"
	,
	"COROANA (CONSTANTA)"
	,
	"COSLUGEA (CONSTANTA)"
	,
	"COSTINESTI (CONSTANTA)"
	,
	"COTU VAII (CONSTANTA)"
	,
	"CRANGU (CONSTANTA)"
	,
	"CREDINTA (CONSTANTA)"
	,
	"CRISAN (CONSTANTA)"
	,
	"CRUCEA (CONSTANTA)"
	,
	"CUIUGIUC (CONSTANTA)"
	,
	"CUMPANA (CONSTANTA)"
	,
	"CURCANI (CONSTANTA)"
	,
	"CUZA VODA (CONSTANTA)"
	,
	"DARABANI (CONSTANTA)"
	,
	"DELENI (CONSTANTA)"
	,
	"DOBROMIR (CONSTANTA)"
	,
	"DOBROMIRU DIN DEAL (CONSTANTA)"
	,
	"DOROBANTU (CONSTANTA)"
	,
	"DROPIA (CONSTANTA)"
	,
	"DULCESTI (CONSTANTA)"
	,
	"DULGHERU (CONSTANTA)"
	,
	"DUMBRAVENI (CONSTANTA)"
	,
	"DUNAREA (CONSTANTA)"
	,
	"DUNARENI (CONSTANTA)"
	,
	"EFORIE (CONSTANTA)"
	,
	"EFORIE NORD (CONSTANTA)"
	,
	"EFORIE SUD (CONSTANTA)"
	,
	"ESECHIOI (CONSTANTA)"
	,
	"FACLIA (CONSTANTA)"
	,
	"FANTANA MARE (CONSTANTA)"
	,
	"FANTANELE (CONSTANTA)"
	,
	"FAUREI (CONSTANTA)"
	,
	"FLORIILE (CONSTANTA)"
	,
	"FURNICA (CONSTANTA)"
	,
	"GALBIORI (CONSTANTA)"
	,
	"GALITA (CONSTANTA)"
	,
	"GARLICIU (CONSTANTA)"
	,
	"GARLITA (CONSTANTA)"
	,
	"GENERAL SCARISOREANU (CONSTANTA)"
	,
	"GHERGHINA (CONSTANTA)"
	,
	"GHINDARESTI (CONSTANTA)"
	,
	"GORUNI (CONSTANTA)"
	,
	"GRADINA (CONSTANTA)"
	,
	"GRANICERU (CONSTANTA)"
	,
	"GURA DOBROGEI (CONSTANTA)"
	,
	"HAGIENI (CONSTANTA)"
	,
	"HARSOVA (CONSTANTA)"
	,
	"HATEG (CONSTANTA)"
	,
	"HORIA (CONSTANTA)"
	,
	"INDEPENDENTA (CONSTANTA)"
	,
	"ION CORVIN (CONSTANTA)"
	,
	"ISTRIA (CONSTANTA)"
	,
	"IVRINEZU MARE (CONSTANTA)"
	,
	"IVRINEZU MIC (CONSTANTA)"
	,
	"IZVOARELE (CONSTANTA)"
	,
	"IZVORU MARE (CONSTANTA)"
	,
	"JUPITER (CONSTANTA)"
	,
	"LANURILE (CONSTANTA)"
	,
	"LAZU (CONSTANTA)"
	,
	"LESPEZI (CONSTANTA)"
	,
	"LIMANU (CONSTANTA)"
	,
	"LIPNITA (CONSTANTA)"
	,
	"LUMINA (CONSTANTA)"
	,
	"LUMINITA (CONSTANTA)"
	,
	"MAGURA (CONSTANTA)"
	,
	"MAMAIA (CONSTANTA)"
	,
	"MAMAIA-SAT (CONSTANTA)"
	,
	"MANGALIA (CONSTANTA)"
	,
	"MEDGIDIA (CONSTANTA)"
	,
	"MERENI (CONSTANTA)"
	,
	"MIHAI VITEAZU (CONSTANTA)"
	,
	"MIHAIL KOGALNICEANU (CONSTANTA)"
	,
	"MIORITA (CONSTANTA)"
	,
	"MIRCEA VODA (CONSTANTA)"
	,
	"MIREASA (CONSTANTA)"
	,
	"MIRISTEA (CONSTANTA)"
	,
	"MOSNENI (CONSTANTA)"
	,
	"MOVILA VERDE (CONSTANTA)"
	,
	"MOVILITA (CONSTANTA)"
	,
	"NAVODARI (CONSTANTA)"
	,
	"NAVODARI TABARA (CONSTANTA)"
	,
	"NAZARCEA (CONSTANTA)"
	,
	"NEGRESTI (CONSTANTA)"
	,
	"NEGRU VODA (CONSTANTA)"
	,
	"NEGURENI (CONSTANTA)"
	,
	"NEPTUN (CONSTANTA)"
	,
	"NICOLAE BALCESCU (CONSTANTA)"
	,
	"NISIPARI (CONSTANTA)"
	,
	"NISTORESTI (CONSTANTA)"
	,
	"NUNTASI (CONSTANTA)"
	,
	"OITUZ (CONSTANTA)"
	,
	"OLIMP (CONSTANTA)"
	,
	"OLTENI (CONSTANTA)"
	,
	"OLTINA (CONSTANTA)"
	,
	"OSMANCEA (CONSTANTA)"
	,
	"OSTROV (CONSTANTA)"
	,
	"OVIDIU (CONSTANTA)"
	,
	"PADURENI (CONSTANTA)"
	,
	"PALAZU MARE (CONSTANTA)"
	,
	"PALAZU MIC (CONSTANTA)"
	,
	"PANTELIMON (CONSTANTA)"
	,
	"PANTELIMON DE JOS (CONSTANTA)"
	,
	"PECINEAGA (CONSTANTA)"
	,
	"PELINU (CONSTANTA)"
	,
	"PESTERA (CONSTANTA)"
	,
	"PETROSANI (CONSTANTA)"
	,
	"PIATRA (CONSTANTA)"
	,
	"PIETRENI (CONSTANTA)"
	,
	"PLOPENI (CONSTANTA)"
	,
	"POARTA ALBA (CONSTANTA)"
	,
	"POIANA (CONSTANTA)"
	,
	"POTARNICHEA (CONSTANTA)"
	,
	"RAMNICU DE JOS (CONSTANTA)"
	,
	"RAMNICU DE SUS (CONSTANTA)"
	,
	"RARISTEA (CONSTANTA)"
	,
	"RASOVA (CONSTANTA)"
	,
	"RAZOARELE (CONSTANTA)"
	,
	"REMUS OPREANU (CONSTANTA)"
	,
	"RUNCU (CONSTANTA)"
	,
	"SACELE (CONSTANTA)"
	,
	"SALIGNY (CONSTANTA)"
	,
	"SANATORIUL AGIGEA (CONSTANTA)"
	,
	"SARAIU (CONSTANTA)"
	,
	"SATU NOU (MIRCEA VODA) (CONSTANTA)"
	,
	"SATU NOU (OLTINA) (CONSTANTA)"
	,
	"SATURN (CONSTANTA)"
	,
	"SCHITU (CONSTANTA)"
	,
	"SEIMENI (CONSTANTA)"
	,
	"SEIMENII MICI (CONSTANTA)"
	,
	"SIBIOARA (CONSTANTA)"
	,
	"SILISTEA (CONSTANTA)"
	,
	"SIMINOC (CONSTANTA)"
	,
	"SINOIE (CONSTANTA)"
	,
	"SIPOTELE (CONSTANTA)"
	,
	"SIRIU (CONSTANTA)"
	,
	"STATIUNEA ZOOLOGICA MARINA AGIGEA (CONSTANTA)"
	,
	"STEFAN CEL MARE (CONSTANTA)"
	,
	"STEJARU (CONSTANTA)"
	,
	"STRAJA (CONSTANTA)"
	,
	"STRUNGA (CONSTANTA)"
	,
	"STUPINA (CONSTANTA)"
	,
	"TARGUSOR (CONSTANTA)"
	,
	"TARIVERDE (CONSTANTA)"
	,
	"TATARU (CONSTANTA)"
	,
	"TECHIRGHIOL (CONSTANTA)"
	,
	"TEPES VODA (CONSTANTA)"
	,
	"TIBRINU (CONSTANTA)"
	,
	"TICHILESTI (CONSTANTA)"
	,
	"TOPALU (CONSTANTA)"
	,
	"TOPRAISAR (CONSTANTA)"
	,
	"TORTOMAN (CONSTANTA)"
	,
	"TRAIAN (CONSTANTA)"
	,
	"TUDOR VLADIMIRESCU (CONSTANTA)"
	,
	"TUFANI (CONSTANTA)"
	,
	"TUZLA (CONSTANTA)"
	,
	"URLUIA (CONSTANTA)"
	,
	"VADU (CONSTANTA)"
	,
	"VADU OII (CONSTANTA)"
	,
	"VALCELELE (CONSTANTA)"
	,
	"VALEA DACILOR (CONSTANTA)"
	,
	"VALENI (CONSTANTA)"
	,
	"VALU LUI TRAIAN (CONSTANTA)"
	,
	"VAMA VECHE (CONSTANTA)"
	,
	"VANATORI (CONSTANTA)"
	,
	"VARTOP (CONSTANTA)"
	,
	"VENUS (CONSTANTA)"
	,
	"VETERANU (CONSTANTA)"
	,
	"VIILE (CONSTANTA)"
	,
	"VIISOARA (CONSTANTA)"
	,
	"VIROAGA (CONSTANTA)"
	,
	"VLAHII (CONSTANTA)"
	,
	"VULTURU (CONSTANTA)"
	,
	"ZORILE (CONSTANTA)"
	,
	"AITA MARE (COVASNA)"
	,
	"AITA MEDIE (COVASNA)"
	,
	"AITA SEACA (COVASNA)"
	,
	"ALBIS (COVASNA)"
	,
	"ALUNGENI (COVASNA)"
	,
	"ANGHELUS (COVASNA)"
	,
	"ANINOASA (COVASNA)"
	,
	"ARACI (COVASNA)"
	,
	"ARCUS (COVASNA)"
	,
	"ARIUSD (COVASNA)"
	,
	"BACEL (COVASNA)"
	,
	"BARAOLT (COVASNA)"
	,
	"BARCANI (COVASNA)"
	,
	"BATANI (COVASNA)"
	,
	"BATANII MARI (COVASNA)"
	,
	"BATANII MICI (COVASNA)"
	,
	"BELANI (COVASNA)"
	,
	"BELIN (COVASNA)"
	,
	"BELIN-VALE (COVASNA)"
	,
	"BIBORTENI (COVASNA)"
	,
	"BICFALAU (COVASNA)"
	,
	"BITA (COVASNA)"
	,
	"BIXAD (COVASNA)"
	,
	"BODOC (COVASNA)"
	,
	"BODOS (COVASNA)"
	,
	"BOROSNEU MARE (COVASNA)"
	,
	"BOROSNEU MIC (COVASNA)"
	,
	"BRADET (COVASNA)"
	,
	"BRADUT (COVASNA)"
	,
	"BRATES (COVASNA)"
	,
	"BRETCU (COVASNA)"
	,
	"CALNIC (COVASNA)"
	,
	"CAPENI (COVASNA)"
	,
	"CARPINENII (COVASNA)"
	,
	"CASINU MIC (COVASNA)"
	,
	"CATALINA (COVASNA)"
	,
	"CERNAT (COVASNA)"
	,
	"CHICHIS (COVASNA)"
	,
	"CHILIENI (COVASNA)"
	,
	"CHIURUS (COVASNA)"
	,
	"COMANDAU (COVASNA)"
	,
	"COSENI (COVASNA)"
	,
	"COVASNA (COVASNA)"
	,
	"CRASNA (COVASNA)"
	,
	"DALNIC (COVASNA)"
	,
	"DOBARLAU (COVASNA)"
	,
	"DOBOLII DE JOS (COVASNA)"
	,
	"DOBOLII DE SUS (COVASNA)"
	,
	"DOBOSENI (COVASNA)"
	,
	"ESTELNIC (COVASNA)"
	,
	"FILIA (COVASNA)"
	,
	"FLOROAIA (COVASNA)"
	,
	"FOTOS (COVASNA)"
	,
	"GHELINTA (COVASNA)"
	,
	"GHIDFALAU (COVASNA)"
	,
	"HAGHIG (COVASNA)"
	,
	"HARALE (COVASNA)"
	,
	"HATUICA (COVASNA)"
	,
	"HERCULIAN (COVASNA)"
	,
	"HETEA (COVASNA)"
	,
	"HILIB (COVASNA)"
	,
	"IARAS (COVASNA)"
	,
	"ICAFALAU (COVASNA)"
	,
	"ILIENI (COVASNA)"
	,
	"IMENI (COVASNA)"
	,
	"INTORSURA BUZAULUI (COVASNA)"
	,
	"LADAUTI (COVASNA)"
	,
	"LEMNIA (COVASNA)"
	,
	"LET (COVASNA)"
	,
	"LISNAU (COVASNA)"
	,
	"LISNAU-VALE (COVASNA)"
	,
	"LUNCA MARCUSULUI (COVASNA)"
	,
	"LUNCA OZUNULUI (COVASNA)"
	,
	"LUNGA (COVASNA)"
	,
	"LUTOASA (COVASNA)"
	,
	"MAGHERUS (COVASNA)"
	,
	"MALNAS (COVASNA)"
	,
	"MALNAS-BAI (COVASNA)"
	,
	"MARCUS (COVASNA)"
	,
	"MARCUSA (COVASNA)"
	,
	"MARTANUS (COVASNA)"
	,
	"MARTINENI (COVASNA)"
	,
	"MERENI (COVASNA)"
	,
	"MERISOR (COVASNA)"
	,
	"MICFALAU (COVASNA)"
	,
	"MICLOSOARA (COVASNA)"
	,
	"MOACSA (COVASNA)"
	,
	"OITUZ (COVASNA)"
	,
	"OJDULA (COVASNA)"
	,
	"OLTENI (COVASNA)"
	,
	"OZUN (COVASNA)"
	,
	"OZUNCA-BAI (COVASNA)"
	,
	"PACHIA (COVASNA)"
	,
	"PADURENI (COVASNA)"
	,
	"PAPAUTI (COVASNA)"
	,
	"PETENI (COVASNA)"
	,
	"PETRICENI (COVASNA)"
	,
	"POIAN (COVASNA)"
	,
	"RACOSUL DE SUS (COVASNA)"
	,
	"RECI (COVASNA)"
	,
	"SACIOVA (COVASNA)"
	,
	"SANCRAIU (COVASNA)"
	,
	"SANTIONLUNCA (COVASNA)"
	,
	"SANZIENI (COVASNA)"
	,
	"SARAMAS (COVASNA)"
	,
	"SCRADOASA (COVASNA)"
	,
	"SFANTU GHEORGHE (COVASNA)"
	,
	"SITA BUZAULUI (COVASNA)"
	,
	"SURCEA (COVASNA)"
	,
	"TALISOARA (COVASNA)"
	,
	"TAMASFALAU (COVASNA)"
	,
	"TARGU SECUIESC (COVASNA)"
	,
	"TELECHIA (COVASNA)"
	,
	"TUFALAU (COVASNA)"
	,
	"TURIA (COVASNA)"
	,
	"VALCELE (COVASNA)"
	,
	"VALEA CRISULUI (COVASNA)"
	,
	"VALEA DOBARLAULUI (COVASNA)"
	,
	"VALEA MARE (COVASNA)"
	,
	"VALEA MICA (COVASNA)"
	,
	"VALEA SCURTA (COVASNA)"
	,
	"VALEA SEACA (COVASNA)"
	,
	"VALEA ZALANULUI (COVASNA)"
	,
	"VARGHIS (COVASNA)"
	,
	"ZABALA (COVASNA)"
	,
	"ZABRATAU (COVASNA)"
	,
	"ZAGON (COVASNA)"
	,
	"ZALAN (COVASNA)"
	,
	"ZOLTAN (COVASNA)"
	,
	"NECUNOSCUT (DAMBOVITA)"
	,
	"ALUNIS (DAMBOVITA)"
	,
	"ALUNISU (DAMBOVITA)"
	,
	"ANINOASA (DAMBOVITA)"
	,
	"ANINOSANI (DAMBOVITA)"
	,
	"BACESTI (DAMBOVITA)"
	,
	"BADENI (DAMBOVITA)"
	,
	"BADULESTI (DAMBOVITA)"
	,
	"BALANESTI (DAMBOVITA)"
	,
	"BALDANA (DAMBOVITA)"
	,
	"BALENI (DAMBOVITA)"
	,
	"BALENI-ROMANI (DAMBOVITA)"
	,
	"BALENI-SARBI (DAMBOVITA)"
	,
	"BALTENI (DAMBOVITA)"
	,
	"BANESTI (DAMBOVITA)"
	,
	"BARACENI (DAMBOVITA)"
	,
	"BARBUCEANU (DAMBOVITA)"
	,
	"BARBULETU (DAMBOVITA)"
	,
	"BECHINESTI (DAMBOVITA)"
	,
	"BELA (DAMBOVITA)"
	,
	"BEREVOESTI (DAMBOVITA)"
	,
	"BEZDEAD (DAMBOVITA)"
	,
	"BILCIURESTI (DAMBOVITA)"
	,
	"BLIDARI (DAMBOVITA)"
	,
	"BOBOCI (DAMBOVITA)"
	,
	"BOLOVANI (DAMBOVITA)"
	,
	"BOTENI (DAMBOVITA)"
	,
	"BRADATEL (DAMBOVITA)"
	,
	"BRANCOVEANU (DAMBOVITA)"
	,
	"BRANESTI (DAMBOVITA)"
	,
	"BRANISTEA (DAMBOVITA)"
	,
	"BRATESTII DE JOS (DAMBOVITA)"
	,
	"BREBU (DAMBOVITA)"
	,
	"BREZOAELE (DAMBOVITA)"
	,
	"BREZOAIA (DAMBOVITA)"
	,
	"BROSTENI (BEZDEAD) (DAMBOVITA)"
	,
	"BROSTENI (PRODULESTI) (DAMBOVITA)"
	,
	"BROSTENI (VISINA) (DAMBOVITA)"
	,
	"BUCIUMENI (DAMBOVITA)"
	,
	"BUCSANI (DAMBOVITA)"
	,
	"BUJOREANCA (DAMBOVITA)"
	,
	"BUMBUIA (DAMBOVITA)"
	,
	"BUNGETU (DAMBOVITA)"
	,
	"BURDUCA (DAMBOVITA)"
	,
	"BUTIMANU (DAMBOVITA)"
	,
	"BUTOIU DE JOS (DAMBOVITA)"
	,
	"BUTOIU DE SUS (DAMBOVITA)"
	,
	"CALUGARENI (COBIA) (DAMBOVITA)"
	,
	"CALUGARENI (CONTESTI) (DAMBOVITA)"
	,
	"CANDESTI (DAMBOVITA)"
	,
	"CANDESTI-DEAL (DAMBOVITA)"
	,
	"CANDESTI-VALE (DAMBOVITA)"
	,
	"CAPRIORU (DAMBOVITA)"
	,
	"CAPSUNA (DAMBOVITA)"
	,
	"CAPU COASTEI (DAMBOVITA)"
	,
	"CARLANESTI (DAMBOVITA)"
	,
	"CATANELE (DAMBOVITA)"
	,
	"CATUNU (CORNESTI) (DAMBOVITA)"
	,
	"CATUNU (SALCIOARA) (DAMBOVITA)"
	,
	"CAZACI (DAMBOVITA)"
	,
	"CETATUIA (DAMBOVITA)"
	,
	"CHIRCA (DAMBOVITA)"
	,
	"CIOCANARI (DAMBOVITA)"
	,
	"CIOCANESTI (DAMBOVITA)"
	,
	"COADA IZVORULUI (DAMBOVITA)"
	,
	"COBIA (DAMBOVITA)"
	,
	"COBIUTA (DAMBOVITA)"
	,
	"COCANI (DAMBOVITA)"
	,
	"COJASCA (DAMBOVITA)"
	,
	"COJOCARU (DAMBOVITA)"
	,
	"COJOIU (DAMBOVITA)"
	,
	"COLACU (DAMBOVITA)"
	,
	"COLANU (DAMBOVITA)"
	,
	"COLIBASI (DAMBOVITA)"
	,
	"COMISANI (DAMBOVITA)"
	,
	"CONTESTI (DAMBOVITA)"
	,
	"COPACENI (DAMBOVITA)"
	,
	"CORBII MARI (DAMBOVITA)"
	,
	"CORNATELU (DAMBOVITA)"
	,
	"CORNESTI (DAMBOVITA)"
	,
	"CORNI (DAMBOVITA)"
	,
	"COSTESTI (DAMBOVITA)"
	,
	"COSTESTII DIN DEAL (DAMBOVITA)"
	,
	"COSTESTII DIN VALE (DAMBOVITA)"
	,
	"COSTISATA (DAMBOVITA)"
	,
	"CRACIUNESTI (DAMBOVITA)"
	,
	"CRANGASI (DAMBOVITA)"
	,
	"CRANGURILE (DAMBOVITA)"
	,
	"CRANGURILE DE JOS (DAMBOVITA)"
	,
	"CRANGURILE DE SUS (DAMBOVITA)"
	,
	"CRETU (DAMBOVITA)"
	,
	"CRETULESTI (DAMBOVITA)"
	,
	"CREVEDIA (DAMBOVITA)"
	,
	"CRICOVU DULCE (DAMBOVITA)"
	,
	"CRISTEASCA (DAMBOVITA)"
	,
	"CRIVATU (DAMBOVITA)"
	,
	"CROITORI (DAMBOVITA)"
	,
	"CROVU (DAMBOVITA)"
	,
	"CUCUTENI (DAMBOVITA)"
	,
	"CUPARU (DAMBOVITA)"
	,
	"CUZA VODA (DAMBOVITA)"
	,
	"DAMBOVICIOARA (DAMBOVITA)"
	,
	"DARMANESTI (DAMBOVITA)"
	,
	"DARZA (DAMBOVITA)"
	,
	"DEALU FRUMOS (DAMBOVITA)"
	,
	"DEALU MARE (DAMBOVITA)"
	,
	"DECINDEA (DAMBOVITA)"
	,
	"DECINDENI (DAMBOVITA)"
	,
	"DIACONESTI (DAMBOVITA)"
	,
	"DIMOIU (DAMBOVITA)"
	,
	"DOBRA (DAMBOVITA)"
	,
	"DOBRESTI (DAMBOVITA)"
	,
	"DOICESTI (DAMBOVITA)"
	,
	"DOSPINESTI (DAMBOVITA)"
	,
	"DRAGAESTI-PAMANTENI (DAMBOVITA)"
	,
	"DRAGAESTI-UNGURENI (DAMBOVITA)"
	,
	"DRAGODANA (DAMBOVITA)"
	,
	"DRAGODANESTI (DAMBOVITA)"
	,
	"DRAGOMIRESTI (DAMBOVITA)"
	,
	"DUMBRAVA (DAMBOVITA)"
	,
	"DUPA DEAL (DAMBOVITA)"
	,
	"FAGETU (DAMBOVITA)"
	,
	"FANTANELE (DAMBOVITA)"
	,
	"FERESTRE (DAMBOVITA)"
	,
	"FETENI (DAMBOVITA)"
	,
	"FIENI (DAMBOVITA)"
	,
	"FIERBINTI (DAMBOVITA)"
	,
	"FINTA (DAMBOVITA)"
	,
	"FINTA MARE (DAMBOVITA)"
	,
	"FINTA VECHE (DAMBOVITA)"
	,
	"FRASIN-DEAL (DAMBOVITA)"
	,
	"FRASIN-VALE (DAMBOVITA)"
	,
	"FRASINU (DAMBOVITA)"
	,
	"FUSEA (DAMBOVITA)"
	,
	"GAESTI (DAMBOVITA)"
	,
	"GAMANESTI (DAMBOVITA)"
	,
	"GARLENI (DAMBOVITA)"
	,
	"GEANGOESTI (DAMBOVITA)"
	,
	"GEMENEA-BRATULESTI (DAMBOVITA)"
	,
	"GHEBOAIA (DAMBOVITA)"
	,
	"GHEBOIENI (DAMBOVITA)"
	,
	"GHERGANI (DAMBOVITA)"
	,
	"GHERGHESTI (DAMBOVITA)"
	,
	"GHERGHITESTI (DAMBOVITA)"
	,
	"GHIMPATI (DAMBOVITA)"
	,
	"GHINESTI (DAMBOVITA)"
	,
	"GHIRDOVENI (DAMBOVITA)"
	,
	"GLOD (DAMBOVITA)"
	,
	"GLODENI (DAMBOVITA)"
	,
	"GLODENI (PUCIOASA) (DAMBOVITA)"
	,
	"GLOGOVEANU (DAMBOVITA)"
	,
	"GORGOTA (DAMBOVITA)"
	,
	"GRECI (DAMBOVITA)"
	,
	"GROZAVESTI (DAMBOVITA)"
	,
	"GULIA (DAMBOVITA)"
	,
	"GURA BARBULETULUI (DAMBOVITA)"
	,
	"GURA FOII (DAMBOVITA)"
	,
	"GURA OCNITEI (DAMBOVITA)"
	,
	"GURA SUTII (DAMBOVITA)"
	,
	"GURA VULCANEI (DAMBOVITA)"
	,
	"GUSOIU (DAMBOVITA)"
	,
	"HABENI (DAMBOVITA)"
	,
	"HAGIOAICA (DAMBOVITA)"
	,
	"HANU LUI PALA (DAMBOVITA)"
	,
	"HELESTEU (DAMBOVITA)"
	,
	"HODARASTI (DAMBOVITA)"
	,
	"HULUBESTI (DAMBOVITA)"
	,
	"IL CARAGIALE (DAMBOVITA)"
	,
	"IAZU (DAMBOVITA)"
	,
	"IBRIANU (DAMBOVITA)"
	,
	"IEDERA (DAMBOVITA)"
	,
	"IEDERA DE JOS (DAMBOVITA)"
	,
	"IEDERA DE SUS (DAMBOVITA)"
	,
	"ILFOVENI (DAMBOVITA)"
	,
	"IONESTI (DAMBOVITA)"
	,
	"IZVOARELE (DAMBOVITA)"
	,
	"IZVORU (VALEA LUNGA) (DAMBOVITA)"
	,
	"IZVORU (VISINA) (DAMBOVITA)"
	,
	"JUGURENI (DAMBOVITA)"
	,
	"LACULETE (DAMBOVITA)"
	,
	"LACULETE-GARA (DAMBOVITA)"
	,
	"LAZURI (DAMBOVITA)"
	,
	"LIVEZILE (GLODENI) (DAMBOVITA)"
	,
	"LIVEZILE (VALEA MARE) (DAMBOVITA)"
	,
	"LUCIANCA (DAMBOVITA)"
	,
	"LUCIENI (DAMBOVITA)"
	,
	"LUDESTI (DAMBOVITA)"
	,
	"LUNCA (MOROENI) (DAMBOVITA)"
	,
	"LUNCA (VOINESTI) (DAMBOVITA)"
	,
	"LUNGULETU (DAMBOVITA)"
	,
	"MAGURA (BEZDEAD) (DAMBOVITA)"
	,
	"MAGURA (HULUBESTI) (DAMBOVITA)"
	,
	"MALU CU FLORI (DAMBOVITA)"
	,
	"MALU MIERII (DAMBOVITA)"
	,
	"MALURILE (DAMBOVITA)"
	,
	"MANASTIOARA (DAMBOVITA)"
	,
	"MANASTIREA (DAMBOVITA)"
	,
	"MANESTI (DAMBOVITA)"
	,
	"MANGA (DAMBOVITA)"
	,
	"MANJINA (DAMBOVITA)"
	,
	"MARCESTI (DAMBOVITA)"
	,
	"MARGINENII DE SUS (DAMBOVITA)"
	,
	"MARUNTISU (DAMBOVITA)"
	,
	"MATASARU (DAMBOVITA)"
	,
	"MATRACA (DAMBOVITA)"
	,
	"MAVRODIN (DAMBOVITA)"
	,
	"MEISOARE (DAMBOVITA)"
	,
	"MERENI (CONTESTI) (DAMBOVITA)"
	,
	"MERENI (TITU) (DAMBOVITA)"
	,
	"MERII (DAMBOVITA)"
	,
	"MERISORU (DAMBOVITA)"
	,
	"MESTEACAN (DAMBOVITA)"
	,
	"MICLOSANII MARI (DAMBOVITA)"
	,
	"MICLOSANII MICI (DAMBOVITA)"
	,
	"MICULESTI (DAMBOVITA)"
	,
	"MIJA (DAMBOVITA)"
	,
	"MILOSARI (DAMBOVITA)"
	,
	"MIRCEA VODA (DAMBOVITA)"
	,
	"MISLEA (DAMBOVITA)"
	,
	"MIULESTI (DAMBOVITA)"
	,
	"MOARA DIN GROAPA (DAMBOVITA)"
	,
	"MOARA NOUA (DAMBOVITA)"
	,
	"MOGOSANI (DAMBOVITA)"
	,
	"MOGOSESTI (DAMBOVITA)"
	,
	"MORENI (DAMBOVITA)"
	,
	"MOROENI (DAMBOVITA)"
	,
	"MORTENI (DAMBOVITA)"
	,
	"MOSIA MICA (DAMBOVITA)"
	,
	"MOTAIENI (DAMBOVITA)"
	,
	"MOVILA (NICULESTI) (DAMBOVITA)"
	,
	"MOVILA (SALCIOARA) (DAMBOVITA)"
	,
	"MUSCEL (DAMBOVITA)"
	,
	"NEAJLOVU (DAMBOVITA)"
	,
	"NICOLAESTI (DAMBOVITA)"
	,
	"NICULESTI (DAMBOVITA)"
	,
	"NISIPURILE (DAMBOVITA)"
	,
	"NUCET (DAMBOVITA)"
	,
	"OCHIURI (DAMBOVITA)"
	,
	"OCNITA (DAMBOVITA)"
	,
	"ODAIA TURCULUI (DAMBOVITA)"
	,
	"ODOBESTI (DAMBOVITA)"
	,
	"OLTENI (LUCIENI) (DAMBOVITA)"
	,
	"OLTENI (ULIESTI) (DAMBOVITA)"
	,
	"ONCESTI (DAMBOVITA)"
	,
	"OREASCA (DAMBOVITA)"
	,
	"PADURENI (DAMBOVITA)"
	,
	"PATROAIA-DEAL (DAMBOVITA)"
	,
	"PATROAIA-VALE (DAMBOVITA)"
	,
	"PERSINARI (DAMBOVITA)"
	,
	"PETRESTI (DAMBOVITA)"
	,
	"PETRESTI (CORBII MARI) (DAMBOVITA)"
	,
	"PIATRA (DAMBOVITA)"
	,
	"PICIOR DE MUNTE (DAMBOVITA)"
	,
	"PIETRARI (DAMBOVITA)"
	,
	"PIETROSITA (DAMBOVITA)"
	,
	"PITARU (DAMBOVITA)"
	,
	"PLOPU (DAMBOVITA)"
	,
	"PODU CORBENCII (DAMBOVITA)"
	,
	"PODU CRISTINII (DAMBOVITA)"
	,
	"PODU RIZII (DAMBOVITA)"
	,
	"POIANA (DAMBOVITA)"
	,
	"POIENITA (DAMBOVITA)"
	,
	"POROINICA (DAMBOVITA)"
	,
	"POSTARNACU (DAMBOVITA)"
	,
	"POTLOGENI-DEAL (DAMBOVITA)"
	,
	"POTLOGENI-VALE (DAMBOVITA)"
	,
	"POTLOGI (DAMBOVITA)"
	,
	"POTOCELU (DAMBOVITA)"
	,
	"PRIBOIU (BRANESTI) (DAMBOVITA)"
	,
	"PRIBOIU (TATARANI) (DAMBOVITA)"
	,
	"PRISEACA (DAMBOVITA)"
	,
	"PRODULESTI (DAMBOVITA)"
	,
	"PUCHENI (DAMBOVITA)"
	,
	"PUCHENI (MOROENI) (DAMBOVITA)"
	,
	"PUCIOASA (DAMBOVITA)"
	,
	"PUCIOASA-SAT (DAMBOVITA)"
	,
	"PUNTEA DE GRECI (DAMBOVITA)"
	,
	"PUTU CU SALCIE (DAMBOVITA)"
	,
	"RACARI (DAMBOVITA)"
	,
	"RACIU (DAMBOVITA)"
	,
	"RACOVITA (DAMBOVITA)"
	,
	"RAGU (DAMBOVITA)"
	,
	"RANCACIOV (DAMBOVITA)"
	,
	"RASCAETI (DAMBOVITA)"
	,
	"RATESTI (DAMBOVITA)"
	,
	"RATOAIA (DAMBOVITA)"
	,
	"RAU ALB DE JOS (DAMBOVITA)"
	,
	"RAU ALB DE SUS (DAMBOVITA)"
	,
	"RAZVAD (DAMBOVITA)"
	,
	"ROMANESTI (DAMBOVITA)"
	,
	"RUNCU (DAMBOVITA)"
	,
	"SABIESTI (DAMBOVITA)"
	,
	"SACUENI (DAMBOVITA)"
	,
	"SALCIOARA (DAMBOVITA)"
	,
	"SALCIOARA (MATASARU) (DAMBOVITA)"
	,
	"SALCUTA (DAMBOVITA)"
	,
	"SAMURCASI (DAMBOVITA)"
	,
	"SARU (DAMBOVITA)"
	,
	"SATENI (DAMBOVITA)"
	,
	"SATU NOU (DAMBOVITA)"
	,
	"SAVESTI (DAMBOVITA)"
	,
	"SCHEIU DE JOS (DAMBOVITA)"
	,
	"SCHEIU DE SUS (DAMBOVITA)"
	,
	"SCHELA (DAMBOVITA)"
	,
	"SELARU (DAMBOVITA)"
	,
	"SERBANEASA (DAMBOVITA)"
	,
	"SERDANU (DAMBOVITA)"
	,
	"SILISTEA (LUCIENI) (DAMBOVITA)"
	,
	"SILISTEA (RUNCU) (DAMBOVITA)"
	,
	"SIPOT (DAMBOVITA)"
	,
	"SLOBOZIA (DAMBOVITA)"
	,
	"SLOBOZIA MOARA (DAMBOVITA)"
	,
	"SOTANGA (DAMBOVITA)"
	,
	"SPERIETENI (DAMBOVITA)"
	,
	"STANESTI (DAMBOVITA)"
	,
	"STATESTI (DAMBOVITA)"
	,
	"STAVROPOLIA (DAMBOVITA)"
	,
	"STRAOSTI (DAMBOVITA)"
	,
	"STRATONESTI (DAMBOVITA)"
	,
	"STUBEIE TISA (DAMBOVITA)"
	,
	"SUDULENI (DAMBOVITA)"
	,
	"SULTANU (DAMBOVITA)"
	,
	"SUSENI-SOCETU (DAMBOVITA)"
	,
	"SUTA SEACA (DAMBOVITA)"
	,
	"SUVITA (DAMBOVITA)"
	,
	"TARGOVISTE (DAMBOVITA)"
	,
	"TARTASESTI (DAMBOVITA)"
	,
	"TATARANI (DAMBOVITA)"
	,
	"TEIS (DAMBOVITA)"
	,
	"TELESTI (DAMBOVITA)"
	,
	"TETCOIU (DAMBOVITA)"
	,
	"TITU (DAMBOVITA)"
	,
	"TOCULESTI (DAMBOVITA)"
	,
	"TOMSANI (DAMBOVITA)"
	,
	"TUNARI (DAMBOVITA)"
	,
	"UDRESTI (DAMBOVITA)"
	,
	"ULIESTI (DAMBOVITA)"
	,
	"ULMETU (DAMBOVITA)"
	,
	"ULMI (DAMBOVITA)"
	,
	"UNGURENI (BUTIMANU) (DAMBOVITA)"
	,
	"UNGURENI (CORBII MARI) (DAMBOVITA)"
	,
	"UNGURENI (CORNESTI) (DAMBOVITA)"
	,
	"UNGURENI (DRAGOMIRESTI) (DAMBOVITA)"
	,
	"URSEIU (DAMBOVITA)"
	,
	"URZICEANCA (DAMBOVITA)"
	,
	"VACARESTI (DAMBOVITA)"
	,
	"VADU STANCHII (DAMBOVITA)"
	,
	"VALEA (DAMBOVITA)"
	,
	"VALEA CASELOR (DAMBOVITA)"
	,
	"VALEA DADEI (DAMBOVITA)"
	,
	"VALEA LARGA (DAMBOVITA)"
	,
	"VALEA LEURZII (DAMBOVITA)"
	,
	"VALEA LUI DAN (DAMBOVITA)"
	,
	"VALEA LUNGA (DAMBOVITA)"
	,
	"VALEA LUNGA-CRICOV (DAMBOVITA)"
	,
	"VALEA LUNGA-GORGOTA (DAMBOVITA)"
	,
	"VALEA LUNGA-OGREA (DAMBOVITA)"
	,
	"VALEA MARE (DAMBOVITA)"
	,
	"VALEA MARE (CANDESTI) (DAMBOVITA)"
	,
	"VALEA MARE (VALEA LUNGA) (DAMBOVITA)"
	,
	"VALEA MORII (DAMBOVITA)"
	,
	"VALEA VOIEVOZILOR (DAMBOVITA)"
	,
	"VALENI-DAMBOVITA (DAMBOVITA)"
	,
	"VARFURENI (DAMBOVITA)"
	,
	"VARFURI (DAMBOVITA)"
	,
	"VIFORATA (DAMBOVITA)"
	,
	"VIISOARA (DAMBOVITA)"
	,
	"VISINA (DAMBOVITA)"
	,
	"VISINESTI (DAMBOVITA)"
	,
	"VIZURESTI (DAMBOVITA)"
	,
	"VLADENI (DAMBOVITA)"
	,
	"VLASCENI (DAMBOVITA)"
	,
	"VOIA (DAMBOVITA)"
	,
	"VOINESTI (DAMBOVITA)"
	,
	"VULCANA-BAI (DAMBOVITA)"
	,
	"VULCANA DE SUS (DAMBOVITA)"
	,
	"VULCANA-PANDELE (DAMBOVITA)"
	,
	"VULTUREANCA (DAMBOVITA)"
	,
	"ZAVOIU (DAMBOVITA)"
	,
	"ZIDURILE (DAMBOVITA)"
	,
	"ADANCATA (DOLJ)"
	,
	"AFUMATI (DOLJ)"
	,
	"ALBESTI (DOLJ)"
	,
	"ALMAJ (DOLJ)"
	,
	"ALMAJEL (DOLJ)"
	,
	"AMARASTI (DOLJ)"
	,
	"AMARASTII DE JOS (DOLJ)"
	,
	"AMARASTII DE SUS (DOLJ)"
	,
	"APELE VII (DOLJ)"
	,
	"ARGETOAIA (DOLJ)"
	,
	"BADOSI (DOLJ)"
	,
	"BAILESTI (DOLJ)"
	,
	"BALASAN (DOLJ)"
	,
	"BALOTA DE JOS (DOLJ)"
	,
	"BALOTA DE SUS (DOLJ)"
	,
	"BALTA (DOLJ)"
	,
	"BALTA VERDE (DOLJ)"
	,
	"BARANU (DOLJ)"
	,
	"BARBOI (DOLJ)"
	,
	"BARCA (DOLJ)"
	,
	"BASARABI (DOLJ)"
	,
	"BASCOV (DOLJ)"
	,
	"BAZDANA (DOLJ)"
	,
	"BECHET (DOLJ)"
	,
	"BECHET (ORODEL) (DOLJ)"
	,
	"BEHARCA (DOLJ)"
	,
	"BELCINU (DOLJ)"
	,
	"BELOT (DOLJ)"
	,
	"BENESTI (DOLJ)"
	,
	"BERBESU (DOLJ)"
	,
	"BISTRET (DOLJ)"
	,
	"BISTRETU NOU (DOLJ)"
	,
	"BOBEANU (DOLJ)"
	,
	"BODAIESTI (DOLJ)"
	,
	"BODAIESTII DE SUS (DOLJ)"
	,
	"BOGEA (DOLJ)"
	,
	"BOJOIU (DOLJ)"
	,
	"BOOVENI (DOLJ)"
	,
	"BOTOSESTI-PAIA (DOLJ)"
	,
	"BOURENI (DOLJ)"
	,
	"BRABETI (DOLJ)"
	,
	"BRABOVA (DOLJ)"
	,
	"BRADESTI (DOLJ)"
	,
	"BRADESTII BATRANI (DOLJ)"
	,
	"BRALOSTITA (DOLJ)"
	,
	"BRANDUSA (DOLJ)"
	,
	"BRANISTE (DANETI) (DOLJ)"
	,
	"BRANISTE (FILIASI) (DOLJ)"
	,
	"BRANISTE (PODARI) (DOLJ)"
	,
	"BRATOVOESTI (DOLJ)"
	,
	"BREASTA (DOLJ)"
	,
	"BUCICANI (DOLJ)"
	,
	"BUCOVAT (DOLJ)"
	,
	"BUCOVICIOR (DOLJ)"
	,
	"BUJOR (DOLJ)"
	,
	"BULZESTI (DOLJ)"
	,
	"BUSTENI (DOLJ)"
	,
	"BUSU (DOLJ)"
	,
	"BUSULETU (DOLJ)"
	,
	"BUZDUC (DOLJ)"
	,
	"CACIULATESTI (DOLJ)"
	,
	"CACIULATU (DOLJ)"
	,
	"CALAFAT (DOLJ)"
	,
	"CALARASI (DOLJ)"
	,
	"CALINESTI (DOLJ)"
	,
	"CALOPAR (DOLJ)"
	,
	"CALUGAREI (DOLJ)"
	,
	"CAMPENI (DOLJ)"
	,
	"CARAIMAN (DOLJ)"
	,
	"CARAULA (DOLJ)"
	,
	"CARCEA (DOLJ)"
	,
	"CARLIGEI (DOLJ)"
	,
	"CARNA (DOLJ)"
	,
	"CARPEN (DOLJ)"
	,
	"CARSTOVANI (DOLJ)"
	,
	"CARUIA (DOLJ)"
	,
	"CASTRANOVA (DOLJ)"
	,
	"CASTRELE TRAIANE (DOLJ)"
	,
	"CATANE (DOLJ)"
	,
	"CATANELE NOI (DOLJ)"
	,
	"CELARU (DOLJ)"
	,
	"CERAT (DOLJ)"
	,
	"CERNAT (DOLJ)"
	,
	"CERNATESTI (DOLJ)"
	,
	"CETATE (DOLJ)"
	,
	"CETATUIA (CIOROIASI) (DOLJ)"
	,
	"CETATUIA (VELA) (DOLJ)"
	,
	"CHIASU (DOLJ)"
	,
	"CIOCANELE (DOLJ)"
	,
	"CIOCANESTI (DOLJ)"
	,
	"CIOROIASI (DOLJ)"
	,
	"CIOROIU NOU (DOLJ)"
	,
	"CIUPERCENII NOI (DOLJ)"
	,
	"CIUPERCENII VECHI (DOLJ)"
	,
	"CIUTURA (DOLJ)"
	,
	"CLEANOV (DOLJ)"
	,
	"COMANICEA (DOLJ)"
	,
	"COMOSTENI (DOLJ)"
	,
	"CORLATE (DOLJ)"
	,
	"CORNETU (DOLJ)"
	,
	"CORNITA (DOLJ)"
	,
	"CORNU (DOLJ)"
	,
	"COSERENI (DOLJ)"
	,
	"COSOVENI (DOLJ)"
	,
	"COTOFENII DIN DOS (DOLJ)"
	,
	"COTOFENII DIN FATA (DOLJ)"
	,
	"COTU (DOLJ)"
	,
	"COVEI (DOLJ)"
	,
	"CRAIOVA (DOLJ)"
	,
	"CRIVA (DOLJ)"
	,
	"CROVNA (DOLJ)"
	,
	"CURMATURA (DOLJ)"
	,
	"DABULENI (DOLJ)"
	,
	"DANETI (DOLJ)"
	,
	"DELENI (DOLJ)"
	,
	"DESA (DOLJ)"
	,
	"DESNATUI (DOLJ)"
	,
	"DIOSTI (DOLJ)"
	,
	"DOBRESTI (DOLJ)"
	,
	"DOBRIDOR (DOLJ)"
	,
	"DOBROMIRA (DOLJ)"
	,
	"DOBROTESTI (DOLJ)"
	,
	"DOMNU TUDOR (DOLJ)"
	,
	"DRAGOAIA (DOLJ)"
	,
	"DRAGOTESTI (DOLJ)"
	,
	"DRANIC (DOLJ)"
	,
	"DUDOVICESTI (DOLJ)"
	,
	"DUTULESTI (DOLJ)"
	,
	"FACAI (DOLJ)"
	,
	"FAGET (DOLJ)"
	,
	"FANTANELE (RADOVAN) (DOLJ)"
	,
	"FANTANELE (TESLUI) (DOLJ)"
	,
	"FANTANI (DOLJ)"
	,
	"FARCAS (DOLJ)"
	,
	"FILARET (DOLJ)"
	,
	"FILIASI (DOLJ)"
	,
	"FLORAN (DOLJ)"
	,
	"FLORESTI (DOLJ)"
	,
	"FOISOR (DOLJ)"
	,
	"FRASIN (DOLJ)"
	,
	"FRATILA (DOLJ)"
	,
	"FRATOSTITA (DOLJ)"
	,
	"GABRU (DOLJ)"
	,
	"GAIA (DOLJ)"
	,
	"GALICEA MARE (DOLJ)"
	,
	"GALICIUICA (DOLJ)"
	,
	"GANGIOVA (DOLJ)"
	,
	"GARLESTI (DOLJ)"
	,
	"GEBLESTI (DOLJ)"
	,
	"GEOROCEL (DOLJ)"
	,
	"GEOROCU MARE (DOLJ)"
	,
	"GHERCESTI (DOLJ)"
	,
	"GHIDICI (DOLJ)"
	,
	"GHINDENI (DOLJ)"
	,
	"GHIZDAVESTI (DOLJ)"
	,
	"GIGHERA (DOLJ)"
	,
	"GIUBEGA (DOLJ)"
	,
	"GIURGITA (DOLJ)"
	,
	"GODENI (DOLJ)"
	,
	"GOGOSESTI (DOLJ)"
	,
	"GOGOSITA (DOLJ)"
	,
	"GOGOSU (DOLJ)"
	,
	"GOICEA (DOLJ)"
	,
	"GOIESTI (DOLJ)"
	,
	"GOLENTI (DOLJ)"
	,
	"GOLFIN (DOLJ)"
	,
	"GOLUMBELU (DOLJ)"
	,
	"GOLUMBU (DOLJ)"
	,
	"GRADISTEA (DOLJ)"
	,
	"GRECESTI (DOLJ)"
	,
	"GROPANELE (DOLJ)"
	,
	"GRUITA (DOLJ)"
	,
	"GUBAUCEA (DOLJ)"
	,
	"GURA RACULUI (DOLJ)"
	,
	"GURA VAII (DOLJ)"
	,
	"HOREZU-POENARI (DOLJ)"
	,
	"HUNIA (DOLJ)"
	,
	"INFRATIREA (DOLJ)"
	,
	"INTORSURA (DOLJ)"
	,
	"IORDACHESTI (DOLJ)"
	,
	"ISALNITA (DOLJ)"
	,
	"ITALIENI (DOLJ)"
	,
	"IZVOARE (DOLJ)"
	,
	"IZVOR (DOLJ)"
	,
	"JIENI (DOLJ)"
	,
	"JIUL (DOLJ)"
	,
	"LACRITA MARE (DOLJ)"
	,
	"LACRITA MICA (DOLJ)"
	,
	"LANGA (DOLJ)"
	,
	"LAZU (DOLJ)"
	,
	"LEAMNA DE JOS (DOLJ)"
	,
	"LEAMNA DE SUS (DOLJ)"
	,
	"LEORDOASA (DOLJ)"
	,
	"LESILE (DOLJ)"
	,
	"LEU (DOLJ)"
	,
	"LIPOVU (DOLJ)"
	,
	"LIPOVU DE SUS (DOLJ)"
	,
	"LISTEAVA (DOLJ)"
	,
	"LIVEZI (DOLJ)"
	,
	"LOCUSTENI (DOLJ)"
	,
	"LUNCSORU (DOLJ)"
	,
	"MACESU DE JOS (DOLJ)"
	,
	"MACESU DE SUS (DOLJ)"
	,
	"MAGLAVIT (DOLJ)"
	,
	"MALAESTI (DOLJ)"
	,
	"MALAICA (DOLJ)"
	,
	"MALU MARE (DOLJ)"
	,
	"MALUMNIC (DOLJ)"
	,
	"MARACINELE (DOLJ)"
	,
	"MAROTINU DE JOS (DOLJ)"
	,
	"MAROTINU DE SUS (DOLJ)"
	,
	"MARSANI (DOLJ)"
	,
	"MARZA (DOLJ)"
	,
	"MELINESTI (DOLJ)"
	,
	"METEU (DOLJ)"
	,
	"MIHAITA (DOLJ)"
	,
	"MILESTI (DOLJ)"
	,
	"MILOVAN (DOLJ)"
	,
	"MISCHII (DOLJ)"
	,
	"MLECANESTI (DOLJ)"
	,
	"MOFLENI (DOLJ)"
	,
	"MOFLESTI (DOLJ)"
	,
	"MOGOSESTI (DOLJ)"
	,
	"MORENI (DOLJ)"
	,
	"MOSNA (DOLJ)"
	,
	"MOSNENI (DOLJ)"
	,
	"MOTATEI (DOLJ)"
	,
	"MOTATEI-GARA (DOLJ)"
	,
	"MOTOCI (DOLJ)"
	,
	"MUERENI (DOLJ)"
	,
	"MUIERUSU (DOLJ)"
	,
	"MURGASI (DOLJ)"
	,
	"MURTA (DOLJ)"
	,
	"NEDEIA (DOLJ)"
	,
	"NEGOI (DOLJ)"
	,
	"NEGOIESTI (DOLJ)"
	,
	"NISIPURI (DOLJ)"
	,
	"NISTOI (DOLJ)"
	,
	"NOVAC (DOLJ)"
	,
	"OBEDIN (DOLJ)"
	,
	"OCOLNA (DOLJ)"
	,
	"ODOLENI (DOLJ)"
	,
	"OHABA (DOLJ)"
	,
	"ORODEL (DOLJ)"
	,
	"OSTROVENI (DOLJ)"
	,
	"PADEA (DOLJ)"
	,
	"PALILULA (DOLJ)"
	,
	"PANAGHIA (DOLJ)"
	,
	"PERENI (DOLJ)"
	,
	"PERISOR (DOLJ)"
	,
	"PICATURILE (DOLJ)"
	,
	"PIELESTI (DOLJ)"
	,
	"PIETROAIA (DOLJ)"
	,
	"PIORESTI (DOLJ)"
	,
	"PIRIA (DOLJ)"
	,
	"PISCANI (DOLJ)"
	,
	"PISCU LUNG (DOLJ)"
	,
	"PISCU NOU (DOLJ)"
	,
	"PISCU SADOVEI (DOLJ)"
	,
	"PISCU VECHI (DOLJ)"
	,
	"PISCULET (DOLJ)"
	,
	"PLENITA (DOLJ)"
	,
	"PLESOI (DOLJ)"
	,
	"PLOPSOR (DOLJ)"
	,
	"PLOPU-AMARASTI (DOLJ)"
	,
	"PLOSCA (DOLJ)"
	,
	"PLOSTINA (DOLJ)"
	,
	"PODARI (DOLJ)"
	,
	"POIANA FANTANII (DOLJ)"
	,
	"POIANA MARE (DOLJ)"
	,
	"POIENILE (DOLJ)"
	,
	"POMETESTI (DOLJ)"
	,
	"POPANZALESTI (DOLJ)"
	,
	"POPEASA (DOLJ)"
	,
	"POPESTI (DOLJ)"
	,
	"POPOVENI (DOLJ)"
	,
	"POTMELTU (DOLJ)"
	,
	"PRAPOR (DOLJ)"
	,
	"PREAJBA (DOLJ)"
	,
	"PREAJBA DE JOS (DOLJ)"
	,
	"PREAJBA DE PADURE (DOLJ)"
	,
	"PREDESTI (DOLJ)"
	,
	"PREDESTII MICI (DOLJ)"
	,
	"PREJOI (DOLJ)"
	,
	"PRUNET (DOLJ)"
	,
	"PUTINEI (DOLJ)"
	,
	"PUTURI (DOLJ)"
	,
	"RACARII DE JOS (DOLJ)"
	,
	"RACARII DE SUS (DOLJ)"
	,
	"RACHITA DE JOS (DOLJ)"
	,
	"RACHITA DE SUS (DOLJ)"
	,
	"RACOVITA (DOLJ)"
	,
	"RADOMIR (DOLJ)"
	,
	"RADOVAN (DOLJ)"
	,
	"RASNICU BATRAN (DOLJ)"
	,
	"RASNICU OGHIAN (DOLJ)"
	,
	"RAST (DOLJ)"
	,
	"ROBANESTI (DOLJ)"
	,
	"ROBANESTII DE JOS (DOLJ)"
	,
	"ROBANESTII DE SUS (DOLJ)"
	,
	"ROJISTE (DOLJ)"
	,
	"ROMANESTI (DOLJ)"
	,
	"ROSIENI (DOLJ)"
	,
	"RUPTURILE (DOLJ)"
	,
	"SADOVA (DOLJ)"
	,
	"SALCIA (DOLJ)"
	,
	"SALCUTA (DOLJ)"
	,
	"SALCUTA (CALOPAR) (DOLJ)"
	,
	"SALISTE (DOLJ)"
	,
	"SAPATA (DOLJ)"
	,
	"SARATA (DOLJ)"
	,
	"SARBATOAREA (DOLJ)"
	,
	"SARSCA (DOLJ)"
	,
	"SCAESTI (DOLJ)"
	,
	"SCHITU (DOLJ)"
	,
	"SEACA DE CAMP (DOLJ)"
	,
	"SEACA DE PADURE (DOLJ)"
	,
	"SECU (DOLJ)"
	,
	"SECUI (DOLJ)"
	,
	"SECULESTI (DOLJ)"
	,
	"SEGARCEA (DOLJ)"
	,
	"SEGLET (DOLJ)"
	,
	"SFIRCEA (DOLJ)"
	,
	"SILISTEA CRUCII (DOLJ)"
	,
	"SIMNICU DE JOS (DOLJ)"
	,
	"SIMNICU DE SUS (DOLJ)"
	,
	"SITOAIA (DOLJ)"
	,
	"SMADOVICIOARA DE SECU (DOLJ)"
	,
	"SMARDAN (DOLJ)"
	,
	"SOCENI (DOLJ)"
	,
	"SOPOT (DOLJ)"
	,
	"SORENI (DOLJ)"
	,
	"SPINENI (DOLJ)"
	,
	"STEFANEL (DOLJ)"
	,
	"STIUBEI (DOLJ)"
	,
	"STOICESTI (DOLJ)"
	,
	"SUHARU (DOLJ)"
	,
	"SUMANDRA (DOLJ)"
	,
	"TALPAS (DOLJ)"
	,
	"TAMBURESTI (DOLJ)"
	,
	"TANDARA (DOLJ)"
	,
	"TARNAVA (DOLJ)"
	,
	"TARTAL (DOLJ)"
	,
	"TATOMIRESTI (DOLJ)"
	,
	"TEASC (DOLJ)"
	,
	"TEASCU DIN DEAL (DOLJ)"
	,
	"TEIU (DOLJ)"
	,
	"TENCANAU (DOLJ)"
	,
	"TERPEZITA (DOLJ)"
	,
	"TESLUI (DOLJ)"
	,
	"TIU (DOLJ)"
	,
	"TOCENI (DOLJ)"
	,
	"TUGLUI (DOLJ)"
	,
	"TUNARII NOI (DOLJ)"
	,
	"TUNARII VECHI (DOLJ)"
	,
	"UNGURENI (DOLJ)"
	,
	"UNGURENII MICI (DOLJ)"
	,
	"UNIREA (DOLJ)"
	,
	"URDINITA (DOLJ)"
	,
	"URECHESTI (DOLJ)"
	,
	"URIENI (DOLJ)"
	,
	"URSOAIA (DOLJ)"
	,
	"URZICA MARE (DOLJ)"
	,
	"URZICUTA (DOLJ)"
	,
	"USCACI (DOLJ)"
	,
	"VALEA FANTANILOR (DOLJ)"
	,
	"VALEA LUI PATRU (DOLJ)"
	,
	"VALEA LUNGULUI (DOLJ)"
	,
	"VALEA MARE (DOLJ)"
	,
	"VALEA MUIERII DE JOS (DOLJ)"
	,
	"VALEA STANCIULUI (DOLJ)"
	,
	"VARTOP (DOLJ)"
	,
	"VARVOR (DOLJ)"
	,
	"VARVORU DE JOS (DOLJ)"
	,
	"VELA (DOLJ)"
	,
	"VELENI (DOLJ)"
	,
	"VELESTI (DOLJ)"
	,
	"VERBICIOARA (DOLJ)"
	,
	"VERBITA (DOLJ)"
	,
	"VIISOARA (DOLJ)"
	,
	"VIISOARA-MOSNENI (DOLJ)"
	,
	"VLADIMIR (DOLJ)"
	,
	"VOITA (DOLJ)"
	,
	"ZANOAGA (DOLJ)"
	,
	"ZAVAL (DOLJ)"
	,
	"ZLATARI (DOLJ)"
	,
	"ZVORSCA (DOLJ)"
	,
	"ADAM (GALATI)"
	,
	"ALDESTI (GALATI)"
	,
	"BALABANESTI (GALATI)"
	,
	"BALASESTI (GALATI)"
	,
	"BALENI (GALATI)"
	,
	"BALINTESTI (GALATI)"
	,
	"BALTARETI (GALATI)"
	,
	"BANEASA (GALATI)"
	,
	"BARCEA (GALATI)"
	,
	"BERESTI (GALATI)"
	,
	"BERESTI-MERIA (GALATI)"
	,
	"BLANZI (GALATI)"
	,
	"BRAHASESTI (GALATI)"
	,
	"BRANESTI (GALATI)"
	,
	"BRANISTEA (GALATI)"
	,
	"BRANISTEA (NICORESTI) (GALATI)"
	,
	"BRATULESTI (GALATI)"
	,
	"BUCESTI (GALATI)"
	,
	"BUCIUMENI (GALATI)"
	,
	"BURSUCANI (GALATI)"
	,
	"CALMATUI (GALATI)"
	,
	"CARAPCESTI (GALATI)"
	,
	"CARLOMANESTI (GALATI)"
	,
	"CAUIESTI (GALATI)"
	,
	"CAVADINESTI (GALATI)"
	,
	"CERTESTI (GALATI)"
	,
	"CHIRAFTEI (GALATI)"
	,
	"CIORASTI (GALATI)"
	,
	"CISMELE (GALATI)"
	,
	"CIURESTI (GALATI)"
	,
	"CIURESTII NOI (GALATI)"
	,
	"COASTA LUPEI (GALATI)"
	,
	"COMANESTI (GALATI)"
	,
	"CONDREA (GALATI)"
	,
	"CORCIOVENI (GALATI)"
	,
	"CORNI (GALATI)"
	,
	"COROD (GALATI)"
	,
	"COSITENI (GALATI)"
	,
	"COSMESTI (GALATI)"
	,
	"COSMESTII-VALE (GALATI)"
	,
	"COSTACHE NEGRI (GALATI)"
	,
	"COSTI (GALATI)"
	,
	"COTOROAIA (GALATI)"
	,
	"CRAIESTI (GALATI)"
	,
	"CRANGENI (GALATI)"
	,
	"CRUCEANU (GALATI)"
	,
	"CUCA (GALATI)"
	,
	"CUDALBI (GALATI)"
	,
	"CUZA VODA (GALATI)"
	,
	"DOBRINESTI (GALATI)"
	,
	"DRAGANESTI (GALATI)"
	,
	"DRAGUSENI (GALATI)"
	,
	"FANTANELE (GALATI)"
	,
	"FANTANI (GALATI)"
	,
	"FARTANESTI (GALATI)"
	,
	"FOLTESTI (GALATI)"
	,
	"FRUMUSITA (GALATI)"
	,
	"FRUNZEASCA (GALATI)"
	,
	"FUNDEANU (GALATI)"
	,
	"FUNDENI (GALATI)"
	,
	"FUNDENII NOI (GALATI)"
	,
	"FURCENII NOI (GALATI)"
	,
	"FURCENII VECHI (GALATI)"
	,
	"GALATI (GALATI)"
	,
	"GANESTI (GALATI)"
	,
	"GARA BERHECI (GALATI)"
	,
	"GARA GHIDIGENI (GALATI)"
	,
	"GARBOVAT (GALATI)"
	,
	"GEFU (GALATI)"
	,
	"GHIDIGENI (GALATI)"
	,
	"GHINGHESTI (GALATI)"
	,
	"GOHOR (GALATI)"
	,
	"GRIVITA (GALATI)"
	,
	"GROZAVESTI (GALATI)"
	,
	"GURA GARBOVATULUI (GALATI)"
	,
	"HANTESTI (GALATI)"
	,
	"HANU CONACHI (GALATI)"
	,
	"HUSTIU (GALATI)"
	,
	"IJDILENI (GALATI)"
	,
	"INDEPENDENTA (GALATI)"
	,
	"IONASESTI (GALATI)"
	,
	"IREASCA (GALATI)"
	,
	"IVESTI (GALATI)"
	,
	"IZVOARELE (GALATI)"
	,
	"JORASTI (GALATI)"
	,
	"LIESTI (GALATI)"
	,
	"LIESTI (PRIPONESTI) (GALATI)"
	,
	"LOZOVA (GALATI)"
	,
	"LUNCA (GALATI)"
	,
	"LUNGESTI (GALATI)"
	,
	"LUNGOCI (GALATI)"
	,
	"LUPELE (GALATI)"
	,
	"MACISENI (GALATI)"
	,
	"MALU ALB (GALATI)"
	,
	"MALURENI (GALATI)"
	,
	"MANDRESTI (GALATI)"
	,
	"MASTACANI (GALATI)"
	,
	"MATCA (GALATI)"
	,
	"MIHAIL KOGALNICEANU (GALATI)"
	,
	"MOSCU (GALATI)"
	,
	"MOVILENI (GALATI)"
	,
	"MOVILENI (SENDRENI) (GALATI)"
	,
	"MUNTENI (GALATI)"
	,
	"NAMOLOASA (GALATI)"
	,
	"NAMOLOASA-SAT (GALATI)"
	,
	"NARTESTI (GALATI)"
	,
	"NEGREA (GALATI)"
	,
	"NEGRILESTI (GALATI)"
	,
	"NICOPOLE (GALATI)"
	,
	"NICORESTI (GALATI)"
	,
	"OANCEA (GALATI)"
	,
	"ODAIA MANOLACHE (GALATI)"
	,
	"ONCIU (GALATI)"
	,
	"PECHEA (GALATI)"
	,
	"PISCU (GALATI)"
	,
	"PISCU CORBULUI (GALATI)"
	,
	"PLESA (GALATI)"
	,
	"PLEVNA (GALATI)"
	,
	"PODOLENI (GALATI)"
	,
	"POIANA (GALATI)"
	,
	"POSTA (GALATI)"
	,
	"PRIPONESTI (GALATI)"
	,
	"PRIPONESTII DE JOS (GALATI)"
	,
	"PRODANESTI (GALATI)"
	,
	"PUPEZENI (GALATI)"
	,
	"PURICANI (GALATI)"
	,
	"RADESTI (GALATI)"
	,
	"REDIU (GALATI)"
	,
	"ROGOJENI (GALATI)"
	,
	"ROSCANI (GALATI)"
	,
	"SALCIA (GALATI)"
	,
	"SARBI (GALATI)"
	,
	"SASENI (GALATI)"
	,
	"SATU NOU (GALATI)"
	,
	"SCANTEIESTI (GALATI)"
	,
	"SCHELA (GALATI)"
	,
	"SENDRENI (GALATI)"
	,
	"SERBESTII VECHI (GALATI)"
	,
	"SILISTEA (GALATI)"
	,
	"SIPOTE (GALATI)"
	,
	"SIVITA (GALATI)"
	,
	"SLIVNA (GALATI)"
	,
	"SLOBOZIA BLANEASA (GALATI)"
	,
	"SLOBOZIA CONACHI (GALATI)"
	,
	"SLOBOZIA CORNI (GALATI)"
	,
	"SLOBOZIA OANCEA (GALATI)"
	,
	"SMARDAN (GALATI)"
	,
	"SMULTI (GALATI)"
	,
	"STIETESTI (GALATI)"
	,
	"STOICANI (GALATI)"
	,
	"SUCEVENI (GALATI)"
	,
	"SUHURLUI (GALATI)"
	,
	"TALPIGI (GALATI)"
	,
	"TAMAOANI (GALATI)"
	,
	"TAPLAU (GALATI)"
	,
	"TARGU BUJOR (GALATI)"
	,
	"TATARCA (GALATI)"
	,
	"TECUCELU SEC (GALATI)"
	,
	"TECUCI (GALATI)"
	,
	"TEPU (GALATI)"
	,
	"TEPU DE SUS (GALATI)"
	,
	"TIGANESTI (GALATI)"
	,
	"TOFLEA (GALATI)"
	,
	"TORCESTI (GALATI)"
	,
	"TRAIAN (GALATI)"
	,
	"TUDOR VLADIMIRESCU (GALATI)"
	,
	"TULUCESTI (GALATI)"
	,
	"UMBRARESTI (GALATI)"
	,
	"UMBRARESTI (TARGU BUJOR) (GALATI)"
	,
	"UMBRARESTI-DEAL (GALATI)"
	,
	"UNGURENI (GALATI)"
	,
	"URLESTI (GALATI)"
	,
	"VADENI (GALATI)"
	,
	"VALEA MARULUI (GALATI)"
	,
	"VAMES (GALATI)"
	,
	"VANATORI (GALATI)"
	,
	"VARLEZI (GALATI)"
	,
	"VASILE ALECSANDRI (GALATI)"
	,
	"VIILE (GALATI)"
	,
	"VISINA (GALATI)"
	,
	"VIZURESTI (GALATI)"
	,
	"VLADESTI (GALATI)"
	,
	"ZARNESTI (GALATI)"
	,
	"ZIMBRU (GALATI)"
	,
	"ADUNATII-COPACENI (GIURGIU)"
	,
	"ANGHELESTI (GIURGIU)"
	,
	"BACU (GIURGIU)"
	,
	"BALANU (GIURGIU)"
	,
	"BANEASA (GIURGIU)"
	,
	"BANESTI (GIURGIU)"
	,
	"BILA (GIURGIU)"
	,
	"BOLINTIN-DEAL (GIURGIU)"
	,
	"BOLINTIN-VALE (GIURGIU)"
	,
	"BRANISTARI (GIURGIU)"
	,
	"BRANISTEA (GIURGIU)"
	,
	"BUCSANI (GIURGIU)"
	,
	"BUDENI (GIURGIU)"
	,
	"BULBUCATA (GIURGIU)"
	,
	"BUTURUGENI (GIURGIU)"
	,
	"CALUGARENI (GIURGIU)"
	,
	"CAMINEASCA (GIURGIU)"
	,
	"CAMPURELU (GIURGIU)"
	,
	"CARAPANCEA (GIURGIU)"
	,
	"CARPENISU (GIURGIU)"
	,
	"CARTOJANI (GIURGIU)"
	,
	"CASCIOARELE (GAISENI) (GIURGIU)"
	,
	"CASCIOARELE (ULMI) (GIURGIU)"
	,
	"CETATEA (GIURGIU)"
	,
	"CETATUIA (GIURGIU)"
	,
	"CHIRCULESTI (GIURGIU)"
	,
	"CHIRIACU (GIURGIU)"
	,
	"CLEJANI (GIURGIU)"
	,
	"COLIBASI (GIURGIU)"
	,
	"COMANA (GIURGIU)"
	,
	"COPACIU (GIURGIU)"
	,
	"CORBEANCA (GIURGIU)"
	,
	"COSOBA (GIURGIU)"
	,
	"COTENI (GIURGIU)"
	,
	"CRANGURI (GIURGIU)"
	,
	"CREVEDIA MARE (GIURGIU)"
	,
	"CREVEDIA MICA (GIURGIU)"
	,
	"CRIVINA (GIURGIU)"
	,
	"CRUCEA DE PIATRA (GIURGIU)"
	,
	"CUCURUZU (GIURGIU)"
	,
	"CUPELE (GIURGIU)"
	,
	"DAIA (GIURGIU)"
	,
	"DARASTI-VLASCA (GIURGIU)"
	,
	"DEALU (GIURGIU)"
	,
	"DIMITRIE CANTEMIR (GIURGIU)"
	,
	"DOBRENI (GIURGIU)"
	,
	"DRAGANEASCA (GIURGIU)"
	,
	"DRAGANESCU (GIURGIU)"
	,
	"DRAGHICEANU (GIURGIU)"
	,
	"FACAU (GIURGIU)"
	,
	"FALASTOACA (GIURGIU)"
	,
	"FLORESTI (GIURGIU)"
	,
	"FLORESTI-STOENESTI (GIURGIU)"
	,
	"FRASINU (GIURGIU)"
	,
	"FRATESTI (GIURGIU)"
	,
	"GAISEANCA (GIURGIU)"
	,
	"GAISENI (GIURGIU)"
	,
	"GAUJANI (GIURGIU)"
	,
	"GHIMPATI (GIURGIU)"
	,
	"GHIONEA (GIURGIU)"
	,
	"GHIZDARU (GIURGIU)"
	,
	"GIURGIU (GIURGIU)"
	,
	"GOGOSARI (GIURGIU)"
	,
	"GOLEASCA (GIURGIU)"
	,
	"GORNENI (GIURGIU)"
	,
	"GOSTINARI (GIURGIU)"
	,
	"GOSTINU (GIURGIU)"
	,
	"GRADINARI (GIURGIU)"
	,
	"GRADISTEA (GIURGIU)"
	,
	"GREACA (GIURGIU)"
	,
	"HERASTI (GIURGIU)"
	,
	"HOBAIA (GIURGIU)"
	,
	"HODIVOAIA (GIURGIU)"
	,
	"HOTARELE (GIURGIU)"
	,
	"HULUBESTI (GIURGIU)"
	,
	"IANCULESTI (GIURGIU)"
	,
	"ICOANA (GIURGIU)"
	,
	"IEPURESTI (GIURGIU)"
	,
	"IZVOARELE (GIURGIU)"
	,
	"IZVOARELE (HOTARELE) (GIURGIU)"
	,
	"IZVORU (GOGOSARI) (GIURGIU)"
	,
	"IZVORU (VANATORII MICI) (GIURGIU)"
	,
	"JOITA (GIURGIU)"
	,
	"LETCA NOUA (GIURGIU)"
	,
	"LETCA VECHE (GIURGIU)"
	,
	"MALU (GIURGIU)"
	,
	"MALU SPART (GIURGIU)"
	,
	"MARSA (GIURGIU)"
	,
	"MIHAI BRAVU (GIURGIU)"
	,
	"MIHAI VODA (GIURGIU)"
	,
	"MIHAILESTI (GIURGIU)"
	,
	"MILCOVATU (GIURGIU)"
	,
	"MILOSESTI (GIURGIU)"
	,
	"MIRAU (GIURGIU)"
	,
	"MIRONESTI (GIURGIU)"
	,
	"MOGOSESTI (GIURGIU)"
	,
	"MOSTENI (GIURGIU)"
	,
	"NAIPU (GIURGIU)"
	,
	"NEAJLOVU (GIURGIU)"
	,
	"NOVACI (GIURGIU)"
	,
	"OBEDENI (GIURGIU)"
	,
	"OGREZENI (GIURGIU)"
	,
	"OINACU (GIURGIU)"
	,
	"ONCESTI (GIURGIU)"
	,
	"PADURENI (GIURGIU)"
	,
	"PALANCA (GIURGIU)"
	,
	"PETRU RARES (GIURGIU)"
	,
	"PIETRELE (GIURGIU)"
	,
	"PIETRISU (GIURGIU)"
	,
	"PLOPSORU (GIURGIU)"
	,
	"PODISOR (GIURGIU)"
	,
	"PODU DOAMNEI (GIURGIU)"
	,
	"PODU ILFOVATULUI (GIURGIU)"
	,
	"PODU POPA NAE (GIURGIU)"
	,
	"POENARI (GIURGIU)"
	,
	"POIANA LUI STANGA (GIURGIU)"
	,
	"POPESTI (GIURGIU)"
	,
	"POSTA (GIURGIU)"
	,
	"PRIBOIU (GIURGIU)"
	,
	"PRUNDU (GIURGIU)"
	,
	"PUIENI (GIURGIU)"
	,
	"PUTINEIU (GIURGIU)"
	,
	"PUTU GRECI (GIURGIU)"
	,
	"RADU VODA (GIURGIU)"
	,
	"RALESTI (GIURGIU)"
	,
	"RASUCENI (GIURGIU)"
	,
	"REMUS (GIURGIU)"
	,
	"ROATA DE JOS (GIURGIU)"
	,
	"ROATA MICA (GIURGIU)"
	,
	"SABARENI (GIURGIU)"
	,
	"SADINA (GIURGIU)"
	,
	"SATU NOU (GIURGIU)"
	,
	"SCHITU (GIURGIU)"
	,
	"SFANTU GHEORGHE (BANEASA) (GIURGIU)"
	,
	"SFANTU GHEORGHE (CREVEDIA MARE) (GIURGIU)"
	,
	"SINGURENI (GIURGIU)"
	,
	"SLOBOZIA (GIURGIU)"
	,
	"STALPU (GIURGIU)"
	,
	"STANESTI (GIURGIU)"
	,
	"STEJARU (GIURGIU)"
	,
	"STEREA (GIURGIU)"
	,
	"STOENESTI (GIURGIU)"
	,
	"STOENESTI (FLORESTI-STOENESTI) (GIURGIU)"
	,
	"SUSENI (GIURGIU)"
	,
	"TANTAVA (GIURGIU)"
	,
	"TEISORI (GIURGIU)"
	,
	"TEIUSU (GIURGIU)"
	,
	"TOMULESTI (GIURGIU)"
	,
	"TOPORU (GIURGIU)"
	,
	"TRESTIENI (GIURGIU)"
	,
	"UIESTI (GIURGIU)"
	,
	"ULMI (GIURGIU)"
	,
	"UZUNU (GIURGIU)"
	,
	"VADU LAT (GIURGIU)"
	,
	"VALCELELE (GIURGIU)"
	,
	"VALEA BUJORULUI (GIURGIU)"
	,
	"VALEA DRAGULUI (GIURGIU)"
	,
	"VALEA PLOPILOR (GIURGIU)"
	,
	"VALTER MARACINEANU (GIURGIU)"
	,
	"VANATORII MARI (GIURGIU)"
	,
	"VANATORII MICI (GIURGIU)"
	,
	"VARASTI (GIURGIU)"
	,
	"VARLAAM (GIURGIU)"
	,
	"VEDEA (GIURGIU)"
	,
	"VIERU (GIURGIU)"
	,
	"VLAD TEPES (GIURGIU)"
	,
	"VLASIN (GIURGIU)"
	,
	"ZADARICIU (GIURGIU)"
	,
	"ZBOIU (GIURGIU)"
	,
	"ZORILE (GIURGIU)"
	,
	"ALBENI (GORJ)"
	,
	"ALEXENI (GORJ)"
	,
	"ALIMPESTI (GORJ)"
	,
	"ALUNIS (GORJ)"
	,
	"ANDREESTI (GORJ)"
	,
	"ANINISU DIN DEAL (GORJ)"
	,
	"ANINISU DIN VALE (GORJ)"
	,
	"ANINOASA (GORJ)"
	,
	"APA NEAGRA (GORJ)"
	,
	"ARCANI (GORJ)"
	,
	"ARJOCI (GORJ)"
	,
	"ARPADIA (GORJ)"
	,
	"ARSENI (GORJ)"
	,
	"ARSURI (GORJ)"
	,
	"ARTANU (GORJ)"
	,
	"BACESTI (GORJ)"
	,
	"BADESTI (GORJ)"
	,
	"BAIA DE FIER (GORJ)"
	,
	"BALACESTI (GORJ)"
	,
	"BALANESTI (GORJ)"
	,
	"BALANI (GORJ)"
	,
	"BALCESTI (GORJ)"
	,
	"BALESTI (GORJ)"
	,
	"BALOSANI (GORJ)"
	,
	"BALTA (GORJ)"
	,
	"BALTENI (GORJ)"
	,
	"BALTISOARA (GORJ)"
	,
	"BANIU (GORJ)"
	,
	"BARBATESTI (GORJ)"
	,
	"BARCACIU (GORJ)"
	,
	"BARSESTI (GORJ)"
	,
	"BARZA (GORJ)"
	,
	"BARZEIU (GORJ)"
	,
	"BARZEIU DE GILORT (GORJ)"
	,
	"BAZAVANI (GORJ)"
	,
	"BECHENI (GORJ)"
	,
	"BENGESTI (GORJ)"
	,
	"BENGESTI-CIOCADIA (GORJ)"
	,
	"BERCESTI (GORJ)"
	,
	"BERLESTI (GORJ)"
	,
	"BIBESTI (GORJ)"
	,
	"BIBULESTI (GORJ)"
	,
	"BIRCII (GORJ)"
	,
	"BLAHNITA DE JOS (GORJ)"
	,
	"BLAHNITA DE SUS (GORJ)"
	,
	"BLIDARI (GORJ)"
	,
	"BOBAIA (GORJ)"
	,
	"BOBOIESTI (GORJ)"
	,
	"BOBU (GORJ)"
	,
	"BOCA (GORJ)"
	,
	"BOHOREL (GORJ)"
	,
	"BOIA (GORJ)"
	,
	"BOJINU (GORJ)"
	,
	"BOLBOASA (GORJ)"
	,
	"BOLBOCESTI (GORJ)"
	,
	"BOLBOSI (GORJ)"
	,
	"BORASCU (GORJ)"
	,
	"BOROSTENI (GORJ)"
	,
	"BOTOROGI (GORJ)"
	,
	"BRADET (GORJ)"
	,
	"BRADETEL (GORJ)"
	,
	"BRADICENI (GORJ)"
	,
	"BRANESTI (GORJ)"
	,
	"BRATESTI (GORJ)"
	,
	"BRATUIA (GORJ)"
	,
	"BREBENEI (GORJ)"
	,
	"BROSTENI (GORJ)"
	,
	"BROSTENII DE SUS (GORJ)"
	,
	"BUCSANA (GORJ)"
	,
	"BUCUREASA (GORJ)"
	,
	"BUDIENI (GORJ)"
	,
	"BUDUHALA (GORJ)"
	,
	"BULBUCENI (GORJ)"
	,
	"BUMBESTI-JIU (GORJ)"
	,
	"BUMBESTI-PITIC (GORJ)"
	,
	"BURLANI (GORJ)"
	,
	"BUSTUCHIN (GORJ)"
	,
	"BUSUIOCI (GORJ)"
	,
	"BUZESTI (GORJ)"
	,
	"CALAPARU (GORJ)"
	,
	"CALCESTI (GORJ)"
	,
	"CALESTI (GORJ)"
	,
	"CALNIC (GORJ)"
	,
	"CALNICU DE SUS (GORJ)"
	,
	"CALUGAREASA (GORJ)"
	,
	"CALUGARENI (GORJ)"
	,
	"CAMPOFENI (GORJ)"
	,
	"CAMPU MARE (GORJ)"
	,
	"CAMUIESTI (GORJ)"
	,
	"CANEPESTI (GORJ)"
	,
	"CAPRENI (GORJ)"
	,
	"CAPU DEALULUI (GORJ)"
	,
	"CARBESTI (GORJ)"
	,
	"CARBUNESTI-SAT (GORJ)"
	,
	"CARCIU (GORJ)"
	,
	"CARLIGEI (GORJ)"
	,
	"CARPINIS (GORJ)"
	,
	"CARTIU (GORJ)"
	,
	"CATUNELE (GORJ)"
	,
	"CEAURU (GORJ)"
	,
	"CELEI (GORJ)"
	,
	"CEPLEA (GORJ)"
	,
	"CERATU DE COPACIOASA (GORJ)"
	,
	"CERNA-SAT (GORJ)"
	,
	"CERNADIA (GORJ)"
	,
	"CETATEA (GORJ)"
	,
	"CHICIORA (GORJ)"
	,
	"CHILIU (GORJ)"
	,
	"CIOCADIA (GORJ)"
	,
	"CIONTI (GORJ)"
	,
	"CIORARI (GORJ)"
	,
	"CIUPERCENI (GORJ)"
	,
	"CIUPERCENII DE OLTET (GORJ)"
	,
	"CLESNESTI (GORJ)"
	,
	"CLOSANI (GORJ)"
	,
	"COCORENI (GORJ)"
	,
	"COCOROVA (GORJ)"
	,
	"COJANI (GORJ)"
	,
	"COJMANESTI (GORJ)"
	,
	"COLIBASI (GORJ)"
	,
	"COLTESTI (GORJ)"
	,
	"CONDEIESTI (GORJ)"
	,
	"COPACIOASA (GORJ)"
	,
	"CORNESTI (GORJ)"
	,
	"CORNETU (GORJ)"
	,
	"COROBAI (GORJ)"
	,
	"CORSORU (GORJ)"
	,
	"COSTENI (GORJ)"
	,
	"COSTESTI (GORJ)"
	,
	"COVRIGI (GORJ)"
	,
	"CRASNA (GORJ)"
	,
	"CRASNA DIN DEAL (GORJ)"
	,
	"CRETESTI (GORJ)"
	,
	"CROICI (GORJ)"
	,
	"CRUSET (GORJ)"
	,
	"CURPEN (GORJ)"
	,
	"CURSARU (GORJ)"
	,
	"CURTEANA (GORJ)"
	,
	"CURTISOARA (GORJ)"
	,
	"DAMBOVA (GORJ)"
	,
	"DANCIULESTI (GORJ)"
	,
	"DANESTI (GORJ)"
	,
	"DEALU LEULUI (GORJ)"
	,
	"DEALU POMILOR (GORJ)"
	,
	"DEALU SPIREI (GORJ)"
	,
	"DEALU VIEI (GORJ)"
	,
	"DEALU VIILOR (GORJ)"
	,
	"DELENI (GORJ)"
	,
	"DIDILESTI (GORJ)"
	,
	"DOBRANA (GORJ)"
	,
	"DOBRITA (GORJ)"
	,
	"DOLCESTI (GORJ)"
	,
	"DOSENI (GORJ)"
	,
	"DRAGOENI (GORJ)"
	,
	"DRAGOIESTI (GORJ)"
	,
	"DRAGOTESTI (GORJ)"
	,
	"DRAGUTESTI (GORJ)"
	,
	"DUCULESTI (GORJ)"
	,
	"DUMBRAVENI (GORJ)"
	,
	"FANTANELE (GORJ)"
	,
	"FARCASESTI (GORJ)"
	,
	"FARCASESTI-MOSNENI (GORJ)"
	,
	"FLORESTENI (GORJ)"
	,
	"FLORESTI (GORJ)"
	,
	"FRANCESTI (GORJ)"
	,
	"FRASIN (GORJ)"
	,
	"FRATESTI (GORJ)"
	,
	"FRUMUSEI (GORJ)"
	,
	"FRUNZA (GORJ)"
	,
	"GALCESTI (GORJ)"
	,
	"GALESOAIA (GORJ)"
	,
	"GAMANI (GORJ)"
	,
	"GARBOVU (GORJ)"
	,
	"GAVANESTI (GORJ)"
	,
	"GILORTU (GORJ)"
	,
	"GLODENI (GORJ)"
	,
	"GLOGOVA (GORJ)"
	,
	"GODINESTI (GORJ)"
	,
	"GORNACEL (GORJ)"
	,
	"GORNOVITA (GORJ)"
	,
	"GROSEREA (GORJ)"
	,
	"GRUI (GORJ)"
	,
	"GURA-MENTI (GORJ)"
	,
	"GURA SUSITEI (GORJ)"
	,
	"GURENI (GORJ)"
	,
	"HAIESTI (GORJ)"
	,
	"HALANGESTI (GORJ)"
	,
	"HIRISESTI (GORJ)"
	,
	"HOBITA (GORJ)"
	,
	"HODOREASCA (GORJ)"
	,
	"HORASTI (GORJ)"
	,
	"HOREZU (GORJ)"
	,
	"HOTAROASA (GORJ)"
	,
	"HUREZANI (GORJ)"
	,
	"IASI-GORJ (GORJ)"
	,
	"IEZURENI (GORJ)"
	,
	"IGIROSU (GORJ)"
	,
	"ILIESTI (GORJ)"
	,
	"INSURATEI (GORJ)"
	,
	"IONESTI (GORJ)"
	,
	"IORMANESTI (GORJ)"
	,
	"ISVARNA (GORJ)"
	,
	"IZVOARELE (GORJ)"
	,
	"JERISTEA (GORJ)"
	,
	"JILTU (GORJ)"
	,
	"JUPANESTI (GORJ)"
	,
	"LARGA (GORJ)"
	,
	"LAZARESTI (GORJ)"
	,
	"LAZURI (GORJ)"
	,
	"LELESTI (GORJ)"
	,
	"LEURDA (GORJ)"
	,
	"LICURICI (GORJ)"
	,
	"LIHULESTI (GORJ)"
	,
	"LINTEA (GORJ)"
	,
	"LOGRESTI (GORJ)"
	,
	"LOGRESTI-MOSTENI (GORJ)"
	,
	"LUPOAIA (GORJ)"
	,
	"LUPOITA (GORJ)"
	,
	"MACESU (GORJ)"
	,
	"MAGHERESTI (GORJ)"
	,
	"MAIAG (GORJ)"
	,
	"MARINESTI (GORJ)"
	,
	"MARU (GORJ)"
	,
	"MATASARI (GORJ)"
	,
	"MAZAROI (GORJ)"
	,
	"MENTII DIN DOS (GORJ)"
	,
	"MERFULESTI (GORJ)"
	,
	"MICLOSU (GORJ)"
	,
	"MICULESTI (GORJ)"
	,
	"MIELUSEI (GORJ)"
	,
	"MIEREA (GORJ)"
	,
	"MIERICEAUA (GORJ)"
	,
	"MILUTA (GORJ)"
	,
	"MIROSLOVENI (GORJ)"
	,
	"MOGOSANI (GORJ)"
	,
	"MOI (GORJ)"
	,
	"MOTORGI (GORJ)"
	,
	"MOTRU (GORJ)"
	,
	"MOTRU SEC (GORJ)"
	,
	"MURGESTI (GORJ)"
	,
	"MURGILESTI (GORJ)"
	,
	"MUSCULESTI (GORJ)"
	,
	"MUSETESTI (GORJ)"
	,
	"NAMETE (GORJ)"
	,
	"NEGOIESTI (GORJ)"
	,
	"NEGOMIR (GORJ)"
	,
	"NEGRENI (GORJ)"
	,
	"NISTORESTI (GORJ)"
	,
	"NOVACI (GORJ)"
	,
	"NUCETU (GORJ)"
	,
	"OBARSIA (GORJ)"
	,
	"OBREJA (GORJ)"
	,
	"OHABA (GORJ)"
	,
	"OHABA-JIU (GORJ)"
	,
	"OLARI (GORJ)"
	,
	"OLTEANU (GORJ)"
	,
	"ORZESTI (GORJ)"
	,
	"ORZU (GORJ)"
	,
	"PADES (GORJ)"
	,
	"PAISANI (GORJ)"
	,
	"PAJISTELE (GORJ)"
	,
	"PALTINU (GORJ)"
	,
	"PARAU (GORJ)"
	,
	"PARAU BOIA (GORJ)"
	,
	"PARAU DE PRIPOR (GORJ)"
	,
	"PARAU DE VALE (GORJ)"
	,
	"PARAU VIU (GORJ)"
	,
	"PARVULESTI (GORJ)"
	,
	"PEGENI (GORJ)"
	,
	"PESTEANA DE JOS (GORJ)"
	,
	"PESTEANA-JIU (GORJ)"
	,
	"PESTEANA-VULCAN (GORJ)"
	,
	"PESTISANI (GORJ)"
	,
	"PETRACHEI (GORJ)"
	,
	"PETRESTI (GORJ)"
	,
	"PICU (GORJ)"
	,
	"PIEPTANI (GORJ)"
	,
	"PINOASA (GORJ)"
	,
	"PISCOIU (GORJ)"
	,
	"PISCURI (GORJ)"
	,
	"PISTESTII DIN DEAL (GORJ)"
	,
	"PLESA (GORJ)"
	,
	"PLOPSORU (GORJ)"
	,
	"PLOPU (GORJ)"
	,
	"PLOSTINA (GORJ)"
	,
	"POCIOVALISTEA (GORJ)"
	,
	"POCRUIA (GORJ)"
	,
	"POIANA (GORJ)"
	,
	"POIANA-SECIURI (GORJ)"
	,
	"POIENARI (GORJ)"
	,
	"POIENITA (GORJ)"
	,
	"POJARU (GORJ)"
	,
	"POJOGENI (GORJ)"
	,
	"POLATA (GORJ)"
	,
	"POLOVRAGI (GORJ)"
	,
	"POPESTI (GORJ)"
	,
	"POPESTI-STEJARI (GORJ)"
	,
	"PREAJBA MARE (GORJ)"
	,
	"PRIGORIA (GORJ)"
	,
	"PRIPORU (GORJ)"
	,
	"PRUNESTI (GORJ)"
	,
	"PURCARU (GORJ)"
	,
	"RACHITI (GORJ)"
	,
	"RACI (GORJ)"
	,
	"RACOTI (GORJ)"
	,
	"RACOVITA (GORJ)"
	,
	"RADINESTI (GORJ)"
	,
	"RADOSI (GORJ)"
	,
	"RAPA (GORJ)"
	,
	"RASOVA (GORJ)"
	,
	"RASOVITA (GORJ)"
	,
	"RATEZ (GORJ)"
	,
	"ROGOJEL (GORJ)"
	,
	"ROGOJENI (GORJ)"
	,
	"ROMANESTI (GORJ)"
	,
	"ROSIA DE AMARADIA (GORJ)"
	,
	"ROSIA-JIU (GORJ)"
	,
	"ROSIUTA (GORJ)"
	,
	"ROVINARI (GORJ)"
	,
	"RUGET (GORJ)"
	,
	"RUGI (GORJ)"
	,
	"RUNCU (GORJ)"
	,
	"RUNCUREL (GORJ)"
	,
	"SACELU (GORJ)"
	,
	"SAMARINESTI (GORJ)"
	,
	"SAMBOTIN (GORJ)"
	,
	"SANATESTI (GORJ)"
	,
	"SARBESTI (GORJ)"
	,
	"SARDANESTI (GORJ)"
	,
	"SASA (GORJ)"
	,
	"SATU NOU (GORJ)"
	,
	"SAULESTI (GORJ)"
	,
	"SCHELA (GORJ)"
	,
	"SCOARTA (GORJ)"
	,
	"SCORUSU (GORJ)"
	,
	"SCRADA (GORJ)"
	,
	"SCURTU (GORJ)"
	,
	"SEACA (GORJ)"
	,
	"SECIURILE (GORJ)"
	,
	"SEUCA (GORJ)"
	,
	"SIACU (GORJ)"
	,
	"SIPOTU (GORJ)"
	,
	"SITESTI (GORJ)"
	,
	"SITOAIA (GORJ)"
	,
	"SLAMNESTI (GORJ)"
	,
	"SLAVUTA (GORJ)"
	,
	"SLIVILESTI (GORJ)"
	,
	"SLOBOZIA (GORJ)"
	,
	"SOCU (GORJ)"
	,
	"SOHODOL (GORJ)"
	,
	"SOMANESTI (GORJ)"
	,
	"SPAHII (GORJ)"
	,
	"STANCESTI (GORJ)"
	,
	"STANCESTI-LARGA (GORJ)"
	,
	"STANESTI (GORJ)"
	,
	"STEFANESTI (GORJ)"
	,
	"STEIC (GORJ)"
	,
	"STEJARI (GORJ)"
	,
	"STEJARU (GORJ)"
	,
	"STEJEREI (GORJ)"
	,
	"STERPOAIA (GORJ)"
	,
	"STIUCANI (GORJ)"
	,
	"STOINA (GORJ)"
	,
	"STOLOJANI (GORJ)"
	,
	"STRAMBA-JIU (GORJ)"
	,
	"STRAMBA-VULCAN (GORJ)"
	,
	"STRAMTU (GORJ)"
	,
	"STROIESTI (GORJ)"
	,
	"SURA (GORJ)"
	,
	"SUSENI (GORJ)"
	,
	"TALPASESTI (GORJ)"
	,
	"TALVESTI (GORJ)"
	,
	"TAMASESTI (GORJ)"
	,
	"TANTARENI (GORJ)"
	,
	"TARCULESTI (GORJ)"
	,
	"TARGU CARBUNESTI (GORJ)"
	,
	"TARGU JIU (GORJ)"
	,
	"TARGU LOGRESTI (GORJ)"
	,
	"TEHOMIR (GORJ)"
	,
	"TELESTI (GORJ)"
	,
	"TETILA (GORJ)"
	,
	"TICLENI (GORJ)"
	,
	"TIMISENI (GORJ)"
	,
	"TIRIOI (GORJ)"
	,
	"TISMANA (GORJ)"
	,
	"TOIAGA (GORJ)"
	,
	"TOPESTI (GORJ)"
	,
	"TOTEA (GORJ)"
	,
	"TOTEA DE HUREZANI (GORJ)"
	,
	"TRESTIOARA (GORJ)"
	,
	"TROCANI (GORJ)"
	,
	"TURBUREA (GORJ)"
	,
	"TURCENI (GORJ)"
	,
	"TURCINESTI (GORJ)"
	,
	"ULMET (GORJ)"
	,
	"UNGURENI (GORJ)"
	,
	"URDA DE JOS (GORJ)"
	,
	"URDA DE SUS (GORJ)"
	,
	"URDARI (GORJ)"
	,
	"URECHESTI (GORJ)"
	,
	"URSATI (GORJ)"
	,
	"URSOAIA (GORJ)"
	,
	"VACAREA (GORJ)"
	,
	"VAGIULESTI (GORJ)"
	,
	"VAIDEI (GORJ)"
	,
	"VAIENI (GORJ)"
	,
	"VALARI (GORJ)"
	,
	"VALCEAUA (GORJ)"
	,
	"VALCELE (GORJ)"
	,
	"VALEA (GORJ)"
	,
	"VALEA BISERICII (GORJ)"
	,
	"VALEA CU APA (GORJ)"
	,
	"VALEA DESULUI (GORJ)"
	,
	"VALEA MANASTIRII (GORJ)"
	,
	"VALEA MARE (GORJ)"
	,
	"VALEA MICA (GORJ)"
	,
	"VALEA MOTRULUI (GORJ)"
	,
	"VALEA PERILOR (GORJ)"
	,
	"VALEA POIENII (GORJ)"
	,
	"VALEA POJARULUI (GORJ)"
	,
	"VALEA RACILOR (GORJ)"
	,
	"VALEA VIEI (GORJ)"
	,
	"VALENI (GORJ)"
	,
	"VALUTA (GORJ)"
	,
	"VANATA (GORJ)"
	,
	"VARTOPU (GORJ)"
	,
	"VIDIN (GORJ)"
	,
	"VIERSANI (GORJ)"
	,
	"VLADIMIR (GORJ)"
	,
	"VLADULENI (GORJ)"
	,
	"VOINIGESTI (GORJ)"
	,
	"VOITESTII DIN DEAL (GORJ)"
	,
	"VOITESTII DIN VALE (GORJ)"
	,
	"ZAICOIU (GORJ)"
	,
	"ZORLESTI (GORJ)"
	,
	"ZORZILA (GORJ)"
	,
	"ALDEA (HARGHITA)"
	,
	"ALEXANDRITA (HARGHITA)"
	,
	"ALUNIS (HARGHITA)"
	,
	"ANDREENI (HARGHITA)"
	,
	"ARMASENI (HARGHITA)"
	,
	"ARMASENII NOI (HARGHITA)"
	,
	"ARVATENI (HARGHITA)"
	,
	"ATIA (HARGHITA)"
	,
	"ATID (HARGHITA)"
	,
	"AVRAMESTI (HARGHITA)"
	,
	"BADENI (HARGHITA)"
	,
	"BAILE CHIRUI (HARGHITA)"
	,
	"BAILE HOMOROD (HARGHITA)"
	,
	"BAILE TUSNAD (HARGHITA)"
	,
	"BALAN (HARGHITA)"
	,
	"BANCU (HARGHITA)"
	,
	"BARATCOS (HARGHITA)"
	,
	"BARZAVA (HARGHITA)"
	,
	"BECAS (HARGHITA)"
	,
	"BENTID (HARGHITA)"
	,
	"BETA (HARGHITA)"
	,
	"BETESTI (HARGHITA)"
	,
	"BILBOR (HARGHITA)"
	,
	"BISERICANI (HARGHITA)"
	,
	"BODOGAIA (HARGHITA)"
	,
	"BORSEC (HARGHITA)"
	,
	"BORZONT (HARGHITA)"
	,
	"BRADESTI (HARGHITA)"
	,
	"BUCIN (JOSENI) (HARGHITA)"
	,
	"BUCIN (PRAID) (HARGHITA)"
	,
	"BULGARENI (HARGHITA)"
	,
	"CADACIU MARE (HARGHITA)"
	,
	"CADACIU MIC (HARGHITA)"
	,
	"CALIMANEL (HARGHITA)"
	,
	"CALNACI (HARGHITA)"
	,
	"CALONDA (HARGHITA)"
	,
	"CALUGARENI (HARGHITA)"
	,
	"CAPALNITA (HARGHITA)"
	,
	"CAPU CORBULUI (HARGHITA)"
	,
	"CARPITUS (HARGHITA)"
	,
	"CARTA (HARGHITA)"
	,
	"CASINU NOU (HARGHITA)"
	,
	"CECHESTI (HARGHITA)"
	,
	"CEHETEL (HARGHITA)"
	,
	"CETATUIA (HARGHITA)"
	,
	"CHEDIA MARE (HARGHITA)"
	,
	"CHEDIA MICA (HARGHITA)"
	,
	"CHILENI (HARGHITA)"
	,
	"CHINUSU (HARGHITA)"
	,
	"CIARACIO (HARGHITA)"
	,
	"CIBA (HARGHITA)"
	,
	"CICEU (HARGHITA)"
	,
	"CIOBANIS (HARGHITA)"
	,
	"CIRESENI (HARGHITA)"
	,
	"CIUCANI (HARGHITA)"
	,
	"CIUCSANGEORGIU (HARGHITA)"
	,
	"CIUMANI (HARGHITA)"
	,
	"COBATESTI (HARGHITA)"
	,
	"COMANESTI (HARGHITA)"
	,
	"COMIAT (HARGHITA)"
	,
	"CORBU (HARGHITA)"
	,
	"CORUND (HARGHITA)"
	,
	"COTORMANI (HARGHITA)"
	,
	"COVACIPETER (HARGHITA)"
	,
	"COZMENI (HARGHITA)"
	,
	"CRACIUNEL (HARGHITA)"
	,
	"CRISENI (HARGHITA)"
	,
	"CRISTURU SECUIESC (HARGHITA)"
	,
	"CUSMED (HARGHITA)"
	,
	"DAIA (HARGHITA)"
	,
	"DANESTI (HARGHITA)"
	,
	"DARJIU (HARGHITA)"
	,
	"DEALU (HARGHITA)"
	,
	"DEALU ARMANULUI (HARGHITA)"
	,
	"DEJUTIU (HARGHITA)"
	,
	"DELNITA (HARGHITA)"
	,
	"DESAG (HARGHITA)"
	,
	"DITRAU (HARGHITA)"
	,
	"DOBENI (HARGHITA)"
	,
	"DUDA (HARGHITA)"
	,
	"EGHERSEC (HARGHITA)"
	,
	"ELISENI (HARGHITA)"
	,
	"FAGETEL (FRUMOASA) (HARGHITA)"
	,
	"FAGETEL (REMETEA) (HARGHITA)"
	,
	"FANCEL (HARGHITA)"
	,
	"FANTANA BRAZILOR (HARGHITA)"
	,
	"FELICENI (HARGHITA)"
	,
	"FILIAS (HARGHITA)"
	,
	"FILPEA (HARGHITA)"
	,
	"FIRTANUS (HARGHITA)"
	,
	"FIRTUSU (HARGHITA)"
	,
	"FITOD (HARGHITA)"
	,
	"FORTENI (HARGHITA)"
	,
	"FRUMOASA (HARGHITA)"
	,
	"FUNDOAIA (HARGHITA)"
	,
	"GALAUTAS (HARGHITA)"
	,
	"GALAUTAS-PARAU (HARGHITA)"
	,
	"GHEORGHENI (HARGHITA)"
	,
	"GHIDUT (HARGHITA)"
	,
	"GHIPES (HARGHITA)"
	,
	"GHIURCHE (HARGHITA)"
	,
	"GOAGIU (HARGHITA)"
	,
	"HAGOTA (HARGHITA)"
	,
	"HARGHITA-BAI (HARGHITA)"
	,
	"HODOSA (HARGHITA)"
	,
	"HOGHIA (HARGHITA)"
	,
	"HOSASAU (HARGHITA)"
	,
	"IACOBENI (HARGHITA)"
	,
	"IASU (HARGHITA)"
	,
	"IGHIU (HARGHITA)"
	,
	"IMPER (HARGHITA)"
	,
	"INEU (HARGHITA)"
	,
	"INLACENI (HARGHITA)"
	,
	"IZVOARE (HARGHITA)"
	,
	"IZVORU MURESULUI (HARGHITA)"
	,
	"IZVORUL TROTUSULUI (HARGHITA)"
	,
	"JIGODIN-BAI (HARGHITA)"
	,
	"JOLOTCA (HARGHITA)"
	,
	"JOSENI (HARGHITA)"
	,
	"LACU ROSU (HARGHITA)"
	,
	"LAZ-FIRTANUS (HARGHITA)"
	,
	"LAZ-SOIMUS (HARGHITA)"
	,
	"LAZAREA (HARGHITA)"
	,
	"LAZARESTI (HARGHITA)"
	,
	"LELICENI (HARGHITA)"
	,
	"LIBAN (HARGHITA)"
	,
	"LIVEZI (HARGHITA)"
	,
	"LOCODENI (HARGHITA)"
	,
	"LUETA (HARGHITA)"
	,
	"LUNCA DE JOS (HARGHITA)"
	,
	"LUNCA DE SUS (HARGHITA)"
	,
	"LUNCANI (HARGHITA)"
	,
	"LUPENI (HARGHITA)"
	,
	"LUTITA (HARGHITA)"
	,
	"MADARAS (HARGHITA)"
	,
	"MAGHERUS (HARGHITA)"
	,
	"MARTINIS (HARGHITA)"
	,
	"MARTONCA (HARGHITA)"
	,
	"MATISENI (HARGHITA)"
	,
	"MEDISORU MARE (HARGHITA)"
	,
	"MEDISORU MIC (HARGHITA)"
	,
	"MERESTI (HARGHITA)"
	,
	"MIERCUREA CIUC (HARGHITA)"
	,
	"MIHAILENI (HARGHITA)"
	,
	"MIHAILENI (SIMONESTI) (HARGHITA)"
	,
	"MINELE LUETA (HARGHITA)"
	,
	"MISENTEA (HARGHITA)"
	,
	"MOGLANESTI (HARGHITA)"
	,
	"MORARENI (HARGHITA)"
	,
	"MUGENI (HARGHITA)"
	,
	"MUJNA (HARGHITA)"
	,
	"NADEJDEA (HARGHITA)"
	,
	"NICOLENI (HARGHITA)"
	,
	"NICOLESTI (FRUMOASA) (HARGHITA)"
	,
	"NICOLESTI (ULIES) (HARGHITA)"
	,
	"NUTENI (HARGHITA)"
	,
	"OBRANESTI (HARGHITA)"
	,
	"OCLAND (HARGHITA)"
	,
	"OCNA DE JOS (HARGHITA)"
	,
	"OCNA DE SUS (HARGHITA)"
	,
	"ODORHEIU SECUIESC (HARGHITA)"
	,
	"ORASENI (HARGHITA)"
	,
	"OTENI (HARGHITA)"
	,
	"PALTINIS (HARGHITA)"
	,
	"PALTINIS-CIUC (HARGHITA)"
	,
	"PAULENI (HARGHITA)"
	,
	"PAULENI-CIUC (HARGHITA)"
	,
	"PETECU (HARGHITA)"
	,
	"PETRENI (HARGHITA)"
	,
	"PINTIC (HARGHITA)"
	,
	"PLAIESII DE JOS (HARGHITA)"
	,
	"PLAIESII DE SUS (HARGHITA)"
	,
	"PLATONESTI (HARGHITA)"
	,
	"PLOPIS (HARGHITA)"
	,
	"POIANA FAGULUI (HARGHITA)"
	,
	"POIANA TARNAVEI (HARGHITA)"
	,
	"POLONITA (HARGHITA)"
	,
	"PORUMBENII MARI (HARGHITA)"
	,
	"PORUMBENII MICI (HARGHITA)"
	,
	"POTIOND (HARGHITA)"
	,
	"PRAID (HARGHITA)"
	,
	"PRELUCA (HARGHITA)"
	,
	"PUNTEA LUPULUI (HARGHITA)"
	,
	"RACHITIS (HARGHITA)"
	,
	"RACU (HARGHITA)"
	,
	"RARES (HARGHITA)"
	,
	"RECEA (HARGHITA)"
	,
	"REMETEA (HARGHITA)"
	,
	"RUGANESTI (HARGHITA)"
	,
	"RUNC (HARGHITA)"
	,
	"SACEL (HARGHITA)"
	,
	"SANCEL (HARGHITA)"
	,
	"SANCRAI (HARGHITA)"
	,
	"SANCRAIENI (HARGHITA)"
	,
	"SANDOMINIC (HARGHITA)"
	,
	"SANMARTIN (HARGHITA)"
	,
	"SANPAUL (HARGHITA)"
	,
	"SANSIMION (HARGHITA)"
	,
	"SANTIMBRU (HARGHITA)"
	,
	"SANTIMBRU-BAI (HARGHITA)"
	,
	"SARMAS (HARGHITA)"
	,
	"SASVERES (HARGHITA)"
	,
	"SATU MARE (HARGHITA)"
	,
	"SATU MIC (HARGHITA)"
	,
	"SATU NOU (OCLAND) (HARGHITA)"
	,
	"SATU NOU (SICULENI) (HARGHITA)"
	,
	"SECU (HARGHITA)"
	,
	"SECUIENI (HARGHITA)"
	,
	"SENETEA (HARGHITA)"
	,
	"SICASAU (HARGHITA)"
	,
	"SICLOD (HARGHITA)"
	,
	"SICULENI (HARGHITA)"
	,
	"SIMONESTI (HARGHITA)"
	,
	"SINEU (HARGHITA)"
	,
	"SOIMENI (HARGHITA)"
	,
	"SOIMUSU MARE (HARGHITA)"
	,
	"SOIMUSU MIC (HARGHITA)"
	,
	"SUB CETATE (HARGHITA)"
	,
	"SUBCETATE (HARGHITA)"
	,
	"SUSENI (HARGHITA)"
	,
	"TAIETURA (HARGHITA)"
	,
	"TAMASU (HARGHITA)"
	,
	"TARCESTI (HARGHITA)"
	,
	"TARNOVITA (HARGHITA)"
	,
	"TAURENI (HARGHITA)"
	,
	"TELEAC (HARGHITA)"
	,
	"TENGHELER (HARGHITA)"
	,
	"TIBOD (HARGHITA)"
	,
	"TOLESENI (HARGHITA)"
	,
	"TOMESTI (HARGHITA)"
	,
	"TOPLITA (HARGHITA)"
	,
	"TULGHES (HARGHITA)"
	,
	"TURDENI (HARGHITA)"
	,
	"TUSNAD (HARGHITA)"
	,
	"TUSNADU NOU (HARGHITA)"
	,
	"UILAC (HARGHITA)"
	,
	"ULCANI (HARGHITA)"
	,
	"ULIES (HARGHITA)"
	,
	"VACARESTI (HARGHITA)"
	,
	"VAGANI (HARGHITA)"
	,
	"VALE (HARGHITA)"
	,
	"VALEA BOROS (HARGHITA)"
	,
	"VALEA CAPELEI (HARGHITA)"
	,
	"VALEA GARBEA (HARGHITA)"
	,
	"VALEA INTUNECOASA (HARGHITA)"
	,
	"VALEA LUI ANTALOC (HARGHITA)"
	,
	"VALEA LUI PAVEL (HARGHITA)"
	,
	"VALEA RECE (HARGHITA)"
	,
	"VALEA ROTUNDA (HARGHITA)"
	,
	"VALEA STRAMBA (HARGHITA)"
	,
	"VALEA UGRA (HARGHITA)"
	,
	"VALEA UZULUI (HARGHITA)"
	,
	"VALENI (HARGHITA)"
	,
	"VARGATAC (HARGHITA)"
	,
	"VARSAG (HARGHITA)"
	,
	"VASILENI (HARGHITA)"
	,
	"VIDACUT (HARGHITA)"
	,
	"VISAFOLIO (HARGHITA)"
	,
	"VLAHITA (HARGHITA)"
	,
	"VOSLABENI (HARGHITA)"
	,
	"VRABIA (HARGHITA)"
	,
	"ZAPODEA (HARGHITA)"
	,
	"ZENCANI (HARGHITA)"
	,
	"ZETEA (HARGHITA)"
	,
	"ABUCEA (HUNEDOARA)"
	,
	"ALMAS-SALISTE (HUNEDOARA)"
	,
	"ALMASEL (HUNEDOARA)"
	,
	"ALMASU MIC (HUNEDOARA)"
	,
	"ALMASU MIC DE MUNTE (HUNEDOARA)"
	,
	"ALMASU SEC (HUNEDOARA)"
	,
	"ALUN (BOSOROD) (HUNEDOARA)"
	,
	"ALUN (BUNILA) (HUNEDOARA)"
	,
	"ANINOASA (HUNEDOARA)"
	,
	"ARANIES (HUNEDOARA)"
	,
	"ARCHIA (HUNEDOARA)"
	,
	"ARDEU (HUNEDOARA)"
	,
	"AUREL VLAICU (HUNEDOARA)"
	,
	"BACAIA (HUNEDOARA)"
	,
	"BACEA (HUNEDOARA)"
	,
	"BACIA (HUNEDOARA)"
	,
	"BAIA DE CRIS (HUNEDOARA)"
	,
	"BAIESTI (HUNEDOARA)"
	,
	"BAITA (HUNEDOARA)"
	,
	"BALATA (HUNEDOARA)"
	,
	"BALDOVIN (HUNEDOARA)"
	,
	"BALOMIR (HUNEDOARA)"
	,
	"BALSA (HUNEDOARA)"
	,
	"BANITA (HUNEDOARA)"
	,
	"BANPOTOC (HUNEDOARA)"
	,
	"BARASTII HATEGULUI (HUNEDOARA)"
	,
	"BARASTII ILIEI (HUNEDOARA)"
	,
	"BARBURA (HUNEDOARA)"
	,
	"BARCEA MARE (HUNEDOARA)"
	,
	"BARCEA MICA (HUNEDOARA)"
	,
	"BARSAU (HUNEDOARA)"
	,
	"BARU (HUNEDOARA)"
	,
	"BARZA (HUNEDOARA)"
	,
	"BASARABASA (HUNEDOARA)"
	,
	"BASTEA (HUNEDOARA)"
	,
	"BATALAR (HUNEDOARA)"
	,
	"BATIZ (HUNEDOARA)"
	,
	"BATRANA (HUNEDOARA)"
	,
	"BEJAN (HUNEDOARA)"
	,
	"BEJAN-TARNAVITA (HUNEDOARA)"
	,
	"BERCU (HUNEDOARA)"
	,
	"BERIU (HUNEDOARA)"
	,
	"BIRTIN (HUNEDOARA)"
	,
	"BLAJENI (HUNEDOARA)"
	,
	"BLAJENI-VULCAN (HUNEDOARA)"
	,
	"BOBAIA (HUNEDOARA)"
	,
	"BOBALNA (HUNEDOARA)"
	,
	"BOCSA MARE (HUNEDOARA)"
	,
	"BOCSA MICA (HUNEDOARA)"
	,
	"BOHOLT (HUNEDOARA)"
	,
	"BOIA BARZII (HUNEDOARA)"
	,
	"BOITA (HUNEDOARA)"
	,
	"BOIU (HUNEDOARA)"
	,
	"BOIU DE JOS (HUNEDOARA)"
	,
	"BOIU DE SUS (HUNEDOARA)"
	,
	"BOS (HUNEDOARA)"
	,
	"BOSOROD (HUNEDOARA)"
	,
	"BOZ (HUNEDOARA)"
	,
	"BOZES (HUNEDOARA)"
	,
	"BRAD (HUNEDOARA)"
	,
	"BRADATEL (HUNEDOARA)"
	,
	"BRANISCA (HUNEDOARA)"
	,
	"BRASEU (HUNEDOARA)"
	,
	"BRAZI (HUNEDOARA)"
	,
	"BRAZNIC (HUNEDOARA)"
	,
	"BREAZOVA (HUNEDOARA)"
	,
	"BRETEA MURESANA (HUNEDOARA)"
	,
	"BRETEA ROMANA (HUNEDOARA)"
	,
	"BRETEA STREIULUI (HUNEDOARA)"
	,
	"BRETELIN (HUNEDOARA)"
	,
	"BROTUNA (HUNEDOARA)"
	,
	"BUCES (HUNEDOARA)"
	,
	"BUCES-VULCAN (HUNEDOARA)"
	,
	"BUCIUM (HUNEDOARA)"
	,
	"BUCIUM-ORLEA (HUNEDOARA)"
	,
	"BUCURESCI (HUNEDOARA)"
	,
	"BUJORU (HUNEDOARA)"
	,
	"BULZESTII DE JOS (HUNEDOARA)"
	,
	"BULZESTII DE SUS (HUNEDOARA)"
	,
	"BUNESTI (HUNEDOARA)"
	,
	"BUNILA (HUNEDOARA)"
	,
	"BURJUC (HUNEDOARA)"
	,
	"CABESTI (HUNEDOARA)"
	,
	"CAINELU DE JOS (HUNEDOARA)"
	,
	"CAINELU DE SUS (HUNEDOARA)"
	,
	"CALAN (HUNEDOARA)"
	,
	"CALANU MIC (HUNEDOARA)"
	,
	"CAMPU LUI NEAG (HUNEDOARA)"
	,
	"CAMPURI DE SUS (HUNEDOARA)"
	,
	"CAMPURI-SURDUC (HUNEDOARA)"
	,
	"CAOI (HUNEDOARA)"
	,
	"CARACI (HUNEDOARA)"
	,
	"CARASTAU (HUNEDOARA)"
	,
	"CARJITI (HUNEDOARA)"
	,
	"CARMAZANESTI (HUNEDOARA)"
	,
	"CARNESTI (HUNEDOARA)"
	,
	"CARPINIS (HUNEDOARA)"
	,
	"CASTAU (HUNEDOARA)"
	,
	"CAZANESTI (HUNEDOARA)"
	,
	"CERBAL (HUNEDOARA)"
	,
	"CERBIA (HUNEDOARA)"
	,
	"CERISOR (HUNEDOARA)"
	,
	"CERNISOARA FLORESE (HUNEDOARA)"
	,
	"CERTEJU DE JOS (HUNEDOARA)"
	,
	"CERTEJU DE SUS (HUNEDOARA)"
	,
	"CHERGHES (HUNEDOARA)"
	,
	"CHIMINDIA (HUNEDOARA)"
	,
	"CHISCADAGA (HUNEDOARA)"
	,
	"CHITID (HUNEDOARA)"
	,
	"CIGMAU (HUNEDOARA)"
	,
	"CIMPA (HUNEDOARA)"
	,
	"CINCIS-CERNA (HUNEDOARA)"
	,
	"CIOCLOVINA (HUNEDOARA)"
	,
	"CIOPEIA (HUNEDOARA)"
	,
	"CIULA MARE (HUNEDOARA)"
	,
	"CIULA MICA (HUNEDOARA)"
	,
	"CIULPAZ (HUNEDOARA)"
	,
	"CIUMITA (HUNEDOARA)"
	,
	"CIUNGANI (HUNEDOARA)"
	,
	"CIUNGU MARE (HUNEDOARA)"
	,
	"CLOPOTIVA (HUNEDOARA)"
	,
	"COAJA (HUNEDOARA)"
	,
	"COPACI (HUNEDOARA)"
	,
	"COROIESTI (HUNEDOARA)"
	,
	"COSESTI (HUNEDOARA)"
	,
	"COSTESTI (HUNEDOARA)"
	,
	"COSTESTI-DEAL (HUNEDOARA)"
	,
	"COVRAGIU (HUNEDOARA)"
	,
	"COZIA (HUNEDOARA)"
	,
	"CRACIUNESTI (HUNEDOARA)"
	,
	"CRAGUIS (HUNEDOARA)"
	,
	"CRIS (HUNEDOARA)"
	,
	"CRISAN (HUNEDOARA)"
	,
	"CRISCIOR (HUNEDOARA)"
	,
	"CRISTUR (HUNEDOARA)"
	,
	"CRIVA (HUNEDOARA)"
	,
	"CRIVADIA (HUNEDOARA)"
	,
	"CUCUIS (HUNEDOARA)"
	,
	"CUIES (HUNEDOARA)"
	,
	"CURECHIU (HUNEDOARA)"
	,
	"CURPENII SILVASULUI (HUNEDOARA)"
	,
	"CUTIN (HUNEDOARA)"
	,
	"DABACA (HUNEDOARA)"
	,
	"DALJA MARE (HUNEDOARA)"
	,
	"DALJA MICA (HUNEDOARA)"
	,
	"DANCU MARE (HUNEDOARA)"
	,
	"DANCU MIC (HUNEDOARA)"
	,
	"DANULESTI (HUNEDOARA)"
	,
	"DEALU BABII (HUNEDOARA)"
	,
	"DEALU MARE (HUNEDOARA)"
	,
	"DEALU MIC (HUNEDOARA)"
	,
	"DELENI (HUNEDOARA)"
	,
	"DENSUS (HUNEDOARA)"
	,
	"DEVA (HUNEDOARA)"
	,
	"DOBRA (HUNEDOARA)"
	,
	"DOBROT (HUNEDOARA)"
	,
	"DRAGU-BRAD (HUNEDOARA)"
	,
	"DUDESTI (HUNEDOARA)"
	,
	"DUMBRAVA (HUNEDOARA)"
	,
	"DUMBRAVA DE JOS (HUNEDOARA)"
	,
	"DUMBRAVA DE SUS (HUNEDOARA)"
	,
	"DUMBRAVITA (HUNEDOARA)"
	,
	"DUMESTI (HUNEDOARA)"
	,
	"DUPAPIATRA (HUNEDOARA)"
	,
	"FAGETEL (HUNEDOARA)"
	,
	"FANTANA (HUNEDOARA)"
	,
	"FARCADIN (HUNEDOARA)"
	,
	"FATA ROSIE (HUNEDOARA)"
	,
	"FEDERI (HUNEDOARA)"
	,
	"FEREGI (HUNEDOARA)"
	,
	"FINTOAG (HUNEDOARA)"
	,
	"FIZES (HUNEDOARA)"
	,
	"FIZESTI (HUNEDOARA)"
	,
	"FOLT (HUNEDOARA)"
	,
	"FORNADIA (HUNEDOARA)"
	,
	"FURCSOARA (HUNEDOARA)"
	,
	"GALATI (HUNEDOARA)"
	,
	"GALBINA (HUNEDOARA)"
	,
	"GANTAGA (HUNEDOARA)"
	,
	"GELMAR (HUNEDOARA)"
	,
	"GENERAL BERTHELOT (HUNEDOARA)"
	,
	"GEOAGIU (HUNEDOARA)"
	,
	"GEOAGIU-BAI (HUNEDOARA)"
	,
	"GHELARI (HUNEDOARA)"
	,
	"GIALACUTA (HUNEDOARA)"
	,
	"GIURGESTI (HUNEDOARA)"
	,
	"GLODGHILESTI (HUNEDOARA)"
	,
	"GODINESTI (HUNEDOARA)"
	,
	"GOLES (HUNEDOARA)"
	,
	"GOTESTI (HUNEDOARA)"
	,
	"GOTHATEA (HUNEDOARA)"
	,
	"GOVAJDIA (HUNEDOARA)"
	,
	"GRADISTEA DE MUNTE (HUNEDOARA)"
	,
	"GRID (HUNEDOARA)"
	,
	"GRIND (HUNEDOARA)"
	,
	"GROHOT (HUNEDOARA)"
	,
	"GROHOTELE (HUNEDOARA)"
	,
	"GROS (HUNEDOARA)"
	,
	"GROSURI (HUNEDOARA)"
	,
	"GURA BORDULUI (HUNEDOARA)"
	,
	"GURASADA (HUNEDOARA)"
	,
	"HARAU (HUNEDOARA)"
	,
	"HARTAGANI (HUNEDOARA)"
	,
	"HASDAT (HUNEDOARA)"
	,
	"HASDAU (HUNEDOARA)"
	,
	"HATAGEL (HUNEDOARA)"
	,
	"HATEG (HUNEDOARA)"
	,
	"HEREPEIA (HUNEDOARA)"
	,
	"HOBITA (HUNEDOARA)"
	,
	"HOBITA-GRADISTE (HUNEDOARA)"
	,
	"HOLDEA (HUNEDOARA)"
	,
	"HOMOROD (HUNEDOARA)"
	,
	"HONDOL (HUNEDOARA)"
	,
	"HUNEDOARA (HUNEDOARA)"
	,
	"ILIA (HUNEDOARA)"
	,
	"ISCRONI (HUNEDOARA)"
	,
	"IZVOARELE (HUNEDOARA)"
	,
	"JELEDINTI (HUNEDOARA)"
	,
	"JIET (HUNEDOARA)"
	,
	"JIU-PAROSENI (HUNEDOARA)"
	,
	"JOSANI (HUNEDOARA)"
	,
	"LAPUGIU DE JOS (HUNEDOARA)"
	,
	"LAPUGIU DE SUS (HUNEDOARA)"
	,
	"LAPUSNIC (HUNEDOARA)"
	,
	"LASAU (HUNEDOARA)"
	,
	"LEAUT (HUNEDOARA)"
	,
	"LELESE (HUNEDOARA)"
	,
	"LESNIC (HUNEDOARA)"
	,
	"LIVADA (HUNEDOARA)"
	,
	"LIVADIA (HUNEDOARA)"
	,
	"LIVEZI (HUNEDOARA)"
	,
	"LUDESTII DE JOS (HUNEDOARA)"
	,
	"LUDESTII DE SUS (HUNEDOARA)"
	,
	"LUNCA (BAIA DE CRIS) (HUNEDOARA)"
	,
	"LUNCA (BAITA) (HUNEDOARA)"
	,
	"LUNCA CERNII DE JOS (HUNEDOARA)"
	,
	"LUNCA CERNII DE SUS (HUNEDOARA)"
	,
	"LUNCANI (HUNEDOARA)"
	,
	"LUNCOIU DE JOS (HUNEDOARA)"
	,
	"LUNCOIU DE SUS (HUNEDOARA)"
	,
	"LUNCSOARA (HUNEDOARA)"
	,
	"LUPENI (HUNEDOARA)"
	,
	"MACEU (HUNEDOARA)"
	,
	"MADA (HUNEDOARA)"
	,
	"MAGURA (HUNEDOARA)"
	,
	"MAGURA-TOPLITA (HUNEDOARA)"
	,
	"MAGURENI (HUNEDOARA)"
	,
	"MALAIESTI (HUNEDOARA)"
	,
	"MANERAU (HUNEDOARA)"
	,
	"MARTINESTI (HUNEDOARA)"
	,
	"MERIA (HUNEDOARA)"
	,
	"MERISOR (BANITA) (HUNEDOARA)"
	,
	"MERISOR (BUCURESCI) (HUNEDOARA)"
	,
	"MERISORU DE MUNTE (HUNEDOARA)"
	,
	"MERMEZEU-VALENI (HUNEDOARA)"
	,
	"MESTEACAN (BRAD) (HUNEDOARA)"
	,
	"MESTEACAN (RACHITOVA) (HUNEDOARA)"
	,
	"MICANESTI (HUNEDOARA)"
	,
	"MIHAIESTI (HUNEDOARA)"
	,
	"MIHAILENI (HUNEDOARA)"
	,
	"MINTIA (HUNEDOARA)"
	,
	"MOSORU (HUNEDOARA)"
	,
	"MUNCELU MARE (HUNEDOARA)"
	,
	"MUNCELU MIC (HUNEDOARA)"
	,
	"NADASTIA DE JOS (HUNEDOARA)"
	,
	"NADASTIA DE SUS (HUNEDOARA)"
	,
	"NALATVAD (HUNEDOARA)"
	,
	"NANDRU (HUNEDOARA)"
	,
	"NEGOIU (HUNEDOARA)"
	,
	"NOJAG (HUNEDOARA)"
	,
	"NUCSOARA (HUNEDOARA)"
	,
	"OBARSA (HUNEDOARA)"
	,
	"OCISOR (HUNEDOARA)"
	,
	"OCIU (HUNEDOARA)"
	,
	"OCOLISU MARE (HUNEDOARA)"
	,
	"OCOLISU MIC (HUNEDOARA)"
	,
	"OHABA (HUNEDOARA)"
	,
	"OHABA DE SUB PIATRA (HUNEDOARA)"
	,
	"OHABA-PONOR (HUNEDOARA)"
	,
	"OHABA-SIBISEL (HUNEDOARA)"
	,
	"OHABA STREIULUI (HUNEDOARA)"
	,
	"OPRISESTI (HUNEDOARA)"
	,
	"ORASTIE (HUNEDOARA)"
	,
	"ORASTIOARA DE JOS (HUNEDOARA)"
	,
	"ORASTIOARA DE SUS (HUNEDOARA)"
	,
	"ORMINDEA (HUNEDOARA)"
	,
	"OSTROV (HUNEDOARA)"
	,
	"OSTROVEL (HUNEDOARA)"
	,
	"OSTROVU MIC (HUNEDOARA)"
	,
	"PACLISA (HUNEDOARA)"
	,
	"PANC (HUNEDOARA)"
	,
	"PANC-SALISTE (HUNEDOARA)"
	,
	"PAROS (HUNEDOARA)"
	,
	"PAUCINESTI (HUNEDOARA)"
	,
	"PAULESTI (HUNEDOARA)"
	,
	"PAULIS (HUNEDOARA)"
	,
	"PESTEANA (HUNEDOARA)"
	,
	"PESTENITA (HUNEDOARA)"
	,
	"PESTERA (BAITA) (HUNEDOARA)"
	,
	"PESTERA (PETROSANI) (HUNEDOARA)"
	,
	"PESTERA (SALASU DE SUS) (HUNEDOARA)"
	,
	"PESTISU MARE (HUNEDOARA)"
	,
	"PESTISU MIC (HUNEDOARA)"
	,
	"PETRENI (HUNEDOARA)"
	,
	"PETRESTI (HUNEDOARA)"
	,
	"PETRILA (HUNEDOARA)"
	,
	"PETROS (HUNEDOARA)"
	,
	"PETROSANI (HUNEDOARA)"
	,
	"PIATRA (HUNEDOARA)"
	,
	"PISCHINTI (HUNEDOARA)"
	,
	"PLAI (HUNEDOARA)"
	,
	"PLOP (HUNEDOARA)"
	,
	"PLOPI (HUNEDOARA)"
	,
	"PODELE (HUNEDOARA)"
	,
	"POGANESTI (HUNEDOARA)"
	,
	"POIANA (HUNEDOARA)"
	,
	"POIANA RACHITELII (HUNEDOARA)"
	,
	"POIENI (BERIU) (HUNEDOARA)"
	,
	"POIENI (DENSUS) (HUNEDOARA)"
	,
	"POIENITA (HUNEDOARA)"
	,
	"POIENITA TOMII (HUNEDOARA)"
	,
	"POIENITA VOINII (HUNEDOARA)"
	,
	"POJOGA (HUNEDOARA)"
	,
	"PONOR (HUNEDOARA)"
	,
	"POPESTI (HUNEDOARA)"
	,
	"POTINGANI (HUNEDOARA)"
	,
	"PRAVALENI (HUNEDOARA)"
	,
	"PRICAZ (HUNEDOARA)"
	,
	"PRIHODISTE (BOSOROD) (HUNEDOARA)"
	,
	"PRIHODISTE (VATA DE JOS) (HUNEDOARA)"
	,
	"PUI (HUNEDOARA)"
	,
	"RACASTIA (HUNEDOARA)"
	,
	"RACHITAUA (HUNEDOARA)"
	,
	"RACHITOVA (HUNEDOARA)"
	,
	"RADULESTI (HUNEDOARA)"
	,
	"RAPAS (HUNEDOARA)"
	,
	"RAPOLTEL (HUNEDOARA)"
	,
	"RAPOLTU MARE (HUNEDOARA)"
	,
	"RASCOALA (HUNEDOARA)"
	,
	"RAU ALB (HUNEDOARA)"
	,
	"RAU BARBAT (HUNEDOARA)"
	,
	"RAU DE MORI (HUNEDOARA)"
	,
	"RAU MIC (HUNEDOARA)"
	,
	"REEA (HUNEDOARA)"
	,
	"RENGHET (HUNEDOARA)"
	,
	"RET (HUNEDOARA)"
	,
	"RIBICIOARA (HUNEDOARA)"
	,
	"RIBITA (HUNEDOARA)"
	,
	"RISCA (HUNEDOARA)"
	,
	"RISCULITA (HUNEDOARA)"
	,
	"ROMOS (HUNEDOARA)"
	,
	"ROMOSEL (HUNEDOARA)"
	,
	"ROSCANI (HUNEDOARA)"
	,
	"ROSIA (HUNEDOARA)"
	,
	"ROVINA (BRANISCA) (HUNEDOARA)"
	,
	"ROVINA (BUCURESCI) (HUNEDOARA)"
	,
	"RUDA (HUNEDOARA)"
	,
	"RUDA-BRAD (HUNEDOARA)"
	,
	"RUNCSOR (HUNEDOARA)"
	,
	"RUNCU MARE (HUNEDOARA)"
	,
	"RUNCU MIC (HUNEDOARA)"
	,
	"RUSESTI (HUNEDOARA)"
	,
	"RUSI (HUNEDOARA)"
	,
	"RUSOR (HUNEDOARA)"
	,
	"SACAMAS (HUNEDOARA)"
	,
	"SACARAMB (HUNEDOARA)"
	,
	"SACEL (HUNEDOARA)"
	,
	"SALASU DE JOS (HUNEDOARA)"
	,
	"SALASU DE SUS (HUNEDOARA)"
	,
	"SALATRUC (HUNEDOARA)"
	,
	"SALCIVA (HUNEDOARA)"
	,
	"SALISTE (HUNEDOARA)"
	,
	"SALISTIOARA (HUNEDOARA)"
	,
	"SANCRAI (HUNEDOARA)"
	,
	"SANPETRU (HUNEDOARA)"
	,
	"SANTAMARIA DE PIATRA (HUNEDOARA)"
	,
	"SANTAMARIA-ORLEA (HUNEDOARA)"
	,
	"SANTANDREI (HUNEDOARA)"
	,
	"SANTUHALM (HUNEDOARA)"
	,
	"SARBI (HUNEDOARA)"
	,
	"SARMIZEGETUSA (HUNEDOARA)"
	,
	"SAULESTI (HUNEDOARA)"
	,
	"SERECA (HUNEDOARA)"
	,
	"SEREL (HUNEDOARA)"
	,
	"SESURI (HUNEDOARA)"
	,
	"SIBISEL (BERIU) (HUNEDOARA)"
	,
	"SIBISEL (RAU DE MORI) (HUNEDOARA)"
	,
	"SILVASU DE JOS (HUNEDOARA)"
	,
	"SILVASU DE SUS (HUNEDOARA)"
	,
	"SIMERIA (HUNEDOARA)"
	,
	"SIMERIA VECHE (HUNEDOARA)"
	,
	"SLATINIOARA (HUNEDOARA)"
	,
	"SOCET (HUNEDOARA)"
	,
	"SOHODOL (HUNEDOARA)"
	,
	"SOIMUS (HUNEDOARA)"
	,
	"SPINI (HUNEDOARA)"
	,
	"STANCESTI (HUNEDOARA)"
	,
	"STANCESTI-OHABA (HUNEDOARA)"
	,
	"STANCULESTI (HUNEDOARA)"
	,
	"STANIJA (HUNEDOARA)"
	,
	"STAUINI (HUNEDOARA)"
	,
	"STEI (HUNEDOARA)"
	,
	"STEIA (HUNEDOARA)"
	,
	"STEJAREL (HUNEDOARA)"
	,
	"STOIENEASA (HUNEDOARA)"
	,
	"STREI (HUNEDOARA)"
	,
	"STREI-SACEL (HUNEDOARA)"
	,
	"STREISANGEORGIU (HUNEDOARA)"
	,
	"STRETEA (HUNEDOARA)"
	,
	"SUBCETATE (HUNEDOARA)"
	,
	"SULIGHETE (HUNEDOARA)"
	,
	"SUSENI (HUNEDOARA)"
	,
	"TAMASASA (HUNEDOARA)"
	,
	"TAMASESTI (HUNEDOARA)"
	,
	"TAMPA (HUNEDOARA)"
	,
	"TARATEL (HUNEDOARA)"
	,
	"TARNAVA (HUNEDOARA)"
	,
	"TARNAVA DE CRIS (HUNEDOARA)"
	,
	"TARNAVITA (HUNEDOARA)"
	,
	"TARNITA (HUNEDOARA)"
	,
	"TARSA (HUNEDOARA)"
	,
	"TATARASTI (HUNEDOARA)"
	,
	"TATARASTII DE CRIS (HUNEDOARA)"
	,
	"TEBEA (HUNEDOARA)"
	,
	"TECHEREU (HUNEDOARA)"
	,
	"TEIU (HUNEDOARA)"
	,
	"TELIUCU INFERIOR (HUNEDOARA)"
	,
	"TELIUCU SUPERIOR (HUNEDOARA)"
	,
	"TICERA (HUNEDOARA)"
	,
	"TIRICI (HUNEDOARA)"
	,
	"TISA (HUNEDOARA)"
	,
	"TIULESTI (HUNEDOARA)"
	,
	"TOMESTI (HUNEDOARA)"
	,
	"TOMNATEC (HUNEDOARA)"
	,
	"TOPLITA (HUNEDOARA)"
	,
	"TOPLITA MURESULUI (HUNEDOARA)"
	,
	"TOTESTI (HUNEDOARA)"
	,
	"TOTIA (HUNEDOARA)"
	,
	"TRESTIA (HUNEDOARA)"
	,
	"TURDAS (HUNEDOARA)"
	,
	"TURMAS (HUNEDOARA)"
	,
	"TUSTEA (HUNEDOARA)"
	,
	"UIBARESTI (HUNEDOARA)"
	,
	"ULIES (HUNEDOARA)"
	,
	"ULM (HUNEDOARA)"
	,
	"UNCIUC (HUNEDOARA)"
	,
	"URIC (HUNEDOARA)"
	,
	"URICANI (HUNEDOARA)"
	,
	"UROI (HUNEDOARA)"
	,
	"URSICI (HUNEDOARA)"
	,
	"VADU (HUNEDOARA)"
	,
	"VADU DOBRII (HUNEDOARA)"
	,
	"VAIDEI (HUNEDOARA)"
	,
	"VALARI (HUNEDOARA)"
	,
	"VALCELE (HUNEDOARA)"
	,
	"VALCELELE BUNE (HUNEDOARA)"
	,
	"VALCELUTA (HUNEDOARA)"
	,
	"VALEA (HUNEDOARA)"
	,
	"VALEA ARSULUI (HUNEDOARA)"
	,
	"VALEA BABII (HUNEDOARA)"
	,
	"VALEA BRADULUI (HUNEDOARA)"
	,
	"VALEA DALJII (HUNEDOARA)"
	,
	"VALEA DE BRAZI (HUNEDOARA)"
	,
	"VALEA LUNGA (HUNEDOARA)"
	,
	"VALEA LUPULUI (HUNEDOARA)"
	,
	"VALEA MARE DE CRIS (HUNEDOARA)"
	,
	"VALEA NANDRULUI (HUNEDOARA)"
	,
	"VALEA POIENII (HUNEDOARA)"
	,
	"VALEA SANGEORGIULUI (HUNEDOARA)"
	,
	"VALENI (BAIA DE CRIS) (HUNEDOARA)"
	,
	"VALENI (GEOAGIU) (HUNEDOARA)"
	,
	"VALIOARA (HUNEDOARA)"
	,
	"VALISOARA (HUNEDOARA)"
	,
	"VALISOARA (BALSA) (HUNEDOARA)"
	,
	"VARMAGA (HUNEDOARA)"
	,
	"VATA DE JOS (HUNEDOARA)"
	,
	"VATA DE SUS (HUNEDOARA)"
	,
	"VETEL (HUNEDOARA)"
	,
	"VICA (HUNEDOARA)"
	,
	"VISCA (HUNEDOARA)"
	,
	"VOIA (HUNEDOARA)"
	,
	"VORTA (HUNEDOARA)"
	,
	"VULCAN (HUNEDOARA)"
	,
	"ZAM (HUNEDOARA)"
	,
	"ZAVOI (HUNEDOARA)"
	,
	"ZDRAPTI (HUNEDOARA)"
	,
	"ZEICANI (HUNEDOARA)"
	,
	"ADANCATA (IALOMITA)"
	,
	"ALBESTI (IALOMITA)"
	,
	"ALEXENI (IALOMITA)"
	,
	"AMARA (IALOMITA)"
	,
	"AMARA NOUA (IALOMITA)"
	,
	"ANDRASESTI (IALOMITA)"
	,
	"ARMASESTI (IALOMITA)"
	,
	"AXINTELE (IALOMITA)"
	,
	"BALACIU (IALOMITA)"
	,
	"BARBATESCU (IALOMITA)"
	,
	"BARBULESTI (IALOMITA)"
	,
	"BARCANESTI (IALOMITA)"
	,
	"BATALURI (IALOMITA)"
	,
	"BITINA-PAMANTENI (IALOMITA)"
	,
	"BITINA-UNGURENI (IALOMITA)"
	,
	"BORA (IALOMITA)"
	,
	"BORANESTI (IALOMITA)"
	,
	"BORDUSANI (IALOMITA)"
	,
	"BORDUSELU (IALOMITA)"
	,
	"BOTENI (IALOMITA)"
	,
	"BRAZII (IALOMITA)"
	,
	"BROSTENI (IALOMITA)"
	,
	"BUCSA (IALOMITA)"
	,
	"BUCU (IALOMITA)"
	,
	"BUESTI (IALOMITA)"
	,
	"BULIGA (IALOMITA)"
	,
	"BUTOIU (IALOMITA)"
	,
	"CATRUNESTI (IALOMITA)"
	,
	"CAZANESTI (IALOMITA)"
	,
	"CEGANI (IALOMITA)"
	,
	"CHIROIU-PAMANTENI (IALOMITA)"
	,
	"CHIROIU-SATU NOU (IALOMITA)"
	,
	"CHIROIU-UNGURENI (IALOMITA)"
	,
	"CIOCARLIA (IALOMITA)"
	,
	"CIOCHINA (IALOMITA)"
	,
	"CIULNITA (IALOMITA)"
	,
	"COCORA (IALOMITA)"
	,
	"COLELIA (IALOMITA)"
	,
	"CONDEESTI (IALOMITA)"
	,
	"COPUZU (IALOMITA)"
	,
	"COSAMBESTI (IALOMITA)"
	,
	"COSERENI (IALOMITA)"
	,
	"COTORCA (IALOMITA)"
	,
	"CRASANII DE JOS (IALOMITA)"
	,
	"CRASANII DE SUS (IALOMITA)"
	,
	"CRUNTI (IALOMITA)"
	,
	"DRAGOESTI (IALOMITA)"
	,
	"DRIDU (IALOMITA)"
	,
	"DRIDU-SNAGOV (IALOMITA)"
	,
	"DUMITRESTI (IALOMITA)"
	,
	"FACAENI (IALOMITA)"
	,
	"FETESTI (IALOMITA)"
	,
	"FETESTI-GARA (IALOMITA)"
	,
	"FIERBINTI-TARG (IALOMITA)"
	,
	"FIERBINTII DE JOS (IALOMITA)"
	,
	"FIERBINTII DE SUS (IALOMITA)"
	,
	"FRATILESTI (IALOMITA)"
	,
	"FUNDATA (IALOMITA)"
	,
	"GARBOVI (IALOMITA)"
	,
	"GHEORGHE DOJA (IALOMITA)"
	,
	"GHEORGHE LAZAR (IALOMITA)"
	,
	"GIMBASANI (IALOMITA)"
	,
	"GIURGENI (IALOMITA)"
	,
	"GRECII DE JOS (IALOMITA)"
	,
	"GRINDASI (IALOMITA)"
	,
	"GRINDU (IALOMITA)"
	,
	"GRIVITA (IALOMITA)"
	,
	"GURA IALOMITEI (IALOMITA)"
	,
	"GURA VAII (IALOMITA)"
	,
	"HAGIENI (IALOMITA)"
	,
	"HAGIESTI (IALOMITA)"
	,
	"HORIA (IALOMITA)"
	,
	"IAZU (IALOMITA)"
	,
	"ION GHICA (IALOMITA)"
	,
	"ION ROATA (IALOMITA)"
	,
	"IVANESTI (IALOMITA)"
	,
	"JILAVELE (IALOMITA)"
	,
	"LACUSTENI (IALOMITA)"
	,
	"LILIECI (IALOMITA)"
	,
	"LIVEDEA (IALOMITA)"
	,
	"LUCIU (IALOMITA)"
	,
	"MAIA (IALOMITA)"
	,
	"MALTEZI (IALOMITA)"
	,
	"MALU (IALOMITA)"
	,
	"MALU ROSU (IALOMITA)"
	,
	"MANASIA (IALOMITA)"
	,
	"MARCULESTI (IALOMITA)"
	,
	"MARSILIENI (IALOMITA)"
	,
	"MIHAIL KOGALNICEANU (IALOMITA)"
	,
	"MILOSESTI (IALOMITA)"
	,
	"MIRCEA CEL BATRAN (IALOMITA)"
	,
	"MISLEANU (IALOMITA)"
	,
	"MOLDOVENI (IALOMITA)"
	,
	"MOVILA (IALOMITA)"
	,
	"MOVILEANCA (IALOMITA)"
	,
	"MOVILITA (IALOMITA)"
	,
	"MUNTENI-BUZAU (IALOMITA)"
	,
	"MURGEANCA (IALOMITA)"
	,
	"NENISORI (IALOMITA)"
	,
	"NICOLESTI (IALOMITA)"
	,
	"OGRADA (IALOMITA)"
	,
	"ORBOESTI (IALOMITA)"
	,
	"OREZU (IALOMITA)"
	,
	"PALTINISU (IALOMITA)"
	,
	"PATRU FRATI (IALOMITA)"
	,
	"PERIETI (IALOMITA)"
	,
	"PIERSICA (IALOMITA)"
	,
	"PLATONESTI (IALOMITA)"
	,
	"POIANA (IALOMITA)"
	,
	"PROGRESU (IALOMITA)"
	,
	"RASI (IALOMITA)"
	,
	"RASIMNICEA (IALOMITA)"
	,
	"RETEZATU (IALOMITA)"
	,
	"REVIGA (IALOMITA)"
	,
	"ROSIORI (IALOMITA)"
	,
	"ROVINE (IALOMITA)"
	,
	"SALCIOARA (IALOMITA)"
	,
	"SARATENI (IALOMITA)"
	,
	"SAVENI (IALOMITA)"
	,
	"SCANTEIA (IALOMITA)"
	,
	"SFANTU GHEORGHE (IALOMITA)"
	,
	"SINESTI (IALOMITA)"
	,
	"SINTESTI (IALOMITA)"
	,
	"SLATIOARELE (IALOMITA)"
	,
	"SLOBOZIA (IALOMITA)"
	,
	"SLOBOZIA NOUA (IALOMITA)"
	,
	"SMIRNA (IALOMITA)"
	,
	"STEJARU (IALOMITA)"
	,
	"STELNICA (IALOMITA)"
	,
	"SUDITI (IALOMITA)"
	,
	"TANDAREI (IALOMITA)"
	,
	"TOVARASIA (IALOMITA)"
	,
	"TRAIAN (IALOMITA)"
	,
	"URZICENI (IALOMITA)"
	,
	"VALEA BISERICII (IALOMITA)"
	,
	"VALEA CIORII (IALOMITA)"
	,
	"VALEA MACRISULUI (IALOMITA)"
	,
	"VLADENI (IALOMITA)"
	,
	"VLASCA (IALOMITA)"
	,
	"ALBESTI (IASI)"
	,
	"ALEXANDRU CEL BUN (IASI)"
	,
	"ALEXANDRU I. CUZA (IASI)"
	,
	"ALEXENI (IASI)"
	,
	"ALEXESTI (IASI)"
	,
	"ANDRIESENI (IASI)"
	,
	"ARAMA (IASI)"
	,
	"ARONEANU (IASI)"
	,
	"AVANTU (IASI)"
	,
	"BACU (IASI)"
	,
	"BADENI (IASI)"
	,
	"BAHLUIU (IASI)"
	,
	"BAICENI (CUCUTENI) (IASI)"
	,
	"BAICENI (TODIRESTI) (IASI)"
	,
	"BALCIU (IASI)"
	,
	"BALS (IASI)"
	,
	"BALTATI (IASI)"
	,
	"BALTENI (IASI)"
	,
	"BALUSESTI (IASI)"
	,
	"BANU (IASI)"
	,
	"BARBATESTI (IASI)"
	,
	"BARLESTI (IASI)"
	,
	"BARNOVA (IASI)"
	,
	"BELCESTI (IASI)"
	,
	"BEREZLOGI (IASI)"
	,
	"BIVOLARI (IASI)"
	,
	"BLAGA (IASI)"
	,
	"BLAGESTI (IASI)"
	,
	"BOATCA (IASI)"
	,
	"BOCNITA (IASI)"
	,
	"BODESTI (IASI)"
	,
	"BOGDANESTI (IASI)"
	,
	"BOGONOS (IASI)"
	,
	"BOHOTIN (IASI)"
	,
	"BOJILA (IASI)"
	,
	"BOLDESTI (IASI)"
	,
	"BOROSESTI (IASI)"
	,
	"BOROSOAIA (IASI)"
	,
	"BORSA (IASI)"
	,
	"BOSIA (IASI)"
	,
	"BOSTENI (IASI)"
	,
	"BOURENI (MOTCA) (IASI)"
	,
	"BOURENI (TARGU FRUMOS) (IASI)"
	,
	"BRADICESTI (IASI)"
	,
	"BRAESTI (IASI)"
	,
	"BRAN (IASI)"
	,
	"BRATESTI (IASI)"
	,
	"BRATULENI (IASI)"
	,
	"BRATULESTI (IASI)"
	,
	"BREAZU (IASI)"
	,
	"BROSTENI (IASI)"
	,
	"BUDA (BRAESTI) (IASI)"
	,
	"BUDA (LESPEZI) (IASI)"
	,
	"BUDAI (IASI)"
	,
	"BUDESTI (IASI)"
	,
	"BUHAENI (IASI)"
	,
	"BUHALNITA (IASI)"
	,
	"BULBUCANI (IASI)"
	,
	"BURSUC-DEAL (IASI)"
	,
	"BURSUC-VALE (IASI)"
	,
	"BURUIENESTI (IASI)"
	,
	"BUTEA (IASI)"
	,
	"BUZDUG (IASI)"
	,
	"BUZNEA (IASI)"
	,
	"CARBUNARI (IASI)"
	,
	"CARJOAIA (IASI)"
	,
	"CARLIG (IASI)"
	,
	"CARNICENI (IASI)"
	,
	"CAUESTI (IASI)"
	,
	"CEPLENITA (IASI)"
	,
	"CERCU (IASI)"
	,
	"CHICEREA (IASI)"
	,
	"CHILISOAIA (IASI)"
	,
	"CHIPERESTI (IASI)"
	,
	"CHISCARENI (IASI)"
	,
	"CILIBIU (IASI)"
	,
	"CIOCA-BOCA (IASI)"
	,
	"CIOCARLESTI (IASI)"
	,
	"CIOHORANI (IASI)"
	,
	"CIORTESTI (IASI)"
	,
	"CIRESENI (IASI)"
	,
	"CIURBESTI (IASI)"
	,
	"CIUREA (IASI)"
	,
	"COADA STANCII (IASI)"
	,
	"COARNELE CAPREI (IASI)"
	,
	"COASTA MAGURII (IASI)"
	,
	"COGEASCA (IASI)"
	,
	"COLTU CORNII (IASI)"
	,
	"COMARNA (IASI)"
	,
	"CONTESTI (IASI)"
	,
	"CORCODEL (IASI)"
	,
	"CORNESTI (IASI)"
	,
	"COROPCENI (IASI)"
	,
	"COSITENI (IASI)"
	,
	"COSTESTI (IASI)"
	,
	"COSTULENI (IASI)"
	,
	"COTARGACI (IASI)"
	,
	"COTNARI (IASI)"
	,
	"COTU LUI IVAN (IASI)"
	,
	"COTU MORII (IASI)"
	,
	"COVASNA (IASI)"
	,
	"COZIA (IASI)"
	,
	"COZMESTI (IASI)"
	,
	"COZMESTI (STOLNICENI-PRAJESCU) (IASI)"
	,
	"CRISTESTI (IASI)"
	,
	"CRISTESTI (BRAESTI) (IASI)"
	,
	"CRISTESTI (HOLBOCA) (IASI)"
	,
	"CRIVESTI (STRUNGA) (IASI)"
	,
	"CRIVESTI (VANATORI) (IASI)"
	,
	"CRUCEA (IASI)"
	,
	"CUCOVA (IASI)"
	,
	"CUCUTENI (IASI)"
	,
	"CUCUTENI (LETCANI) (IASI)"
	,
	"CURAGAU (IASI)"
	,
	"CURATURI (IASI)"
	,
	"CUZA VODA (IPATELE) (IASI)"
	,
	"CUZA VODA (POPRICANI) (IASI)"
	,
	"DADESTI (IASI)"
	,
	"DAGATA (IASI)"
	,
	"DANCAS (IASI)"
	,
	"DANCU (IASI)"
	,
	"DELENI (IASI)"
	,
	"DELENI (CIORTESTI) (IASI)"
	,
	"DOBROVAT (IASI)"
	,
	"DOLHESTI (IASI)"
	,
	"DOMNITA (IASI)"
	,
	"DOROBANT (IASI)"
	,
	"DOROSCANI (IASI)"
	,
	"DRAGANESTI (IASI)"
	,
	"DRAGUSENI (IASI)"
	,
	"DUMBRAVA (CIUREA) (IASI)"
	,
	"DUMBRAVA (LESPEZI) (IASI)"
	,
	"DUMBRAVITA (IASI)"
	,
	"DUMESTI (IASI)"
	,
	"DUMITRESTII GALATII (IASI)"
	,
	"ERBICENI (IASI)"
	,
	"FAGAT (IASI)"
	,
	"FANTANELE (ANDRIESENI) (IASI)"
	,
	"FANTANELE (FOCURI) (IASI)"
	,
	"FARCASENI (IASI)"
	,
	"FEDELESENI (IASI)"
	,
	"FEREDENI (IASI)"
	,
	"FETESTI (IASI)"
	,
	"FILIASI (IASI)"
	,
	"FOCURI (IASI)"
	,
	"FORASTI (IASI)"
	,
	"FRASULENI (IASI)"
	,
	"FRENCIUGI (IASI)"
	,
	"FRUMUSICA (IASI)"
	,
	"GANESTI (IASI)"
	,
	"GARBESTI (IASI)"
	,
	"GASTESTI (IASI)"
	,
	"GAURENI (IASI)"
	,
	"GIURGESTI (IASI)"
	,
	"GLAVANESTI (IASI)"
	,
	"GLODENII GANDULUI (IASI)"
	,
	"GOESTI (IASI)"
	,
	"GOLAIESTI (IASI)"
	,
	"GORBAN (IASI)"
	,
	"GORUNI (IASI)"
	,
	"GRADINARI (IASI)"
	,
	"GRAJDURI (IASI)"
	,
	"GRIESTI (IASI)"
	,
	"GROPNITA (IASI)"
	,
	"GROZESTI (IASI)"
	,
	"GURA BADILITEI (IASI)"
	,
	"GURA BOHOTIN (IASI)"
	,
	"GURA VAII (IASI)"
	,
	"HABASESTI (IASI)"
	,
	"HADAMBU (IASI)"
	,
	"HALAUCESTI (IASI)"
	,
	"HALCENI (IASI)"
	,
	"HANDRESTI (IASI)"
	,
	"HARLAU (IASI)"
	,
	"HARMANEASA (IASI)"
	,
	"HARMANESTII NOI (IASI)"
	,
	"HARMANESTII VECHI (IASI)"
	,
	"HARPASESTI (IASI)"
	,
	"HARTOAPE (IASI)"
	,
	"HECI (IASI)"
	,
	"HELESTENI (IASI)"
	,
	"HERMEZIU (IASI)"
	,
	"HILITA (IASI)"
	,
	"HLINCEA (IASI)"
	,
	"HODORA (IASI)"
	,
	"HOISESTI (IASI)"
	,
	"HOLBOCA (IASI)"
	,
	"HOLM (IASI)"
	,
	"HOMITA (IASI)"
	,
	"HORLESTI (IASI)"
	,
	"HORLESTI (REDIU) (IASI)"
	,
	"HORODISTEA (IASI)"
	,
	"HORPAZ (IASI)"
	,
	"HUMOSU (IASI)"
	,
	"IACOBENI (IASI)"
	,
	"IASI (IASI)"
	,
	"IAZU NOU (IASI)"
	,
	"IAZU VECHI (IASI)"
	,
	"ICUSENI (IASI)"
	,
	"IEPURENI (ANDRIESENI) (IASI)"
	,
	"IEPURENI (MOVILENI) (IASI)"
	,
	"ION NECULCE (IASI)"
	,
	"IORCANI (IASI)"
	,
	"IOSUPENI (IASI)"
	,
	"IPATELE (IASI)"
	,
	"ISAIIA (IASI)"
	,
	"IUGANI (IASI)"
	,
	"IZVOARELE (IASI)"
	,
	"JIGORENI (IASI)"
	,
	"KOGALNICENI (IASI)"
	,
	"LARGA-JIJIA (IASI)"
	,
	"LEAHU-NACU (IASI)"
	,
	"LESPEZI (IASI)"
	,
	"LETCANI (IASI)"
	,
	"LITENI (IASI)"
	,
	"LUCENI (IASI)"
	,
	"LUNCA (GRAJDURI) (IASI)"
	,
	"LUNCA (PASCANI) (IASI)"
	,
	"LUNCA CETATUII (IASI)"
	,
	"LUNCA RATES (IASI)"
	,
	"LUNCASI (IASI)"
	,
	"LUNGANI (IASI)"
	,
	"LUNGANI (VOINESTI) (IASI)"
	,
	"LUPARIA (IASI)"
	,
	"MACARESTI (IASI)"
	,
	"MADARJAC (IASI)"
	,
	"MADARJESTI (IASI)"
	,
	"MALAESTI (IASI)"
	,
	"MANASTIREA (IASI)"
	,
	"MANJESTI (IASI)"
	,
	"MANZATESTI (IASI)"
	,
	"MAXUT (IASI)"
	,
	"MEDELENI (IASI)"
	,
	"MICLAUSENI (IASI)"
	,
	"MIHAIL KOGALNICEANU (IASI)"
	,
	"MIRCESTI (IASI)"
	,
	"MIRONEASA (IASI)"
	,
	"MIROSLAVA (IASI)"
	,
	"MIROSLOVESTI (IASI)"
	,
	"MITESTI (IASI)"
	,
	"MITOC (IASI)"
	,
	"MOARA CIORNEI (IASI)"
	,
	"MOGOSESTI (IASI)"
	,
	"MOGOSESTI-SIRET (IASI)"
	,
	"MOIMESTI (IASI)"
	,
	"MORENI (IASI)"
	,
	"MOSNA (IASI)"
	,
	"MOTCA (IASI)"
	,
	"MOVILENI (IASI)"
	,
	"MOVILENI (HELESTENI) (IASI)"
	,
	"MUNCELU DE SUS (IASI)"
	,
	"MUNTENI (IASI)"
	,
	"OBOROCENI (IASI)"
	,
	"OBRIJENI (IASI)"
	,
	"ONESTI (IASI)"
	,
	"OPRISENI (IASI)"
	,
	"OPROAIA (IASI)"
	,
	"ORZENI (IASI)"
	,
	"OSOI (COMARNA) (IASI)"
	,
	"OSOI (SINESTI) (IASI)"
	,
	"OTELENI (IASI)"
	,
	"PADURENI (GRAJDURI) (IASI)"
	,
	"PADURENI (POPESTI) (IASI)"
	,
	"PARCOVACI (IASI)"
	,
	"PASCANI (IASI)"
	,
	"PAUN (IASI)"
	,
	"PAUSESTI (IASI)"
	,
	"PERIENI (IASI)"
	,
	"PETRESTI (IASI)"
	,
	"PETROSICA (IASI)"
	,
	"PICIORU LUPULUI (IASI)"
	,
	"PIETRARIA (IASI)"
	,
	"PIETRIS (IASI)"
	,
	"PIETROSU (IASI)"
	,
	"PISCU RUSULUI (IASI)"
	,
	"PLUGARI (IASI)"
	,
	"POCREACA (IASI)"
	,
	"PODISU (IASI)"
	,
	"PODOLENII DE JOS (IASI)"
	,
	"PODOLENII DE SUS (IASI)"
	,
	"PODU HAGIULUI (IASI)"
	,
	"PODU ILOAIEI (IASI)"
	,
	"PODU JIJIEI (IASI)"
	,
	"POIANA (DELENI) (IASI)"
	,
	"POIANA (SCHITU DUCA) (IASI)"
	,
	"POIANA CU CETATE (IASI)"
	,
	"POIANA DE SUS (IASI)"
	,
	"POIANA MANASTIRII (IASI)"
	,
	"POIANA MARULUI (IASI)"
	,
	"POIANA SCHEII (IASI)"
	,
	"POIENI (IASI)"
	,
	"POIENILE (IASI)"
	,
	"POPESTI (IASI)"
	,
	"POPRICANI (IASI)"
	,
	"POTANGENI (IASI)"
	,
	"PRIGORENI (IASI)"
	,
	"PRISACANI (IASI)"
	,
	"PROBOTA (IASI)"
	,
	"PROSELNICI (IASI)"
	,
	"RACHITENI (IASI)"
	,
	"RADENI (IASI)"
	,
	"RADUCANENI (IASI)"
	,
	"RASBOIENI (IASI)"
	,
	"RAZBOIENI (IASI)"
	,
	"RECEA (IASI)"
	,
	"REDIU (IASI)"
	,
	"REDIU (BRAESTI) (IASI)"
	,
	"REDIU (RUGINOASA) (IASI)"
	,
	"REDIU (SCANTEIA) (IASI)"
	,
	"REDIU ALDEI (IASI)"
	,
	"REDIU MITROPOLIEI (IASI)"
	,
	"ROMANESTI (IASI)"
	,
	"ROSCANI (IASI)"
	,
	"ROSU (IASI)"
	,
	"ROTARIA (IASI)"
	,
	"RUGINOASA (IASI)"
	,
	"RUNCU (IASI)"
	,
	"RUSENII NOI (IASI)"
	,
	"RUSENII VECHI (IASI)"
	,
	"SACARESTI (IASI)"
	,
	"SALAGENI (IASI)"
	,
	"SANGERI (IASI)"
	,
	"SARCA (IASI)"
	,
	"SATU NOU (BELCESTI) (IASI)"
	,
	"SATU NOU (SCHEIA) (IASI)"
	,
	"SATU NOU (SCHITU DUCA) (IASI)"
	,
	"SATU NOU (SIRETEL) (IASI)"
	,
	"SAVENI (IASI)"
	,
	"SCANTEIA (IASI)"
	,
	"SCHEIA (IASI)"
	,
	"SCHITU DUCA (IASI)"
	,
	"SCHITU HADAMBULUI (IASI)"
	,
	"SCHITU STAVNIC (IASI)"
	,
	"SCOBALTENI (IASI)"
	,
	"SCOBINTI (IASI)"
	,
	"SCOPOSENI (GORBAN) (IASI)"
	,
	"SCOPOSENI (HORLESTI) (IASI)"
	,
	"SCULENI (IASI)"
	,
	"SENDRENI (IASI)"
	,
	"SERBESTI (IASI)"
	,
	"SINESTI (IASI)"
	,
	"SIPOTE (IASI)"
	,
	"SIRETEL (IASI)"
	,
	"SLOBOZIA (CIUREA) (IASI)"
	,
	"SLOBOZIA (DELENI) (IASI)"
	,
	"SLOBOZIA (SCHITU DUCA) (IASI)"
	,
	"SLOBOZIA (SIRETEL) (IASI)"
	,
	"SLOBOZIA (VOINESTI) (IASI)"
	,
	"SOCI (IASI)"
	,
	"SODOMENI (IASI)"
	,
	"SOLONET (IASI)"
	,
	"SOROGARI (IASI)"
	,
	"SPINENI (IASI)"
	,
	"SPINOASA (IASI)"
	,
	"SPRANCEANA (IASI)"
	,
	"STANCA (COMARNA) (IASI)"
	,
	"STANCA (VICTORIA) (IASI)"
	,
	"STEJARII (IASI)"
	,
	"STICLARIA (IASI)"
	,
	"STOLNICENI-PRAJESCU (IASI)"
	,
	"STORNESTI (IASI)"
	,
	"STROESTI (IASI)"
	,
	"STRUNGA (IASI)"
	,
	"SUHULET (IASI)"
	,
	"TABARA (IASI)"
	,
	"TANSA (IASI)"
	,
	"TANSA (BELCESTI) (IASI)"
	,
	"TARGU FRUMOS (IASI)"
	,
	"TARNITA (IASI)"
	,
	"TATARUSI (IASI)"
	,
	"TAUTESTI (IASI)"
	,
	"TIBANA (IASI)"
	,
	"TIBANESTI (IASI)"
	,
	"TIGANASI (IASI)"
	,
	"TIPILESTI (IASI)"
	,
	"TODIREL (IASI)"
	,
	"TODIRESTI (IASI)"
	,
	"TOMESTI (IASI)"
	,
	"TOPILE (IASI)"
	,
	"TOTOESTI (IASI)"
	,
	"TRAIAN (IASI)"
	,
	"TRIFESTI (IASI)"
	,
	"TUDOR VLADIMIRESCU (IASI)"
	,
	"TUFESTII DE SUS (IASI)"
	,
	"TUNGUJEI (IASI)"
	,
	"TUTORA (IASI)"
	,
	"UDA (IASI)"
	,
	"ULMI (IASI)"
	,
	"UNGHENI (IASI)"
	,
	"URICANI (IASI)"
	,
	"URSARESTI (IASI)"
	,
	"URSITA (IASI)"
	,
	"URSOAIA (IASI)"
	,
	"VADU VEJEI (IASI)"
	,
	"VALCELELE (IASI)"
	,
	"VALCICA (IASI)"
	,
	"VALEA ADANCA (IASI)"
	,
	"VALEA LUNGA (IASI)"
	,
	"VALEA LUPULUI (IASI)"
	,
	"VALEA OILOR (IASI)"
	,
	"VALEA RACULUI (IASI)"
	,
	"VALEA SATULUI (IASI)"
	,
	"VALEA SEACA (IASI)"
	,
	"VALEA URSULUI (IASI)"
	,
	"VALENII (IASI)"
	,
	"VAMA (IASI)"
	,
	"VANATORI (IASI)"
	,
	"VANATORI (POPRICANI) (IASI)"
	,
	"VASCANI (IASI)"
	,
	"VERSENI (IASI)"
	,
	"VICTORIA (IASI)"
	,
	"VISAN (IASI)"
	,
	"VLADENI (IASI)"
	,
	"VLADICENI (IASI)"
	,
	"VLADNICUT (IASI)"
	,
	"VLADOMIRA (IASI)"
	,
	"VOCOTESTI (IASI)"
	,
	"VOINESTI (IASI)"
	,
	"VOLINTIRESTI (IASI)"
	,
	"VOROVESTI (IASI)"
	,
	"VULTURI (IASI)"
	,
	"ZABOLOTENI (IASI)"
	,
	"ZAGAVIA (IASI)"
	,
	"ZBERENI (IASI)"
	,
	"ZBEROAIA (IASI)"
	,
	"ZECE PRAJINI (IASI)"
	,
	"ZLODICA (IASI)"
	,
	"ZMEU (IASI)"
	,
	"1 DECEMBRIE (ILFOV)"
	,
	"AFUMATI (ILFOV)"
	,
	"ALUNISU (ILFOV)"
	,
	"BALACEANCA (ILFOV)"
	,
	"BALOTESTI (ILFOV)"
	,
	"BALTA NEAGRA (ILFOV)"
	,
	"BALTENI (ILFOV)"
	,
	"BERCENI (ILFOV)"
	,
	"BRAGADIRU (ILFOV)"
	,
	"BRANESTI (ILFOV)"
	,
	"BUCIUMENI (ILFOV)"
	,
	"BUDA (ILFOV)"
	,
	"BUFTEA (ILFOV)"
	,
	"BURIAS (ILFOV)"
	,
	"CACIULATI (ILFOV)"
	,
	"CALDARARU (ILFOV)"
	,
	"CATELU (ILFOV)"
	,
	"CERNICA (ILFOV)"
	,
	"CHIAJNA (ILFOV)"
	,
	"CHITILA (ILFOV)"
	,
	"CIOFLICENI (ILFOV)"
	,
	"CIOLPANI (ILFOV)"
	,
	"CIOROGARLA (ILFOV)"
	,
	"CLINCENI (ILFOV)"
	,
	"COPACENI (ILFOV)"
	,
	"CORBEANCA (ILFOV)"
	,
	"CORNETU (ILFOV)"
	,
	"COZIENI (ILFOV)"
	,
	"CREATA (ILFOV)"
	,
	"CRETESTI (ILFOV)"
	,
	"CRETULEASCA (ILFOV)"
	,
	"DARASTI-ILFOV (ILFOV)"
	,
	"DARVARI (ILFOV)"
	,
	"DASCALU (ILFOV)"
	,
	"DIMIENI (ILFOV)"
	,
	"DOBROESTI (ILFOV)"
	,
	"DOMNESTI (ILFOV)"
	,
	"DRAGOMIRESTI-DEAL (ILFOV)"
	,
	"DRAGOMIRESTI-VALE (ILFOV)"
	,
	"DUDU (ILFOV)"
	,
	"DUMBRAVENI (ILFOV)"
	,
	"DUMITRANA (ILFOV)"
	,
	"FUNDENI (ILFOV)"
	,
	"GAGU (ILFOV)"
	,
	"GANEASA (ILFOV)"
	,
	"GHERMANESTI (ILFOV)"
	,
	"GLINA (ILFOV)"
	,
	"GRADISTEA (ILFOV)"
	,
	"GRUIU (ILFOV)"
	,
	"ISLAZ (ILFOV)"
	,
	"IZVORANI (ILFOV)"
	,
	"JILAVA (ILFOV)"
	,
	"LIPIA (ILFOV)"
	,
	"LUPARIA (ILFOV)"
	,
	"MAGURELE (ILFOV)"
	,
	"MAINEASCA (ILFOV)"
	,
	"MANOLACHE (ILFOV)"
	,
	"MERII PETCHII (ILFOV)"
	,
	"MICSUNESTI-MOARA (ILFOV)"
	,
	"MICSUNESTII MARI (ILFOV)"
	,
	"MOARA DOMNEASCA (ILFOV)"
	,
	"MOARA VLASIEI (ILFOV)"
	,
	"MOGOSOAIA (ILFOV)"
	,
	"NUCI (ILFOV)"
	,
	"ODAILE (ILFOV)"
	,
	"OLTENI (ILFOV)"
	,
	"ORDOREANU (ILFOV)"
	,
	"OSTRATU (ILFOV)"
	,
	"OTOPENI (ILFOV)"
	,
	"PANTELIMON (ILFOV)"
	,
	"PASAREA (ILFOV)"
	,
	"PERIS (ILFOV)"
	,
	"PETRACHIOAIA (ILFOV)"
	,
	"PETRESTI (ILFOV)"
	,
	"PISCU (ILFOV)"
	,
	"PITEASCA (ILFOV)"
	,
	"POPESTI-LEORDENI (ILFOV)"
	,
	"POSTA (ILFOV)"
	,
	"PRUNI (ILFOV)"
	,
	"ROSU (ILFOV)"
	,
	"RUDENI (ILFOV)"
	,
	"RUNCU (ILFOV)"
	,
	"SAFTICA (ILFOV)"
	,
	"SANTU-FLORESTI (ILFOV)"
	,
	"SILISTEA SNAGOVULUI (ILFOV)"
	,
	"SINDRILITA (ILFOV)"
	,
	"SINTESTI (ILFOV)"
	,
	"SITARU (ILFOV)"
	,
	"SNAGOV (ILFOV)"
	,
	"STEFANESTII DE JOS (ILFOV)"
	,
	"STEFANESTII DE SUS (ILFOV)"
	,
	"SURLARI (ILFOV)"
	,
	"TAMASI (ILFOV)"
	,
	"TANCABESTI (ILFOV)"
	,
	"TANGANU (ILFOV)"
	,
	"TEGHES (ILFOV)"
	,
	"TUNARI (ILFOV)"
	,
	"VADU ANEI (ILFOV)"
	,
	"VANATORI (ILFOV)"
	,
	"VARTEJU (ILFOV)"
	,
	"VIDRA (ILFOV)"
	,
	"VLADICEASCA (ILFOV)"
	,
	"VOLUNTARI (ILFOV)"
	,
	"ZURBAUA (ILFOV)"
	,
	"ARDUSAT (MARAMURES)"
	,
	"ARDUZEL (MARAMURES)"
	,
	"ARIESU DE CAMP (MARAMURES)"
	,
	"ARIESU DE PADURE (MARAMURES)"
	,
	"ARINIS (MARAMURES)"
	,
	"ASPRA (MARAMURES)"
	,
	"ASUAJU DE JOS (MARAMURES)"
	,
	"ASUAJU DE SUS (MARAMURES)"
	,
	"BABA (MARAMURES)"
	,
	"BAIA MARE (MARAMURES)"
	,
	"BAIA SPRIE (MARAMURES)"
	,
	"BAILE BORSA (MARAMURES)"
	,
	"BAITA (MARAMURES)"
	,
	"BAITA DE SUB CODRU (MARAMURES)"
	,
	"BAIUT (MARAMURES)"
	,
	"BARGAU (MARAMURES)"
	,
	"BARSANA (MARAMURES)"
	,
	"BASESTI (MARAMURES)"
	,
	"BERBESTI (MARAMURES)"
	,
	"BERCHEZ (MARAMURES)"
	,
	"BERCHEZOAIA (MARAMURES)"
	,
	"BERINTA (MARAMURES)"
	,
	"BICAZ (MARAMURES)"
	,
	"BISTRA (MARAMURES)"
	,
	"BLIDARI (MARAMURES)"
	,
	"BOCICOEL (MARAMURES)"
	,
	"BOCICOIU MARE (MARAMURES)"
	,
	"BOGDAN VODA (MARAMURES)"
	,
	"BOIERENI (MARAMURES)"
	,
	"BOIU MARE (MARAMURES)"
	,
	"BONTAIENI (MARAMURES)"
	,
	"BORCUT (MARAMURES)"
	,
	"BORSA (MARAMURES)"
	,
	"BOTIZA (MARAMURES)"
	,
	"BOZANTA MARE (MARAMURES)"
	,
	"BOZANTA MICA (MARAMURES)"
	,
	"BREB (MARAMURES)"
	,
	"BREBENI (MARAMURES)"
	,
	"BUCIUMI (MARAMURES)"
	,
	"BUDESTI (MARAMURES)"
	,
	"BUSAG (MARAMURES)"
	,
	"BUTEASA (MARAMURES)"
	,
	"BUZESTI (MARAMURES)"
	,
	"CALINESTI (MARAMURES)"
	,
	"CAMPULUNG LA TISA (MARAMURES)"
	,
	"CARBUNARI (MARAMURES)"
	,
	"CARPINIS (MARAMURES)"
	,
	"CATALINA (MARAMURES)"
	,
	"CAVNIC (MARAMURES)"
	,
	"CERNESTI (MARAMURES)"
	,
	"CETATELE (MARAMURES)"
	,
	"CHECHIS (MARAMURES)"
	,
	"CHELINTA (MARAMURES)"
	,
	"CHIUZBAIA (MARAMURES)"
	,
	"CICARLAU (MARAMURES)"
	,
	"CIOCOTIS (MARAMURES)"
	,
	"CIOLT (MARAMURES)"
	,
	"CIUTA (MARAMURES)"
	,
	"COAS (MARAMURES)"
	,
	"CODRU BUTESII (MARAMURES)"
	,
	"COLTAU (MARAMURES)"
	,
	"COLTIREA (MARAMURES)"
	,
	"COPALNIC (MARAMURES)"
	,
	"COPALNIC-DEAL (MARAMURES)"
	,
	"COPALNIC-MANASTUR (MARAMURES)"
	,
	"CORNESTI (MARAMURES)"
	,
	"CORNI (MARAMURES)"
	,
	"COROIENI (MARAMURES)"
	,
	"CORUIA (MARAMURES)"
	,
	"COSTENI (MARAMURES)"
	,
	"COSTIUI (MARAMURES)"
	,
	"CRACIUNESTI (MARAMURES)"
	,
	"CRASNA VISEULUI (MARAMURES)"
	,
	"CUFOAIA (MARAMURES)"
	,
	"CULCEA (MARAMURES)"
	,
	"CUPSENI (MARAMURES)"
	,
	"CURTUIUSU MARE (MARAMURES)"
	,
	"CURTUIUSU MIC (MARAMURES)"
	,
	"DAMACUSENI (MARAMURES)"
	,
	"DANESTI (MARAMURES)"
	,
	"DANESTII CHIOARULUI (MARAMURES)"
	,
	"DEALU CORBULUI (MARAMURES)"
	,
	"DEALU MARE (MARAMURES)"
	,
	"DESESTI (MARAMURES)"
	,
	"DOBRICU LAPUSULUI (MARAMURES)"
	,
	"DRAGHIA (MARAMURES)"
	,
	"DRAGOMIRESTI (MARAMURES)"
	,
	"DUMBRAVA (MARAMURES)"
	,
	"DUMBRAVITA (MARAMURES)"
	,
	"DURUSA (MARAMURES)"
	,
	"FANATE (MARAMURES)"
	,
	"FANTANELE (MARAMURES)"
	,
	"FARCASA (MARAMURES)"
	,
	"FAURESTI (MARAMURES)"
	,
	"FERESTI (MARAMURES)"
	,
	"FERICEA (MARAMURES)"
	,
	"FERSIG (MARAMURES)"
	,
	"FINTEUSU MARE (MARAMURES)"
	,
	"FINTEUSU MIC (MARAMURES)"
	,
	"FIRIZA (MARAMURES)"
	,
	"FRANCENII BOIULUI (MARAMURES)"
	,
	"GARDANI (MARAMURES)"
	,
	"GIULESTI (MARAMURES)"
	,
	"GLOD (MARAMURES)"
	,
	"GROAPE (MARAMURES)"
	,
	"GROSI (MARAMURES)"
	,
	"GROSII TIBLESULUI (MARAMURES)"
	,
	"HANDALU ILBEI (MARAMURES)"
	,
	"HARNICESTI (MARAMURES)"
	,
	"HIDEAGA (MARAMURES)"
	,
	"HOTENI (MARAMURES)"
	,
	"HOVRILA (MARAMURES)"
	,
	"IADARA (MARAMURES)"
	,
	"IAPA (MARAMURES)"
	,
	"IEUD (MARAMURES)"
	,
	"ILBA (MARAMURES)"
	,
	"INAU (MARAMURES)"
	,
	"INTRERAURI (MARAMURES)"
	,
	"IZVOARELE (MARAMURES)"
	,
	"JUGASTRENI (MARAMURES)"
	,
	"LAPUS (MARAMURES)"
	,
	"LAPUSEL (MARAMURES)"
	,
	"LARGA (MARAMURES)"
	,
	"LASCHIA (MARAMURES)"
	,
	"LAZU BACIULUI (MARAMURES)"
	,
	"LEORDINA (MARAMURES)"
	,
	"LIBOTIN (MARAMURES)"
	,
	"LUCACESTI (MARAMURES)"
	,
	"LUNCA LA TISA (MARAMURES)"
	,
	"MAGURENI (MARAMURES)"
	,
	"MANASTIREA (MARAMURES)"
	,
	"MANAU (MARAMURES)"
	,
	"MARA (MARAMURES)"
	,
	"MERISOR (MARAMURES)"
	,
	"MESTEACAN (MARAMURES)"
	,
	"MIRESU MARE (MARAMURES)"
	,
	"MOCIRA (MARAMURES)"
	,
	"MOGOSESTI (MARAMURES)"
	,
	"MOISEI (MARAMURES)"
	,
	"NANESTI (MARAMURES)"
	,
	"NEGREIA (MARAMURES)"
	,
	"NISTRU (MARAMURES)"
	,
	"OARTA DE JOS (MARAMURES)"
	,
	"OARTA DE SUS (MARAMURES)"
	,
	"OCNA SUGATAG (MARAMURES)"
	,
	"OCOLIS (MARAMURES)"
	,
	"ODESTI (MARAMURES)"
	,
	"ONCESTI (MARAMURES)"
	,
	"ORTITA (MARAMURES)"
	,
	"PETERITEA (MARAMURES)"
	,
	"PETROVA (MARAMURES)"
	,
	"PIATRA (MARAMURES)"
	,
	"PLOPIS (MARAMURES)"
	,
	"POIANA BOTIZII (MARAMURES)"
	,
	"POIENILE DE SUB MUNTE (MARAMURES)"
	,
	"POIENILE IZEI (MARAMURES)"
	,
	"POSTA (MARAMURES)"
	,
	"PRELUCA NOUA (MARAMURES)"
	,
	"PRELUCA VECHE (MARAMURES)"
	,
	"PRIBILESTI (MARAMURES)"
	,
	"PRISLOP (MARAMURES)"
	,
	"RAZOARE (MARAMURES)"
	,
	"RECEA (MARAMURES)"
	,
	"REMECIOARA (MARAMURES)"
	,
	"REMETEA CHIOARULUI (MARAMURES)"
	,
	"REMETI (MARAMURES)"
	,
	"REMETI PE SOMES (MARAMURES)"
	,
	"REPEDEA (MARAMURES)"
	,
	"RODINA (MARAMURES)"
	,
	"ROGOZ (MARAMURES)"
	,
	"ROHIA (MARAMURES)"
	,
	"ROMANESTI (MARAMURES)"
	,
	"RONA DE JOS (MARAMURES)"
	,
	"RONA DE SUS (MARAMURES)"
	,
	"ROZAVLEA (MARAMURES)"
	,
	"RUS (MARAMURES)"
	,
	"RUSCOVA (MARAMURES)"
	,
	"RUSOR (MARAMURES)"
	,
	"SABISA (MARAMURES)"
	,
	"SACALASENI (MARAMURES)"
	,
	"SACEL (MARAMURES)"
	,
	"SALISTE (MARAMURES)"
	,
	"SALISTEA DE SUS (MARAMURES)"
	,
	"SALNITA (MARAMURES)"
	,
	"SALSIG (MARAMURES)"
	,
	"SAPANTA (MARAMURES)"
	,
	"SARASAU (MARAMURES)"
	,
	"SARBI (BUDESTI) (MARAMURES)"
	,
	"SARBI (FARCASA) (MARAMURES)"
	,
	"SASAR (MARAMURES)"
	,
	"SAT-SUGATAG (MARAMURES)"
	,
	"SATU NOU DE JOS (MARAMURES)"
	,
	"SATU NOU DE SUS (MARAMURES)"
	,
	"SATULUNG (MARAMURES)"
	,
	"SEINI (MARAMURES)"
	,
	"SIEU (MARAMURES)"
	,
	"SIGHETU MARMATIEI (MARAMURES)"
	,
	"SINDRESTI (MARAMURES)"
	,
	"SISESTI (MARAMURES)"
	,
	"SLATIOARA (MARAMURES)"
	,
	"SOMCUTA MARE (MARAMURES)"
	,
	"SOMES-UILEAC (MARAMURES)"
	,
	"STEJERA (MARAMURES)"
	,
	"STOICENI (MARAMURES)"
	,
	"STRAMBU-BAIUT (MARAMURES)"
	,
	"STRAMTURA (MARAMURES)"
	,
	"STREMT (MARAMURES)"
	,
	"SUCIU DE JOS (MARAMURES)"
	,
	"SUCIU DE SUS (MARAMURES)"
	,
	"SUGAU (MARAMURES)"
	,
	"SURDESTI (MARAMURES)"
	,
	"TAMAIA (MARAMURES)"
	,
	"TAMASESTI (MARAMURES)"
	,
	"TARGU LAPUS (MARAMURES)"
	,
	"TAUTII DE SUS (MARAMURES)"
	,
	"TAUTII-MAGHERAUS (MARAMURES)"
	,
	"TECEU MIC (MARAMURES)"
	,
	"TICAU (MARAMURES)"
	,
	"TISA (MARAMURES)"
	,
	"TOHAT (MARAMURES)"
	,
	"TRESTIA (MARAMURES)"
	,
	"TULGHIES (MARAMURES)"
	,
	"ULMENI (MARAMURES)"
	,
	"ULMOASA (MARAMURES)"
	,
	"UNGURAS (MARAMURES)"
	,
	"UNGURENI (MARAMURES)"
	,
	"URMENIS (MARAMURES)"
	,
	"VAD (MARAMURES)"
	,
	"VADU IZEI (MARAMURES)"
	,
	"VALEA CHIOARULUI (MARAMURES)"
	,
	"VALEA CUFUNDOASA (MARAMURES)"
	,
	"VALEA HOTARULUI (MARAMURES)"
	,
	"VALEA NEAGRA (MARAMURES)"
	,
	"VALEA STEJARULUI (MARAMURES)"
	,
	"VALEA VISEULUI (MARAMURES)"
	,
	"VALENI (MARAMURES)"
	,
	"VALENII LAPUSULUI (MARAMURES)"
	,
	"VALENII SOMCUTEI (MARAMURES)"
	,
	"VARAI (MARAMURES)"
	,
	"VICEA (MARAMURES)"
	,
	"VIILE APEI (MARAMURES)"
	,
	"VIMA MARE (MARAMURES)"
	,
	"VIMA MICA (MARAMURES)"
	,
	"VISEU DE JOS (MARAMURES)"
	,
	"VISEU DE MIJLOC (MARAMURES)"
	,
	"VISEU DE SUS (MARAMURES)"
	,
	"23 AUGUST (MEHEDINTI)"
	,
	"ADUNATII TEIULUI (MEHEDINTI)"
	,
	"ALBULESTI (MEHEDINTI)"
	,
	"ALMAJEL (MEHEDINTI)"
	,
	"ALUNISUL (MEHEDINTI)"
	,
	"ARGINESTI (MEHEDINTI)"
	,
	"ARVATESTI (MEHEDINTI)"
	,
	"AURORA (MEHEDINTI)"
	,
	"BACLES (MEHEDINTI)"
	,
	"BADITESTI (MEHEDINTI)"
	,
	"BAHNA (MEHEDINTI)"
	,
	"BAIA DE ARAMA (MEHEDINTI)"
	,
	"BAIA NOUA (MEHEDINTI)"
	,
	"BALA (MEHEDINTI)"
	,
	"BALA DE SUS (MEHEDINTI)"
	,
	"BALACITA (MEHEDINTI)"
	,
	"BALOTA (MEHEDINTI)"
	,
	"BALOTESTI (MEHEDINTI)"
	,
	"BALTA (MEHEDINTI)"
	,
	"BALTA VERDE (MEHEDINTI)"
	,
	"BALTANELE (GRECI) (MEHEDINTI)"
	,
	"BALTANELE (PRUNISOR) (MEHEDINTI)"
	,
	"BALUTA (MEHEDINTI)"
	,
	"BALVANESTI (MEHEDINTI)"
	,
	"BALVANESTII DE JOS (MEHEDINTI)"
	,
	"BARAIACU (MEHEDINTI)"
	,
	"BARDA (MEHEDINTI)"
	,
	"BATOTI (MEHEDINTI)"
	,
	"BISTRETU (MEHEDINTI)"
	,
	"BISTRITA (MEHEDINTI)"
	,
	"BLIDARU (MEHEDINTI)"
	,
	"BOBAITA (MEHEDINTI)"
	,
	"BOCENI (MEHEDINTI)"
	,
	"BOROGEA (MEHEDINTI)"
	,
	"BRAGLEASA (MEHEDINTI)"
	,
	"BRANISTEA (MEHEDINTI)"
	,
	"BRANZENI (MEHEDINTI)"
	,
	"BRATESUL (MEHEDINTI)"
	,
	"BRATILOVU (MEHEDINTI)"
	,
	"BRATIVOESTI (MEHEDINTI)"
	,
	"BREBINA (MEHEDINTI)"
	,
	"BRETA (MEHEDINTI)"
	,
	"BREZNICIOARA (MEHEDINTI)"
	,
	"BREZNITA-MOTRU (MEHEDINTI)"
	,
	"BREZNITA-OCOL (MEHEDINTI)"
	,
	"BROSTENI (MEHEDINTI)"
	,
	"BUCURA (MEHEDINTI)"
	,
	"BUDANESTI (MEHEDINTI)"
	,
	"BUICANI (MEHEDINTI)"
	,
	"BUICESTI (MEHEDINTI)"
	,
	"BUNOAICA (MEHEDINTI)"
	,
	"BURILA MARE (MEHEDINTI)"
	,
	"BURILA MICA (MEHEDINTI)"
	,
	"BUSESTI (MEHEDINTI)"
	,
	"BUTOIESTI (MEHEDINTI)"
	,
	"CALINESTII DE JOS (MEHEDINTI)"
	,
	"CALINESTII DE SUS (MEHEDINTI)"
	,
	"CAMPU MARE (MEHEDINTI)"
	,
	"CAPATANESTI (MEHEDINTI)"
	,
	"CARAMIDARU (MEHEDINTI)"
	,
	"CARCENI (MEHEDINTI)"
	,
	"CARJEI (MEHEDINTI)"
	,
	"CARSU (MEHEDINTI)"
	,
	"CAZANESTI (MEHEDINTI)"
	,
	"CEARANGU (MEHEDINTI)"
	,
	"CELNATA (MEHEDINTI)"
	,
	"CEPTURENI (MEHEDINTI)"
	,
	"CERANGANUL (MEHEDINTI)"
	,
	"CERNA-VARF (MEHEDINTI)"
	,
	"CERNAIA (MEHEDINTI)"
	,
	"CERNETI (MEHEDINTI)"
	,
	"CERVENITA (MEHEDINTI)"
	,
	"CIOCHIUTA (MEHEDINTI)"
	,
	"CIOROBORENI (MEHEDINTI)"
	,
	"CIOVARNASANI (MEHEDINTI)"
	,
	"CIRESU (MEHEDINTI)"
	,
	"COADA CORNETULUI (MEHEDINTI)"
	,
	"COCOROVA (MEHEDINTI)"
	,
	"COLARET (MEHEDINTI)"
	,
	"COLIBASI (MEHEDINTI)"
	,
	"COMANDA (MEHEDINTI)"
	,
	"COMANESTI (MEHEDINTI)"
	,
	"COPACIOASA (MEHEDINTI)"
	,
	"CORCOVA (MEHEDINTI)"
	,
	"CORDUN (MEHEDINTI)"
	,
	"CORLATEL (MEHEDINTI)"
	,
	"CORZU (MEHEDINTI)"
	,
	"COSOVAT (MEHEDINTI)"
	,
	"COSTESTI (MEHEDINTI)"
	,
	"COTOROAIA (MEHEDINTI)"
	,
	"COZIA (MEHEDINTI)"
	,
	"CRACU LUNG (MEHEDINTI)"
	,
	"CRACU MUNTELUI (MEHEDINTI)"
	,
	"CRAGUESTI (MEHEDINTI)"
	,
	"CRAINICI (MEHEDINTI)"
	,
	"CREMENEA (MEHEDINTI)"
	,
	"CRIVINA (MEHEDINTI)"
	,
	"CROICA (MEHEDINTI)"
	,
	"CUJMIR (MEHEDINTI)"
	,
	"CUJMIRU MIC (MEHEDINTI)"
	,
	"DALBOCITA (MEHEDINTI)"
	,
	"DALMA (MEHEDINTI)"
	,
	"DANCEU (MEHEDINTI)"
	,
	"DARVARI (MEHEDINTI)"
	,
	"DEALU MARE (MEHEDINTI)"
	,
	"DEDOVITA NOUA (MEHEDINTI)"
	,
	"DEDOVITA VECHE (MEHEDINTI)"
	,
	"DELENI (MEHEDINTI)"
	,
	"DELURENI (MEHEDINTI)"
	,
	"DEVESEL (MEHEDINTI)"
	,
	"DOBRA (MEHEDINTI)"
	,
	"DRAGHESTI (MEHEDINTI)"
	,
	"DRAGOTESTI (MEHEDINTI)"
	,
	"DRINCEA (MEHEDINTI)"
	,
	"DROBETA-TURNU SEVERIN (MEHEDINTI)"
	,
	"DUBOVA (MEHEDINTI)"
	,
	"DUDASU (MEHEDINTI)"
	,
	"DUDASU SCHELEI (MEHEDINTI)"
	,
	"DUMBRAVA (MEHEDINTI)"
	,
	"DUMBRAVA DE JOS (MEHEDINTI)"
	,
	"DUMBRAVA DE MIJLOC (MEHEDINTI)"
	,
	"DUMBRAVA DE SUS (MEHEDINTI)"
	,
	"DUMBRAVITA (MEHEDINTI)"
	,
	"DUNAREA MICA (MEHEDINTI)"
	,
	"EIBENTHAL (MEHEDINTI)"
	,
	"ERCEA (MEHEDINTI)"
	,
	"ERGHEVITA (MEHEDINTI)"
	,
	"ESELNITA (MEHEDINTI)"
	,
	"FANTANA DOMNEASCA (MEHEDINTI)"
	,
	"FANTANILE NEGRE (MEHEDINTI)"
	,
	"FATA CREMENII (MEHEDINTI)"
	,
	"FATA MOTRULUI (MEHEDINTI)"
	,
	"FAUROAIA (MEHEDINTI)"
	,
	"FIRIZU (MEHEDINTI)"
	,
	"FLORESTI (MEHEDINTI)"
	,
	"GARBOVATU DE JOS (MEHEDINTI)"
	,
	"GARBOVATU DE SUS (MEHEDINTI)"
	,
	"GARDANEASA (MEHEDINTI)"
	,
	"GARDOAIA (MEHEDINTI)"
	,
	"GARLA MARE (MEHEDINTI)"
	,
	"GARNITA (MEHEDINTI)"
	,
	"GEMENI (MEHEDINTI)"
	,
	"GHELMEGIOAIA (MEHEDINTI)"
	,
	"GHEORGHESTI (MEHEDINTI)"
	,
	"GIURA (MEHEDINTI)"
	,
	"GIURGIANI (MEHEDINTI)"
	,
	"GOANTA (MEHEDINTI)"
	,
	"GODEANU (MEHEDINTI)"
	,
	"GODEANU (OBARSIA-CLOSANI) (MEHEDINTI)"
	,
	"GOGOSU (MEHEDINTI)"
	,
	"GOLINEASA (MEHEDINTI)"
	,
	"GORNENTI (MEHEDINTI)"
	,
	"GORNOVITA (MEHEDINTI)"
	,
	"GOVODARVA (MEHEDINTI)"
	,
	"GRECI (MEHEDINTI)"
	,
	"GROZESTI (MEHEDINTI)"
	,
	"GRUIA (MEHEDINTI)"
	,
	"GURA MOTRULUI (MEHEDINTI)"
	,
	"GURA VAII (MEHEDINTI)"
	,
	"GUTU (MEHEDINTI)"
	,
	"GVARDINITA (MEHEDINTI)"
	,
	"HALANGA (MEHEDINTI)"
	,
	"HIGIU (MEHEDINTI)"
	,
	"HINOVA (MEHEDINTI)"
	,
	"HOTARANI (MEHEDINTI)"
	,
	"HURDUCESTI (MEHEDINTI)"
	,
	"HUSNICIOARA (MEHEDINTI)"
	,
	"IABLANITA (MEHEDINTI)"
	,
	"IGIROASA (MEHEDINTI)"
	,
	"ILOVAT (MEHEDINTI)"
	,
	"ILOVITA (MEHEDINTI)"
	,
	"ILOVU (MEHEDINTI)"
	,
	"IMOASA (MEHEDINTI)"
	,
	"ISVERNA (MEHEDINTI)"
	,
	"IUPCA (MEHEDINTI)"
	,
	"IZIMSA (MEHEDINTI)"
	,
	"IZVOARELE (MEHEDINTI)"
	,
	"IZVORALU (MEHEDINTI)"
	,
	"IZVORALU DE JOS (MEHEDINTI)"
	,
	"IZVORU ANESTILOR (MEHEDINTI)"
	,
	"IZVORU BARZII (MEHEDINTI)"
	,
	"IZVORU FRUMOS (MEHEDINTI)"
	,
	"JIANA (MEHEDINTI)"
	,
	"JIANA MARE (MEHEDINTI)"
	,
	"JIANA VECHE (MEHEDINTI)"
	,
	"JIDOSTITA (MEHEDINTI)"
	,
	"JIGNITA (MEHEDINTI)"
	,
	"JIROV (MEHEDINTI)"
	,
	"JUGASTRU (MEHEDINTI)"
	,
	"JUPANESTI (MEHEDINTI)"
	,
	"LAC (MEHEDINTI)"
	,
	"LAZU (MEHEDINTI)"
	,
	"LIVEZI (MEHEDINTI)"
	,
	"LIVEZILE (MEHEDINTI)"
	,
	"LUDU (MEHEDINTI)"
	,
	"LUMNIC (MEHEDINTI)"
	,
	"LUNCA BANULUI (MEHEDINTI)"
	,
	"LUNCSOARA (MEHEDINTI)"
	,
	"LUPSA DE JOS (MEHEDINTI)"
	,
	"LUPSA DE SUS (MEHEDINTI)"
	,
	"MAGHERU (MEHEDINTI)"
	,
	"MAGURELE (MEHEDINTI)"
	,
	"MALARISCA (MEHEDINTI)"
	,
	"MALOVAT (MEHEDINTI)"
	,
	"MANU (MEHEDINTI)"
	,
	"MARASESTI (MEHEDINTI)"
	,
	"MARGA (MEHEDINTI)"
	,
	"MARMANU (MEHEDINTI)"
	,
	"MARU ROSU (MEHEDINTI)"
	,
	"MENTI (MEHEDINTI)"
	,
	"MERIS (MEHEDINTI)"
	,
	"MIJARCA (MEHEDINTI)"
	,
	"MOISESTI (MEHEDINTI)"
	,
	"MOLANI (MEHEDINTI)"
	,
	"MOSNENI (MEHEDINTI)"
	,
	"MOTRULENI (MEHEDINTI)"
	,
	"NADANOVA (MEHEDINTI)"
	,
	"NEGOESTI (MEHEDINTI)"
	,
	"NEGRESTI (MEHEDINTI)"
	,
	"NEGRUSA (MEHEDINTI)"
	,
	"NEVATU (MEHEDINTI)"
	,
	"NICOLAE BALCESCU (MEHEDINTI)"
	,
	"NOAPTESA (MEHEDINTI)"
	,
	"OBARSIA-CLOSANI (MEHEDINTI)"
	,
	"OBARSIA DE CAMP (MEHEDINTI)"
	,
	"OHABA (MEHEDINTI)"
	,
	"OLTEANCA (MEHEDINTI)"
	,
	"OPRANESTI (MEHEDINTI)"
	,
	"OPRISOR (MEHEDINTI)"
	,
	"OREVITA MARE (MEHEDINTI)"
	,
	"ORSOVA (MEHEDINTI)"
	,
	"OSTROVU CORBULUI (MEHEDINTI)"
	,
	"OSTROVU MARE (MEHEDINTI)"
	,
	"PADINA (MEHEDINTI)"
	,
	"PADINA MARE (MEHEDINTI)"
	,
	"PADINA MICA (MEHEDINTI)"
	,
	"PALTINISU (MEHEDINTI)"
	,
	"PARLAGELE (MEHEDINTI)"
	,
	"PARVULESTI (MEHEDINTI)"
	,
	"PASARANI (MEHEDINTI)"
	,
	"PATULELE (MEHEDINTI)"
	,
	"PAUNESTI (MEHEDINTI)"
	,
	"PAVAT (MEHEDINTI)"
	,
	"PERI (MEHEDINTI)"
	,
	"PESTEANA (MEHEDINTI)"
	,
	"PESTENUTA (MEHEDINTI)"
	,
	"PETRA (MEHEDINTI)"
	,
	"PETRIS (MEHEDINTI)"
	,
	"PISTRITA (MEHEDINTI)"
	,
	"PLAI (MEHEDINTI)"
	,
	"PLOPI (MEHEDINTI)"
	,
	"PLUTA (MEHEDINTI)"
	,
	"PODENI (MEHEDINTI)"
	,
	"PODU GROSULUI (MEHEDINTI)"
	,
	"POIANA (MEHEDINTI)"
	,
	"POIANA GRUII (MEHEDINTI)"
	,
	"PONOARELE (MEHEDINTI)"
	,
	"POROINA (MEHEDINTI)"
	,
	"POROINA MARE (MEHEDINTI)"
	,
	"POROINITA (MEHEDINTI)"
	,
	"PORTILE DE FIER II (MEHEDINTI)"
	,
	"POSTA VECHE (MEHEDINTI)"
	,
	"PREJNA (MEHEDINTI)"
	,
	"PRIBOIESTI (MEHEDINTI)"
	,
	"PRISACEAUA (MEHEDINTI)"
	,
	"PRISTOL (MEHEDINTI)"
	,
	"PROITESTI (MEHEDINTI)"
	,
	"PRUNARU (MEHEDINTI)"
	,
	"PRUNISOR (MEHEDINTI)"
	,
	"PUNGHINA (MEHEDINTI)"
	,
	"PUSCASU (MEHEDINTI)"
	,
	"PUTINEI (MEHEDINTI)"
	,
	"RACOVA (MEHEDINTI)"
	,
	"RADUTESTI (MEHEDINTI)"
	,
	"RAICULESTI (MEHEDINTI)"
	,
	"RASCOLESTI (MEHEDINTI)"
	,
	"RECEA (MEHEDINTI)"
	,
	"ROCSORENI (MEHEDINTI)"
	,
	"ROGOVA (MEHEDINTI)"
	,
	"ROSIA (MEHEDINTI)"
	,
	"ROSIORI (MEHEDINTI)"
	,
	"RUDINA (MEHEDINTI)"
	,
	"RUNCUSORU (MEHEDINTI)"
	,
	"RUPTURA (MEHEDINTI)"
	,
	"SALATRUC (MEHEDINTI)"
	,
	"SALCIA (MEHEDINTI)"
	,
	"SARDANESTI (MEHEDINTI)"
	,
	"SATU MARE (MEHEDINTI)"
	,
	"SATU NOU (MEHEDINTI)"
	,
	"SCAPAU (MEHEDINTI)"
	,
	"SCHELA CLADOVEI (MEHEDINTI)"
	,
	"SCHINTEIESTI (MEHEDINTI)"
	,
	"SCHITU TOPOLNITEI (MEHEDINTI)"
	,
	"SCORILA (MEHEDINTI)"
	,
	"SELISTEA (MEHEDINTI)"
	,
	"SELISTENI (MEHEDINTI)"
	,
	"SELISTIUTA (MEHEDINTI)"
	,
	"SEVERINESTI (MEHEDINTI)"
	,
	"SFODEA (MEHEDINTI)"
	,
	"SIMIAN (MEHEDINTI)"
	,
	"SIPOTU (PONOARELE) (MEHEDINTI)"
	,
	"SIPOTU (POROINA MARE) (MEHEDINTI)"
	,
	"SIROCA (MEHEDINTI)"
	,
	"SISESTI (MEHEDINTI)"
	,
	"SLASOMA (MEHEDINTI)"
	,
	"SLATINICU MARE (MEHEDINTI)"
	,
	"SLATINICU MIC (MEHEDINTI)"
	,
	"SMADOVITA (MEHEDINTI)"
	,
	"SOVARNA (MEHEDINTI)"
	,
	"SPERLESTI (MEHEDINTI)"
	,
	"STANCESTI (MEHEDINTI)"
	,
	"STANESTI (MEHEDINTI)"
	,
	"STANGACEAUA (MEHEDINTI)"
	,
	"STEJARU (MEHEDINTI)"
	,
	"STIGNITA (MEHEDINTI)"
	,
	"STIRCOVITA (MEHEDINTI)"
	,
	"STREHAIA (MEHEDINTI)"
	,
	"STROESTI (MEHEDINTI)"
	,
	"STUDINA (MEHEDINTI)"
	,
	"SUHARU (MEHEDINTI)"
	,
	"SUSITA (BREZNITA-OCOL) (MEHEDINTI)"
	,
	"SUSITA (GROZESTI) (MEHEDINTI)"
	,
	"SVINITA (MEHEDINTI)"
	,
	"TALAPANU (MEHEDINTI)"
	,
	"TAMNA (MEHEDINTI)"
	,
	"TANTARU (MEHEDINTI)"
	,
	"TARSA (MEHEDINTI)"
	,
	"TIGANASI (MEHEDINTI)"
	,
	"TISMANA (MEHEDINTI)"
	,
	"TITERLESTI (MEHEDINTI)"
	,
	"TITIRIGI (MEHEDINTI)"
	,
	"TRAIAN (MEHEDINTI)"
	,
	"TURTABA (MEHEDINTI)"
	,
	"VALEA ANILOR (MEHEDINTI)"
	,
	"VALEA BUNA (MEHEDINTI)"
	,
	"VALEA COPCII (MEHEDINTI)"
	,
	"VALEA COSUSTEI (MEHEDINTI)"
	,
	"VALEA IZVORULUI (MEHEDINTI)"
	,
	"VALEA MARCULUI (MEHEDINTI)"
	,
	"VALEA PETRII (MEHEDINTI)"
	,
	"VALEA TEIULUI (MEHEDINTI)"
	,
	"VALEA URSULUI (PONOARELE) (MEHEDINTI)"
	,
	"VALEA URSULUI (TAMNA) (MEHEDINTI)"
	,
	"VANATORI (MEHEDINTI)"
	,
	"VANJU MARE (MEHEDINTI)"
	,
	"VANJULET (MEHEDINTI)"
	,
	"VARODIA (MEHEDINTI)"
	,
	"VIASU (MEHEDINTI)"
	,
	"VIDIMIRESTI (MEHEDINTI)"
	,
	"VISINA (MEHEDINTI)"
	,
	"VLADAIA (MEHEDINTI)"
	,
	"VLADASESTI (MEHEDINTI)"
	,
	"VLADICA (MEHEDINTI)"
	,
	"VOLOIAC (MEHEDINTI)"
	,
	"VOLOICEL (MEHEDINTI)"
	,
	"VRANCEA (MEHEDINTI)"
	,
	"VRATA (MEHEDINTI)"
	,
	"ZEGAIA (MEHEDINTI)"
	,
	"ZEGUJANI (MEHEDINTI)"
	,
	"ABUD (MURES)"
	,
	"ABUS (MURES)"
	,
	"ACATARI (MURES)"
	,
	"ADAMUS (MURES)"
	,
	"ADRIAN (MURES)"
	,
	"ADRIANU MARE (MURES)"
	,
	"ADRIANU MIC (MURES)"
	,
	"AGRISTEU (MURES)"
	,
	"ALBESTI (MURES)"
	,
	"ALUNIS (MURES)"
	,
	"ANDRENEASA (MURES)"
	,
	"ANGOFA (MURES)"
	,
	"APALINA (MURES)"
	,
	"APOLD (MURES)"
	,
	"ARCHITA (MURES)"
	,
	"ARSITA (MURES)"
	,
	"ATINTIS (MURES)"
	,
	"AUREL VLAICU (MURES)"
	,
	"AVRAMESTI (MURES)"
	,
	"BAGACIU (MURES)"
	,
	"BAHNEA (MURES)"
	,
	"BAITA (MURES)"
	,
	"BALA (MURES)"
	,
	"BALAUSERI (MURES)"
	,
	"BALDA (MURES)"
	,
	"BAND (MURES)"
	,
	"BARA (MURES)"
	,
	"BARBOSI (MURES)"
	,
	"BARDESTI (MURES)"
	,
	"BARLIBAS (MURES)"
	,
	"BARLIBASOAIA (MURES)"
	,
	"BARZA (MURES)"
	,
	"BATOS (MURES)"
	,
	"BEDENI (MURES)"
	,
	"BEICA DE JOS (MURES)"
	,
	"BEICA DE SUS (MURES)"
	,
	"BERENI (MURES)"
	,
	"BERGHIA (MURES)"
	,
	"BERNADEA (MURES)"
	,
	"BEU (MURES)"
	,
	"BEZID (MURES)"
	,
	"BEZIDU NOU (MURES)"
	,
	"BICASU (MURES)"
	,
	"BICHIS (MURES)"
	,
	"BISTRA MURESULUI (MURES)"
	,
	"BLIDIREASA (MURES)"
	,
	"BOBOHALMA (MURES)"
	,
	"BOGATA (MURES)"
	,
	"BOIU (MURES)"
	,
	"BOLINTINENI (MURES)"
	,
	"BOLOGAIA (MURES)"
	,
	"BORD (MURES)"
	,
	"BORDOSIU (MURES)"
	,
	"BORZIA (MURES)"
	,
	"BOTEI (MURES)"
	,
	"BOTEZ (MURES)"
	,
	"BOTORCA (MURES)"
	,
	"BOZED (MURES)"
	,
	"BOZENI (MURES)"
	,
	"BRADETELU (MURES)"
	,
	"BRANCOVENESTI (MURES)"
	,
	"BREAZA (MURES)"
	,
	"BUDIU MIC (MURES)"
	,
	"BUJOR (MURES)"
	,
	"BUJOR-HODAIE (MURES)"
	,
	"CACIULATA (MURES)"
	,
	"CACUCIU (MURES)"
	,
	"CALIMANESTI (MURES)"
	,
	"CALUGARENI (MURES)"
	,
	"CALUSERI (MURES)"
	,
	"CAMPENITA (MURES)"
	,
	"CAMPU CETATII (MURES)"
	,
	"CANDU (MURES)"
	,
	"CAPALNA DE SUS (MURES)"
	,
	"CAPETI (MURES)"
	,
	"CAPUSU DE CAMPIE (MURES)"
	,
	"CASVA (MURES)"
	,
	"CECALACA (MURES)"
	,
	"CEIE (MURES)"
	,
	"CERGHID (MURES)"
	,
	"CERGHIZEL (MURES)"
	,
	"CEUAS (MURES)"
	,
	"CEUASU DE CAMPIE (MURES)"
	,
	"CHENDU (MURES)"
	,
	"CHETANI (MURES)"
	,
	"CHIBED (MURES)"
	,
	"CHIHERU DE JOS (MURES)"
	,
	"CHIHERU DE SUS (MURES)"
	,
	"CHINARI (MURES)"
	,
	"CHINCIUS (MURES)"
	,
	"CHIRILEU (MURES)"
	,
	"CHISALITA (MURES)"
	,
	"CIBU (MURES)"
	,
	"CINTA (MURES)"
	,
	"CIOARGA (MURES)"
	,
	"CIOBOTANI (MURES)"
	,
	"CIPAIENI (MURES)"
	,
	"CIPAU (MURES)"
	,
	"CIRETEA (MURES)"
	,
	"CIRHAGAU (MURES)"
	,
	"CIULEA (MURES)"
	,
	"CIURGAU (MURES)"
	,
	"CLOASTERF (MURES)"
	,
	"COASTA GRINDULUI (MURES)"
	,
	"COASTA MARE (MURES)"
	,
	"COMORI (MURES)"
	,
	"CORBESTI (MURES)"
	,
	"CORDOS (MURES)"
	,
	"CORNESTI (ADAMUS) (MURES)"
	,
	"CORNESTI (CRACIUNESTI) (MURES)"
	,
	"COROI (MURES)"
	,
	"COROISANMARTIN (MURES)"
	,
	"CORUNCA (MURES)"
	,
	"COTORINAU (MURES)"
	,
	"COTUS (MURES)"
	,
	"COZMA (MURES)"
	,
	"CRACIUNESTI (MURES)"
	,
	"CRAIESTI (MURES)"
	,
	"CRAIESTI (ADAMUS) (MURES)"
	,
	"CRIS (MURES)"
	,
	"CRISTESTI (MURES)"
	,
	"CUCERDEA (MURES)"
	,
	"CUCI (MURES)"
	,
	"CUIESD (MURES)"
	,
	"CULPIU (MURES)"
	,
	"CUND (MURES)"
	,
	"CURETE (MURES)"
	,
	"CURTENI (MURES)"
	,
	"CUSTELNIC (MURES)"
	,
	"DAIA (APOLD) (MURES)"
	,
	"DAIA (BAHNEA) (MURES)"
	,
	"DALU (MURES)"
	,
	"DAMBAU (MURES)"
	,
	"DAMBU (MURES)"
	,
	"DAMIENI (MURES)"
	,
	"DANES (MURES)"
	,
	"DATASENI (MURES)"
	,
	"DEAG (MURES)"
	,
	"DEAJ (MURES)"
	,
	"DEDA (MURES)"
	,
	"DEDRAD (MURES)"
	,
	"DELENI (IDECIU DE JOS) (MURES)"
	,
	"DELENI (POGACEAUA) (MURES)"
	,
	"DELENII (MURES)"
	,
	"DILEU NOU (MURES)"
	,
	"DILEU VECHI (MURES)"
	,
	"DOBRA (MURES)"
	,
	"DRACULEA BANDULUI (MURES)"
	,
	"DROJDII (MURES)"
	,
	"DUBISTEA DE PADURE (MURES)"
	,
	"DULCEA (MURES)"
	,
	"DUMBRAVA (MURES)"
	,
	"DUMBRAVIOARA (MURES)"
	,
	"DUMITRENI (MURES)"
	,
	"DUMITRESTII (MURES)"
	,
	"DUPA DEAL (CUCI) (MURES)"
	,
	"DUPA DEAL (ICLANZEL) (MURES)"
	,
	"ERCEA (MURES)"
	,
	"EREMIENI (MURES)"
	,
	"EREMITU (MURES)"
	,
	"ERNEI (MURES)"
	,
	"FANATE (BAND) (MURES)"
	,
	"FANATE (FARAGAU) (MURES)"
	,
	"FANATE (ICLANZEL) (MURES)"
	,
	"FANATE (TAURENI) (MURES)"
	,
	"FANATELE CAPUSULUI (MURES)"
	,
	"FANATELE MADARASULUI (MURES)"
	,
	"FANATELE SOCOLULUI (MURES)"
	,
	"FANTANA BABII (MURES)"
	,
	"FANTANELE (MURES)"
	,
	"FARAGAU (MURES)"
	,
	"FELEAG (MURES)"
	,
	"FILEA (MURES)"
	,
	"FILITELNIC (MURES)"
	,
	"FILPISU MARE (MURES)"
	,
	"FILPISU MIC (MURES)"
	,
	"FITCAU (MURES)"
	,
	"FRUNZENI (MURES)"
	,
	"FUNDATURA (MURES)"
	,
	"FUNDOAIA (MURES)"
	,
	"GAIESTI (MURES)"
	,
	"GALAOAIA (MURES)"
	,
	"GALATENI (MURES)"
	,
	"GALESTI (MURES)"
	,
	"GAMBUT (MURES)"
	,
	"GANESTI (MURES)"
	,
	"GAURA SANGERULUI (MURES)"
	,
	"GHEJA (MURES)"
	,
	"GHEORGHE DOJA (MURES)"
	,
	"GHIDASTEU (MURES)"
	,
	"GHINDARI (MURES)"
	,
	"GHINESTI (MURES)"
	,
	"GIULUS (MURES)"
	,
	"GIURGIS (MURES)"
	,
	"GLAJARIE (MURES)"
	,
	"GLODENI (MURES)"
	,
	"GOGAN (MURES)"
	,
	"GORENI (MURES)"
	,
	"GORNESTI (MURES)"
	,
	"GRADINI (MURES)"
	,
	"GRAUSORUL (MURES)"
	,
	"GREBENISU DE CAMPIE (MURES)"
	,
	"GRINDENI (MURES)"
	,
	"GROAPA RADAII (MURES)"
	,
	"GRUISOR (MURES)"
	,
	"GURGHIU (MURES)"
	,
	"HABIC (MURES)"
	,
	"HADARENI (MURES)"
	,
	"HAGAU (MURES)"
	,
	"HARANGLAB (MURES)"
	,
	"HARTAU (MURES)"
	,
	"HEREPEA (MURES)"
	,
	"HERGHELIA (MURES)"
	,
	"HETIUR (MURES)"
	,
	"HODAC (MURES)"
	,
	"HODAIA (MURES)"
	,
	"HODOSA (MURES)"
	,
	"IARA DE MURES (MURES)"
	,
	"IBANESTI (MURES)"
	,
	"IBANESTI-PADURE (MURES)"
	,
	"ICLAND (MURES)"
	,
	"ICLANDU MARE (MURES)"
	,
	"ICLANZEL (MURES)"
	,
	"IDECIU DE JOS (MURES)"
	,
	"IDECIU DE SUS (MURES)"
	,
	"IDICEL (MURES)"
	,
	"IDICEL-PADURE (MURES)"
	,
	"IDICIU (MURES)"
	,
	"IDRIFAIA (MURES)"
	,
	"IERNUT (MURES)"
	,
	"IERNUTENI (MURES)"
	,
	"IHOD (MURES)"
	,
	"ILIENI (MURES)"
	,
	"ILIESI (MURES)"
	,
	"ILIOARA (MURES)"
	,
	"IOD (MURES)"
	,
	"ISLA (MURES)"
	,
	"ISTAN-TAU (MURES)"
	,
	"ISTIHAZA (MURES)"
	,
	"IVANESTI (MURES)"
	,
	"JABENITA (MURES)"
	,
	"JACODU (MURES)"
	,
	"JACU (MURES)"
	,
	"LAPUSNA (MURES)"
	,
	"LARGA (GURGHIU) (MURES)"
	,
	"LARGA (SARMASU) (MURES)"
	,
	"LASCUD (MURES)"
	,
	"LASLAU MARE (MURES)"
	,
	"LASLAU MIC (MURES)"
	,
	"LAURENI (MURES)"
	,
	"LECHINCIOARA (MURES)"
	,
	"LECHINTA (MURES)"
	,
	"LEFAIA (MURES)"
	,
	"LENIS (MURES)"
	,
	"LEORDENI (MURES)"
	,
	"LEORINTA (MURES)"
	,
	"LEORINTA-SAULIA (MURES)"
	,
	"LEPINDEA (MURES)"
	,
	"LINT (MURES)"
	,
	"LIVEZENI (MURES)"
	,
	"LOGIG (MURES)"
	,
	"LOTU (MURES)"
	,
	"LUDUS (MURES)"
	,
	"LUIERIU (MURES)"
	,
	"LUNCA (MURES)"
	,
	"LUNCA BRADULUI (MURES)"
	,
	"LUNCA MURESULUI (MURES)"
	,
	"MACICASESTI (MURES)"
	,
	"MADARAS (MURES)"
	,
	"MADARASENI (MURES)"
	,
	"MAGHERANI (MURES)"
	,
	"MAGHERUS (MURES)"
	,
	"MAIA (MURES)"
	,
	"MAIAD (MURES)"
	,
	"MAIORESTI (MURES)"
	,
	"MALAESTI (MURES)"
	,
	"MALDAOCI (MURES)"
	,
	"MALEA (MURES)"
	,
	"MARASESTI (MURES)"
	,
	"MARCULENI (MURES)"
	,
	"MATRICI (MURES)"
	,
	"MERISOR (MURES)"
	,
	"MERISORU (MURES)"
	,
	"MESTERA (MURES)"
	,
	"MICA (MURES)"
	,
	"MIERCUREA NIRAJULUI (MURES)"
	,
	"MIHAI VITEAZU (MURES)"
	,
	"MIHESU DE CAMPIE (MURES)"
	,
	"MILASEL (MURES)"
	,
	"MIRIGIOAIA (MURES)"
	,
	"MITRESTI (MURES)"
	,
	"MOARA DE JOS (MURES)"
	,
	"MOGOAIA (MURES)"
	,
	"MOISA (MURES)"
	,
	"MORARENI (MURES)"
	,
	"MORESTI (MURES)"
	,
	"MORUT (MURES)"
	,
	"MOSUNI (MURES)"
	,
	"MURA MARE (MURES)"
	,
	"MURA MICA (MURES)"
	,
	"MURENI (MURES)"
	,
	"MURESENI (MURES)"
	,
	"MURGESTI (MURES)"
	,
	"NADASA (MURES)"
	,
	"NADES (MURES)"
	,
	"NANDRA (MURES)"
	,
	"NAZNA (MURES)"
	,
	"NEAGRA (MURES)"
	,
	"NEAUA (MURES)"
	,
	"NEGRENII DE CAMPIE (MURES)"
	,
	"NIMA MILASELULUI (MURES)"
	,
	"NIMA RACIULUI (MURES)"
	,
	"OARBA DE MURES (MURES)"
	,
	"OBARSIE (MURES)"
	,
	"ODRIHEI (MURES)"
	,
	"OGRA (MURES)"
	,
	"ONUCA (MURES)"
	,
	"ORMENIS (MURES)"
	,
	"OROIU (MURES)"
	,
	"OROSIA (MURES)"
	,
	"ORSOVA (MURES)"
	,
	"ORSOVA-PADURE (MURES)"
	,
	"OZD (MURES)"
	,
	"PACURENI (MURES)"
	,
	"PADUREA (MURES)"
	,
	"PADURENI (MURES)"
	,
	"PAINGENI (MURES)"
	,
	"PANET (MURES)"
	,
	"PAPIU ILARIAN (MURES)"
	,
	"PARAU CRUCII (POGACEAUA) (MURES)"
	,
	"PARAU CRUCII (RACIU) (MURES)"
	,
	"PARAU MARE (MURES)"
	,
	"PASARENI (MURES)"
	,
	"PAUCISOARA (MURES)"
	,
	"PAULOAIA (MURES)"
	,
	"PERIS (MURES)"
	,
	"PETEA (MURES)"
	,
	"PETELEA (MURES)"
	,
	"PETRILACA (MURES)"
	,
	"PETRILACA DE MURES (MURES)"
	,
	"PIETRIS (MURES)"
	,
	"PIPEA (MURES)"
	,
	"POARTA (MURES)"
	,
	"PODURI (MURES)"
	,
	"POGACEAUA (MURES)"
	,
	"POIENITA (MURES)"
	,
	"PORUMBAC (MURES)"
	,
	"PORUMBENI (MURES)"
	,
	"PRIPOARE (MURES)"
	,
	"PUSTA (MURES)"
	,
	"RACAMET (MURES)"
	,
	"RACIU (MURES)"
	,
	"RANTA (MURES)"
	,
	"RAPA DE JOS (MURES)"
	,
	"RASTOLITA (MURES)"
	,
	"RAZOARE (MURES)"
	,
	"RECEA (MURES)"
	,
	"REGHIN (MURES)"
	,
	"REMETEA (MURES)"
	,
	"RIGMANI (MURES)"
	,
	"RORA (MURES)"
	,
	"ROSIORI (MURES)"
	,
	"ROTENI (MURES)"
	,
	"ROUA (MURES)"
	,
	"RUSII-MUNTI (MURES)"
	,
	"SABED (MURES)"
	,
	"SACADAT (MURES)"
	,
	"SACALU DE PADURE (MURES)"
	,
	"SACARENI (MURES)"
	,
	"SAES (MURES)"
	,
	"SALARD (MURES)"
	,
	"SALASURI (MURES)"
	,
	"SALCUD (MURES)"
	,
	"SAMBRIAS (MURES)"
	,
	"SANCRAIU DE MURES (MURES)"
	,
	"SANDRU (MURES)"
	,
	"SANGEORGIU DE CAMPIE (MURES)"
	,
	"SANGEORGIU DE MURES (MURES)"
	,
	"SANGEORGIU DE PADURE (MURES)"
	,
	"SANGER (MURES)"
	,
	"SANGERU DE PADURE (MURES)"
	,
	"SANIACOB (MURES)"
	,
	"SANISOR (MURES)"
	,
	"SANMARGHITA (MURES)"
	,
	"SANMARTINU DE CAMPIE (MURES)"
	,
	"SANMIHAI DE PADURE (MURES)"
	,
	"SANPAUL (MURES)"
	,
	"SANPETRU DE CAMPIE (MURES)"
	,
	"SANSIMION (MURES)"
	,
	"SANTANA DE MURES (MURES)"
	,
	"SANTIOANA (MURES)"
	,
	"SANTIOANA DE MURES (MURES)"
	,
	"SANTU (MURES)"
	,
	"SAPARTOC (MURES)"
	,
	"SARATENI (MURES)"
	,
	"SARDU NIRAJULUI (MURES)"
	,
	"SARMASEL (MURES)"
	,
	"SARMASEL-GARA (MURES)"
	,
	"SARMASU (MURES)"
	,
	"SASCHIZ (MURES)"
	,
	"SATU NOU (GHEORGHE DOJA) (MURES)"
	,
	"SATU NOU (SANPETRU DE CAMPIE) (MURES)"
	,
	"SAULIA (MURES)"
	,
	"SAULITA (MURES)"
	,
	"SAUSA (MURES)"
	,
	"SCURTA (MURES)"
	,
	"SEBES (MURES)"
	,
	"SELEUS (DANES) (MURES)"
	,
	"SELEUS (ZAGAR) (MURES)"
	,
	"SENEREUS (MURES)"
	,
	"SERBENI (MURES)"
	,
	"SEULIA DE MURES (MURES)"
	,
	"SFANTU GHEORGHE (MURES)"
	,
	"SICELE (MURES)"
	,
	"SIGHISOARA (MURES)"
	,
	"SILEA NIRAJULUI (MURES)"
	,
	"SINCAI (MURES)"
	,
	"SINCAI-FANATE (MURES)"
	,
	"SOARD (MURES)"
	,
	"SOCOLU DE CAMPIE (MURES)"
	,
	"SOIMUS (MURES)"
	,
	"SOLOCMA (MURES)"
	,
	"SOLOVASTRU (MURES)"
	,
	"SOMOSTELNIC (MURES)"
	,
	"SOROMICLEA (MURES)"
	,
	"SOVATA (MURES)"
	,
	"STANCENI (MURES)"
	,
	"STEFANCA (MURES)"
	,
	"STEFANEACA (MURES)"
	,
	"STEJARENII (MURES)"
	,
	"STEJERIS (MURES)"
	,
	"SUB PADURE (MURES)"
	,
	"SUPLAC (MURES)"
	,
	"SUSENI (MURES)"
	,
	"SUVEICA (MURES)"
	,
	"TABLASENI (MURES)"
	,
	"TAMPA (MURES)"
	,
	"TARGU MURES (MURES)"
	,
	"TARNAVENI (MURES)"
	,
	"TAU (MURES)"
	,
	"TAURENI (MURES)"
	,
	"TELEAC (MURES)"
	,
	"TIGMANDRU (MURES)"
	,
	"TIPTELNIC (MURES)"
	,
	"TIREU (MURES)"
	,
	"TIRIMIA (MURES)"
	,
	"TIRIMIOARA (MURES)"
	,
	"TISIEU (MURES)"
	,
	"TITIANA (MURES)"
	,
	"TOACA (MURES)"
	,
	"TOFALAU (MURES)"
	,
	"TOLDAL (MURES)"
	,
	"TONCIU (MURES)"
	,
	"TOPA (MURES)"
	,
	"TORBA (MURES)"
	,
	"TREI SATE (MURES)"
	,
	"TROITA (MURES)"
	,
	"TUSINU (MURES)"
	,
	"UILA (MURES)"
	,
	"ULIES (MURES)"
	,
	"UNGHENI (MURES)"
	,
	"URICEA (MURES)"
	,
	"URISIU DE JOS (MURES)"
	,
	"URISIU DE SUS (MURES)"
	,
	"URSOAIA (MURES)"
	,
	"VADAS (MURES)"
	,
	"VADU (MURES)"
	,
	"VAIDACUTA (MURES)"
	,
	"VAIDEIU (MURES)"
	,
	"VALEA (MURES)"
	,
	"VALEA ALBESTIULUI (MURES)"
	,
	"VALEA DAII (MURES)"
	,
	"VALEA FRATIEI (MURES)"
	,
	"VALEA GLODULUI (MURES)"
	,
	"VALEA ICLANDULUI (MURES)"
	,
	"VALEA IZVOARELOR (MURES)"
	,
	"VALEA LARGA (MURES)"
	,
	"VALEA MARE (MURES)"
	,
	"VALEA PADURII (MURES)"
	,
	"VALEA RECE (MURES)"
	,
	"VALEA SANMARTINULUI (MURES)"
	,
	"VALEA SANPETRULUI (GREBENISU DE CAMPIE (MURES)"
	,
	"VALEA SANPETRULUI (POGACEAUA) (MURES)"
	,
	"VALEA SAPARTOCULUI (MURES)"
	,
	"VALEA SASULUI (MURES)"
	,
	"VALEA SEACA (MURES)"
	,
	"VALEA SURII (MURES)"
	,
	"VALEA ULIESULUI (MURES)"
	,
	"VALEA UNGURULUI (MURES)"
	,
	"VALEA URIESULUI (MURES)"
	,
	"VALENI (MURES)"
	,
	"VALENII (MURES)"
	,
	"VALENII DE MURES (MURES)"
	,
	"VALISOARA (MURES)"
	,
	"VALURENI (MURES)"
	,
	"VANATORI (MURES)"
	,
	"VARGATA (MURES)"
	,
	"VATAVA (MURES)"
	,
	"VENCHI (MURES)"
	,
	"VETA (MURES)"
	,
	"VETCA (MURES)"
	,
	"VIDRASAU (MURES)"
	,
	"VIFOROASA (MURES)"
	,
	"VIILOR (MURES)"
	,
	"VIISOARA (MURES)"
	,
	"VISINELU (MURES)"
	,
	"VOINICENI (MURES)"
	,
	"VOIVODENI (MURES)"
	,
	"VULCAN (MURES)"
	,
	"ZAGAR (MURES)"
	,
	"ZAPODEA (MURES)"
	,
	"ZAU DE CAMPIE (MURES)"
	,
	"ZIMTI (MURES)"
	,
	"ADJUDENI (NEAMT)"
	,
	"AGAPIA (NEAMT)"
	,
	"AGAPIA-MANASTIRE (NEAMT)"
	,
	"AGARCIA (NEAMT)"
	,
	"ALEXANDRU CEL BUN (NEAMT)"
	,
	"ALMAS (NEAMT)"
	,
	"ARAMESTI (NEAMT)"
	,
	"ARAMOAIA (NEAMT)"
	,
	"ARDELUTA (NEAMT)"
	,
	"AVERESTI (NEAMT)"
	,
	"BAHNA (NEAMT)"
	,
	"BAHNA MARE (NEAMT)"
	,
	"BAHNISOARA (NEAMT)"
	,
	"BALANESTI (NEAMT)"
	,
	"BALTATESTI (NEAMT)"
	,
	"BALUSESTI (GIROV) (NEAMT)"
	,
	"BALUSESTI (ICUSESTI) (NEAMT)"
	,
	"BANEASA (NEAMT)"
	,
	"BARA (NEAMT)"
	,
	"BARATCA (NEAMT)"
	,
	"BARCANESTI (NEAMT)"
	,
	"BARGAUANI (NEAMT)"
	,
	"BARJOVENI (NEAMT)"
	,
	"BARNADU (NEAMT)"
	,
	"BARTICESTI (NEAMT)"
	,
	"BASTA (NEAMT)"
	,
	"BATRANESTI (NEAMT)"
	,
	"BETESTI (NEAMT)"
	,
	"BICAZ (NEAMT)"
	,
	"BICAZ-CHEI (NEAMT)"
	,
	"BICAZU ARDELEAN (NEAMT)"
	,
	"BISERICANI (NEAMT)"
	,
	"BISTRICIOARA (NEAMT)"
	,
	"BISTRITA (NEAMT)"
	,
	"BLEBEA (NEAMT)"
	,
	"BOBOIESTI (NEAMT)"
	,
	"BODESTI (NEAMT)"
	,
	"BODESTII DE JOS (NEAMT)"
	,
	"BOGHICEA (NEAMT)"
	,
	"BOGZESTI (NEAMT)"
	,
	"BOISTEA (NEAMT)"
	,
	"BORCA (NEAMT)"
	,
	"BORDEA (NEAMT)"
	,
	"BORLESTI (NEAMT)"
	,
	"BORNIS (NEAMT)"
	,
	"BORSENI (NEAMT)"
	,
	"BOTESTI (NEAMT)"
	,
	"BOZIENI (NEAMT)"
	,
	"BOZIENII DE SUS (NEAMT)"
	,
	"BRADU (NEAMT)"
	,
	"BRASAUTI (NEAMT)"
	,
	"BRATES (NEAMT)"
	,
	"BREAZA (NEAMT)"
	,
	"BRITCANI (NEAMT)"
	,
	"BROSTENI (NEAMT)"
	,
	"BRUSTURI (NEAMT)"
	,
	"BRUSTURI-DRAGANESTI (NEAMT)"
	,
	"BUCIUM (NEAMT)"
	,
	"BUDESTI (NEAMT)"
	,
	"BUHALNITA (NEAMT)"
	,
	"BUHONCA (NEAMT)"
	,
	"BUNGHI (NEAMT)"
	,
	"BURUIENESTI (NEAMT)"
	,
	"BUSMEI (NEAMT)"
	,
	"BUTNARESTI (NEAMT)"
	,
	"CACIULESTI (NEAMT)"
	,
	"CALUGARENI (NEAMT)"
	,
	"CANDESTI (NEAMT)"
	,
	"CAPSA (NEAMT)"
	,
	"CARLIG (NEAMT)"
	,
	"CARLIGI (NEAMT)"
	,
	"CASARIA (NEAMT)"
	,
	"CAUSENI (NEAMT)"
	,
	"CAZACI (NEAMT)"
	,
	"CEAHLAU (NEAMT)"
	,
	"CERTIENI (NEAMT)"
	,
	"CHICEREA (NEAMT)"
	,
	"CHILIA (NEAMT)"
	,
	"CHILII (NEAMT)"
	,
	"CHINTINICI (NEAMT)"
	,
	"CHIRITENI (NEAMT)"
	,
	"CIORNEI (NEAMT)"
	,
	"CIRITEI (NEAMT)"
	,
	"CIUREA (NEAMT)"
	,
	"CLIMESTI (NEAMT)"
	,
	"CORDUN (NEAMT)"
	,
	"CORHANA (NEAMT)"
	,
	"CORNI (NEAMT)"
	,
	"COSTISA (NEAMT)"
	,
	"COTU VAMES (NEAMT)"
	,
	"CRACAOANI (NEAMT)"
	,
	"CRACAUL NEGRU (NEAMT)"
	,
	"CRAIESTI (NEAMT)"
	,
	"CUCI (NEAMT)"
	,
	"CUEJDIU (NEAMT)"
	,
	"CURECHISTEA (NEAMT)"
	,
	"CUT (NEAMT)"
	,
	"DAMUC (NEAMT)"
	,
	"DANESTI (NEAMT)"
	,
	"DARLOAIA (NEAMT)"
	,
	"DAVID (NEAMT)"
	,
	"DAVIDENI (NEAMT)"
	,
	"DELENI (NEAMT)"
	,
	"DOAMNA (NEAMT)"
	,
	"DOBRENI (NEAMT)"
	,
	"DOCHIA (NEAMT)"
	,
	"DODENI (NEAMT)"
	,
	"DOINA (NEAMT)"
	,
	"DOLHESTI (NEAMT)"
	,
	"DOLJESTI (NEAMT)"
	,
	"DORNESTI (NEAMT)"
	,
	"DRAGANESTI (NEAMT)"
	,
	"DRAGOMIRESTI (NEAMT)"
	,
	"DRAGOVA (NEAMT)"
	,
	"DREPTU (NEAMT)"
	,
	"DULCESTI (NEAMT)"
	,
	"DUMBRAVA (NEAMT)"
	,
	"DUMBRAVA-DEAL (NEAMT)"
	,
	"DUMBRAVA ROSIE (NEAMT)"
	,
	"DURAU (NEAMT)"
	,
	"DUSESTI (NEAMT)"
	,
	"FARCASA (NEAMT)"
	,
	"FAUREI (NEAMT)"
	,
	"FILIOARA (NEAMT)"
	,
	"FRUMOSU (NEAMT)"
	,
	"FRUNZENI (NEAMT)"
	,
	"GADINTI (NEAMT)"
	,
	"GALU (NEAMT)"
	,
	"GARCINA (NEAMT)"
	,
	"GHELAIESTI (NEAMT)"
	,
	"GHERAESTI (NEAMT)"
	,
	"GHERAESTII NOI (NEAMT)"
	,
	"GHERMAN (NEAMT)"
	,
	"GHIDION (NEAMT)"
	,
	"GHIGOIESTI (NEAMT)"
	,
	"GHINDAOANI (NEAMT)"
	,
	"GIROV (NEAMT)"
	,
	"GIULESTI (NEAMT)"
	,
	"GIURGENI (NEAMT)"
	,
	"GORUN (NEAMT)"
	,
	"GOSMANI (NEAMT)"
	,
	"GRINTIES (NEAMT)"
	,
	"GROSI (NEAMT)"
	,
	"GROZAVESTI (NEAMT)"
	,
	"GRUMAZESTI (NEAMT)"
	,
	"GURA VAII (NEAMT)"
	,
	"HAMZOAIA (NEAMT)"
	,
	"HANGU (NEAMT)"
	,
	"HANUL ANCUTEI (NEAMT)"
	,
	"HARTESTI (NEAMT)"
	,
	"HARTOP (NEAMT)"
	,
	"HLAPESTI (NEAMT)"
	,
	"HOCIUNGI (NEAMT)"
	,
	"HOISESTI (NEAMT)"
	,
	"HOLM (NEAMT)"
	,
	"HOMICENI (NEAMT)"
	,
	"HORIA (NEAMT)"
	,
	"HUISUREZ (NEAMT)"
	,
	"HUMULESTI (NEAMT)"
	,
	"HUMULESTII NOI (NEAMT)"
	,
	"ICUSESTI (NEAMT)"
	,
	"INGARESTI (NEAMT)"
	,
	"ION CREANGA (NEAMT)"
	,
	"ITRINESTI (NEAMT)"
	,
	"IUCSA (NEAMT)"
	,
	"IVANES (NEAMT)"
	,
	"IZVOARE (BAHNA) (NEAMT)"
	,
	"IZVOARE (DUMBRAVA ROSIE) (NEAMT)"
	,
	"IZVORU (NEAMT)"
	,
	"IZVORU ALB (NEAMT)"
	,
	"IZVORU MUNTELUI (NEAMT)"
	,
	"LEGHIN (NEAMT)"
	,
	"LILIAC (NEAMT)"
	,
	"LINSESTI (NEAMT)"
	,
	"LUMINIS (NEAMT)"
	,
	"LUNCA (BORCA) (NEAMT)"
	,
	"LUNCA (ONICENI) (NEAMT)"
	,
	"LUNCA (VANATORI-NEAMT) (NEAMT)"
	,
	"LUNCA MOLDOVEI (NEAMT)"
	,
	"LUTCA (NEAMT)"
	,
	"MADEI (NEAMT)"
	,
	"MAGAZIA (NEAMT)"
	,
	"MANASTIREA NEAMT (NEAMT)"
	,
	"MANOAIA (NEAMT)"
	,
	"MARGINENI (NEAMT)"
	,
	"MARMURENI (NEAMT)"
	,
	"MASTACAN (BORLESTI) (NEAMT)"
	,
	"MASTACAN (DRAGOMIRESTI) (NEAMT)"
	,
	"MESTEACAN (NEAMT)"
	,
	"MICSUNESTI (NEAMT)"
	,
	"MIRON COSTIN (NEAMT)"
	,
	"MITOCU BALAN (NEAMT)"
	,
	"MOLDOVENI (NEAMT)"
	,
	"MORENI (NEAMT)"
	,
	"MUNCELU (NEAMT)"
	,
	"MUNCELU DE JOS (NEAMT)"
	,
	"MUNTENI (NEAMT)"
	,
	"NEAGRA (NEAMT)"
	,
	"NECHIT (NEAMT)"
	,
	"NEGRESTI (BARA) (NEAMT)"
	,
	"NEGRESTI (DOBRENI) (NEAMT)"
	,
	"NEGRITESTI (NEAMT)"
	,
	"NEGULESTI (NEAMT)"
	,
	"NEMTISOR (NEAMT)"
	,
	"NETEZI (NEAMT)"
	,
	"NISIPORESTI (NEAMT)"
	,
	"NISTRIA (NEAMT)"
	,
	"OANTU (NEAMT)"
	,
	"OGLINZI (NEAMT)"
	,
	"ONICENI (NEAMT)"
	,
	"ORTASTI (NEAMT)"
	,
	"OSLOBENI (NEAMT)"
	,
	"PADURENI (NEAMT)"
	,
	"PANCESTI (NEAMT)"
	,
	"PANGARACIOR (NEAMT)"
	,
	"PANGARATI (NEAMT)"
	,
	"PARAUL CARJEI (NEAMT)"
	,
	"PARAUL FAGULUI (NEAMT)"
	,
	"PARAUL MARE (NEAMT)"
	,
	"PARAUL PANTEI (NEAMT)"
	,
	"PASTRAVENI (NEAMT)"
	,
	"PATALIGENI (NEAMT)"
	,
	"PATRICHENI (NEAMT)"
	,
	"PETRICANI (NEAMT)"
	,
	"PETRU VODA (NEAMT)"
	,
	"PIATRA NEAMT (NEAMT)"
	,
	"PIATRA SOIMULUI (NEAMT)"
	,
	"PIETROSU (NEAMT)"
	,
	"PILDESTI (NEAMT)"
	,
	"PIPIRIG (NEAMT)"
	,
	"PLAIESU (NEAMT)"
	,
	"PLUGARI (NEAMT)"
	,
	"PLUTON (NEAMT)"
	,
	"PODOLENI (NEAMT)"
	,
	"POIANA (BRUSTURI-DRAGANESTI) (NEAMT)"
	,
	"POIANA (DOBRENI) (NEAMT)"
	,
	"POIANA (DULCESTI) (NEAMT)"
	,
	"POIANA (GRINTIES) (NEAMT)"
	,
	"POIANA (PANGARATI) (NEAMT)"
	,
	"POIANA CRACAOANI (NEAMT)"
	,
	"POIANA HUMEI (NEAMT)"
	,
	"POIANA LARGULUI (NEAMT)"
	,
	"POIANA TEIULUI (NEAMT)"
	,
	"POIENARI (NEAMT)"
	,
	"POIENI (NEAMT)"
	,
	"POIENILE OANCEI (NEAMT)"
	,
	"POLOBOC (NEAMT)"
	,
	"POPESTI (FARCASA) (NEAMT)"
	,
	"POPESTI (GIROV) (NEAMT)"
	,
	"POTOCI (NEAMT)"
	,
	"PRAJESTI (NEAMT)"
	,
	"PRELUCA (NEAMT)"
	,
	"PREUTESTI (NEAMT)"
	,
	"PUSTIETA (NEAMT)"
	,
	"RADENI (NEAMT)"
	,
	"RASCA (NEAMT)"
	,
	"RAUCESTI (NEAMT)"
	,
	"RAZBOIENI (NEAMT)"
	,
	"RAZBOIENII DE JOS (NEAMT)"
	,
	"RECEA (NEAMT)"
	,
	"REDIU (NEAMT)"
	,
	"REDIU (BARA) (NEAMT)"
	,
	"ROCNA (NEAMT)"
	,
	"ROMAN (NEAMT)"
	,
	"ROMANI (NEAMT)"
	,
	"ROSENI (NEAMT)"
	,
	"ROSIORI (NEAMT)"
	,
	"ROTUNDA (NEAMT)"
	,
	"ROZNOV (NEAMT)"
	,
	"RUGINESTI (NEAMT)"
	,
	"RUGINOASA (NEAMT)"
	,
	"RUSENI (BORLESTI) (NEAMT)"
	,
	"RUSENI (POIANA TEIULUI) (NEAMT)"
	,
	"SABAOANI (NEAMT)"
	,
	"SABASA (NEAMT)"
	,
	"SACALENI (NEAMT)"
	,
	"SACALUSESTI (NEAMT)"
	,
	"SAGNA (NEAMT)"
	,
	"SARATA (NEAMT)"
	,
	"SAVESTI (NEAMT)"
	,
	"SAVINESTI (NEAMT)"
	,
	"SAVINESTI (POIANA TEIULUI) (NEAMT)"
	,
	"SCARICICA (NEAMT)"
	,
	"SCHITU TARCAU (NEAMT)"
	,
	"SECU (NEAMT)"
	,
	"SECUIENI (NEAMT)"
	,
	"SECUIENII NOI (NEAMT)"
	,
	"SILISTEA (NEAMT)"
	,
	"SIMIONESTI (NEAMT)"
	,
	"SLOBOZIA (BARA) (NEAMT)"
	,
	"SLOBOZIA (ROZNOV) (NEAMT)"
	,
	"SOCEA (NEAMT)"
	,
	"SOCI (BORCA) (NEAMT)"
	,
	"SOCI (STEFAN CEL MARE) (NEAMT)"
	,
	"SOIMARESTI (NEAMT)"
	,
	"SOLCA (NEAMT)"
	,
	"SOVOAIA (NEAMT)"
	,
	"SPIESTI (NEAMT)"
	,
	"SPIRIDONESTI (NEAMT)"
	,
	"STANCA (NEAMT)"
	,
	"STANITA (NEAMT)"
	,
	"STEFAN CEL MARE (NEAMT)"
	,
	"STEJARU (FARCASA) (NEAMT)"
	,
	"STEJARU (ION CREANGA) (NEAMT)"
	,
	"STEJARU (PANGARATI) (NEAMT)"
	,
	"STRAJA (NEAMT)"
	,
	"TABARA (NEAMT)"
	,
	"TALPA (NEAMT)"
	,
	"TALPALAI (NEAMT)"
	,
	"TAMASENI (NEAMT)"
	,
	"TARCAU (NEAMT)"
	,
	"TARDENII MICI (NEAMT)"
	,
	"TARGU NEAMT (NEAMT)"
	,
	"TARPESTI (NEAMT)"
	,
	"TARZIA (NEAMT)"
	,
	"TASCA (NEAMT)"
	,
	"TAZLAU (NEAMT)"
	,
	"TELEC (NEAMT)"
	,
	"TETCANI (NEAMT)"
	,
	"TIBUCANI (NEAMT)"
	,
	"TIBUCANII DE JOS (NEAMT)"
	,
	"TICOS (NEAMT)"
	,
	"TICOS-FLOAREA (NEAMT)"
	,
	"TIMISESTI (NEAMT)"
	,
	"TODIRENI (NEAMT)"
	,
	"TOLICI (NEAMT)"
	,
	"TOPOLICENI (NEAMT)"
	,
	"TOPOLITA (NEAMT)"
	,
	"TOTOIESTI (NEAMT)"
	,
	"TRAIAN (SABAOANI) (NEAMT)"
	,
	"TRAIAN (ZANESTI) (NEAMT)"
	,
	"TREI FANTANI (NEAMT)"
	,
	"TRIFESTI (NEAMT)"
	,
	"TUPILATI (NEAMT)"
	,
	"TURTURESTI (NEAMT)"
	,
	"TUTCANII DIN DEAL (NEAMT)"
	,
	"TUTCANII DIN VALE (NEAMT)"
	,
	"UNCESTI (NEAMT)"
	,
	"UNGHENI (NEAMT)"
	,
	"UNGHI (NEAMT)"
	,
	"URECHENI (NEAMT)"
	,
	"VAD (NEAMT)"
	,
	"VADURELE (ALEXANDRU CEL BUN) (NEAMT)"
	,
	"VADURELE (CANDESTI) (NEAMT)"
	,
	"VADURI (NEAMT)"
	,
	"VALEA ALBA (NEAMT)"
	,
	"VALEA ARINI (NEAMT)"
	,
	"VALEA ENEI (NEAMT)"
	,
	"VALEA MARE (NEAMT)"
	,
	"VALEA SEACA (NEAMT)"
	,
	"VALEA URSULUI (NEAMT)"
	,
	"VALENI (BOTESTI) (NEAMT)"
	,
	"VALENI (PIATRA-NEAMT) (NEAMT)"
	,
	"VANATORI-NEAMT (NEAMT)"
	,
	"VARATEC (NEAMT)"
	,
	"VEJA (NEAMT)"
	,
	"VERSESTI (NEAMT)"
	,
	"VIISOARA (NEAMT)"
	,
	"VLADICENI (NEAMT)"
	,
	"VLADNICELE (NEAMT)"
	,
	"VULPASESTI (NEAMT)"
	,
	"ZANESTI (NEAMT)"
	,
	"ZVORANESTI (NEAMT)"
	,
	"AFUMATI (OLT)"
	,
	"ALBESTI (OLT)"
	,
	"ALIMANESTI (OLT)"
	,
	"ALUNISU (OLT)"
	,
	"ARCESTI (OLT)"
	,
	"ARCESTI-COT (OLT)"
	,
	"ARVATEASCA (OLT)"
	,
	"BABICIU (OLT)"
	,
	"BACEA (OLT)"
	,
	"BAGESTI (OLT)"
	,
	"BALANESTI (OLT)"
	,
	"BALDOVINESTI (OLT)"
	,
	"BALEASA (OLT)"
	,
	"BALS (OLT)"
	,
	"BALTATI (OLT)"
	,
	"BALTENI (OLT)"
	,
	"BARASTI (OLT)"
	,
	"BARASTI (COLONESTI) (OLT)"
	,
	"BARASTI (MORUNGLAV) (OLT)"
	,
	"BARASTII DE CEPTURI (OLT)"
	,
	"BARASTII DE VEDE (OLT)"
	,
	"BARBALAI (OLT)"
	,
	"BARCA (OLT)"
	,
	"BARCANESTI (OLT)"
	,
	"BARSESTII DE SUS (OLT)"
	,
	"BARZA (OLT)"
	,
	"BATARENI (OLT)"
	,
	"BATIA (OLT)"
	,
	"BECHET (OLT)"
	,
	"BECULESTI (OLT)"
	,
	"BELGUN (OLT)"
	,
	"BERIA DE JOS (OLT)"
	,
	"BERIA DE SUS (OLT)"
	,
	"BERINDEI (OLT)"
	,
	"BIRCII (OLT)"
	,
	"BISTRITA NOUA (OLT)"
	,
	"BLAJ (OLT)"
	,
	"BOBICESTI (OLT)"
	,
	"BOBU (OLT)"
	,
	"BONDREA (OLT)"
	,
	"BOROESTI (OLT)"
	,
	"BRANCOVENI (OLT)"
	,
	"BRANET (OLT)"
	,
	"BRASTAVATU (OLT)"
	,
	"BREBENI (OLT)"
	,
	"BROSTENI (OLT)"
	,
	"BUCINISU (OLT)"
	,
	"BUCINISU MIC (OLT)"
	,
	"BUICESTI (OLT)"
	,
	"BULIMANU (OLT)"
	,
	"BURDULESTI (OLT)"
	,
	"BUSCA (OLT)"
	,
	"BUTA (OLT)"
	,
	"BUTOI (OLT)"
	,
	"BUZESTI (OLT)"
	,
	"CALINESTI (OLT)"
	,
	"CALUI (OLT)"
	,
	"CAMPU MARE (OLT)"
	,
	"CAMPU PARULUI (OLT)"
	,
	"CANDELESTI (OLT)"
	,
	"CARACAL (OLT)"
	,
	"CARLOGANI (OLT)"
	,
	"CARSTANI (OLT)"
	,
	"CATANELE (OLT)"
	,
	"CAZANESTI (OLT)"
	,
	"CEPARI (OLT)"
	,
	"CEPESTI (OLT)"
	,
	"CERBENI (OLT)"
	,
	"CEZIENI (OLT)"
	,
	"CHELBESTI (OLT)"
	,
	"CHERLESTII DIN DEAL (OLT)"
	,
	"CHERLESTII MOSTENI (OLT)"
	,
	"CHILIA (OLT)"
	,
	"CHILII (OLT)"
	,
	"CHINTESTI (OLT)"
	,
	"CHITEASCA (OLT)"
	,
	"CILIENI (OLT)"
	,
	"CIOCANESTI (OLT)"
	,
	"CIOFLANU (OLT)"
	,
	"CIORACA (OLT)"
	,
	"CIOROIASU (OLT)"
	,
	"CIOROIU (OLT)"
	,
	"CIREASOV (OLT)"
	,
	"CIURESTI (OLT)"
	,
	"COCORASTI (OLT)"
	,
	"COJGAREI (OLT)"
	,
	"COLIBASI (OLT)"
	,
	"COLONESTI (OLT)"
	,
	"COMANCA (OLT)"
	,
	"COMANESTI (OLT)"
	,
	"COMANI (OLT)"
	,
	"COMANITA (OLT)"
	,
	"CONSTANTINESTI (OLT)"
	,
	"CORABIA (OLT)"
	,
	"CORBENI (OLT)"
	,
	"CORBU (OLT)"
	,
	"CORBU (TESLUI) (OLT)"
	,
	"CORLATESTI (OLT)"
	,
	"CORNATELU (OLT)"
	,
	"COTEANA (OLT)"
	,
	"COTENI (OLT)"
	,
	"COTORBESTI (OLT)"
	,
	"CRACIUNEI (OLT)"
	,
	"CRAMPOIA (OLT)"
	,
	"CRETI (OLT)"
	,
	"CRIVA DE JOS (OLT)"
	,
	"CRIVA DE SUS (OLT)"
	,
	"CRUSOVU (OLT)"
	,
	"CUCUETI (OLT)"
	,
	"CUNGREA (OLT)"
	,
	"CURTISOARA (OLT)"
	,
	"CURTISOARA (DOBRETU) (OLT)"
	,
	"CUZA VODA (OLT)"
	,
	"DAMBURILE (OLT)"
	,
	"DANEASA (OLT)"
	,
	"DAVIDESTI (OLT)"
	,
	"DEJESTI (OLT)"
	,
	"DELENI (OLT)"
	,
	"DEVESELU (OLT)"
	,
	"DIENCI (OLT)"
	,
	"DOANCA (OLT)"
	,
	"DOBA (OLT)"
	,
	"DOBRETU (OLT)"
	,
	"DOBRICENI (OLT)"
	,
	"DOBROSLOVENI (OLT)"
	,
	"DOBROTEASA (OLT)"
	,
	"DOBROTINET (OLT)"
	,
	"DOBRUN (OLT)"
	,
	"DONESTI (OLT)"
	,
	"DRAGANESTI-OLT (OLT)"
	,
	"DRAGHICENI (OLT)"
	,
	"DRANOVATU (OLT)"
	,
	"DUMITRESTI (OLT)"
	,
	"ENOSESTI (OLT)"
	,
	"FAGETELU (OLT)"
	,
	"FALCOIU (OLT)"
	,
	"FARCASELE (OLT)"
	,
	"FARCASU DE JOS (OLT)"
	,
	"FLORU (OLT)"
	,
	"FRASINET-GARA (OLT)"
	,
	"FRASINETU (OLT)"
	,
	"FRUNZARU (OLT)"
	,
	"GANEASA (OLT)"
	,
	"GARCOV (OLT)"
	,
	"GAVANESTI (OLT)"
	,
	"GHIMPATI (OLT)"
	,
	"GHIMPETENI (OLT)"
	,
	"GHIMPETENII NOI (OLT)"
	,
	"GHIOSANI (OLT)"
	,
	"GIUVARASTI (OLT)"
	,
	"GOSTAVATU (OLT)"
	,
	"GOVORA (OLT)"
	,
	"GRADINARI (OLT)"
	,
	"GRADINILE (OLT)"
	,
	"GRADISTEA (OLT)"
	,
	"GRECI (OSICA DE SUS) (OLT)"
	,
	"GRECI (SCHITU) (OLT)"
	,
	"GREERESTI (OLT)"
	,
	"GROJDIBODU (OLT)"
	,
	"GROPSANI (OLT)"
	,
	"GROZAVESTI (OLT)"
	,
	"GRUIU (OLT)"
	,
	"GUBANDRU (OLT)"
	,
	"GUESTI (OLT)"
	,
	"GURA CALUIU (OLT)"
	,
	"GURA PADINII (OLT)"
	,
	"HOREZU (OLT)"
	,
	"HOTARANI (OLT)"
	,
	"HOTARU (OLT)"
	,
	"IANCA (OLT)"
	,
	"IANCA NOUA (OLT)"
	,
	"IANCU JIANU (OLT)"
	,
	"IBANESTI (OLT)"
	,
	"ICOANA (OLT)"
	,
	"IONICESTI (OLT)"
	,
	"IPOTESTI (OLT)"
	,
	"ISACI (OLT)"
	,
	"IZBICENI (OLT)"
	,
	"IZVOARELE (OLT)"
	,
	"IZVORU (OLT)"
	,
	"JIENI (OLT)"
	,
	"JITARU (OLT)"
	,
	"LAUNELE (OLT)"
	,
	"LAZARESTI (OLT)"
	,
	"LELEASCA (OLT)"
	,
	"LEOTESTI (OLT)"
	,
	"LIICENI (OLT)"
	,
	"LINIA DIN VALE (OLT)"
	,
	"LISA (OLT)"
	,
	"LUNCA (OLT)"
	,
	"MAGURA (PERIETI) (OLT)"
	,
	"MAGURA (TATULESTI) (OLT)"
	,
	"MALU ROSU (OLT)"
	,
	"MAMURA (OLT)"
	,
	"MANDRA (OLT)"
	,
	"MANULESTI (OLT)"
	,
	"MARDALE (OLT)"
	,
	"MARGARITESTI (OLT)"
	,
	"MARGHENI (OLT)"
	,
	"MARGINENI-SLOBOZIA (OLT)"
	,
	"MARUNTEI (OLT)"
	,
	"MARUNTEI (COLONESTI) (OLT)"
	,
	"MERENI (OLT)"
	,
	"MIERLESTII DE SUS (OLT)"
	,
	"MIERLICESTI (OLT)"
	,
	"MIESTI (OLT)"
	,
	"MIHAESTI (OLT)"
	,
	"MIHAILESTI-POPESTI (OLT)"
	,
	"MILCOV (OLT)"
	,
	"MILCOVENI (OLT)"
	,
	"MILCOVU DIN DEAL (OLT)"
	,
	"MILCOVU DIN VALE (OLT)"
	,
	"MIRCESTI (OLT)"
	,
	"MIRILA (OLT)"
	,
	"MOGOSESTI (OLT)"
	,
	"MOMAIU (OLT)"
	,
	"MORUNESTI (OLT)"
	,
	"MORUNGLAV (OLT)"
	,
	"MOSTENI (OLT)"
	,
	"MOTOESTI (OLT)"
	,
	"MOVILENI (OLT)"
	,
	"NAVARGENI (OLT)"
	,
	"NEGRENI (OLT)"
	,
	"NICOLAE TITULESCU (OLT)"
	,
	"OBARSIA (OLT)"
	,
	"OBARSIA NOUA (OLT)"
	,
	"OBOGA (OLT)"
	,
	"OCIOGI (OLT)"
	,
	"OLARI (OLT)"
	,
	"OLTISORU (OLT)"
	,
	"OPORELU (OLT)"
	,
	"OPTASANI (OLT)"
	,
	"OPTASI (OLT)"
	,
	"OPTASI-MAGURA (OLT)"
	,
	"ORLEA (OLT)"
	,
	"ORLEA NOUA (OLT)"
	,
	"OSICA DE JOS (OLT)"
	,
	"OSICA DE SUS (OLT)"
	,
	"OSTROV (OLT)"
	,
	"OTESTII DE JOS (OLT)"
	,
	"OTESTII DE SUS (OLT)"
	,
	"PARSCOVENI (OLT)"
	,
	"PERETU (OLT)"
	,
	"PERIETI (OLT)"
	,
	"PESCARESTI (OLT)"
	,
	"PESTRA (OLT)"
	,
	"PETCULESTI (OLT)"
	,
	"PIATRA (OLT)"
	,
	"PIATRA-OLT (OLT)"
	,
	"PIELCANI (OLT)"
	,
	"PIETRIS (OLT)"
	,
	"PIETRISU (OLT)"
	,
	"PISCANI (OLT)"
	,
	"PLAVICEANCA (OLT)"
	,
	"PLAVICENI (OLT)"
	,
	"PLESOIU (OLT)"
	,
	"PLOPSORELU (OLT)"
	,
	"POBORU (OLT)"
	,
	"POGANU (OLT)"
	,
	"POIANA (OLT)"
	,
	"POIANA MARE (OLT)"
	,
	"POPESTI (BARASTI) (OLT)"
	,
	"POPESTI (VALENI) (OLT)"
	,
	"POTCOAVA (OLT)"
	,
	"POTCOAVA-FALCOENI (OLT)"
	,
	"POTELU (OLT)"
	,
	"POTLOGENI (OLT)"
	,
	"POTOPINU (OLT)"
	,
	"PREOTESTI (OLT)"
	,
	"PRISACA (OLT)"
	,
	"PRISEACA (OLT)"
	,
	"PROASPETI (OLT)"
	,
	"PROFA (OLT)"
	,
	"RACOVITA (OLT)"
	,
	"RADESTI (OLT)"
	,
	"RADOMIRESTI (OLT)"
	,
	"RAITIU (OLT)"
	,
	"RECEA (OLT)"
	,
	"REDEA (OLT)"
	,
	"REDISOARA (OLT)"
	,
	"RESCA (OLT)"
	,
	"RESCUTA (OLT)"
	,
	"ROMANA (OLT)"
	,
	"ROSIENII MARI (OLT)"
	,
	"ROSIENII MICI (OLT)"
	,
	"ROTUNDA (OLT)"
	,
	"RUDARI (OLT)"
	,
	"RUNCU MARE (OLT)"
	,
	"RUSANESTI (OLT)"
	,
	"RUSANESTII DE SUS (OLT)"
	,
	"RUSCIORI (OLT)"
	,
	"SALCIA (OLT)"
	,
	"SALTANESTI (OLT)"
	,
	"SAMBURESTI (OLT)"
	,
	"SATU NOU (GRADINARI) (OLT)"
	,
	"SATU NOU (ORLEA) (OLT)"
	,
	"SCARISOARA (OLT)"
	,
	"SCHITU (OLT)"
	,
	"SCHITU DELENI (OLT)"
	,
	"SCHITU DIN DEAL (OLT)"
	,
	"SCHITU DIN VALE (OLT)"
	,
	"SCORBURA (OLT)"
	,
	"SCORNICESTI (OLT)"
	,
	"SEACA (OLT)"
	,
	"SEACA (POBORU) (OLT)"
	,
	"SERBANESTI (OLT)"
	,
	"SERBANESTII DE SUS (OLT)"
	,
	"SIMNICENI (OLT)"
	,
	"SINESTI (OLT)"
	,
	"SLATINA (OLT)"
	,
	"SLATIOARA (OLT)"
	,
	"SLAVENI (OLT)"
	,
	"SOPARLITA (OLT)"
	,
	"SPATARU (OLT)"
	,
	"SPINENI (OLT)"
	,
	"SPRANCENATA (OLT)"
	,
	"STANULEASA (SAMBURESTI) (OLT)"
	,
	"STANULEASA (VITOMIRESTI) (OLT)"
	,
	"STAVARU (OLT)"
	,
	"STEFAN CEL MARE (OLT)"
	,
	"STEJARU (OLT)"
	,
	"STOBORASTI (OLT)"
	,
	"STOENESTI (OLT)"
	,
	"STOICANESTI (OLT)"
	,
	"STREJESTI (OLT)"
	,
	"STREJESTII DE SUS (OLT)"
	,
	"STRUGURELU (OLT)"
	,
	"STUDINA (OLT)"
	,
	"STUDINITA (OLT)"
	,
	"STUPINA (OLT)"
	,
	"SUICA (OLT)"
	,
	"SURPENI (OLT)"
	,
	"TABACI (OLT)"
	,
	"TABONU (OLT)"
	,
	"TATULESTI (OLT)"
	,
	"TEIS (OLT)"
	,
	"TEIUS (OLT)"
	,
	"TEIUSU (OLT)"
	,
	"TESLUI (OLT)"
	,
	"TIA MARE (OLT)"
	,
	"TIRISNEAG (OLT)"
	,
	"TOMENI (OLT)"
	,
	"TONESTI (LELEASCA) (OLT)"
	,
	"TONESTI (SAMBURESTI) (OLT)"
	,
	"TOPANA (OLT)"
	,
	"TRAIAN (OLT)"
	,
	"TREPTENI (OLT)"
	,
	"TRUFINESTI (OLT)"
	,
	"TUDOR VLADIMIRESCU (OLT)"
	,
	"TUFARU (OLT)"
	,
	"TUFENI (OLT)"
	,
	"TURIA (OLT)"
	,
	"ULMET (OLT)"
	,
	"ULMI (OLT)"
	,
	"UNGURENI (OLT)"
	,
	"URIA (OLT)"
	,
	"URSA (OLT)"
	,
	"URSI (OLT)"
	,
	"URSOAIA (OLT)"
	,
	"URZICA (OLT)"
	,
	"VADASTRA (OLT)"
	,
	"VADASTRITA (OLT)"
	,
	"VALCELE (OLT)"
	,
	"VALCELELE DE SUS (OLT)"
	,
	"VALEA FETEI (OLT)"
	,
	"VALEA LUI ALB (OLT)"
	,
	"VALEA MARE (OLT)"
	,
	"VALEA MERILOR (OLT)"
	,
	"VALEA SATULUI (OLT)"
	,
	"VALEA SOARELUI (OLT)"
	,
	"VALENI (OLT)"
	,
	"VALENI (BRANCOVENI) (OLT)"
	,
	"VANESTI (OLT)"
	,
	"VARTOPU (OLT)"
	,
	"VERGULEASA (OLT)"
	,
	"VINETI (OLT)"
	,
	"VISINA (OLT)"
	,
	"VISINA NOUA (OLT)"
	,
	"VITANESTI (OLT)"
	,
	"VITOMIRESTI (OLT)"
	,
	"VLADILA (OLT)"
	,
	"VLADILA NOUA (OLT)"
	,
	"VLADULENI (OLT)"
	,
	"VLAICI (OLT)"
	,
	"VLANGARESTI (OLT)"
	,
	"VOINEASA (OLT)"
	,
	"VULPENI (OLT)"
	,
	"VULPESTI (OLT)"
	,
	"VULTURESTI (OLT)"
	,
	"ZANOAGA (OLT)"
	,
	"ZORLEASCA (OLT)"
	,
	"ADUNATI (PRAHOVA)"
	,
	"ALBESTI-MURU (PRAHOVA)"
	,
	"ALBESTI-PALEOLOGU (PRAHOVA)"
	,
	"ALBINARI (PRAHOVA)"
	,
	"ALUNIS (PRAHOVA)"
	,
	"ANTOFILOAIA (PRAHOVA)"
	,
	"APOSTOLACHE (PRAHOVA)"
	,
	"ARICESTII RAHTIVANI (PRAHOVA)"
	,
	"ARICESTII ZELETIN (PRAHOVA)"
	,
	"ARIONESTII NOI (PRAHOVA)"
	,
	"ARIONESTII VECHI (PRAHOVA)"
	,
	"ARVA (PRAHOVA)"
	,
	"AZUGA (PRAHOVA)"
	,
	"BABA ANA (PRAHOVA)"
	,
	"BAICOI (PRAHOVA)"
	,
	"BALTA DOAMNEI (PRAHOVA)"
	,
	"BALTESTI (PRAHOVA)"
	,
	"BALTITA (PRAHOVA)"
	,
	"BANESTI (PRAHOVA)"
	,
	"BARA (PRAHOVA)"
	,
	"BARAITARU (PRAHOVA)"
	,
	"BARCANESTI (PRAHOVA)"
	,
	"BARZILA (PRAHOVA)"
	,
	"BATESTI (PRAHOVA)"
	,
	"BATRANI (PRAHOVA)"
	,
	"BELCIUG (PRAHOVA)"
	,
	"BERCENI (PRAHOVA)"
	,
	"BERTEA (PRAHOVA)"
	,
	"BIGHILIN (PRAHOVA)"
	,
	"BLEJOI (PRAHOVA)"
	,
	"BOBICESTI (PRAHOVA)"
	,
	"BOBOCI (PRAHOVA)"
	,
	"BOBOLIA (PRAHOVA)"
	,
	"BODESTI (PRAHOVA)"
	,
	"BOGDANESTI (PRAHOVA)"
	,
	"BOLDESTI (PRAHOVA)"
	,
	"BOLDESTI-GRADISTEA (PRAHOVA)"
	,
	"BOLDESTI-SCAENI (PRAHOVA)"
	,
	"BORDENII MARI (PRAHOVA)"
	,
	"BORDENII MICI (PRAHOVA)"
	,
	"BOSILCESTI (PRAHOVA)"
	,
	"BOZIENI (PRAHOVA)"
	,
	"BRADET (PRAHOVA)"
	,
	"BRATASANCA (PRAHOVA)"
	,
	"BRATESTI (PRAHOVA)"
	,
	"BRAZI (PRAHOVA)"
	,
	"BRAZII DE JOS (PRAHOVA)"
	,
	"BRAZII DE SUS (PRAHOVA)"
	,
	"BREAZA (PRAHOVA)"
	,
	"BREAZA DE JOS (PRAHOVA)"
	,
	"BREAZA DE SUS (PRAHOVA)"
	,
	"BREBU (PRAHOVA)"
	,
	"BREBU MANASTIREI (PRAHOVA)"
	,
	"BREBU MEGIESESC (PRAHOVA)"
	,
	"BUCHILASI (PRAHOVA)"
	,
	"BUCOV (PRAHOVA)"
	,
	"BUDA (ARICESTII RAHTIVANI) (PRAHOVA)"
	,
	"BUDA (RAFOV) (PRAHOVA)"
	,
	"BUGHEA DE JOS (PRAHOVA)"
	,
	"BUGHEA DE SUS (PRAHOVA)"
	,
	"BUSTENARI (PRAHOVA)"
	,
	"BUSTENI (PRAHOVA)"
	,
	"BUTUCI (PRAHOVA)"
	,
	"BUZOTA (PRAHOVA)"
	,
	"CALINESTI (PRAHOVA)"
	,
	"CALUGARENI (PRAHOVA)"
	,
	"CAMPINA (PRAHOVA)"
	,
	"CAP ROSU (PRAHOVA)"
	,
	"CARBUNARI (PRAHOVA)"
	,
	"CARBUNESTI (PRAHOVA)"
	,
	"CARJARI (PRAHOVA)"
	,
	"CARTIERUL DAMBU (PRAHOVA)"
	,
	"CATINA (PRAHOVA)"
	,
	"CATUNU (BERCENI) (PRAHOVA)"
	,
	"CATUNU (DRAJNA) (PRAHOVA)"
	,
	"CEPTURA (PRAHOVA)"
	,
	"CEPTURA DE JOS (PRAHOVA)"
	,
	"CEPTURA DE SUS (PRAHOVA)"
	,
	"CERASU (PRAHOVA)"
	,
	"CERNESTI (PRAHOVA)"
	,
	"CHEIA (PRAHOVA)"
	,
	"CHERBA (PRAHOVA)"
	,
	"CHESNOIU (PRAHOVA)"
	,
	"CHICIURENI (PRAHOVA)"
	,
	"CHIOJDEANCA (PRAHOVA)"
	,
	"CHIRITESTI (PRAHOVA)"
	,
	"CHITORANI (PRAHOVA)"
	,
	"CIOCENI (PRAHOVA)"
	,
	"CIOCRAC (PRAHOVA)"
	,
	"CIORANI (PRAHOVA)"
	,
	"CIORANII DE JOS (PRAHOVA)"
	,
	"CIORANII DE SUS (PRAHOVA)"
	,
	"CIRESANU (PRAHOVA)"
	,
	"CIUPELNITA (PRAHOVA)"
	,
	"COADA IZVORULUI (PRAHOVA)"
	,
	"COADA MALULUI (PRAHOVA)"
	,
	"COCEANA (PRAHOVA)"
	,
	"COCORASTII CAPLII (PRAHOVA)"
	,
	"COCORASTII COLT (PRAHOVA)"
	,
	"COCORASTII GRIND (PRAHOVA)"
	,
	"COCORASTII MISLII (PRAHOVA)"
	,
	"COCOSESTI (PRAHOVA)"
	,
	"COLCEAG (PRAHOVA)"
	,
	"COLONIA BRAZI (PRAHOVA)"
	,
	"COLTU DE JOS (PRAHOVA)"
	,
	"COMARNIC (PRAHOVA)"
	,
	"CONDURATU (PRAHOVA)"
	,
	"CORLATESTI (PRAHOVA)"
	,
	"CORNU (PRAHOVA)"
	,
	"CORNU DE JOS (CORNU) (PRAHOVA)"
	,
	"CORNU DE JOS (DRAGANESTI) (PRAHOVA)"
	,
	"CORNU DE SUS (CORNU) (PRAHOVA)"
	,
	"CORNU DE SUS (DUMBRAVA) (PRAHOVA)"
	,
	"COSERELE (PRAHOVA)"
	,
	"COSLEGI (PRAHOVA)"
	,
	"COSMINA DE JOS (PRAHOVA)"
	,
	"COSMINA DE SUS (PRAHOVA)"
	,
	"COSMINELE (PRAHOVA)"
	,
	"COSTENI (PRAHOVA)"
	,
	"COTOFENESTI (PRAHOVA)"
	,
	"CRANGURILE (PRAHOVA)"
	,
	"CRIVINA (PRAHOVA)"
	,
	"CUIB (PRAHOVA)"
	,
	"CURCUBEU (PRAHOVA)"
	,
	"CURMATURA (PRAHOVA)"
	,
	"DAMBU (PRAHOVA)"
	,
	"DARVARI (PRAHOVA)"
	,
	"DITESTI (PRAHOVA)"
	,
	"DOBROTA (PRAHOVA)"
	,
	"DOFTANA (PRAHOVA)"
	,
	"DRAGANEASA (PRAHOVA)"
	,
	"DRAGANESTI (PRAHOVA)"
	,
	"DRAGHICESTI (PRAHOVA)"
	,
	"DRAJNA (PRAHOVA)"
	,
	"DRAJNA DE JOS (PRAHOVA)"
	,
	"DRAJNA DE SUS (PRAHOVA)"
	,
	"DUMBRAVA (PRAHOVA)"
	,
	"DUMBRAVESTI (PRAHOVA)"
	,
	"EZENI (PRAHOVA)"
	,
	"FACAIENI (PRAHOVA)"
	,
	"FAGET (PRAHOVA)"
	,
	"FAGETU (PRAHOVA)"
	,
	"FANARI (GHERGHITA) (PRAHOVA)"
	,
	"FANARI (GORGOTA) (PRAHOVA)"
	,
	"FANTANELE (PRAHOVA)"
	,
	"FEFELEI (PRAHOVA)"
	,
	"FILIPESTII DE PADURE (PRAHOVA)"
	,
	"FILIPESTII DE TARG (PRAHOVA)"
	,
	"FLORESTI (PRAHOVA)"
	,
	"FRASINET (PRAHOVA)"
	,
	"FULGA (PRAHOVA)"
	,
	"FULGA DE JOS (PRAHOVA)"
	,
	"FULGA DE SUS (PRAHOVA)"
	,
	"FUNDENI (PRAHOVA)"
	,
	"GAGENI (PRAHOVA)"
	,
	"GALMEIA (PRAHOVA)"
	,
	"GAVANEL (PRAHOVA)"
	,
	"GHEABA (PRAHOVA)"
	,
	"GHERGHITA (PRAHOVA)"
	,
	"GHIGHIU (PRAHOVA)"
	,
	"GHINOAICA (PRAHOVA)"
	,
	"GHIOCEL (PRAHOVA)"
	,
	"GHIOLDUM (PRAHOVA)"
	,
	"GHIOSESTI (PRAHOVA)"
	,
	"GLOD (PRAHOVA)"
	,
	"GOGA (PRAHOVA)"
	,
	"GOGEASCA (PRAHOVA)"
	,
	"GORGOTA (PRAHOVA)"
	,
	"GORNET (PRAHOVA)"
	,
	"GORNET-CRICOV (PRAHOVA)"
	,
	"GORUNA (PRAHOVA)"
	,
	"GRADISTEA (PRAHOVA)"
	,
	"GRESIA (PRAHOVA)"
	,
	"GROSANI (PRAHOVA)"
	,
	"GURA BELIEI (PRAHOVA)"
	,
	"GURA CRIVATULUI (PRAHOVA)"
	,
	"GURA VADULUI (PRAHOVA)"
	,
	"GURA VITIOAREI (PRAHOVA)"
	,
	"HABUD (PRAHOVA)"
	,
	"HARSA (PRAHOVA)"
	,
	"HATCARAU (PRAHOVA)"
	,
	"HOMORACIU (PRAHOVA)"
	,
	"IAZU (PRAHOVA)"
	,
	"INDEPENDENTA (PRAHOVA)"
	,
	"INOTESTI (PRAHOVA)"
	,
	"IORDACHEANU (PRAHOVA)"
	,
	"IRIMESTI (PRAHOVA)"
	,
	"IZESTI (PRAHOVA)"
	,
	"IZVOARELE (PRAHOVA)"
	,
	"IZVORU (PRAHOVA)"
	,
	"JERCALAI (PRAHOVA)"
	,
	"JUGURENI (PRAHOVA)"
	,
	"LACU TURCULUI (PRAHOVA)"
	,
	"LAPOS (PRAHOVA)"
	,
	"LAPOSEL (PRAHOVA)"
	,
	"LILIESTI (PRAHOVA)"
	,
	"LIPANESTI (PRAHOVA)"
	,
	"LIVADEA (PRAHOVA)"
	,
	"LOLOIASCA (PRAHOVA)"
	,
	"LOPATNITA (PRAHOVA)"
	,
	"LUNCA MARE (PRAHOVA)"
	,
	"LUNCA PRAHOVEI (PRAHOVA)"
	,
	"LUTU ROSU (PRAHOVA)"
	,
	"MAGULA (PRAHOVA)"
	,
	"MAGURA (PRAHOVA)"
	,
	"MAGURELE (PRAHOVA)"
	,
	"MAGURENI (PRAHOVA)"
	,
	"MALAESTII DE JOS (PRAHOVA)"
	,
	"MALAESTII DE SUS (PRAHOVA)"
	,
	"MALAIESTI (PRAHOVA)"
	,
	"MALAMUC (PRAHOVA)"
	,
	"MALU ROSU (PRAHOVA)"
	,
	"MALU VANAT (PRAHOVA)"
	,
	"MANASTIREA SUZANA (PRAHOVA)"
	,
	"MANECIU (PRAHOVA)"
	,
	"MANECIU-PAMANTENI (PRAHOVA)"
	,
	"MANECIU-UNGURENI (PRAHOVA)"
	,
	"MANESTI (PRAHOVA)"
	,
	"MARGINEA PADURII (PRAHOVA)"
	,
	"MARGINENII DE JOS (PRAHOVA)"
	,
	"MARLOGEA (PRAHOVA)"
	,
	"MARUNTIS (PRAHOVA)"
	,
	"MATITA (PRAHOVA)"
	,
	"MEHEDINTA (PRAHOVA)"
	,
	"MELICESTI (PRAHOVA)"
	,
	"MERDEALA (PRAHOVA)"
	,
	"MERI (PRAHOVA)"
	,
	"MINIERI (PRAHOVA)"
	,
	"MIRESU MARE (PRAHOVA)"
	,
	"MIRESU MIC (PRAHOVA)"
	,
	"MIROSLAVESTI (PRAHOVA)"
	,
	"MISLEA (PRAHOVA)"
	,
	"MIZIL (PRAHOVA)"
	,
	"MOARA (PRAHOVA)"
	,
	"MOARA DOMNEASCA (PRAHOVA)"
	,
	"MOARA NOUA (PRAHOVA)"
	,
	"MOCESTI (PRAHOVA)"
	,
	"NEDELEA (PRAHOVA)"
	,
	"NEGOIESTI (PRAHOVA)"
	,
	"NEVESTEASCA (PRAHOVA)"
	,
	"NISIPOASA (PRAHOVA)"
	,
	"NISTORESTI (PRAHOVA)"
	,
	"NOVACESTI (PRAHOVA)"
	,
	"NUCET (CHIOJDEANCA) (PRAHOVA)"
	,
	"NUCET (GORNET) (PRAHOVA)"
	,
	"NUCSOARA DE JOS (PRAHOVA)"
	,
	"NUCSOARA DE SUS (PRAHOVA)"
	,
	"OCINA DE JOS (PRAHOVA)"
	,
	"OCINA DE SUS (PRAHOVA)"
	,
	"ODAILE (PRAHOVA)"
	,
	"OGRETIN (PRAHOVA)"
	,
	"OLARI (PRAHOVA)"
	,
	"OLARII VECHI (PRAHOVA)"
	,
	"OLOGENI (PRAHOVA)"
	,
	"OLTENI (PRAHOVA)"
	,
	"ORZOAIA DE JOS (PRAHOVA)"
	,
	"ORZOAIA DE SUS (PRAHOVA)"
	,
	"OSTROVU (PRAHOVA)"
	,
	"PACURETI (PRAHOVA)"
	,
	"PACURI (PRAHOVA)"
	,
	"PALANCA (PRAHOVA)"
	,
	"PANTAZI (PRAHOVA)"
	,
	"PAREPA-RUSANI (PRAHOVA)"
	,
	"PAULESTI (PRAHOVA)"
	,
	"PAULESTII NOI (PRAHOVA)"
	,
	"PERSUNARI (GURA VADULUI) (PRAHOVA)"
	,
	"PERSUNARI (MANESTI) (PRAHOVA)"
	,
	"PIATRA (DRAJNA) (PRAHOVA)"
	,
	"PIATRA (MANESTI) (PRAHOVA)"
	,
	"PIATRA (PROVITA DE JOS) (PRAHOVA)"
	,
	"PIATRA MICA (PRAHOVA)"
	,
	"PIETRICEAUA (PRAHOVA)"
	,
	"PIETRICICA (PRAHOVA)"
	,
	"PIETRISU (PRAHOVA)"
	,
	"PIETROSANI (PRAHOVA)"
	,
	"PIORESTI (PRAHOVA)"
	,
	"PISCULESTI (PRAHOVA)"
	,
	"PITIGOI (PRAHOVA)"
	,
	"PLAI (PRAHOVA)"
	,
	"PLAIETU (PRAHOVA)"
	,
	"PLAIU (PROVITA DE SUS) (PRAHOVA)"
	,
	"PLAIU (TALEA) (PRAHOVA)"
	,
	"PLAIU CAMPINEI (PRAHOVA)"
	,
	"PLAIU CORNULUI (PRAHOVA)"
	,
	"PLAVIA (PRAHOVA)"
	,
	"PLEASA (PRAHOVA)"
	,
	"PLOIESTI (PRAHOVA)"
	,
	"PLOIESTIORI (PRAHOVA)"
	,
	"PLOPENI (PRAHOVA)"
	,
	"PLOPENI (DUMBRAVESTI) (PRAHOVA)"
	,
	"PLOPU (PRAHOVA)"
	,
	"PODENII NOI (PRAHOVA)"
	,
	"PODENII VECHI (PRAHOVA)"
	,
	"PODGORIA (PRAHOVA)"
	,
	"PODU CHEII (PRAHOVA)"
	,
	"PODU CORBULUI (PRAHOVA)"
	,
	"PODU LUI GALBEN (PRAHOVA)"
	,
	"PODU LUNG (PRAHOVA)"
	,
	"PODU URSULUI (PRAHOVA)"
	,
	"PODU VADULUI (PRAHOVA)"
	,
	"PODU VALENI (PRAHOVA)"
	,
	"PODURILE (PRAHOVA)"
	,
	"POIANA (PRAHOVA)"
	,
	"POIANA CAMPINA (PRAHOVA)"
	,
	"POIANA COPACENI (PRAHOVA)"
	,
	"POIANA MARE (PRAHOVA)"
	,
	"POIANA MIERLEI (PRAHOVA)"
	,
	"POIANA TAPULUI (PRAHOVA)"
	,
	"POIANA TRESTIEI (PRAHOVA)"
	,
	"POIANA VARBILAU (PRAHOVA)"
	,
	"POIENARII APOSTOLI (PRAHOVA)"
	,
	"POIENARII BURCHII (PRAHOVA)"
	,
	"POIENARII-RALI (PRAHOVA)"
	,
	"POIENARII VECHI (PRAHOVA)"
	,
	"POIENILE (PRAHOVA)"
	,
	"POPESTI (BRAZI) (PRAHOVA)"
	,
	"POPESTI (PODENII NOI) (PRAHOVA)"
	,
	"POSADA (PRAHOVA)"
	,
	"POSESTI (PRAHOVA)"
	,
	"POSESTII-PAMANTENI (PRAHOVA)"
	,
	"POSESTII-UNGURENI (PRAHOVA)"
	,
	"POTIGRAFU (PRAHOVA)"
	,
	"PRAJANI (PRAHOVA)"
	,
	"PREDEAL (PRAHOVA)"
	,
	"PREDEAL-SARARI (PRAHOVA)"
	,
	"PREDESTI (PRAHOVA)"
	,
	"PRISEACA (PRAHOVA)"
	,
	"PROVITA DE JOS (PRAHOVA)"
	,
	"PROVITA DE SUS (PRAHOVA)"
	,
	"PUCHENII MARI (PRAHOVA)"
	,
	"PUCHENII MICI (PRAHOVA)"
	,
	"PUCHENII-MOSNENI (PRAHOVA)"
	,
	"PUSCASI (PRAHOVA)"
	,
	"RACHIERI (PRAHOVA)"
	,
	"RADILA (PRAHOVA)"
	,
	"RAFOV (PRAHOVA)"
	,
	"RAGMAN (PRAHOVA)"
	,
	"RAHOVA (PRAHOVA)"
	,
	"ROMANESTI (PRAHOVA)"
	,
	"ROTAREA (PRAHOVA)"
	,
	"ROTARI (PRAHOVA)"
	,
	"SALCIA (PRAHOVA)"
	,
	"SALCIILE (PRAHOVA)"
	,
	"SALCIOARA (PRAHOVA)"
	,
	"SANGERU (PRAHOVA)"
	,
	"SARARI (PRAHOVA)"
	,
	"SARATEL (PRAHOVA)"
	,
	"SARCA (PRAHOVA)"
	,
	"SATU DE SUS (PRAHOVA)"
	,
	"SATU NOU (BABA ANA) (PRAHOVA)"
	,
	"SATU NOU (LIPANESTI) (PRAHOVA)"
	,
	"SATUCU (PRAHOVA)"
	,
	"SCHELA (PRAHOVA)"
	,
	"SCHIAU (URLATI) (PRAHOVA)"
	,
	"SCHIAU (VALEA CALUGAREASCA) (PRAHOVA)"
	,
	"SCHIULESTI (PRAHOVA)"
	,
	"SCORTENI (PRAHOVA)"
	,
	"SCURTESTI (PRAHOVA)"
	,
	"SECARIA (PRAHOVA)"
	,
	"SECIU (PRAHOVA)"
	,
	"SECIURI (PRAHOVA)"
	,
	"SFACARU (PRAHOVA)"
	,
	"SFARLEANCA (PRAHOVA)"
	,
	"SICRITA (PRAHOVA)"
	,
	"SILISTEA (PRAHOVA)"
	,
	"SILISTEA DEALULUI (PRAHOVA)"
	,
	"SINAIA (PRAHOVA)"
	,
	"SIPOTU (PRAHOVA)"
	,
	"SIRNA (PRAHOVA)"
	,
	"SLANIC (PRAHOVA)"
	,
	"SLAVU (PRAHOVA)"
	,
	"SLON (PRAHOVA)"
	,
	"SOIMARI (PRAHOVA)"
	,
	"SOIMESTI (PRAHOVA)"
	,
	"SOTRILE (PRAHOVA)"
	,
	"STANCESTI (PRAHOVA)"
	,
	"STARCHIOJD (PRAHOVA)"
	,
	"STEFESTI (PRAHOVA)"
	,
	"STEJARU (PRAHOVA)"
	,
	"STOENESTI (PRAHOVA)"
	,
	"STRAOSTI (PRAHOVA)"
	,
	"STREJNICU (PRAHOVA)"
	,
	"STUBEIU (PRAHOVA)"
	,
	"SURANI (PRAHOVA)"
	,
	"SURDESTI (PRAHOVA)"
	,
	"TALEA (PRAHOVA)"
	,
	"TANTARENI (PRAHOVA)"
	,
	"TARCULESTI (PRAHOVA)"
	,
	"TARGSORU NOU (PRAHOVA)"
	,
	"TARGSORU VECHI (PRAHOVA)"
	,
	"TARICENI (PRAHOVA)"
	,
	"TARLESTI (PRAHOVA)"
	,
	"TARSORENI (PRAHOVA)"
	,
	"TATARAI (PRAHOVA)"
	,
	"TATARANI (PRAHOVA)"
	,
	"TATARU (PRAHOVA)"
	,
	"TEISANI (PRAHOVA)"
	,
	"TELEGA (PRAHOVA)"
	,
	"TESILA (PRAHOVA)"
	,
	"TINOSU (PRAHOVA)"
	,
	"TINTEA (PRAHOVA)"
	,
	"TIPARESTI (PRAHOVA)"
	,
	"TISA (PRAHOVA)"
	,
	"TOHANI (PRAHOVA)"
	,
	"TOMSANI (PRAHOVA)"
	,
	"TONTESTI (PRAHOVA)"
	,
	"TRAISTENI (PRAHOVA)"
	,
	"TRENU (PRAHOVA)"
	,
	"TRESTIENII DE JOS (PRAHOVA)"
	,
	"TRESTIENII DE SUS (PRAHOVA)"
	,
	"TRESTIOARA (PRAHOVA)"
	,
	"TUFANI (PRAHOVA)"
	,
	"TUFENI (PRAHOVA)"
	,
	"TULBUREA (PRAHOVA)"
	,
	"TULBUREA-VALENI (PRAHOVA)"
	,
	"UDRESTI (PRAHOVA)"
	,
	"ULMI (PRAHOVA)"
	,
	"UNGURENI (FANTANELE) (PRAHOVA)"
	,
	"UNGURENI (FILIPESTII DE TARG) (PRAHOVA)"
	,
	"UNGURENI (GHERGHITA) (PRAHOVA)"
	,
	"URLATI (PRAHOVA)"
	,
	"URLETA (PRAHOVA)"
	,
	"VADU PARULUI (PRAHOVA)"
	,
	"VADU SAPAT (PRAHOVA)"
	,
	"VALCANESTI (PRAHOVA)"
	,
	"VALCELELE (PRAHOVA)"
	,
	"VALEA ANEI (PRAHOVA)"
	,
	"VALEA BOBULUI (PRAHOVA)"
	,
	"VALEA BORULUI (PRAHOVA)"
	,
	"VALEA BRADETULUI (PRAHOVA)"
	,
	"VALEA BRADULUI (PRAHOVA)"
	,
	"VALEA CALUGAREASCA (PRAHOVA)"
	,
	"VALEA CRANGULUI (PRAHOVA)"
	,
	"VALEA CRICOVULUI (PRAHOVA)"
	,
	"VALEA CUCULUI (PRAHOVA)"
	,
	"VALEA DOFTANEI (PRAHOVA)"
	,
	"VALEA DULCE (PRAHOVA)"
	,
	"VALEA LARGA (PRAHOVA)"
	,
	"VALEA LESPEZII (PRAHOVA)"
	,
	"VALEA MANTEI (PRAHOVA)"
	,
	"VALEA MIEILOR (PRAHOVA)"
	,
	"VALEA NICOVANI (PRAHOVA)"
	,
	"VALEA NUCETULUI (PRAHOVA)"
	,
	"VALEA OPRII (PRAHOVA)"
	,
	"VALEA ORLEI (PRAHOVA)"
	,
	"VALEA PIETREI (PRAHOVA)"
	,
	"VALEA PLOPULUI (PRAHOVA)"
	,
	"VALEA POIENII (PRAHOVA)"
	,
	"VALEA POPII (PRAHOVA)"
	,
	"VALEA SCHEILOR (PRAHOVA)"
	,
	"VALEA SCREZII (PRAHOVA)"
	,
	"VALEA SEACA (PRAHOVA)"
	,
	"VALEA SEMAN (PRAHOVA)"
	,
	"VALEA STALPULUI (PRAHOVA)"
	,
	"VALEA STUPINII (PRAHOVA)"
	,
	"VALEA TARSEI (PRAHOVA)"
	,
	"VALEA TOCII (PRAHOVA)"
	,
	"VALEA UNGHIULUI (PRAHOVA)"
	,
	"VALEA URLOII (PRAHOVA)"
	,
	"VALEA URSOII (PRAHOVA)"
	,
	"VALENII DE MUNTE (PRAHOVA)"
	,
	"VARBILA (PRAHOVA)"
	,
	"VARBILAU (PRAHOVA)"
	,
	"VARFURILE (PRAHOVA)"
	,
	"VARNITA (PRAHOVA)"
	,
	"VISTIERU (PRAHOVA)"
	,
	"VITIOARA DE SUS (PRAHOVA)"
	,
	"ZAHANAUA (PRAHOVA)"
	,
	"ZALHANAUA (PRAHOVA)"
	,
	"ZAMBROAIA (PRAHOVA)"
	,
	"ZAMFIRA (PRAHOVA)"
	,
	"ZANOAGA (PRAHOVA)"
	,
	"ZMEURET (PRAHOVA)"
	,
	"ADALIN (SALAJ)"
	,
	"AGHIRES (SALAJ)"
	,
	"AGRIJ (SALAJ)"
	,
	"ALEUS (SALAJ)"
	,
	"ALMASU (SALAJ)"
	,
	"ALUNIS (SALAJ)"
	,
	"ARCHID (SALAJ)"
	,
	"BABENI (SALAJ)"
	,
	"BABIU (SALAJ)"
	,
	"BADACIN (SALAJ)"
	,
	"BADON (SALAJ)"
	,
	"BAICA (SALAJ)"
	,
	"BALAN (SALAJ)"
	,
	"BAN (SALAJ)"
	,
	"BANISOR (SALAJ)"
	,
	"BARSA (SALAJ)"
	,
	"BARSAU MARE (SALAJ)"
	,
	"BARSAUTA (SALAJ)"
	,
	"BENESAT (SALAJ)"
	,
	"BERCEA (SALAJ)"
	,
	"BEZDED (SALAJ)"
	,
	"BIC (SALAJ)"
	,
	"BILGHEZ (SALAJ)"
	,
	"BIUSA (SALAJ)"
	,
	"BIZUSA-BAI (SALAJ)"
	,
	"BOBOTA (SALAJ)"
	,
	"BOCSA (SALAJ)"
	,
	"BOCSITA (SALAJ)"
	,
	"BODIA (SALAJ)"
	,
	"BOGDANA (SALAJ)"
	,
	"BOGHIS (SALAJ)"
	,
	"BORLA (SALAJ)"
	,
	"BORZA (SALAJ)"
	,
	"BOZIES (SALAJ)"
	,
	"BOZNA (SALAJ)"
	,
	"BRAGLEZ (SALAJ)"
	,
	"BREBI (SALAJ)"
	,
	"BRUSTURI (SALAJ)"
	,
	"BUCIUMI (SALAJ)"
	,
	"BULGARI (SALAJ)"
	,
	"BUZAS (SALAJ)"
	,
	"CALACEA (SALAJ)"
	,
	"CAMAR (SALAJ)"
	,
	"CAMPIA (SALAJ)"
	,
	"CAPALNA (SALAJ)"
	,
	"CARASTELEC (SALAJ)"
	,
	"CEACA (SALAJ)"
	,
	"CEHEI (SALAJ)"
	,
	"CEHU SILVANIEI (SALAJ)"
	,
	"CERISA (SALAJ)"
	,
	"CERNUC (SALAJ)"
	,
	"CHECHIS (SALAJ)"
	,
	"CHENDREA (SALAJ)"
	,
	"CHENDREMAL (SALAJ)"
	,
	"CHEUD (SALAJ)"
	,
	"CHICHISA (SALAJ)"
	,
	"CHIESD (SALAJ)"
	,
	"CHILIOARA (SALAJ)"
	,
	"CHIZENI (SALAJ)"
	,
	"CIGLEAN (SALAJ)"
	,
	"CIOCMANI (SALAJ)"
	,
	"CIULA (SALAJ)"
	,
	"CIUMARNA (SALAJ)"
	,
	"CIURENI (SALAJ)"
	,
	"CIZER (SALAJ)"
	,
	"CLIT (SALAJ)"
	,
	"COLONIA SIGHETU SILVANIEI (SALAJ)"
	,
	"CORMENIS (SALAJ)"
	,
	"COSEIU (SALAJ)"
	,
	"COSNICIU DE JOS (SALAJ)"
	,
	"COSNICIU DE SUS (SALAJ)"
	,
	"COZLA (SALAJ)"
	,
	"CRASNA (SALAJ)"
	,
	"CREACA (SALAJ)"
	,
	"CRISENI (SALAJ)"
	,
	"CRISTELEC (SALAJ)"
	,
	"CRISTOLT (SALAJ)"
	,
	"CRISTOLTEL (SALAJ)"
	,
	"CRISTUR-CRISENI (SALAJ)"
	,
	"CUBLESU (SALAJ)"
	,
	"CUCEU (SALAJ)"
	,
	"CUCIULAT (SALAJ)"
	,
	"CUTIS (SALAJ)"
	,
	"CUZAPLAC (SALAJ)"
	,
	"DABICENI (SALAJ)"
	,
	"DEJA (SALAJ)"
	,
	"DELENI (SALAJ)"
	,
	"DERSIDA (SALAJ)"
	,
	"DIOSOD (SALAJ)"
	,
	"DOBA (SALAJ)"
	,
	"DOBRIN (SALAJ)"
	,
	"DOBROCINA (SALAJ)"
	,
	"DOH (SALAJ)"
	,
	"DOLHENI (SALAJ)"
	,
	"DOLU (SALAJ)"
	,
	"DOMNIN (SALAJ)"
	,
	"DRAGU (SALAJ)"
	,
	"DRIGHIU (SALAJ)"
	,
	"DUMUSLAU (SALAJ)"
	,
	"FABRICA (SALAJ)"
	,
	"FAGETU (SALAJ)"
	,
	"FALCUSA (SALAJ)"
	,
	"FANTANELE (SALAJ)"
	,
	"FANTANELE-RUS (SALAJ)"
	,
	"FETINDIA (SALAJ)"
	,
	"FILDU DE JOS (SALAJ)"
	,
	"FILDU DE MIJLOC (SALAJ)"
	,
	"FILDU DE SUS (SALAJ)"
	,
	"FIRMINIS (SALAJ)"
	,
	"FIZES (SALAJ)"
	,
	"FODORA (SALAJ)"
	,
	"FRANCENII DE PIATRA (SALAJ)"
	,
	"FUFEZ (SALAJ)"
	,
	"GALASENI (SALAJ)"
	,
	"GALGAU (SALAJ)"
	,
	"GALGAU ALMASULUI (SALAJ)"
	,
	"GALPAIA (SALAJ)"
	,
	"GARBOU (SALAJ)"
	,
	"GARCEIU (SALAJ)"
	,
	"GIURTELECU SIMLEULUI (SALAJ)"
	,
	"GLOD (SALAJ)"
	,
	"GOSTILA (SALAJ)"
	,
	"GURA VLADESEI (SALAJ)"
	,
	"GURUSLAU (SALAJ)"
	,
	"HALMASD (SALAJ)"
	,
	"HASMAS (SALAJ)"
	,
	"HERECLEAN (SALAJ)"
	,
	"HIDA (SALAJ)"
	,
	"HOROATU CEHULUI (SALAJ)"
	,
	"HOROATU CRASNEI (SALAJ)"
	,
	"HUREZ (SALAJ)"
	,
	"HUSENI (SALAJ)"
	,
	"HUSIA (SALAJ)"
	,
	"HUTA (SALAJ)"
	,
	"IAZ (SALAJ)"
	,
	"ILEANDA (SALAJ)"
	,
	"ILISUA (SALAJ)"
	,
	"INAU (SALAJ)"
	,
	"IP (SALAJ)"
	,
	"JAC (SALAJ)"
	,
	"JEBUCU (SALAJ)"
	,
	"JIBOU (SALAJ)"
	,
	"LAZURI (SALAJ)"
	,
	"LEMNIU (SALAJ)"
	,
	"LESMIR (SALAJ)"
	,
	"LETCA (SALAJ)"
	,
	"LOMPIRT (SALAJ)"
	,
	"LOZNA (SALAJ)"
	,
	"LUMINISU (SALAJ)"
	,
	"LUPOAIA (SALAJ)"
	,
	"MAERISTE (SALAJ)"
	,
	"MAGURA (SALAJ)"
	,
	"MAL (SALAJ)"
	,
	"MALADIA (SALAJ)"
	,
	"MALENI (SALAJ)"
	,
	"MARCA (SALAJ)"
	,
	"MARCA-HUTA (SALAJ)"
	,
	"MARIN (SALAJ)"
	,
	"MESESENII DE JOS (SALAJ)"
	,
	"MESESENII DE SUS (SALAJ)"
	,
	"MESTEACANU (SALAJ)"
	,
	"MIERTA (SALAJ)"
	,
	"MILUANI (SALAJ)"
	,
	"MINEU (SALAJ)"
	,
	"MIRSID (SALAJ)"
	,
	"MOIAD (SALAJ)"
	,
	"MOIGRAD-POROLISSUM (SALAJ)"
	,
	"MOTIS (SALAJ)"
	,
	"MUNCEL (SALAJ)"
	,
	"NADIS (SALAJ)"
	,
	"NAIMON (SALAJ)"
	,
	"NAPRADEA (SALAJ)"
	,
	"NEGRENI (SALAJ)"
	,
	"NOTIG (SALAJ)"
	,
	"NUSFALAU (SALAJ)"
	,
	"ORTELEC (SALAJ)"
	,
	"PADURENI (SALAJ)"
	,
	"PADURIS (SALAJ)"
	,
	"PANIC (SALAJ)"
	,
	"PAUSA (SALAJ)"
	,
	"PECEIU (SALAJ)"
	,
	"PERICEI (SALAJ)"
	,
	"PERICEIU MIC (SALAJ)"
	,
	"PERII VADULUI (SALAJ)"
	,
	"PETRINDU (SALAJ)"
	,
	"PETRINZEL (SALAJ)"
	,
	"PIROSA (SALAJ)"
	,
	"PLESCA (SALAJ)"
	,
	"PLOPIS (SALAJ)"
	,
	"POARTA SALAJULUI (SALAJ)"
	,
	"PODISU (SALAJ)"
	,
	"POIANA BLENCHII (SALAJ)"
	,
	"POIANA MAGURA (SALAJ)"
	,
	"POIANA ONTII (SALAJ)"
	,
	"POIENITA (SALAJ)"
	,
	"POPENI (SALAJ)"
	,
	"POPTELEAC (SALAJ)"
	,
	"PORT (SALAJ)"
	,
	"PRELUCI (SALAJ)"
	,
	"PREOTEASA (SALAJ)"
	,
	"PRIA (SALAJ)"
	,
	"PRODANESTI (SALAJ)"
	,
	"PURCARET (SALAJ)"
	,
	"PUSTA (SALAJ)"
	,
	"RACAS (SALAJ)"
	,
	"RASTOCI (SALAJ)"
	,
	"RASTOLT (SALAJ)"
	,
	"RASTOLTU DESERT (SALAJ)"
	,
	"RATIN (SALAJ)"
	,
	"RATOVEI (SALAJ)"
	,
	"RECEA (SALAJ)"
	,
	"RECEA MICA (SALAJ)"
	,
	"ROGNA (SALAJ)"
	,
	"ROMANASI (SALAJ)"
	,
	"ROMITA (SALAJ)"
	,
	"RONA (SALAJ)"
	,
	"RUGINOASA (SALAJ)"
	,
	"RUS (SALAJ)"
	,
	"SAG (SALAJ)"
	,
	"SALAJENI (SALAJ)"
	,
	"SALATIG (SALAJ)"
	,
	"SAMSUD (SALAJ)"
	,
	"SANCRAIU ALMASULUI (SALAJ)"
	,
	"SANCRAIU SILVANIEI (SALAJ)"
	,
	"SANGEORGIU DE MESES (SALAJ)"
	,
	"SANMIHAIU ALMASULUI (SALAJ)"
	,
	"SANPETRU ALMASULUI (SALAJ)"
	,
	"SANTA MARIA (SALAJ)"
	,
	"SARBI (SALAJ)"
	,
	"SARMASAG (SALAJ)"
	,
	"SASA (SALAJ)"
	,
	"SEREDEIU (SALAJ)"
	,
	"SFARAS (SALAJ)"
	,
	"SICI (SALAJ)"
	,
	"SIGHETU SILVANIEI (SALAJ)"
	,
	"SIMISNA (SALAJ)"
	,
	"SIMLEU SILVANIEI (SALAJ)"
	,
	"SOIMUS (SALAJ)"
	,
	"SOIMUSENI (SALAJ)"
	,
	"SOLOMON (SALAJ)"
	,
	"SOLONA (SALAJ)"
	,
	"SOMES-GURUSLAU (SALAJ)"
	,
	"SOMES-ODORHEI (SALAJ)"
	,
	"STANA (SALAJ)"
	,
	"STARCIU (SALAJ)"
	,
	"STOBORU (SALAJ)"
	,
	"STUPINI (SALAJ)"
	,
	"SUB CETATE (SALAJ)"
	,
	"SUMAL (SALAJ)"
	,
	"SURDUC (SALAJ)"
	,
	"SUTORU (SALAJ)"
	,
	"TAMASA (SALAJ)"
	,
	"TARMURE (SALAJ)"
	,
	"TAUDU (SALAJ)"
	,
	"TESTIOARA (SALAJ)"
	,
	"TETISU (SALAJ)"
	,
	"TIHAU (SALAJ)"
	,
	"TOPLITA (SALAJ)"
	,
	"TRANIS (SALAJ)"
	,
	"TRESTIA (SALAJ)"
	,
	"TREZNEA (SALAJ)"
	,
	"TURBUTA (SALAJ)"
	,
	"TUSA (SALAJ)"
	,
	"UGRUTIU (SALAJ)"
	,
	"UILEACU SIMLEULUI (SALAJ)"
	,
	"ULCIUG (SALAJ)"
	,
	"VADURELE (SALAJ)"
	,
	"VALCAU DE JOS (SALAJ)"
	,
	"VALCAU DE SUS (SALAJ)"
	,
	"VALEA CIURENILOR (SALAJ)"
	,
	"VALEA HRANEI (SALAJ)"
	,
	"VALEA LESULUI (SALAJ)"
	,
	"VALEA LOZNEI (SALAJ)"
	,
	"VALEA LUNGA (SALAJ)"
	,
	"VALEA POMILOR (SALAJ)"
	,
	"VALENI (SALAJ)"
	,
	"VALISOARA (SALAJ)"
	,
	"VAR (SALAJ)"
	,
	"VARSOLT (SALAJ)"
	,
	"VARTESCA (SALAJ)"
	,
	"VERVEGHIU (SALAJ)"
	,
	"VIILE JACULUI (SALAJ)"
	,
	"VOIVODENI (SALAJ)"
	,
	"ZALAU (SALAJ)"
	,
	"ZALHA (SALAJ)"
	,
	"ZALNOC (SALAJ)"
	,
	"ZAUAN (SALAJ)"
	,
	"ZAUAN-BAI (SALAJ)"
	,
	"ZIMBOR (SALAJ)"
	,
	"ACAS (SATU MARE)"
	,
	"ACIUA (SATU MARE)"
	,
	"ADRIAN (SATU MARE)"
	,
	"ADY ENDRE (SATU MARE)"
	,
	"AGRIS (SATU MARE)"
	,
	"ALICENI (SATU MARE)"
	,
	"ALIZA (SATU MARE)"
	,
	"AMATI (SATU MARE)"
	,
	"AMBUD (SATU MARE)"
	,
	"ANDRID (SATU MARE)"
	,
	"APA (SATU MARE)"
	,
	"APATEU (SATU MARE)"
	,
	"ARDUD (SATU MARE)"
	,
	"ARDUD-VII (SATU MARE)"
	,
	"ATEA (SATU MARE)"
	,
	"BABA NOVAC (SATU MARE)"
	,
	"BABASESTI (SATU MARE)"
	,
	"BABESTI (SATU MARE)"
	,
	"BABTA (SATU MARE)"
	,
	"BARSAU (SATU MARE)"
	,
	"BARSAU DE JOS (SATU MARE)"
	,
	"BARSAU DE SUS (SATU MARE)"
	,
	"BATARCI (SATU MARE)"
	,
	"BECHENI (SATU MARE)"
	,
	"BELTIUG (SATU MARE)"
	,
	"BERCU (SATU MARE)"
	,
	"BERCU NOU (SATU MARE)"
	,
	"BEREA (SATU MARE)"
	,
	"BERINDAN (SATU MARE)"
	,
	"BERVENI (SATU MARE)"
	,
	"BICAU (SATU MARE)"
	,
	"BIXAD (SATU MARE)"
	,
	"BLAJA (SATU MARE)"
	,
	"BOCICAU (SATU MARE)"
	,
	"BOGDAND (SATU MARE)"
	,
	"BOGHIS (SATU MARE)"
	,
	"BOINESTI (SATU MARE)"
	,
	"BOLDA (SATU MARE)"
	,
	"BORLESTI (SATU MARE)"
	,
	"BOTIZ (SATU MARE)"
	,
	"CALINESTI-OAS (SATU MARE)"
	,
	"CAMARZANA (SATU MARE)"
	,
	"CAMIN (SATU MARE)"
	,
	"CAPLENI (SATU MARE)"
	,
	"CARASEU (SATU MARE)"
	,
	"CAREI (SATU MARE)"
	,
	"CAUAS (SATU MARE)"
	,
	"CEAN (SATU MARE)"
	,
	"CEHAL (SATU MARE)"
	,
	"CEHALUT (SATU MARE)"
	,
	"CERTEZE (SATU MARE)"
	,
	"CHEGEA (SATU MARE)"
	,
	"CHEREUSA (SATU MARE)"
	,
	"CHILIA (SATU MARE)"
	,
	"CHISAU (SATU MARE)"
	,
	"CIDREAG (SATU MARE)"
	,
	"CIG (SATU MARE)"
	,
	"CIONCHESTI (SATU MARE)"
	,
	"CIUMESTI (SATU MARE)"
	,
	"CIUPERCENI (SATU MARE)"
	,
	"COCA (SATU MARE)"
	,
	"COMLAUSA (SATU MARE)"
	,
	"COROD (SATU MARE)"
	,
	"CORUND (SATU MARE)"
	,
	"CRAIDOROLT (SATU MARE)"
	,
	"CRISENI (SATU MARE)"
	,
	"CRUCISOR (SATU MARE)"
	,
	"CUCU (SATU MARE)"
	,
	"CULCIU (SATU MARE)"
	,
	"CULCIU MARE (SATU MARE)"
	,
	"CULCIU MIC (SATU MARE)"
	,
	"CUTA (SATU MARE)"
	,
	"DACIA (SATU MARE)"
	,
	"DARA (SATU MARE)"
	,
	"DECEBAL (SATU MARE)"
	,
	"DINDESTI (SATU MARE)"
	,
	"DINDESTIU MIC (SATU MARE)"
	,
	"DOBA (SATU MARE)"
	,
	"DOBOLT (SATU MARE)"
	,
	"DOBRA (SATU MARE)"
	,
	"DOMANESTI (SATU MARE)"
	,
	"DOROLT (SATU MARE)"
	,
	"DRAGUSENI (SATU MARE)"
	,
	"DUMBRAVA (SATU MARE)"
	,
	"ERIU-SANCRAI (SATU MARE)"
	,
	"ETENI (SATU MARE)"
	,
	"FOIENI (SATU MARE)"
	,
	"GANAS (SATU MARE)"
	,
	"GELU (SATU MARE)"
	,
	"GERAUSA (SATU MARE)"
	,
	"GHENCI (SATU MARE)"
	,
	"GHERTA MARE (SATU MARE)"
	,
	"GHERTA MICA (SATU MARE)"
	,
	"GHILESTI (SATU MARE)"
	,
	"GHILVACI (SATU MARE)"
	,
	"GHIRISA (SATU MARE)"
	,
	"GHIROLT (SATU MARE)"
	,
	"GIOROCUTA (SATU MARE)"
	,
	"GIUNGI (SATU MARE)"
	,
	"GIURTELECU HODODULUI (SATU MARE)"
	,
	"HALMEU (SATU MARE)"
	,
	"HALMEU-VII (SATU MARE)"
	,
	"HODISA (SATU MARE)"
	,
	"HODOD (SATU MARE)"
	,
	"HOMOROADE (SATU MARE)"
	,
	"HOMORODU DE JOS (SATU MARE)"
	,
	"HOMORODU DE MIJLOC (SATU MARE)"
	,
	"HOMORODU DE SUS (SATU MARE)"
	,
	"HOREA (SATU MARE)"
	,
	"HOTOAN (SATU MARE)"
	,
	"HRIP (SATU MARE)"
	,
	"HUREZU MARE (SATU MARE)"
	,
	"HUTA-CERTEZE (SATU MARE)"
	,
	"IANCULESTI (SATU MARE)"
	,
	"IEGHERISTE (SATU MARE)"
	,
	"IOJIB (SATU MARE)"
	,
	"IRINA (SATU MARE)"
	,
	"ISTRAU (SATU MARE)"
	,
	"LAZURI (SATU MARE)"
	,
	"LECHINTA (SATU MARE)"
	,
	"LELEI (SATU MARE)"
	,
	"LIPAU (SATU MARE)"
	,
	"LIVADA (SATU MARE)"
	,
	"LIVADA MICA (SATU MARE)"
	,
	"LUCACENI (SATU MARE)"
	,
	"LUNA (SATU MARE)"
	,
	"LUNCA APEI (SATU MARE)"
	,
	"MADARAS (SATU MARE)"
	,
	"MARIUS (SATU MARE)"
	,
	"MARNA NOUA (SATU MARE)"
	,
	"MARTINESTI (SATU MARE)"
	,
	"MEDIES-RATURI (SATU MARE)"
	,
	"MEDIESU AURIT (SATU MARE)"
	,
	"MEDIES-VII (SATU MARE)"
	,
	"MEDISA (SATU MARE)"
	,
	"MESTEACAN (SATU MARE)"
	,
	"MICULA (SATU MARE)"
	,
	"MICULA NOUA (SATU MARE)"
	,
	"MIHAIENI (SATU MARE)"
	,
	"MOFTIN (SATU MARE)"
	,
	"MOFTINU MARE (SATU MARE)"
	,
	"MOFTINU MIC (SATU MARE)"
	,
	"MOISENI (SATU MARE)"
	,
	"NADISU HODODULUI (SATU MARE)"
	,
	"NECOPOI (SATU MARE)"
	,
	"NEGRESTI-OAS (SATU MARE)"
	,
	"NISIPENI (SATU MARE)"
	,
	"NOROIENI (SATU MARE)"
	,
	"OAR (SATU MARE)"
	,
	"ODOREU (SATU MARE)"
	,
	"ORASU NOU (SATU MARE)"
	,
	"ORASU NOU-VII (SATU MARE)"
	,
	"ORBAU (SATU MARE)"
	,
	"PASUNEA MARE (SATU MARE)"
	,
	"PAULESTI (SATU MARE)"
	,
	"PAULIAN (SATU MARE)"
	,
	"PELES (SATU MARE)"
	,
	"PELISOR (SATU MARE)"
	,
	"PETEA (SATU MARE)"
	,
	"PETIN (SATU MARE)"
	,
	"PETRESTI (SATU MARE)"
	,
	"PIR (SATU MARE)"
	,
	"PIRU NOU (SATU MARE)"
	,
	"PISCARI (SATU MARE)"
	,
	"PISCOLT (SATU MARE)"
	,
	"POIANA CODRULUI (SATU MARE)"
	,
	"POMI (SATU MARE)"
	,
	"PORTITA (SATU MARE)"
	,
	"PORUMBESTI (SATU MARE)"
	,
	"POTAU (SATU MARE)"
	,
	"PRILOG (SATU MARE)"
	,
	"PRILOG-VII (SATU MARE)"
	,
	"RACOVA (SATU MARE)"
	,
	"RACSA (SATU MARE)"
	,
	"RACSA-VII (SATU MARE)"
	,
	"RADULESTI (SATU MARE)"
	,
	"RATESTI (SATU MARE)"
	,
	"RATIU (SATU MARE)"
	,
	"REMETEA OASULUI (SATU MARE)"
	,
	"RESIGHEA (SATU MARE)"
	,
	"ROMANESTI (SATU MARE)"
	,
	"ROSIORI (SATU MARE)"
	,
	"RUSENI (SATU MARE)"
	,
	"SACASENI (SATU MARE)"
	,
	"SAI (SATU MARE)"
	,
	"SANDRA (SATU MARE)"
	,
	"SANISLAU (SATU MARE)"
	,
	"SANMICLAUS (SATU MARE)"
	,
	"SANTAU (SATU MARE)"
	,
	"SARATURA (SATU MARE)"
	,
	"SARAUAD (SATU MARE)"
	,
	"SARVAZEL (SATU MARE)"
	,
	"SATMAREL (SATU MARE)"
	,
	"SATU MARE (SATU MARE)"
	,
	"SATU MIC (SATU MARE)"
	,
	"SAUCA (SATU MARE)"
	,
	"SCARISOARA NOUA (SATU MARE)"
	,
	"SECHERESA (SATU MARE)"
	,
	"SER (SATU MARE)"
	,
	"SILVAS (SATU MARE)"
	,
	"SIRLAU (SATU MARE)"
	,
	"SOCOND (SATU MARE)"
	,
	"SOCONZEL (SATU MARE)"
	,
	"SOLDUBA (SATU MARE)"
	,
	"SOMESENI (SATU MARE)"
	,
	"STANA (SATU MARE)"
	,
	"SUDURAU (SATU MARE)"
	,
	"SUPUR (SATU MARE)"
	,
	"SUPURU DE JOS (SATU MARE)"
	,
	"SUPURU DE SUS (SATU MARE)"
	,
	"TAMASENI (SATU MARE)"
	,
	"TARNA MARE (SATU MARE)"
	,
	"TARSOLT (SATU MARE)"
	,
	"TASNAD (SATU MARE)"
	,
	"TATARESTI (SATU MARE)"
	,
	"TEGHEA (SATU MARE)"
	,
	"TEREBESTI (SATU MARE)"
	,
	"TIREAC (SATU MARE)"
	,
	"TIREAM (SATU MARE)"
	,
	"TRAIAN (SATU MARE)"
	,
	"TRIP (SATU MARE)"
	,
	"TUR (SATU MARE)"
	,
	"TURT (SATU MARE)"
	,
	"TURT-BAI (SATU MARE)"
	,
	"TURULUNG (SATU MARE)"
	,
	"TURULUNG-VII (SATU MARE)"
	,
	"UNIMAT (SATU MARE)"
	,
	"URZICENI (SATU MARE)"
	,
	"URZICENI-PADURE (SATU MARE)"
	,
	"VAGAS (SATU MARE)"
	,
	"VALEA MORII (SATU MARE)"
	,
	"VALEA SEACA (SATU MARE)"
	,
	"VALEA VINULUI (SATU MARE)"
	,
	"VAMA (SATU MARE)"
	,
	"VANATORESTI (SATU MARE)"
	,
	"VETIS (SATU MARE)"
	,
	"VEZENDIU (SATU MARE)"
	,
	"VIILE SATU MARE (SATU MARE)"
	,
	"VIISOARA (SATU MARE)"
	,
	"ACILIU (SIBIU)"
	,
	"AGARBICIU (SIBIU)"
	,
	"AGNITA (SIBIU)"
	,
	"ALAMOR (SIBIU)"
	,
	"ALBI (SIBIU)"
	,
	"ALMA (SIBIU)"
	,
	"ALMA VII (SIBIU)"
	,
	"ALTINA (SIBIU)"
	,
	"AMNAS (SIBIU)"
	,
	"APOLDU DE JOS (SIBIU)"
	,
	"APOLDU DE SUS (SIBIU)"
	,
	"APOS (SIBIU)"
	,
	"ARMENI (SIBIU)"
	,
	"ARPASU DE JOS (SIBIU)"
	,
	"ARPASU DE SUS (SIBIU)"
	,
	"ATEL (SIBIU)"
	,
	"AVRIG (SIBIU)"
	,
	"AXENTE SEVER (SIBIU)"
	,
	"BARGHIS (SIBIU)"
	,
	"BAZNA (SIBIU)"
	,
	"BENESTI (SIBIU)"
	,
	"BIERTAN (SIBIU)"
	,
	"BLAJEL (SIBIU)"
	,
	"BOARTA (SIBIU)"
	,
	"BOGATU ROMAN (SIBIU)"
	,
	"BOIAN (SIBIU)"
	,
	"BOITA (SIBIU)"
	,
	"BRADENI (SIBIU)"
	,
	"BRADU (SIBIU)"
	,
	"BRATEIU (SIBIU)"
	,
	"BROSTENI (SIBIU)"
	,
	"BRUIU (SIBIU)"
	,
	"BUIA (SIBIU)"
	,
	"BUNGARD (SIBIU)"
	,
	"BUZD (SIBIU)"
	,
	"CARTA (SIBIU)"
	,
	"CARTISOARA (SIBIU)"
	,
	"CASOLT (SIBIU)"
	,
	"CHESLER (SIBIU)"
	,
	"CHIRPAR (SIBIU)"
	,
	"CISNADIE (SIBIU)"
	,
	"CISNADIOARA (SIBIU)"
	,
	"COLONIA TALMACIU (SIBIU)"
	,
	"COLONIA TARNAVA (SIBIU)"
	,
	"COLUN (SIBIU)"
	,
	"COPSA MARE (SIBIU)"
	,
	"COPSA MICA (SIBIU)"
	,
	"CORNATEL (SIBIU)"
	,
	"COVES (SIBIU)"
	,
	"CRINT (SIBIU)"
	,
	"CRISTIAN (SIBIU)"
	,
	"CURCIU (SIBIU)"
	,
	"DAIA (SIBIU)"
	,
	"DARLOS (SIBIU)"
	,
	"DEALU FRUMOS (SIBIU)"
	,
	"DOBARCA (SIBIU)"
	,
	"DUMBRAVENI (SIBIU)"
	,
	"DUPUS (SIBIU)"
	,
	"ERNEA (SIBIU)"
	,
	"FANTANELE (SIBIU)"
	,
	"FLORESTI (SIBIU)"
	,
	"FOFELDEA (SIBIU)"
	,
	"GALES (SIBIU)"
	,
	"GHERDEAL (SIBIU)"
	,
	"GHIJASA DE JOS (SIBIU)"
	,
	"GHIJASA DE SUS (SIBIU)"
	,
	"GIACAS (SIBIU)"
	,
	"GLAMBOACA (SIBIU)"
	,
	"GURA RAULUI (SIBIU)"
	,
	"GUSU (SIBIU)"
	,
	"HAMBA (SIBIU)"
	,
	"HASAG (SIBIU)"
	,
	"HOGHILAG (SIBIU)"
	,
	"HOSMAN (SIBIU)"
	,
	"IACOBENI (SIBIU)"
	,
	"IGHISU NOU (SIBIU)"
	,
	"IGHISU VECHI (SIBIU)"
	,
	"ILIMBAV (SIBIU)"
	,
	"JINA (SIBIU)"
	,
	"LASLEA (SIBIU)"
	,
	"LAZARET (SIBIU)"
	,
	"LOAMNES (SIBIU)"
	,
	"LOTRIOARA (SIBIU)"
	,
	"LUDOS (SIBIU)"
	,
	"MAG (SIBIU)"
	,
	"MALANCRAV (SIBIU)"
	,
	"MANDRA (SIBIU)"
	,
	"MARPOD (SIBIU)"
	,
	"MARSA (SIBIU)"
	,
	"MEDIAS (SIBIU)"
	,
	"MERGHINDEAL (SIBIU)"
	,
	"METIS (SIBIU)"
	,
	"MICASASA (SIBIU)"
	,
	"MIERCUREA SIBIULUI (SIBIU)"
	,
	"MIGHINDOALA (SIBIU)"
	,
	"MIHAILENI (SIBIU)"
	,
	"MOARDAS (SIBIU)"
	,
	"MOHU (SIBIU)"
	,
	"MOSNA (SIBIU)"
	,
	"MOTIS (SIBIU)"
	,
	"MOVILE (SIBIU)"
	,
	"NEMSA (SIBIU)"
	,
	"NETUS (SIBIU)"
	,
	"NOCRICH (SIBIU)"
	,
	"NOISTAT (SIBIU)"
	,
	"NOU (SIBIU)"
	,
	"NOU ROMAN (SIBIU)"
	,
	"NOU SASESC (SIBIU)"
	,
	"NUCET (SIBIU)"
	,
	"OCNA SIBIULUI (SIBIU)"
	,
	"ORLAT (SIBIU)"
	,
	"PADURENI (SIBIU)"
	,
	"PALTIN (SIBIU)"
	,
	"PALTINIS (SIBIU)"
	,
	"PAUCA (SIBIU)"
	,
	"PAUCEA (SIBIU)"
	,
	"PELISOR (SIBIU)"
	,
	"PETIS (SIBIU)"
	,
	"POIANA SIBIULUI (SIBIU)"
	,
	"POIENITA (SIBIU)"
	,
	"POPLACA (SIBIU)"
	,
	"PORUMBACU DE JOS (SIBIU)"
	,
	"PORUMBACU DE SUS (SIBIU)"
	,
	"PRESACA (SIBIU)"
	,
	"PRISLOP (SIBIU)"
	,
	"PROD (SIBIU)"
	,
	"RACOVITA (SIBIU)"
	,
	"RASINARI (SIBIU)"
	,
	"RAU SADULUI (SIBIU)"
	,
	"RAVASEL (SIBIU)"
	,
	"RETIS (SIBIU)"
	,
	"RICHIS (SIBIU)"
	,
	"ROANDOLA (SIBIU)"
	,
	"ROD (SIBIU)"
	,
	"ROMANESTI (SIBIU)"
	,
	"ROSIA (SIBIU)"
	,
	"RUJA (SIBIU)"
	,
	"RUSCIORI (SIBIU)"
	,
	"RUSI (SIBIU)"
	,
	"SACADATE (SIBIU)"
	,
	"SACEL (SIBIU)"
	,
	"SADINCA (SIBIU)"
	,
	"SADU (SIBIU)"
	,
	"SALCAU (SIBIU)"
	,
	"SALISTE (SIBIU)"
	,
	"SANGATIN (SIBIU)"
	,
	"SARATA (SIBIU)"
	,
	"SAROS PE TARNAVE (SIBIU)"
	,
	"SASAUS (SIBIU)"
	,
	"SCOREIU (SIBIU)"
	,
	"SEBESU DE JOS (SIBIU)"
	,
	"SEBESU DE SUS (SIBIU)"
	,
	"SEICA MARE (SIBIU)"
	,
	"SEICA MICA (SIBIU)"
	,
	"SELIMBAR (SIBIU)"
	,
	"SIBIEL (SIBIU)"
	,
	"SIBIU (SIBIU)"
	,
	"SLIMNIC (SIBIU)"
	,
	"SMIG (SIBIU)"
	,
	"SOALA (SIBIU)"
	,
	"SOMARTIN (SIBIU)"
	,
	"SOROSTIN (SIBIU)"
	,
	"STEJARISU (SIBIU)"
	,
	"STENEA (SIBIU)"
	,
	"SURA MARE (SIBIU)"
	,
	"SURA MICA (SIBIU)"
	,
	"TALMACEL (SIBIU)"
	,
	"TALMACIU (SIBIU)"
	,
	"TAPU (SIBIU)"
	,
	"TARNAVA (SIBIU)"
	,
	"TELINE (SIBIU)"
	,
	"TICHINDEAL (SIBIU)"
	,
	"TILISCA (SIBIU)"
	,
	"TOPARCEA (SIBIU)"
	,
	"TURNU ROSU (SIBIU)"
	,
	"VALCHID (SIBIU)"
	,
	"VALE (SIBIU)"
	,
	"VALEA LUNGA (SIBIU)"
	,
	"VALEA VIILOR (SIBIU)"
	,
	"VALENI (SIBIU)"
	,
	"VARD (SIBIU)"
	,
	"VECERD (SIBIU)"
	,
	"VELT (SIBIU)"
	,
	"VESEUD (CHIRPAR) (SIBIU)"
	,
	"VESEUD (SLIMNIC) (SIBIU)"
	,
	"VESTEM (SIBIU)"
	,
	"VURPAR (SIBIU)"
	,
	"ZLAGNA (SIBIU)"
	,
	"ADANCATA (SUCEAVA)"
	,
	"ANTOCENI (SUCEAVA)"
	,
	"ARBORE (SUCEAVA)"
	,
	"ARGEL (SUCEAVA)"
	,
	"ARGESTRU (SUCEAVA)"
	,
	"ARGHIRA (SUCEAVA)"
	,
	"ARTARI (SUCEAVA)"
	,
	"BADEUTI (SUCEAVA)"
	,
	"BADRAGI (SUCEAVA)"
	,
	"BAHNA ARIN (SUCEAVA)"
	,
	"BAIA (SUCEAVA)"
	,
	"BAINET (SUCEAVA)"
	,
	"BAISESTI (SUCEAVA)"
	,
	"BALACEANA (SUCEAVA)"
	,
	"BALCAUTI (SUCEAVA)"
	,
	"BALINESTI (SUCEAVA)"
	,
	"BANCESTI (SUCEAVA)"
	,
	"BANESTI (SUCEAVA)"
	,
	"BARASTI (SUCEAVA)"
	,
	"BASARABI (SUCEAVA)"
	,
	"BENIA (SUCEAVA)"
	,
	"BERCHISESTI (SUCEAVA)"
	,
	"BERESTI (SUCEAVA)"
	,
	"BILCA (SUCEAVA)"
	,
	"BIVOLARIA (SUCEAVA)"
	,
	"BOBEICA (SUCEAVA)"
	,
	"BODNARENI (SUCEAVA)"
	,
	"BOGATA (SUCEAVA)"
	,
	"BOGDANESTI (SUCEAVA)"
	,
	"BOROAIA (SUCEAVA)"
	,
	"BOSANCI (SUCEAVA)"
	,
	"BOTESTI (SUCEAVA)"
	,
	"BOTOS (SUCEAVA)"
	,
	"BOTOSANA (SUCEAVA)"
	,
	"BOTOSANITA MARE (SUCEAVA)"
	,
	"BOTOSANITA MICA (SUCEAVA)"
	,
	"BOTUS (SUCEAVA)"
	,
	"BOTUSEL (SUCEAVA)"
	,
	"BOURA (SUCEAVA)"
	,
	"BRADATEL (SUCEAVA)"
	,
	"BRAIESTI (SUCEAVA)"
	,
	"BRANISTEA (SUCEAVA)"
	,
	"BRASCA (SUCEAVA)"
	,
	"BREAZA (SUCEAVA)"
	,
	"BREAZA DE SUS (SUCEAVA)"
	,
	"BRODINA (SUCEAVA)"
	,
	"BRODINA (IZVOARELE SUCEVEI) (SUCEAVA)"
	,
	"BRODINA DE JOS (SUCEAVA)"
	,
	"BROSTENI (SUCEAVA)"
	,
	"BROSTENI (DRAGUSENI) (SUCEAVA)"
	,
	"BUCSOAIA (SUCEAVA)"
	,
	"BUDA (RASCA) (SUCEAVA)"
	,
	"BUDA (ZVORISTEA) (SUCEAVA)"
	,
	"BUDENI (SUCEAVA)"
	,
	"BULAI (SUCEAVA)"
	,
	"BUNESTI (SUCEAVA)"
	,
	"BURLA (SUCEAVA)"
	,
	"BURSUCENI (SUCEAVA)"
	,
	"CACICA (SUCEAVA)"
	,
	"CAJVANA (SUCEAVA)"
	,
	"CALAFINDESTI (SUCEAVA)"
	,
	"CALINESTI (CALAFINDESTI) (SUCEAVA)"
	,
	"CALINESTI (DARMANESTI) (SUCEAVA)"
	,
	"CALINESTI-VASILACHE (SUCEAVA)"
	,
	"CALUGARENI (SUCEAVA)"
	,
	"CAMARZANI (SUCEAVA)"
	,
	"CAMPULUNG MOLDOVENESC (SUCEAVA)"
	,
	"CAPU CAMPULUI (SUCEAVA)"
	,
	"CAPU CODRULUI (SUCEAVA)"
	,
	"CARLIBABA (SUCEAVA)"
	,
	"CARLIBABA NOUA (SUCEAVA)"
	,
	"CASOI (SUCEAVA)"
	,
	"CATRINARI (SUCEAVA)"
	,
	"CHILISENI (SUCEAVA)"
	,
	"CHIRIL (SUCEAVA)"
	,
	"CIOCANESTI (SUCEAVA)"
	,
	"CIOMARTAN (SUCEAVA)"
	,
	"CIPRIAN PORUMBESCU (SUCEAVA)"
	,
	"CIUMARNA (SUCEAVA)"
	,
	"CIUMULESTI (SUCEAVA)"
	,
	"CLIMAUTI (SUCEAVA)"
	,
	"CLIT (SUCEAVA)"
	,
	"CODRU (SUCEAVA)"
	,
	"COJOCARENI (SUCEAVA)"
	,
	"COJOCI (SUCEAVA)"
	,
	"COLACU (SUCEAVA)"
	,
	"COMANESTI (SUCEAVA)"
	,
	"CORLATA (SUCEAVA)"
	,
	"CORNI (SUCEAVA)"
	,
	"CORNU LUNCII (SUCEAVA)"
	,
	"COROCAIESTI (SUCEAVA)"
	,
	"CORPACI (SUCEAVA)"
	,
	"COSNA (SUCEAVA)"
	,
	"COSTANA (SUCEAVA)"
	,
	"COSTILEVA (SUCEAVA)"
	,
	"COSTISA (SUCEAVA)"
	,
	"COTARGASI (SUCEAVA)"
	,
	"COTU BAII (SUCEAVA)"
	,
	"COTU DOBEI (SUCEAVA)"
	,
	"COVERCA (SUCEAVA)"
	,
	"COZANESTI (SUCEAVA)"
	,
	"CRUCEA (SUCEAVA)"
	,
	"CUMPARATURA (SUCEAVA)"
	,
	"CUNUNSCHI (SUCEAVA)"
	,
	"DANILA (SUCEAVA)"
	,
	"DARMANESTI (SUCEAVA)"
	,
	"DARMOXA (SUCEAVA)"
	,
	"DEALU (SUCEAVA)"
	,
	"DEALU FLORENI (SUCEAVA)"
	,
	"DEIA (SUCEAVA)"
	,
	"DELENI (SUCEAVA)"
	,
	"DELNITA (SUCEAVA)"
	,
	"DELUT (SUCEAVA)"
	,
	"DEMACUSA (SUCEAVA)"
	,
	"DOLHASCA (SUCEAVA)"
	,
	"DOLHESTI (SUCEAVA)"
	,
	"DOLHESTII MARI (SUCEAVA)"
	,
	"DOLHESTII MICI (SUCEAVA)"
	,
	"DORNA CANDRENILOR (SUCEAVA)"
	,
	"DORNA-ARINI (SUCEAVA)"
	,
	"DORNESTI (SUCEAVA)"
	,
	"DORNISOARA (SUCEAVA)"
	,
	"DOROTEIA (SUCEAVA)"
	,
	"DRAGOIASA (SUCEAVA)"
	,
	"DRAGOIESTI (SUCEAVA)"
	,
	"DRAGOMIRNA (SUCEAVA)"
	,
	"DRAGOSA (SUCEAVA)"
	,
	"DRAGUSENI (SUCEAVA)"
	,
	"DUBIUSCA (SUCEAVA)"
	,
	"DUMBRAVA (CORNU LUNCII) (SUCEAVA)"
	,
	"DUMBRAVA (GRANICESTI) (SUCEAVA)"
	,
	"DUMBRAVENI (SUCEAVA)"
	,
	"DUMBRAVENI (RASCA) (SUCEAVA)"
	,
	"DUMBRAVITA (SUCEAVA)"
	,
	"EHRESTE (SUCEAVA)"
	,
	"FALCAU (SUCEAVA)"
	,
	"FALTICENI (SUCEAVA)"
	,
	"FANTANA MARE (SUCEAVA)"
	,
	"FANTANELE (SUCEAVA)"
	,
	"FETESTI (SUCEAVA)"
	,
	"FLORINTA (SUCEAVA)"
	,
	"FORASTI (SUCEAVA)"
	,
	"FRASIN (SUCEAVA)"
	,
	"FRASIN (BROSTENI) (SUCEAVA)"
	,
	"FRATAUTII NOI (SUCEAVA)"
	,
	"FRATAUTII VECHI (SUCEAVA)"
	,
	"FRUMOASA (SUCEAVA)"
	,
	"FRUMOSU (SUCEAVA)"
	,
	"FUNDU MOLDOVEI (SUCEAVA)"
	,
	"GAINESTI (SUCEAVA)"
	,
	"GALANESTI (SUCEAVA)"
	,
	"GARA (SUCEAVA)"
	,
	"GARA LEU (SUCEAVA)"
	,
	"GEMENEA (SUCEAVA)"
	,
	"GHEORGHITENI (SUCEAVA)"
	,
	"GIULESTI (SUCEAVA)"
	,
	"GIURGESTI (SUCEAVA)"
	,
	"GLODU (SUCEAVA)"
	,
	"GRAMESTI (SUCEAVA)"
	,
	"GRANICESTI (SUCEAVA)"
	,
	"GRIGORESTI (SUCEAVA)"
	,
	"GROAPA VLADICHII (SUCEAVA)"
	,
	"GROPENI (SUCEAVA)"
	,
	"GULIA (SUCEAVA)"
	,
	"GURA HAITII (SUCEAVA)"
	,
	"GURA HUMORULUI (SUCEAVA)"
	,
	"GURA PUTNEI (SUCEAVA)"
	,
	"GURA SOLCII (SUCEAVA)"
	,
	"HALEASA (SUCEAVA)"
	,
	"HANCEA (SUCEAVA)"
	,
	"HANTESTI (SUCEAVA)"
	,
	"HARTOP (SUCEAVA)"
	,
	"HERLA (SUCEAVA)"
	,
	"HOLDA (SUCEAVA)"
	,
	"HOLDITA (SUCEAVA)"
	,
	"HORODNIC (SUCEAVA)"
	,
	"HORODNIC DE JOS (SUCEAVA)"
	,
	"HORODNIC DE SUS (SUCEAVA)"
	,
	"HORODNICENI (SUCEAVA)"
	,
	"HREATCA (SUCEAVA)"
	,
	"HUMORENI (SUCEAVA)"
	,
	"HURJUIENI (SUCEAVA)"
	,
	"HUSI (SUCEAVA)"
	,
	"IACOBENI (SUCEAVA)"
	,
	"IACOBESTI (SUCEAVA)"
	,
	"IASLOVAT (SUCEAVA)"
	,
	"IAZ (SUCEAVA)"
	,
	"IEDU (SUCEAVA)"
	,
	"IESLE (SUCEAVA)"
	,
	"ILISESTI (SUCEAVA)"
	,
	"IONEASA (SUCEAVA)"
	,
	"IPOTESTI (SUCEAVA)"
	,
	"IZVOARELE SUCEVEI (SUCEAVA)"
	,
	"JACOTA (SUCEAVA)"
	,
	"JAHALIA (SUCEAVA)"
	,
	"LAMASENI (SUCEAVA)"
	,
	"LEUCUSESTI (SUCEAVA)"
	,
	"LIPOVENI (SUCEAVA)"
	,
	"LISAURA (SUCEAVA)"
	,
	"LITENI (SUCEAVA)"
	,
	"LITENI (MOARA) (SUCEAVA)"
	,
	"LUCACESTI (SUCEAVA)"
	,
	"LUNCA (MILISAUTI) (SUCEAVA)"
	,
	"LUNCA (ZAMOSTEA) (SUCEAVA)"
	,
	"LUNCUSOARA (SUCEAVA)"
	,
	"LUNGENI (SUCEAVA)"
	,
	"LUPCINA (SUCEAVA)"
	,
	"MAGURA (SUCEAVA)"
	,
	"MAIDAN (SUCEAVA)"
	,
	"MALINI (SUCEAVA)"
	,
	"NEGOSTINA (SUCEAVA)"
	,
	"NEGRILEASA (SUCEAVA)"
	,
	"NICANI (SUCEAVA)"
	,
	"NIGOTESTI (SUCEAVA)"
	,
	"NISIPITU (SUCEAVA)"
	,
	"NOROCU (SUCEAVA)"
	,
	"OBCINA (SUCEAVA)"
	,
	"ONICENI (SUCEAVA)"
	,
	"ORTOAIA (SUCEAVA)"
	,
	"OSOI (SUCEAVA)"
	,
	"OSTRA (SUCEAVA)"
	,
	"PADURENI (SUCEAVA)"
	,
	"PAISENI (SUCEAVA)"
	,
	"PALTIN (SUCEAVA)"
	,
	"PALTINIS (SUCEAVA)"
	,
	"PALTINOASA (SUCEAVA)"
	,
	"PALTINU (SUCEAVA)"
	,
	"PANACI (SUCEAVA)"
	,
	"PARAIE (SUCEAVA)"
	,
	"PARAU NEGREI (SUCEAVA)"
	,
	"PARHAUTI (SUCEAVA)"
	,
	"PARTESTII DE JOS (SUCEAVA)"
	,
	"PARTESTII DE SUS (SUCEAVA)"
	,
	"PATRAUTI (SUCEAVA)"
	,
	"PETIA (SUCEAVA)"
	,
	"PIETROASA (SUCEAVA)"
	,
	"PILUGANI (SUCEAVA)"
	,
	"PLAI (SUCEAVA)"
	,
	"PLAIU SARULUI (SUCEAVA)"
	,
	"PLAVALARI (SUCEAVA)"
	,
	"PLESA (SUCEAVA)"
	,
	"PLESESTI (SUCEAVA)"
	,
	"PLOPENI (SUCEAVA)"
	,
	"PLUTONITA (SUCEAVA)"
	,
	"POCOLENI (SUCEAVA)"
	,
	"PODENI (SUCEAVA)"
	,
	"PODU COSNEI (SUCEAVA)"
	,
	"POIANA (DOLHASCA) (SUCEAVA)"
	,
	"POIANA (ZVORISTEA) (SUCEAVA)"
	,
	"POIANA MARULUI (SUCEAVA)"
	,
	"POIANA MICULUI (SUCEAVA)"
	,
	"POIANA NEGRII (SUCEAVA)"
	,
	"POIANA STAMPEI (SUCEAVA)"
	,
	"POIENARI (SUCEAVA)"
	,
	"POIENI-SOLCA (SUCEAVA)"
	,
	"POIENI-SUCEAVA (SUCEAVA)"
	,
	"POJORATA (SUCEAVA)"
	,
	"PRALENI (SUCEAVA)"
	,
	"PRAXIA (SUCEAVA)"
	,
	"PRELIPCA (SUCEAVA)"
	,
	"PREUTESTI (SUCEAVA)"
	,
	"PRISACA DORNEI (SUCEAVA)"
	,
	"PROBOTA (SUCEAVA)"
	,
	"PUTNA (SUCEAVA)"
	,
	"RACOVA (SUCEAVA)"
	,
	"RADASENI (SUCEAVA)"
	,
	"RADAUTI (SUCEAVA)"
	,
	"RASCA (SUCEAVA)"
	,
	"RAUTENI (SUCEAVA)"
	,
	"REUSENI (SUCEAVA)"
	,
	"ROMANESTI (DORNA CANDRENILOR) (SUCEAVA)"
	,
	"ROMANESTI (GRANICESTI) (SUCEAVA)"
	,
	"ROSCANI (SUCEAVA)"
	,
	"ROSIORI (SUCEAVA)"
	,
	"ROSU (SUCEAVA)"
	,
	"ROTOPANESTI (SUCEAVA)"
	,
	"ROTUNDA (SUCEAVA)"
	,
	"RUDESTI (SUCEAVA)"
	,
	"RUNCU (SUCEAVA)"
	,
	"RUSCA (SUCEAVA)"
	,
	"RUSI (SUCEAVA)"
	,
	"RUSII-MANASTIOARA (SUCEAVA)"
	,
	"SACUTA (SUCEAVA)"
	,
	"SADAU (SUCEAVA)"
	,
	"SADOVA (SUCEAVA)"
	,
	"SALAGENI (SUCEAVA)"
	,
	"SALCEA (SUCEAVA)"
	,
	"SARGHIESTI (SUCEAVA)"
	,
	"SARISOR (SUCEAVA)"
	,
	"SARISORU MARE (SUCEAVA)"
	,
	"SARU BUCOVINEI (SUCEAVA)"
	,
	"SARU DORNEI (SUCEAVA)"
	,
	"SASCA MARE (SUCEAVA)"
	,
	"SASCA MICA (SUCEAVA)"
	,
	"SASCA NOUA (SUCEAVA)"
	,
	"SATU MARE (SUCEAVA)"
	,
	"SATU MARE (CRUCEA) (SUCEAVA)"
	,
	"SCHEIA (SUCEAVA)"
	,
	"SECURICENI (SUCEAVA)"
	,
	"SERBANESTI (SUCEAVA)"
	,
	"SERBAUTI (SUCEAVA)"
	,
	"SES (SUCEAVA)"
	,
	"SESURI (SUCEAVA)"
	,
	"SFANTU ILIE (SUCEAVA)"
	,
	"SILISTEA (SUCEAVA)"
	,
	"SILISTEA NOUA (SUCEAVA)"
	,
	"SIMINICEA (SUCEAVA)"
	,
	"SINCA (SUCEAVA)"
	,
	"SIRET (SUCEAVA)"
	,
	"SLATINA (SUCEAVA)"
	,
	"SLATIOARA (RASCA) (SUCEAVA)"
	,
	"SLATIOARA (STULPICANI) (SUCEAVA)"
	,
	"SLOBOZIA (FANTANELE) (SUCEAVA)"
	,
	"SLOBOZIA (ZVORISTEA) (SUCEAVA)"
	,
	"SLOBOZIA SUCEVEI (SUCEAVA)"
	,
	"SMIDA UNGURENILOR (SUCEAVA)"
	,
	"SOLCA (SUCEAVA)"
	,
	"SOLDANESTI (SUCEAVA)"
	,
	"SOLONET (SUCEAVA)"
	,
	"SOLONETU NOU (SUCEAVA)"
	,
	"SPATARESTI (SUCEAVA)"
	,
	"STAMATE (SUCEAVA)"
	,
	"STANCA (SUCEAVA)"
	,
	"STANCUTA (SUCEAVA)"
	,
	"STIRBAT (SUCEAVA)"
	,
	"STRAJA (SUCEAVA)"
	,
	"STRAMTURA (SUCEAVA)"
	,
	"STROIESTI (SUCEAVA)"
	,
	"STULPICANI (SUCEAVA)"
	,
	"SUCEAVA (SUCEAVA)"
	,
	"SUCEVITA (SUCEAVA)"
	,
	"SUNATORI (SUCEAVA)"
	,
	"TARNA MARE (SUCEAVA)"
	,
	"TARNICIOARA (SUCEAVA)"
	,
	"TATARU (SUCEAVA)"
	,
	"TAUTESTI (SUCEAVA)"
	,
	"TESNA (DORNA CANDRENILOR) (SUCEAVA)"
	,
	"TESNA (POIANA STAMPEI) (SUCEAVA)"
	,
	"TIBAU (SUCEAVA)"
	,
	"TIBENI (SUCEAVA)"
	,
	"TISAUTI (SUCEAVA)"
	,
	"TODIRENI (SUCEAVA)"
	,
	"TODIRESTI (SUCEAVA)"
	,
	"TOLESTI (SUCEAVA)"
	,
	"TREI MOVILE (SUCEAVA)"
	,
	"UDESTI (SUCEAVA)"
	,
	"UIDESTI (SUCEAVA)"
	,
	"ULMA (SUCEAVA)"
	,
	"UNCESTI (SUCEAVA)"
	,
	"VADU MOLDOVEI (SUCEAVA)"
	,
	"VADU NEGRILESEI (SUCEAVA)"
	,
	"VALCELELE (SUCEAVA)"
	,
	"VALEA BANCULUI (SUCEAVA)"
	,
	"VALEA BOUREI (SUCEAVA)"
	,
	"VALEA GLODULUI (SUCEAVA)"
	,
	"VALEA MOLDOVEI (SUCEAVA)"
	,
	"VALEA POIENEI (SUCEAVA)"
	,
	"VALEA PUTNEI (SUCEAVA)"
	,
	"VALEA STANEI (SUCEAVA)"
	,
	"VALENI-STANISOARA (SUCEAVA)"
	,
	"VAMA (SUCEAVA)"
	,
	"VARATEC (SUCEAVA)"
	,
	"VARFU DEALULUI (SUCEAVA)"
	,
	"VARVATA (SUCEAVA)"
	,
	"VASCAUTI (SUCEAVA)"
	,
	"VATRA DORNEI (SUCEAVA)"
	,
	"VATRA MOLDOVITEI (SUCEAVA)"
	,
	"VERBIA (SUCEAVA)"
	,
	"VERCICANI (SUCEAVA)"
	,
	"VERESTI (SUCEAVA)"
	,
	"VICOVU DE JOS (SUCEAVA)"
	,
	"VICOVU DE SUS (SUCEAVA)"
	,
	"VICSANI (SUCEAVA)"
	,
	"VOIEVODEASA (SUCEAVA)"
	,
	"VOITINEL (SUCEAVA)"
	,
	"VOLOVAT (SUCEAVA)"
	,
	"VORNICENII MARI (SUCEAVA)"
	,
	"VORNICENII MICI (SUCEAVA)"
	,
	"VORONET (SUCEAVA)"
	,
	"VULTURESTI (SUCEAVA)"
	,
	"ZAHARESTI (SUCEAVA)"
	,
	"ZALOMESTRA (SUCEAVA)"
	,
	"ZAMOSTEA (SUCEAVA)"
	,
	"ZVORISTEA (SUCEAVA)"
	,
	"ALBENI (TELEORMAN)"
	,
	"ALBESTI (TELEORMAN)"
	,
	"ALEXANDRIA (TELEORMAN)"
	,
	"ANTONESTI (TELEORMAN)"
	,
	"BABAITA (TELEORMAN)"
	,
	"BACALESTI (TELEORMAN)"
	,
	"BACIU (TELEORMAN)"
	,
	"BADULEASA (TELEORMAN)"
	,
	"BALACI (TELEORMAN)"
	,
	"BALDOVINESTI (TELEORMAN)"
	,
	"BALTA SARATA (TELEORMAN)"
	,
	"BANEASA (TELEORMAN)"
	,
	"BANOV (TELEORMAN)"
	,
	"BARSESTII DE JOS (TELEORMAN)"
	,
	"BASCOVENI (TELEORMAN)"
	,
	"BECIU (TELEORMAN)"
	,
	"BEIU (TELEORMAN)"
	,
	"BELCIUG (TELEORMAN)"
	,
	"BEUCA (TELEORMAN)"
	,
	"BLEJESTI (TELEORMAN)"
	,
	"BOGDANA (TELEORMAN)"
	,
	"BOTOROAGA (TELEORMAN)"
	,
	"BRAGADIRU (TELEORMAN)"
	,
	"BRANCENI (TELEORMAN)"
	,
	"BRANCOVEANCA (TELEORMAN)"
	,
	"BRATASANI (TELEORMAN)"
	,
	"BRATCOVU (TELEORMAN)"
	,
	"BRATESTI (TELEORMAN)"
	,
	"BREBINA (TELEORMAN)"
	,
	"BROSTEANCA (TELEORMAN)"
	,
	"BUJORENI (TELEORMAN)"
	,
	"BUJORU (TELEORMAN)"
	,
	"BUJORU (CALMATUIU) (TELEORMAN)"
	,
	"BURDENI (TELEORMAN)"
	,
	"BUTCULESTI (TELEORMAN)"
	,
	"BUTESTI (TELEORMAN)"
	,
	"BUZESCU (TELEORMAN)"
	,
	"CALINESTI (TELEORMAN)"
	,
	"CALMATUIU (TELEORMAN)"
	,
	"CALMATUIU DE SUS (TELEORMAN)"
	,
	"CALOMFIRESTI (TELEORMAN)"
	,
	"CALUGARU (TELEORMAN)"
	,
	"CARAVANETI (TELEORMAN)"
	,
	"CARLOMANU (TELEORMAN)"
	,
	"CATUNU (TELEORMAN)"
	,
	"CERNETU (TELEORMAN)"
	,
	"CERVENIA (TELEORMAN)"
	,
	"CETATEA (TELEORMAN)"
	,
	"CIOLANESTI (TELEORMAN)"
	,
	"CIOLANESTII DIN DEAL (TELEORMAN)"
	,
	"CIOLANESTII DIN VALE (TELEORMAN)"
	,
	"CIUPERCENI (TELEORMAN)"
	,
	"CIUPERCENI (COSMESTI) (TELEORMAN)"
	,
	"CIURARI (TELEORMAN)"
	,
	"CIURARI-DEAL (TELEORMAN)"
	,
	"CLANITA (TELEORMAN)"
	,
	"COMOARA (TELEORMAN)"
	,
	"CONTESTI (TELEORMAN)"
	,
	"COPACEANCA (TELEORMAN)"
	,
	"COSMESTI (TELEORMAN)"
	,
	"COSOAIA (TELEORMAN)"
	,
	"COSOTENI (TELEORMAN)"
	,
	"CRANGENI (TELEORMAN)"
	,
	"CRANGU (TELEORMAN)"
	,
	"CREVENICU (TELEORMAN)"
	,
	"CUCUETI (TELEORMAN)"
	,
	"DARVAS (TELEORMAN)"
	,
	"DEPARATI (TELEORMAN)"
	,
	"DIDESTI (TELEORMAN)"
	,
	"DOBRENI (TELEORMAN)"
	,
	"DOBROTESTI (TELEORMAN)"
	,
	"DOROBANTU (TELEORMAN)"
	,
	"DRACEA (TELEORMAN)"
	,
	"DRACESTI (TELEORMAN)"
	,
	"DRACSANI (TELEORMAN)"
	,
	"DRACSENEI (TELEORMAN)"
	,
	"DRAGANESTI DE VEDE (TELEORMAN)"
	,
	"DRAGANESTI-VLASCA (TELEORMAN)"
	,
	"DRAGHINESTI (TELEORMAN)"
	,
	"DUDU (TELEORMAN)"
	,
	"DULCEANCA (TELEORMAN)"
	,
	"DULCENI (TELEORMAN)"
	,
	"FANTANELE (TELEORMAN)"
	,
	"FLORICA (TELEORMAN)"
	,
	"FRASINET (TELEORMAN)"
	,
	"FRUMOASA (TELEORMAN)"
	,
	"FURCULESTI (TELEORMAN)"
	,
	"GALATENI (TELEORMAN)"
	,
	"GARAGAU (TELEORMAN)"
	,
	"GARDESTI (TELEORMAN)"
	,
	"GRADISTEANCA (TELEORMAN)"
	,
	"GRATIA (TELEORMAN)"
	,
	"GRESIA (TELEORMAN)"
	,
	"GURUIENI (TELEORMAN)"
	,
	"INSURATEI (TELEORMAN)"
	,
	"IONASCU (TELEORMAN)"
	,
	"ISLAZ (TELEORMAN)"
	,
	"IZVOARELE (TELEORMAN)"
	,
	"LACENI (TELEORMAN)"
	,
	"LADA (TELEORMAN)"
	,
	"LICURICIU (TELEORMAN)"
	,
	"LINIA COSTII (TELEORMAN)"
	,
	"LISA (TELEORMAN)"
	,
	"LITA (TELEORMAN)"
	,
	"LUDANEASCA (TELEORMAN)"
	,
	"LUNCA (TELEORMAN)"
	,
	"MAGURA (TELEORMAN)"
	,
	"MAGURA CU LILIAC (TELEORMAN)"
	,
	"MALDAENI (TELEORMAN)"
	,
	"MARITA (TELEORMAN)"
	,
	"MARZANESTI (TELEORMAN)"
	,
	"MAVRODIN (TELEORMAN)"
	,
	"MERENI (TELEORMAN)"
	,
	"MERENII DE JOS (TELEORMAN)"
	,
	"MERENII DE SUS (TELEORMAN)"
	,
	"MERI (TELEORMAN)"
	,
	"MERISANI (BABAITA) (TELEORMAN)"
	,
	"MERISANI (DOBROTESTI) (TELEORMAN)"
	,
	"MOLDOVENI (TELEORMAN)"
	,
	"MOSTENI (TELEORMAN)"
	,
	"MOSTENI (FURCULESTI) (TELEORMAN)"
	,
	"NANOV (TELEORMAN)"
	,
	"NASTURELU (TELEORMAN)"
	,
	"NAVODARI (TELEORMAN)"
	,
	"NECSESTI (TELEORMAN)"
	,
	"NEGRENI (TELEORMAN)"
	,
	"NEGRENII DE SUS (TELEORMAN)"
	,
	"NEGRENII-OSEBITI (TELEORMAN)"
	,
	"NEGRILESTI (TELEORMAN)"
	,
	"NENCIULESTI (TELEORMAN)"
	,
	"NICOLAE BALCESCU (TELEORMAN)"
	,
	"OBARTU (TELEORMAN)"
	,
	"ODOBEASCA (TELEORMAN)"
	,
	"OLTEANCA (TELEORMAN)"
	,
	"OLTENI (TELEORMAN)"
	,
	"ORBEASCA (TELEORMAN)"
	,
	"ORBEASCA DE JOS (TELEORMAN)"
	,
	"ORBEASCA DE SUS (TELEORMAN)"
	,
	"PARU ROTUND (TELEORMAN)"
	,
	"PAULEASCA (TELEORMAN)"
	,
	"PERETU (TELEORMAN)"
	,
	"PERII BROSTENI (TELEORMAN)"
	,
	"PIATRA (TELEORMAN)"
	,
	"PIETROSANI (TELEORMAN)"
	,
	"PLEASOV (TELEORMAN)"
	,
	"PLOPI (TELEORMAN)"
	,
	"PLOPII-SLAVITESTI (TELEORMAN)"
	,
	"PLOSCA (TELEORMAN)"
	,
	"POENI (TELEORMAN)"
	,
	"POIANA (TELEORMAN)"
	,
	"POROSCHIA (TELEORMAN)"
	,
	"PREAJBA (TELEORMAN)"
	,
	"PRUNARU (TELEORMAN)"
	,
	"PRUNDU (TELEORMAN)"
	,
	"PURANI (SILISTEA) (TELEORMAN)"
	,
	"PURANI (VITANESTI) (TELEORMAN)"
	,
	"PURANII DE SUS (TELEORMAN)"
	,
	"PUTINEIU (TELEORMAN)"
	,
	"RADOIESTI (TELEORMAN)"
	,
	"RADOIESTI-DEAL (TELEORMAN)"
	,
	"RADOIESTI-VALE (TELEORMAN)"
	,
	"RADULESTI (TELEORMAN)"
	,
	"RASMIRESTI (TELEORMAN)"
	,
	"ROSIORI DE VEDE (TELEORMAN)"
	,
	"ROTARESTI (TELEORMAN)"
	,
	"SACENI (TELEORMAN)"
	,
	"SAELELE (TELEORMAN)"
	,
	"SALCIA (TELEORMAN)"
	,
	"SARBENI (TELEORMAN)"
	,
	"SARBENII DE JOS (TELEORMAN)"
	,
	"SATU NOU (TELEORMAN)"
	,
	"SATUL VECHI (TELEORMAN)"
	,
	"SCHITU POIENARI (TELEORMAN)"
	,
	"SCRIOASTEA (TELEORMAN)"
	,
	"SCURTU MARE (TELEORMAN)"
	,
	"SCURTU-SLAVESTI (TELEORMAN)"
	,
	"SEACA (TELEORMAN)"
	,
	"SECARA (TELEORMAN)"
	,
	"SEGARCEA-DEAL (TELEORMAN)"
	,
	"SEGARCEA-VALE (TELEORMAN)"
	,
	"SERICU (TELEORMAN)"
	,
	"SFINTESTI (TELEORMAN)"
	,
	"SILISTEA (TELEORMAN)"
	,
	"SILISTEA (VITANESTI) (TELEORMAN)"
	,
	"SILISTEA GUMESTI (TELEORMAN)"
	,
	"SILISTEA MICA (TELEORMAN)"
	,
	"SLAVESTI (TELEORMAN)"
	,
	"SLOBOZIA MANDRA (TELEORMAN)"
	,
	"SMARDAN (TELEORMAN)"
	,
	"SMARDIOASA (TELEORMAN)"
	,
	"SOCETU (TELEORMAN)"
	,
	"SOIMU (TELEORMAN)"
	,
	"SPATAREI (TELEORMAN)"
	,
	"STEFENI (TELEORMAN)"
	,
	"STEJARU (TELEORMAN)"
	,
	"STEJARU (CRANGENI) (TELEORMAN)"
	,
	"STOROBANEASA (TELEORMAN)"
	,
	"SUHAIA (TELEORMAN)"
	,
	"TALPA (TELEORMAN)"
	,
	"TALPA POSTEI (TELEORMAN)"
	,
	"TALPA-BASCOVENI (TELEORMAN)"
	,
	"TALPA-OGRAZILE (TELEORMAN)"
	,
	"TARNAVA (TELEORMAN)"
	,
	"TATARASTII DE JOS (TELEORMAN)"
	,
	"TATARASTII DE SUS (TELEORMAN)"
	,
	"TAVARLAU (TELEORMAN)"
	,
	"TECUCI (TELEORMAN)"
	,
	"TELEORMANU (TELEORMAN)"
	,
	"TIGANESTI (TELEORMAN)"
	,
	"TRAIAN (TELEORMAN)"
	,
	"TRIVALEA-MOSTENI (TELEORMAN)"
	,
	"TROIANUL (TELEORMAN)"
	,
	"TUDOR VLADIMIRESCU (TELEORMAN)"
	,
	"TUNARI (TELEORMAN)"
	,
	"TURNU MAGURELE (TELEORMAN)"
	,
	"UDA-CLOCOCIOV (TELEORMAN)"
	,
	"UDA-PACIUREA (TELEORMAN)"
	,
	"UDENI (TELEORMAN)"
	,
	"UDUPU (TELEORMAN)"
	,
	"ULMENI (TELEORMAN)"
	,
	"URLUIU (TELEORMAN)"
	,
	"VACARESTI (TELEORMAN)"
	,
	"VACENI (TELEORMAN)"
	,
	"VALEA CIRESULUI (TELEORMAN)"
	,
	"VALEA PARULUI (TELEORMAN)"
	,
	"VALEA POSTEI (TELEORMAN)"
	,
	"VANATORI (TELEORMAN)"
	,
	"VARTOAPE (TELEORMAN)"
	,
	"VARTOAPELE DE JOS (TELEORMAN)"
	,
	"VARTOAPELE DE SUS (TELEORMAN)"
	,
	"VATASI (TELEORMAN)"
	,
	"VATRA (TELEORMAN)"
	,
	"VEDEA (TELEORMAN)"
	,
	"VIDELE (TELEORMAN)"
	,
	"VIILE (TELEORMAN)"
	,
	"VIISOARA (TELEORMAN)"
	,
	"VITANESTI (TELEORMAN)"
	,
	"VOIEVODA (TELEORMAN)"
	,
	"ZAMBREASCA (TELEORMAN)"
	,
	"ZIMNICEA (TELEORMAN)"
	,
	"ZIMNICELE (TELEORMAN)"
	,
	"ZLATA (TELEORMAN)"
	,
	"ALBINA (TIMIS)"
	,
	"ALIOS (TIMIS)"
	,
	"ALTRINGEN (TIMIS)"
	,
	"BABSA (TIMIS)"
	,
	"BACOVA (TIMIS)"
	,
	"BALINT (TIMIS)"
	,
	"BALOSESTI (TIMIS)"
	,
	"BANLOC (TIMIS)"
	,
	"BARA (TIMIS)"
	,
	"BARATEAZ (TIMIS)"
	,
	"BARNA (TIMIS)"
	,
	"BATESTI (TIMIS)"
	,
	"BAZOS (TIMIS)"
	,
	"BAZOSU NOU (TIMIS)"
	,
	"BEBA VECHE (TIMIS)"
	,
	"BECICHERECU MIC (TIMIS)"
	,
	"BEGHEIU MIC (TIMIS)"
	,
	"BELINT (TIMIS)"
	,
	"BENCECU DE JOS (TIMIS)"
	,
	"BENCECU DE SUS (TIMIS)"
	,
	"BERECUTA (TIMIS)"
	,
	"BEREGSAU MARE (TIMIS)"
	,
	"BEREGSAU MIC (TIMIS)"
	,
	"BERINI (TIMIS)"
	,
	"BETHAUSEN (TIMIS)"
	,
	"BICHIGI (TIMIS)"
	,
	"BILED (TIMIS)"
	,
	"BIRDA (TIMIS)"
	,
	"BLAJOVA (TIMIS)"
	,
	"BOBDA (TIMIS)"
	,
	"BODO (TIMIS)"
	,
	"BOGDA (TIMIS)"
	,
	"BOLDUR (TIMIS)"
	,
	"BOTESTI (TIMIS)"
	,
	"BOTINESTI (TIMIS)"
	,
	"BRANESTI (TIMIS)"
	,
	"BREAZOVA (TIMIS)"
	,
	"BRESTEA (TIMIS)"
	,
	"BRESTOVAT (TIMIS)"
	,
	"BUCOVAT (DUMBRAVA) (TIMIS)"
	,
	"BUCOVAT (REMETEA MARE) (TIMIS)"
	,
	"BULGARUS (TIMIS)"
	,
	"BULZA (TIMIS)"
	,
	"BUNEA MARE (TIMIS)"
	,
	"BUNEA MICA (TIMIS)"
	,
	"BUTIN (TIMIS)"
	,
	"BUZAD (TIMIS)"
	,
	"BUZIAS (TIMIS)"
	,
	"CADAR (TIMIS)"
	,
	"CALACEA (TIMIS)"
	,
	"CAPAT (TIMIS)"
	,
	"CARANI (TIMIS)"
	,
	"CARPINIS (TIMIS)"
	,
	"CEBZA (TIMIS)"
	,
	"CENAD (TIMIS)"
	,
	"CENEI (TIMIS)"
	,
	"CERNA (TIMIS)"
	,
	"CERNETEAZ (TIMIS)"
	,
	"CHARLOTENBURG (TIMIS)"
	,
	"CHECEA (TIMIS)"
	,
	"CHECHES (TIMIS)"
	,
	"CHEGLEVICI (TIMIS)"
	,
	"CHERESTUR (TIMIS)"
	,
	"CHEVERESU MARE (TIMIS)"
	,
	"CHISODA (TIMIS)"
	,
	"CHIZATAU (TIMIS)"
	,
	"CIACOVA (TIMIS)"
	,
	"CIRESU (TIMIS)"
	,
	"CIRESU MIC (TIMIS)"
	,
	"CLADOVA (TIMIS)"
	,
	"CLICIOVA (TIMIS)"
	,
	"CLOPODIA (TIMIS)"
	,
	"COLONIA BULGARA (TIMIS)"
	,
	"COLONIA FABRICII (TIMIS)"
	,
	"COLONIA MICA (TIMIS)"
	,
	"COMEAT (TIMIS)"
	,
	"COMLOSU MARE (TIMIS)"
	,
	"COMLOSU MIC (TIMIS)"
	,
	"CORNESTI (TIMIS)"
	,
	"COSARII (TIMIS)"
	,
	"COSAVA (TIMIS)"
	,
	"COSEVITA (TIMIS)"
	,
	"COSTEIU (TIMIS)"
	,
	"COSTEIU DE SUS (TIMIS)"
	,
	"COVACI (TIMIS)"
	,
	"CRAI NOU (TIMIS)"
	,
	"CRALOVAT (TIMIS)"
	,
	"CRICIOVA (TIMIS)"
	,
	"CRIVINA (TIMIS)"
	,
	"CRIVINA DE SUS (TIMIS)"
	,
	"CRIVOBARA (TIMIS)"
	,
	"CRUCENI (TIMIS)"
	,
	"CURTEA (TIMIS)"
	,
	"CUTINA (TIMIS)"
	,
	"DAROVA (TIMIS)"
	,
	"DEJAN (TIMIS)"
	,
	"DENTA (TIMIS)"
	,
	"DETA (TIMIS)"
	,
	"DINIAS (TIMIS)"
	,
	"DOBRESTI (TIMIS)"
	,
	"DOLAT (TIMIS)"
	,
	"DRAGOIESTI (TIMIS)"
	,
	"DRAGOMIRESTI (TIMIS)"
	,
	"DRAGSINA (TIMIS)"
	,
	"DRAGSINESTI (TIMIS)"
	,
	"DRINOVA (TIMIS)"
	,
	"DUBESTI (TIMIS)"
	,
	"DUBOZ (TIMIS)"
	,
	"DUDESTII NOI (TIMIS)"
	,
	"DUDESTII VECHI (TIMIS)"
	,
	"DUMBRAVA (TIMIS)"
	,
	"DUMBRAVITA (TIMIS)"
	,
	"FADIMAC (TIMIS)"
	,
	"FAGET (TIMIS)"
	,
	"FARASESTI (TIMIS)"
	,
	"FARDEA (TIMIS)"
	,
	"FERENDIA (TIMIS)"
	,
	"FIBIS (TIMIS)"
	,
	"FICATAR (TIMIS)"
	,
	"FOENI (TIMIS)"
	,
	"FOLEA (TIMIS)"
	,
	"GAD (TIMIS)"
	,
	"GAIU MIC (TIMIS)"
	,
	"GATAIA (TIMIS)"
	,
	"GAVOJDIA (TIMIS)"
	,
	"GELU (TIMIS)"
	,
	"GHERMAN (TIMIS)"
	,
	"GHILAD (TIMIS)"
	,
	"GHIRODA (TIMIS)"
	,
	"GHIZELA (TIMIS)"
	,
	"GIARMATA (TIMIS)"
	,
	"GIARMATA-VII (TIMIS)"
	,
	"GIERA (TIMIS)"
	,
	"GIROC (TIMIS)"
	,
	"GIULVAZ (TIMIS)"
	,
	"GLADNA MONTANA (TIMIS)"
	,
	"GLADNA ROMANA (TIMIS)"
	,
	"GOTTLOB (TIMIS)"
	,
	"GRABAT (TIMIS)"
	,
	"GRANICERII (TIMIS)"
	,
	"GROSI (TIMIS)"
	,
	"GRUNI (TIMIS)"
	,
	"HAUZESTI (TIMIS)"
	,
	"HERENDESTI (TIMIS)"
	,
	"HERNEACOVA (TIMIS)"
	,
	"HEZERIS (TIMIS)"
	,
	"HISIAS (TIMIS)"
	,
	"HITIAS (TIMIS)"
	,
	"HODONI (TIMIS)"
	,
	"HODOS (BRESTOVAT) (TIMIS)"
	,
	"HODOS (DAROVA) (TIMIS)"
	,
	"HOMOJDIA (TIMIS)"
	,
	"HONORICI (TIMIS)"
	,
	"IANOVA (TIMIS)"
	,
	"ICLODA (TIMIS)"
	,
	"ICTAR-BUDINTI (TIMIS)"
	,
	"IECEA MARE (TIMIS)"
	,
	"IECEA MICA (TIMIS)"
	,
	"IERSNIC (TIMIS)"
	,
	"IGRIS (TIMIS)"
	,
	"IOHANISFELD (TIMIS)"
	,
	"IOSIF (TIMIS)"
	,
	"IOSIFALAU (TIMIS)"
	,
	"IVANDA (TIMIS)"
	,
	"IZVIN (TIMIS)"
	,
	"JABAR (TIMIS)"
	,
	"JAMU MARE (TIMIS)"
	,
	"JDIOARA (TIMIS)"
	,
	"JEBEL (TIMIS)"
	,
	"JENA (TIMIS)"
	,
	"JIMBOLIA (TIMIS)"
	,
	"JUPANESTI (TIMIS)"
	,
	"JUPANI (TIMIS)"
	,
	"JURESTI (TIMIS)"
	,
	"LAPUSNIC (TIMIS)"
	,
	"LATUNAS (TIMIS)"
	,
	"LENAUHEIM (TIMIS)"
	,
	"LEUCUSESTI (TIMIS)"
	,
	"LIEBLING (TIMIS)"
	,
	"LIVEZILE (TIMIS)"
	,
	"LOVRIN (TIMIS)"
	,
	"LUCARET (TIMIS)"
	,
	"LUGOJ (TIMIS)"
	,
	"LUGOJEL (TIMIS)"
	,
	"LUNCANII DE JOS (TIMIS)"
	,
	"LUNCANII DE SUS (TIMIS)"
	,
	"LUNGA (TIMIS)"
	,
	"MACEDONIA (TIMIS)"
	,
	"MAGURI (TIMIS)"
	,
	"MANASTIRE (TIMIS)"
	,
	"MANASTIUR (TIMIS)"
	,
	"MARGINA (TIMIS)"
	,
	"MASLOC (TIMIS)"
	,
	"MATNICU MIC (TIMIS)"
	,
	"MORAVITA (TIMIS)"
	,
	"MOSNITA NOUA (TIMIS)"
	,
	"MOSNITA VECHE (TIMIS)"
	,
	"MURANI (TIMIS)"
	,
	"NADAS (TIMIS)"
	,
	"NADRAG (TIMIS)"
	,
	"NEMESESTI (TIMIS)"
	,
	"NERAU (TIMIS)"
	,
	"NEVRINCEA (TIMIS)"
	,
	"NITCHIDORF (TIMIS)"
	,
	"OBAD (TIMIS)"
	,
	"OFSENITA (TIMIS)"
	,
	"OHABA LUNGA (TIMIS)"
	,
	"OHABA ROMANA (TIMIS)"
	,
	"OHABA-FORGACI (TIMIS)"
	,
	"OLOSAG (TIMIS)"
	,
	"OPATITA (TIMIS)"
	,
	"ORTISOARA (TIMIS)"
	,
	"OTELEC (TIMIS)"
	,
	"OTVESTI (TIMIS)"
	,
	"PADURANI (TIMIS)"
	,
	"PADURENI (JEBEL) (TIMIS)"
	,
	"PADURENI (TIMIS)"
	,
	"PANIOVA (TIMIS)"
	,
	"PARTA (TIMIS)"
	,
	"PARTOS (TIMIS)"
	,
	"PARU (TIMIS)"
	,
	"PECIU NOU (TIMIS)"
	,
	"PERCOSOVA (TIMIS)"
	,
	"PERIAM (TIMIS)"
	,
	"PESAC (TIMIS)"
	,
	"PETROASA MARE (TIMIS)"
	,
	"PETROMAN (TIMIS)"
	,
	"PETROVASELO (TIMIS)"
	,
	"PIETROASA (TIMIS)"
	,
	"PINI (TIMIS)"
	,
	"PISCHIA (TIMIS)"
	,
	"POGANESTI (TIMIS)"
	,
	"POIENI (TIMIS)"
	,
	"PORDEANU (TIMIS)"
	,
	"POVARGINA (TIMIS)"
	,
	"PUSTINIS (TIMIS)"
	,
	"RACHITA (TIMIS)"
	,
	"RACOVITA (TIMIS)"
	,
	"RADMANESTI (TIMIS)"
	,
	"RAUTI (TIMIS)"
	,
	"RECAS (TIMIS)"
	,
	"REMETEA MARE (TIMIS)"
	,
	"REMETEA MICA (TIMIS)"
	,
	"REMETEA-LUNCA (TIMIS)"
	,
	"ROMANESTI (TIMIS)"
	,
	"ROVINITA MARE (TIMIS)"
	,
	"ROVINITA MICA (TIMIS)"
	,
	"RUDICICA (TIMIS)"
	,
	"RUDNA (TIMIS)"
	,
	"SACALAZ (TIMIS)"
	,
	"SACENI (TIMIS)"
	,
	"SACOSU MARE (TIMIS)"
	,
	"SACOSU TURCESC (TIMIS)"
	,
	"SAG (TIMIS)"
	,
	"SALBAGEL (TIMIS)"
	,
	"SALCIUA NOUA (TIMIS)"
	,
	"SANANDREI (TIMIS)"
	,
	"SANDRA (TIMIS)"
	,
	"SANGEORGE (TIMIS)"
	,
	"SANMARTINU MAGHIAR (TIMIS)"
	,
	"SANMARTINU SARBESC (TIMIS)"
	,
	"SANMIHAIU GERMAN (TIMIS)"
	,
	"SANMIHAIU ROMAN (TIMIS)"
	,
	"SANNICOLAU MARE (TIMIS)"
	,
	"SANOVITA (TIMIS)"
	,
	"SANPETRU MARE (TIMIS)"
	,
	"SANPETRU MIC (TIMIS)"
	,
	"SARAVALE (TIMIS)"
	,
	"SARAZANI (TIMIS)"
	,
	"SARBOVA (TIMIS)"
	,
	"SATCHINEZ (TIMIS)"
	,
	"SCULIA (TIMIS)"
	,
	"SECAS (TIMIS)"
	,
	"SECEANI (TIMIS)"
	,
	"SEMLACU MARE (TIMIS)"
	,
	"SEMLACU MIC (TIMIS)"
	,
	"SILAGIU (TIMIS)"
	,
	"SINERSIG (TIMIS)"
	,
	"SINTAR (TIMIS)"
	,
	"SINTESTI (TIMIS)"
	,
	"SIPET (TIMIS)"
	,
	"SOCA (TIMIS)"
	,
	"SPATA (TIMIS)"
	,
	"STAMORA GERMANA (TIMIS)"
	,
	"STAMORA ROMANA (TIMIS)"
	,
	"STANCIOVA (TIMIS)"
	,
	"STIUCA (TIMIS)"
	,
	"SUDRIAS (TIMIS)"
	,
	"SURDUCU MIC (TIMIS)"
	,
	"SUSANI (TIMIS)"
	,
	"SUSTRA (TIMIS)"
	,
	"TAPIA (TIMIS)"
	,
	"TARGOVISTE (TIMIS)"
	,
	"TEMERESTI (TIMIS)"
	,
	"TEREMIA MARE (TIMIS)"
	,
	"TEREMIA MICA (TIMIS)"
	,
	"TES (TIMIS)"
	,
	"TIMISOARA (TIMIS)"
	,
	"TIPARI (TIMIS)"
	,
	"TOAGER (TIMIS)"
	,
	"TOMESTI (TIMIS)"
	,
	"TOMNATIC (TIMIS)"
	,
	"TOPLA (TIMIS)"
	,
	"TOPOLOVATU MARE (TIMIS)"
	,
	"TOPOLOVATU MIC (TIMIS)"
	,
	"TORMAC (TIMIS)"
	,
	"TRAIAN VUIA (TIMIS)"
	,
	"UIHEI (TIMIS)"
	,
	"UIVAR (TIMIS)"
	,
	"ULIUC (TIMIS)"
	,
	"UNIP (TIMIS)"
	,
	"URSENI (TIMIS)"
	,
	"UTVIN (TIMIS)"
	,
	"VALCANI (TIMIS)"
	,
	"VALEA LUNGA ROMANA (TIMIS)"
	,
	"VARIAS (TIMIS)"
	,
	"VICTOR VLAD DELAMARINA (TIMIS)"
	,
	"VISAG (TIMIS)"
	,
	"VIZEJDIA (TIMIS)"
	,
	"VIZMA (TIMIS)"
	,
	"VOITEG (TIMIS)"
	,
	"VUCOVA (TIMIS)"
	,
	"ZGRIBESTI (TIMIS)"
	,
	"ZOLT (TIMIS)"
	,
	"ZORANI (TIMIS)"
	,
	"AGIGHIOL (TULCEA)"
	,
	"ALBA (TULCEA)"
	,
	"ARDEALU (TULCEA)"
	,
	"ATMAGEA (TULCEA)"
	,
	"BABADAG (TULCEA)"
	,
	"BAIA (TULCEA)"
	,
	"BALABANCEA (TULCEA)"
	,
	"BALTENII DE JOS (TULCEA)"
	,
	"BALTENII DE SUS (TULCEA)"
	,
	"BEIDAUD (TULCEA)"
	,
	"BESTEPE (TULCEA)"
	,
	"C.A. ROSETTI (TULCEA)"
	,
	"CALFA (TULCEA)"
	,
	"CAMENA (TULCEA)"
	,
	"CAPRIOARA (TULCEA)"
	,
	"CARAORMAN (TULCEA)"
	,
	"CARCALIU (TULCEA)"
	,
	"CARDON (TULCEA)"
	,
	"CARJELARI (TULCEA)"
	,
	"CASIMCEA (TULCEA)"
	,
	"CASLITA (TULCEA)"
	,
	"CATALOI (TULCEA)"
	,
	"CAUGAGIA (TULCEA)"
	,
	"CEAMURLIA DE JOS (TULCEA)"
	,
	"CEAMURLIA DE SUS (TULCEA)"
	,
	"CEATALCHIOI (TULCEA)"
	,
	"CERBU (TULCEA)"
	,
	"CERNA (TULCEA)"
	,
	"CHILIA VECHE (TULCEA)"
	,
	"CISMEAUA NOUA (TULCEA)"
	,
	"CIUCUROVA (TULCEA)"
	,
	"CLOSCA (TULCEA)"
	,
	"COLINA (TULCEA)"
	,
	"CORUGEA (TULCEA)"
	,
	"CRISAN (TULCEA)"
	,
	"DAENI (TULCEA)"
	,
	"DOROBANTU (TULCEA)"
	,
	"DUNAVATU DE JOS (TULCEA)"
	,
	"DUNAVATU DE SUS (TULCEA)"
	,
	"ENISALA (TULCEA)"
	,
	"FAGARASU NOU (TULCEA)"
	,
	"FANTANA MARE (TULCEA)"
	,
	"FANTANA OILOR (TULCEA)"
	,
	"FLORESTI (TULCEA)"
	,
	"FRECATEI (TULCEA)"
	,
	"GARVAN (TULCEA)"
	,
	"GENERAL PRAPORGESCU (TULCEA)"
	,
	"GORGOVA (TULCEA)"
	,
	"GRECI (TULCEA)"
	,
	"GRINDU (TULCEA)"
	,
	"HAIDAR (TULCEA)"
	,
	"HAMCEARCA (TULCEA)"
	,
	"HORIA (TULCEA)"
	,
	"I.C. BRATIANU (TULCEA)"
	,
	"IAZURILE (TULCEA)"
	,
	"ILGANII DE JOS (TULCEA)"
	,
	"ILGANII DE SUS (TULCEA)"
	,
	"ISACCEA (TULCEA)"
	,
	"IULIA (TULCEA)"
	,
	"IZVOARELE (TULCEA)"
	,
	"JIJILA (TULCEA)"
	,
	"JURILOVCA (TULCEA)"
	,
	"LASTUNI (TULCEA)"
	,
	"LETEA (TULCEA)"
	,
	"LUMINITA (TULCEA)"
	,
	"LUNCA (TULCEA)"
	,
	"LUNCAVITA (TULCEA)"
	,
	"MACIN (TULCEA)"
	,
	"MAGURELE (TULCEA)"
	,
	"MAHMUDIA (TULCEA)"
	,
	"MALCOCI (TULCEA)"
	,
	"MALIUC (TULCEA)"
	,
	"MESTERU (TULCEA)"
	,
	"MIHAI BRAVU (TULCEA)"
	,
	"MIHAIL KOGALNICEANU (TULCEA)"
	,
	"MILA 23 (TULCEA)"
	,
	"MINA ALTAN TEPE (TULCEA)"
	,
	"MINERI (TULCEA)"
	,
	"MIRCEA VODA (TULCEA)"
	,
	"MURIGHIOL (TULCEA)"
	,
	"NALBANT (TULCEA)"
	,
	"NEATARNAREA (TULCEA)"
	,
	"NICOLAE BALCESCU (TULCEA)"
	,
	"NICULITEL (TULCEA)"
	,
	"NIFON (TULCEA)"
	,
	"NUFARU (TULCEA)"
	,
	"OSTROV (TULCEA)"
	,
	"OSTROV TATARU (TULCEA)"
	,
	"PANDURU (TULCEA)"
	,
	"PARCHES (TULCEA)"
	,
	"PARDINA (TULCEA)"
	,
	"PARTIZANI (TULCEA)"
	,
	"PATLAGEANCA (TULCEA)"
	,
	"PECENEAGA (TULCEA)"
	,
	"PERIPRAVA (TULCEA)"
	,
	"PIATRA (TULCEA)"
	,
	"PLAURU (TULCEA)"
	,
	"PLOPUL (TULCEA)"
	,
	"POSTA (TULCEA)"
	,
	"RACHELU (TULCEA)"
	,
	"RAHMAN (TULCEA)"
	,
	"RANDUNICA (TULCEA)"
	,
	"RAZBOIENI (TULCEA)"
	,
	"REVARSAREA (TULCEA)"
	,
	"SABANGIA (TULCEA)"
	,
	"SALCENI (TULCEA)"
	,
	"SALCIOARA (TULCEA)"
	,
	"SAMBATA NOUA (TULCEA)"
	,
	"SARICHIOI (TULCEA)"
	,
	"SARIGHIOL DE DEAL (TULCEA)"
	,
	"SARINASUF (TULCEA)"
	,
	"SATU NOU (TULCEA)"
	,
	"SFANTU GHEORGHE (TULCEA)"
	,
	"SFISTOFCA (TULCEA)"
	,
	"SLAVA CERCHEZA (TULCEA)"
	,
	"SLAVA RUSA (TULCEA)"
	,
	"SMARDAN (TULCEA)"
	,
	"SOMOVA (TULCEA)"
	,
	"STANCA (TULCEA)"
	,
	"STEJARU (TULCEA)"
	,
	"SULINA (TULCEA)"
	,
	"TATANIR (TULCEA)"
	,
	"TELITA (TULCEA)"
	,
	"TICHILESTI (TULCEA)"
	,
	"TOPOLOG (TULCEA)"
	,
	"TRAIAN (TULCEA)"
	,
	"TRESTENIC (TULCEA)"
	,
	"TUDOR VLADIMIRESCU (TULCEA)"
	,
	"TULCEA (TULCEA)"
	,
	"TURCOAIA (TULCEA)"
	,
	"TURDA (TULCEA)"
	,
	"UZLINA (TULCEA)"
	,
	"VACARENI (TULCEA)"
	,
	"VALEA NUCARILOR (TULCEA)"
	,
	"VALEA TEILOR (TULCEA)"
	,
	"VASILE ALECSANDRI (TULCEA)"
	,
	"VICTORIA (TULCEA)"
	,
	"VISINA (TULCEA)"
	,
	"VISTERNA (TULCEA)"
	,
	"VULTURU (TULCEA)"
	,
	"ZEBIL (TULCEA)"
	,
	"AFANATA (VALCEA)"
	,
	"ALDESTI (VALCEA)"
	,
	"ALUNU (VALCEA)"
	,
	"AMARASTI (VALCEA)"
	,
	"ANDREIESTI (VALCEA)"
	,
	"ANINOASA (VALCEA)"
	,
	"ARANGHEL (VALCEA)"
	,
	"ARICIOAIA (VALCEA)"
	,
	"ARMASESTI (VALCEA)"
	,
	"ARSANCA (VALCEA)"
	,
	"AURESTI (VALCEA)"
	,
	"AVRAMESTI (VALCEA)"
	,
	"BABENI (VALCEA)"
	,
	"BABENI-OLTETU (VALCEA)"
	,
	"BABUESTI (VALCEA)"
	,
	"BADENI (VALCEA)"
	,
	"BAIASA (VALCEA)"
	,
	"BAIASU (VALCEA)"
	,
	"BAILE GOVORA (VALCEA)"
	,
	"BAILE OLANESTI (VALCEA)"
	,
	"BAJENARI (VALCEA)"
	,
	"BALACIU (VALCEA)"
	,
	"BALCESTI (VALCEA)"
	,
	"BALOMIREASA (VALCEA)"
	,
	"BALOTA (VALCEA)"
	,
	"BALSOARA (VALCEA)"
	,
	"BALTATENI (VALCEA)"
	,
	"BALTENI (VALCEA)"
	,
	"BALUTOAIA (VALCEA)"
	,
	"BANESTI (VALCEA)"
	,
	"BANTESTI (VALCEA)"
	,
	"BARBARIGENI (VALCEA)"
	,
	"BARBATESTI (VALCEA)"
	,
	"BARBUCENI (VALCEA)"
	,
	"BARCANELE (VALCEA)"
	,
	"BARCANESTI (VALCEA)"
	,
	"BARLOGU (VALCEA)"
	,
	"BAROIU (VALCEA)"
	,
	"BARSESTI (BUDESTI) (VALCEA)"
	,
	"BARSESTI (MIHAESTI) (VALCEA)"
	,
	"BARSOIU (VALCEA)"
	,
	"BARZA (VALCEA)"
	,
	"BARZESTI (VALCEA)"
	,
	"BATASANI (VALCEA)"
	,
	"BECSANI (VALCEA)"
	,
	"BENESTI (VALCEA)"
	,
	"BERBESTI (VALCEA)"
	,
	"BERBESTI (LALOSU) (VALCEA)"
	,
	"BERCIOIU (VALCEA)"
	,
	"BERESTI (VALCEA)"
	,
	"BERISLAVESTI (VALCEA)"
	,
	"BISTRITA (VALCEA)"
	,
	"BLANOIU (VALCEA)"
	,
	"BLEJANI (VALCEA)"
	,
	"BLIDARI (VALCEA)"
	,
	"BOCSA (VALCEA)"
	,
	"BODESTI (ALUNU) (VALCEA)"
	,
	"BODESTI (BARBATESTI) (VALCEA)"
	,
	"BOGDANESTI (BUJORENI) (VALCEA)"
	,
	"BOGDANESTI (OTESANI) (VALCEA)"
	,
	"BOGDANESTI (TOMSANI) (VALCEA)"
	,
	"BOISOARA (VALCEA)"
	,
	"BONCIU (VALCEA)"
	,
	"BONDOCI (VALCEA)"
	,
	"BOROSESTI (VALCEA)"
	,
	"BOTORANI (VALCEA)"
	,
	"BRADISOR (VALCEA)"
	,
	"BRADU-CLOCOTICI (VALCEA)"
	,
	"BRATIA DIN DEAL (VALCEA)"
	,
	"BRATIA DIN VALE (VALCEA)"
	,
	"BRATOVESTI (VALCEA)"
	,
	"BREZOI (VALCEA)"
	,
	"BROSTENI (VALCEA)"
	,
	"BUCIUMENI (VALCEA)"
	,
	"BUCSANI (VALCEA)"
	,
	"BUDA (VALCEA)"
	,
	"BUDELE (VALCEA)"
	,
	"BUDESTI (VALCEA)"
	,
	"BUDESTI (FAURESTI) (VALCEA)"
	,
	"BUDURASTI (VALCEA)"
	,
	"BUJORENI (VALCEA)"
	,
	"BULAGEI (VALCEA)"
	,
	"BULETA (VALCEA)"
	,
	"BUMBUESTI (VALCEA)"
	,
	"BUNESTI (VALCEA)"
	,
	"BUNGETANI (VALCEA)"
	,
	"BURDALESTI (VALCEA)"
	,
	"BUTANU (VALCEA)"
	,
	"BUZDUGAN (VALCEA)"
	,
	"CACIULATA (VALCEA)"
	,
	"CAINENI (VALCEA)"
	,
	"CAINENII MARI (VALCEA)"
	,
	"CAINENII MICI (VALCEA)"
	,
	"CALIGI (VALCEA)"
	,
	"CALIMANESTI (VALCEA)"
	,
	"CALINA (VALCEA)"
	,
	"CALINESTI (VALCEA)"
	,
	"CAPU DEALULUI (VALCEA)"
	,
	"CARCADIESTI (VALCEA)"
	,
	"CARLOGANI (VALCEA)"
	,
	"CARSTANESTI (VALCEA)"
	,
	"CASA VECHE (VALCEA)"
	,
	"CATETU (VALCEA)"
	,
	"CAZANESTI (GHIOROIU) (VALCEA)"
	,
	"CAZANESTI (MILCOIU) (VALCEA)"
	,
	"CAZANESTI (RAMNICU VALCEA) (VALCEA)"
	,
	"CERETU (VALCEA)"
	,
	"CERMEGESTI (LADESTI) (VALCEA)"
	,
	"CERMEGESTI (PESCEANA) (VALCEA)"
	,
	"CERNA (VALCEA)"
	,
	"CERNELELE (VALCEA)"
	,
	"CERNISOARA (VALCEA)"
	,
	"CETATEAUA (VALCEA)"
	,
	"CHEIA (VALCEA)"
	,
	"CHERASTI (VALCEA)"
	,
	"CHICENI (VALCEA)"
	,
	"CHIRCULESTI (VALCEA)"
	,
	"CHIRICESTI (VALCEA)"
	,
	"CIOBOTI (VALCEA)"
	,
	"CIOCALTEI (VALCEA)"
	,
	"CIOCANARI (VALCEA)"
	,
	"CIOPONESTI (VALCEA)"
	,
	"CIORASTI (VALCEA)"
	,
	"CIORTESTI (VALCEA)"
	,
	"CIRESU (VALCEA)"
	,
	"CIRESUL (VALCEA)"
	,
	"CIUCHETI (VALCEA)"
	,
	"CIUMAGI (VALCEA)"
	,
	"CIUNGETU (VALCEA)"
	,
	"CIUTESTI (VALCEA)"
	,
	"COASTA (GOLESTI) (VALCEA)"
	,
	"COASTA (PAUSESTI-MAGLASI) (VALCEA)"
	,
	"COASTA CERBULUI (VALCEA)"
	,
	"COASTA MARE (VALCEA)"
	,
	"COCORU (VALCEA)"
	,
	"COLELIA (VALCEA)"
	,
	"COLTESTI (VALCEA)"
	,
	"COMANCA (VALCEA)"
	,
	"CONDOIESTI (VALCEA)"
	,
	"CONTEA (VALCEA)"
	,
	"COPACELU (VALCEA)"
	,
	"COPACENI (VALCEA)"
	,
	"COPACENI (RACOVITA) (VALCEA)"
	,
	"CORBII DIN VALE (VALCEA)"
	,
	"CORBU (VALCEA)"
	,
	"CORNET (VALCEA)"
	,
	"COSANI (VALCEA)"
	,
	"COSOTA (VALCEA)"
	,
	"COSTESTI (VALCEA)"
	,
	"CRANGU (VALCEA)"
	,
	"CREMENARI (VALCEA)"
	,
	"CRETENI (VALCEA)"
	,
	"CUCESTI (VALCEA)"
	,
	"CUCI (VALCEA)"
	,
	"CUCOIU (VALCEA)"
	,
	"CUCULESTI (VALCEA)"
	,
	"CUENI (VALCEA)"
	,
	"CURATURILE (VALCEA)"
	,
	"CURTEA (VALCEA)"
	,
	"DAESTI (VALCEA)"
	,
	"DAESTI (POPESTI) (VALCEA)"
	,
	"DAMTENI (VALCEA)"
	,
	"DANCAI (VALCEA)"
	,
	"DANGESTI (VALCEA)"
	,
	"DANICEI (VALCEA)"
	,
	"DEALU ALUNIS (VALCEA)"
	,
	"DEALU BISERICII (VALCEA)"
	,
	"DEALU CORNI (VALCEA)"
	,
	"DEALU GLAMEIA (VALCEA)"
	,
	"DEALU LAUNELE (VALCEA)"
	,
	"DEALU MALULUI (VALCEA)"
	,
	"DEALU MARE (GALICEA) (VALCEA)"
	,
	"DEALU MARE (GUSOENI) (VALCEA)"
	,
	"DEALU MARE (IONESTI) (VALCEA)"
	,
	"DEALU SCHEIULUI (VALCEA)"
	,
	"DEALU VALENI (VALCEA)"
	,
	"DEJOI (VALCEA)"
	,
	"DELENI (VALCEA)"
	,
	"DELURENI (IONESTI) (VALCEA)"
	,
	"DELURENI (STOILESTI) (VALCEA)"
	,
	"DELURENI (VALEA MARE) (VALCEA)"
	,
	"DEZROBITI (VALCEA)"
	,
	"DIACONESTI (VALCEA)"
	,
	"DIANU (VALCEA)"
	,
	"DICULESTI (VALCEA)"
	,
	"DIMULESTI (VALCEA)"
	,
	"DOBRESTI (VALCEA)"
	,
	"DOBRICEA (VALCEA)"
	,
	"DOBRICENI (VALCEA)"
	,
	"DOBRUSA (VALCEA)"
	,
	"DOSU RAULUI (VALCEA)"
	,
	"DOZESTI (VALCEA)"
	,
	"DRAGANESTI (BREZOI) (VALCEA)"
	,
	"DRAGANESTI (GOLESTI) (VALCEA)"
	,
	"DRAGANU (VALCEA)"
	,
	"DRAGASANI (VALCEA)"
	,
	"DRAGIOIU (VALCEA)"
	,
	"DRAGOESTI (VALCEA)"
	,
	"DRAGULESTI (VALCEA)"
	,
	"DUMBRAVA (VALCEA)"
	,
	"DUMBRAVESTI (VALCEA)"
	,
	"FACAI (VALCEA)"
	,
	"FARTATESTI (VALCEA)"
	,
	"FAURESTI (VALCEA)"
	,
	"FAURESTI (ZATRENI) (VALCEA)"
	,
	"FEDELESOIU (VALCEA)"
	,
	"FIRESTI (VALCEA)"
	,
	"FIRIJBA (VALCEA)"
	,
	"FISCALIA (VALCEA)"
	,
	"FOLESTII DE JOS (VALCEA)"
	,
	"FOLESTII DE SUS (VALCEA)"
	,
	"FOTESTI (VALCEA)"
	,
	"FRANCESTI (VALCEA)"
	,
	"FRANCESTI-COASTA (VALCEA)"
	,
	"FRASINA (VALCEA)"
	,
	"FUMURENI (VALCEA)"
	,
	"FUNDATURA (VALCEA)"
	,
	"GAGENI (VALCEA)"
	,
	"GAINESTI (VALCEA)"
	,
	"GALICEA (VALCEA)"
	,
	"GALTOFANI (VALCEA)"
	,
	"GANESTI (VALCEA)"
	,
	"GANTULEI (VALCEA)"
	,
	"GARNICET (VALCEA)"
	,
	"GARNICETU (VALCEA)"
	,
	"GATEJESTI (VALCEA)"
	,
	"GAUJANI (VALCEA)"
	,
	"GAVANESTI (VALCEA)"
	,
	"GEAMANA (DRAGOESTI) (VALCEA)"
	,
	"GEAMANA (STOILESTI) (VALCEA)"
	,
	"GENUNENI (VALCEA)"
	,
	"GHINDARI (VALCEA)"
	,
	"GHIOBESTI (VALCEA)"
	,
	"GHIOROIU (VALCEA)"
	,
	"GIBESTI (VALCEA)"
	,
	"GINERICA (VALCEA)"
	,
	"GIULESTI (VALCEA)"
	,
	"GIULESTII DE SUS (VALCEA)"
	,
	"GIURGIUVENI (VALCEA)"
	,
	"GIUROIU (VALCEA)"
	,
	"GLAVILE (VALCEA)"
	,
	"GLODU (VALCEA)"
	,
	"GOLESTI (VALCEA)"
	,
	"GOLOTRENI (VALCEA)"
	,
	"GORUNESTI (BALCESTI) (VALCEA)"
	,
	"GORUNESTI (SLATIOARA) (VALCEA)"
	,
	"GOVORA (VALCEA)"
	,
	"GRADISTEA (VALCEA)"
	,
	"GREBLESTI (VALCEA)"
	,
	"GRECI (VALCEA)"
	,
	"GROPENI (VALCEA)"
	,
	"GROSI (VALCEA)"
	,
	"GRUIERI (VALCEA)"
	,
	"GRUIU (VALCEA)"
	,
	"GRUIU LUPULUI (VALCEA)"
	,
	"GUGUIANCA (VALCEA)"
	,
	"GURA CRUCILOR (VALCEA)"
	,
	"GURA SUHASULUI (VALCEA)"
	,
	"GURA VAII (VALCEA)"
	,
	"GURGUIATA (VALCEA)"
	,
	"GURISOARA (VALCEA)"
	,
	"GUSOENI (VALCEA)"
	,
	"GUSOIANCA (VALCEA)"
	,
	"HERASTI (VALCEA)"
	,
	"HOREZU (VALCEA)"
	,
	"HOTARASA (VALCEA)"
	,
	"HOTARELE (VALCEA)"
	,
	"HOTAROAIA (VALCEA)"
	,
	"IACOVILE (VALCEA)"
	,
	"IFRIMESTI (VALCEA)"
	,
	"IGOIU (VALCEA)"
	,
	"ILACIU (VALCEA)"
	,
	"IONESTI (VALCEA)"
	,
	"IRIMESTI (VALCEA)"
	,
	"IZBASESTI (VALCEA)"
	,
	"IZVORASU (VALCEA)"
	,
	"IZVORU (VALCEA)"
	,
	"IZVORU RECE (STOILESTI) (VALCEA)"
	,
	"IZVORU RECE (VAIDEENI) (VALCEA)"
	,
	"JAROSTEA (VALCEA)"
	,
	"JIBLEA NOUA (VALCEA)"
	,
	"JIBLEA VECHE (VALCEA)"
	,
	"LACUSTENI (VALCEA)"
	,
	"LACUSTENII DE JOS (VALCEA)"
	,
	"LACUSTENII DE SUS (VALCEA)"
	,
	"LADESTI (VALCEA)"
	,
	"LALOSU (VALCEA)"
	,
	"LAPUSATA (VALCEA)"
	,
	"LAUNELE DE JOS (VALCEA)"
	,
	"LINIA (BUDESTI) (VALCEA)"
	,
	"LINIA (GRADISTEA) (VALCEA)"
	,
	"LINIA DEALULUI (VALCEA)"
	,
	"LINIA HANULUI (VALCEA)"
	,
	"LINIA PE VALE (VALCEA)"
	,
	"LIVADIA (VALCEA)"
	,
	"LIVEZI (VALCEA)"
	,
	"LUNCA (BUJORENI) (VALCEA)"
	,
	"LUNCA (OCNELE MARI) (VALCEA)"
	,
	"LUNGESTI (VALCEA)"
	,
	"LUPOAIA (VALCEA)"
	,
	"LUPUIESTI (VALCEA)"
	,
	"MACIUCA (VALCEA)"
	,
	"MACIUCENI (VALCEA)"
	,
	"MADULARI (VALCEA)"
	,
	"MADULARI (CERNISOARA) (VALCEA)"
	,
	"MAGURA (VALCEA)"
	,
	"MAGURENI (VALCEA)"
	,
	"MALAIA (VALCEA)"
	,
	"MALDARESTI (VALCEA)"
	,
	"MALDARESTI (LADESTI) (VALCEA)"
	,
	"MALDARESTI (MACIUCA) (VALCEA)"
	,
	"MALDARESTII DE JOS (VALCEA)"
	,
	"MALU (VALCEA)"
	,
	"MALU ALB (VALCEA)"
	,
	"MALU VARTOP (VALCEA)"
	,
	"MAMU (VALCEA)"
	,
	"MANAILESTI (VALCEA)"
	,
	"MANEASA (VALCEA)"
	,
	"MANGURENI (VALCEA)"
	,
	"MANICEA (VALCEA)"
	,
	"MARCEA (VALCEA)"
	,
	"MARCUSU (VALCEA)"
	,
	"MARGINENI (VALCEA)"
	,
	"MARICESTI (VALCEA)"
	,
	"MARITA (VALCEA)"
	,
	"MATEESTI (VALCEA)"
	,
	"MAZARARU (VALCEA)"
	,
	"MAZILI (VALCEA)"
	,
	"MECEA (VALCEA)"
	,
	"MEIENI (VALCEA)"
	,
	"MERESESTI (VALCEA)"
	,
	"MIEREA (VALCEA)"
	,
	"MIHAESTI (VALCEA)"
	,
	"MIJATI (VALCEA)"
	,
	"MIJLOCU (VALCEA)"
	,
	"MILCOIU (VALCEA)"
	,
	"MILESTI (VALCEA)"
	,
	"MILOSTEA (VALCEA)"
	,
	"MIRESTI (VALCEA)"
	,
	"MITROFANI (VALCEA)"
	,
	"MLACENI (VALCEA)"
	,
	"MODOIA (VALCEA)"
	,
	"MOGESTI (VALCEA)"
	,
	"MOGOSESTI (VALCEA)"
	,
	"MOLOGESTI (VALCEA)"
	,
	"MOSOROASA (VALCEA)"
	,
	"MOSTENI (VALCEA)"
	,
	"MRENESTI (VALCEA)"
	,
	"MUEREASCA (VALCEA)"
	,
	"MUEREASCA DE SUS (VALCEA)"
	,
	"MUNTENI (VALCEA)"
	,
	"NEGHINESTI (VALCEA)"
	,
	"NEGRAIA (VALCEA)"
	,
	"NEGRENI (VALCEA)"
	,
	"NEGRULESTI (VALCEA)"
	,
	"NEMOIU (VALCEA)"
	,
	"NENCIULESTI (VALCEA)"
	,
	"NETESTI (VALCEA)"
	,
	"NICOLAE BALCESCU (VALCEA)"
	,
	"NICOLESTI (VALCEA)"
	,
	"NISIPI (VALCEA)"
	,
	"OBARSIA (VALCEA)"
	,
	"OBISLAVU (VALCEA)"
	,
	"OBOGENI (VALCEA)"
	,
	"OBROCESTI (VALCEA)"
	,
	"OCNELE MARI (VALCEA)"
	,
	"OCNITA (VALCEA)"
	,
	"OCRACU (VALCEA)"
	,
	"OLANESTI (VALCEA)"
	,
	"OLANU (VALCEA)"
	,
	"OLTEANCA (GLAVILE) (VALCEA)"
	,
	"OLTEANCA (LADESTI) (VALCEA)"
	,
	"OLTENI (VALCEA)"
	,
	"OLTETANI (VALCEA)"
	,
	"OLTETU (VALCEA)"
	,
	"OPATESTI (VALCEA)"
	,
	"ORLESTI (VALCEA)"
	,
	"OSTROVENI (VALCEA)"
	,
	"OTESANI (VALCEA)"
	,
	"OTETELISU (VALCEA)"
	,
	"OVESELU (VALCEA)"
	,
	"PADINA (VALCEA)"
	,
	"PADURETU (VALCEA)"
	,
	"PALANGA (VALCEA)"
	,
	"PARAIENII DE JOS (VALCEA)"
	,
	"PARAIENII DE MIJLOC (VALCEA)"
	,
	"PARAIENII DE SUS (VALCEA)"
	,
	"PARAUSANI (VALCEA)"
	,
	"PASAREI (VALCEA)"
	,
	"PASCOAIA (VALCEA)"
	,
	"PASCULESTI (VALCEA)"
	,
	"PATESTI (VALCEA)"
	,
	"PAUSA (VALCEA)"
	,
	"PAUSESTI (VALCEA)"
	,
	"PAUSESTI-MAGLASI (VALCEA)"
	,
	"PAUSESTI-OTASAU (VALCEA)"
	,
	"PERISANI (VALCEA)"
	,
	"PERTESTI (VALCEA)"
	,
	"PESCEANA (VALCEA)"
	,
	"PIETRARI (VALCEA)"
	,
	"PIETRARI (PAUSESTI-MAGLASI) (VALCEA)"
	,
	"PIETRARII DE SUS (VALCEA)"
	,
	"PIETRENI (VALCEA)"
	,
	"PIETRISU (VALCEA)"
	,
	"PIETROASA (VALCEA)"
	,
	"PISCU MARE (VALCEA)"
	,
	"PISCU PIETREI (VALCEA)"
	,
	"PISCU SCOARTEI (VALCEA)"
	,
	"PLEASA (VALCEA)"
	,
	"PLESESTI (VALCEA)"
	,
	"PLESOIU (LIVEZI) (VALCEA)"
	,
	"PLESOIU (NICOLAE BALCESCU) (VALCEA)"
	,
	"PODENI (VALCEA)"
	,
	"POENARI (VALCEA)"
	,
	"POENITA (VALCEA)"
	,
	"POIANA (VALCEA)"
	,
	"POIENARI (VALCEA)"
	,
	"POJOGI-CERNA (VALCEA)"
	,
	"POPESTI (VALCEA)"
	,
	"POPESTI (FARTATESTI) (VALCEA)"
	,
	"POPESTI (GOLESTI) (VALCEA)"
	,
	"POPESTI (LADESTI) (VALCEA)"
	,
	"POPESTI (MACIUCA) (VALCEA)"
	,
	"POPESTI (NICOLAE BALCESCU) (VALCEA)"
	,
	"POPESTI (SINESTI) (VALCEA)"
	,
	"POPESTI (STOENESTI) (VALCEA)"
	,
	"POPESTI (TETOIU) (VALCEA)"
	,
	"PORTARESTI (VALCEA)"
	,
	"PRAJILA (VALCEA)"
	,
	"PREDESTI (VALCEA)"
	,
	"PREOTESTI (VALCEA)"
	,
	"PRIBA (VALCEA)"
	,
	"PRILOAGE (VALCEA)"
	,
	"PRIPOARA (VALCEA)"
	,
	"PRIPOARE (VALCEA)"
	,
	"PRIPORU (VALCEA)"
	,
	"PROCOPOAIA (VALCEA)"
	,
	"PRODANESTI (VALCEA)"
	,
	"PROIENI (VALCEA)"
	,
	"PRUNDENI (VALCEA)"
	,
	"RACOVITA (VALCEA)"
	,
	"RACOVITA (BUDESTI) (VALCEA)"
	,
	"RACU (VALCEA)"
	,
	"RADACINESTI (VALCEA)"
	,
	"RAMESTI (HOREZU) (VALCEA)"
	,
	"RAMESTI (SUSANI) (VALCEA)"
	,
	"RAMNICU VALCEA (VALCEA)"
	,
	"RAPA CARAMIZII (VALCEA)"
	,
	"RAPANESTI (VALCEA)"
	,
	"RATALESTI (VALCEA)"
	,
	"RAU VADULUI (VALCEA)"
	,
	"RAURENI (VALCEA)"
	,
	"ROBAIA (VALCEA)"
	,
	"ROBESTI (VALCEA)"
	,
	"ROESTI (VALCEA)"
	,
	"ROESTI (PESCEANA) (VALCEA)"
	,
	"ROMANESTI (VALCEA)"
	,
	"ROMANI (VALCEA)"
	,
	"ROMANII DE JOS (VALCEA)"
	,
	"ROMANII DE SUS (VALCEA)"
	,
	"ROSIA (VALCEA)"
	,
	"ROSIILE (VALCEA)"
	,
	"ROSIOARA (VALCEA)"
	,
	"ROSOVENI (VALCEA)"
	,
	"ROTARASTI (VALCEA)"
	,
	"RUDA (VALCEA)"
	,
	"RUGETU (MIHAESTI) (VALCEA)"
	,
	"RUGETU (SLATIOARA) (VALCEA)"
	,
	"RUNCU (VALCEA)"
	,
	"RUSANESTI (VALCEA)"
	,
	"SAIOCI (VALCEA)"
	,
	"SALATRUCEL (VALCEA)"
	,
	"SALISTEA (VALCEA)"
	,
	"SANBOTIN (VALCEA)"
	,
	"SARBI (VALCEA)"
	,
	"SARSANESTI (VALCEA)"
	,
	"SARULESTI (VALCEA)"
	,
	"SASCIOARA (VALCEA)"
	,
	"SATU POIENI (VALCEA)"
	,
	"SCAIOSI (VALCEA)"
	,
	"SCARISOARA (VALCEA)"
	,
	"SCAUENI (VALCEA)"
	,
	"SCHITU (VALCEA)"
	,
	"SCORUSU (VALCEA)"
	,
	"SCUNDU (VALCEA)"
	,
	"SEACA (CALIMANESTI) (VALCEA)"
	,
	"SEACA (SALATRUCEL) (VALCEA)"
	,
	"SECIU (VALCEA)"
	,
	"SERBANEASA (VALCEA)"
	,
	"SERBANESTI (LAPUSATA) (VALCEA)"
	,
	"SERBANESTI (PAUSESTI) (VALCEA)"
	,
	"SERBANESTI (SALATRUCEL) (VALCEA)"
	,
	"SERBANESTI (STEFANESTI) (VALCEA)"
	,
	"SILEA (VALCEA)"
	,
	"SINESTI (VALCEA)"
	,
	"SIRINEASA (VALCEA)"
	,
	"SLATIOARA (VALCEA)"
	,
	"SLATIOARELE (VALCEA)"
	,
	"SLAVITESTI (VALCEA)"
	,
	"SNAMANA (VALCEA)"
	,
	"SOLICESTI (VALCEA)"
	,
	"SOTANI (VALCEA)"
	,
	"SPARLENI (VALCEA)"
	,
	"SPINU (VALCEA)"
	,
	"STANCULESTI (VALCEA)"
	,
	"STANESTI (VALCEA)"
	,
	"STANESTI (STOILESTI) (VALCEA)"
	,
	"STANESTI-LUNCA (VALCEA)"
	,
	"STANOMIRU (VALCEA)"
	,
	"STEFANESTI (VALCEA)"
	,
	"STEFANESTI (MACIUCA) (VALCEA)"
	,
	"STIRBESTI (VALCEA)"
	,
	"STOENESTI (VALCEA)"
	,
	"STOENESTI (BERISLAVESTI) (VALCEA)"
	,
	"STOICANESTI (VALCEA)"
	,
	"STOICULESTI (VALCEA)"
	,
	"STOILESTI (VALCEA)"
	,
	"STOLNICENI (VALCEA)"
	,
	"STRACHINESTI (VALCEA)"
	,
	"STREMINOASA (VALCEA)"
	,
	"STROESTI (VALCEA)"
	,
	"STUPAREI (VALCEA)"
	,
	"SUB DEAL (VALCEA)"
	,
	"SUIESTI (VALCEA)"
	,
	"SURDOIU (VALCEA)"
	,
	"SURICARU (VALCEA)"
	,
	"SURPATELE (VALCEA)"
	,
	"SURPATI (VALCEA)"
	,
	"SUSANI (VALCEA)"
	,
	"SUSENI (VALCEA)"
	,
	"SUTA (VALCEA)"
	,
	"SUTESTI (VALCEA)"
	,
	"TANASESTI (VALCEA)"
	,
	"TANISLAVI (VALCEA)"
	,
	"TARGU GANGULESTI (VALCEA)"
	,
	"TATARANI (VALCEA)"
	,
	"TEICA (VALCEA)"
	,
	"TEIU (VALCEA)"
	,
	"TEIUL (VALCEA)"
	,
	"TEIUSU (VALCEA)"
	,
	"TELECHESTI (VALCEA)"
	,
	"TEPESTI (VALCEA)"
	,
	"TEPSENARI (VALCEA)"
	,
	"TETOIU (VALCEA)"
	,
	"TIGHINA (VALCEA)"
	,
	"TINA (VALCEA)"
	,
	"TISA (VALCEA)"
	,
	"TITESTI (VALCEA)"
	,
	"TITIRECI (VALCEA)"
	,
	"TOMSANI (VALCEA)"
	,
	"TROIAN (VALCEA)"
	,
	"TRUNDIN (VALCEA)"
	,
	"TUFANII (VALCEA)"
	,
	"TULEI-CAMPENI (VALCEA)"
	,
	"TURBUREA (VALCEA)"
	,
	"TURCESTI (VALCEA)"
	,
	"TUTULESTI (VALCEA)"
	,
	"TUTURU (VALCEA)"
	,
	"UDRESTI (VALCEA)"
	,
	"ULMETEL (VALCEA)"
	,
	"ULMETU (VALCEA)"
	,
	"URSANI (VALCEA)"
	,
	"URSI (POPESTI) (VALCEA)"
	,
	"URSI (STOILESTI) (VALCEA)"
	,
	"URSOAIA (VALCEA)"
	,
	"URZICA (VALCEA)"
	,
	"USUREI (VALCEA)"
	,
	"VAIDEENI (VALCEA)"
	,
	"VALEA ALUNISULUI (VALCEA)"
	,
	"VALEA BABEI (VALCEA)"
	,
	"VALEA BALCEASCA (VALCEA)"
	,
	"VALEA CASELOR (DRAGASANI) (VALCEA)"
	,
	"VALEA CASELOR (POPESTI) (VALCEA)"
	,
	"VALEA CHEII (VALCEA)"
	,
	"VALEA GRADISTEI (VALCEA)"
	,
	"VALEA LUI STAN (VALCEA)"
	,
	"VALEA LUNGA (VALCEA)"
	,
	"VALEA MACESULUI (VALCEA)"
	,
	"VALEA MARE (VALCEA)"
	,
	"VALEA MARE (BABENI) (VALCEA)"
	,
	"VALEA MARE (BERBESTI) (VALCEA)"
	,
	"VALEA RAULUI (VALCEA)"
	,
	"VALEA SCHEIULUI (VALCEA)"
	,
	"VALEA URSULUI (VALCEA)"
	,
	"VALEA VALENI (VALCEA)"
	,
	"VALEA VIEI (VALCEA)"
	,
	"VALENI (PAUSESTI) (VALCEA)"
	,
	"VALENI (ZATRENI) (VALCEA)"
	,
	"VARATECI (VALCEA)"
	,
	"VARATICA (VALCEA)"
	,
	"VARATICI (VALCEA)"
	,
	"VARLENI (VALCEA)"
	,
	"VATASESTI (VALCEA)"
	,
	"VERDEA (VALCEA)"
	,
	"VETELU (VALCEA)"
	,
	"VIISOARA (VALCEA)"
	,
	"VLADESTI (VALCEA)"
	,
	"VLADUCENI (VALCEA)"
	,
	"VLADULESTI (VALCEA)"
	,
	"VOICESTI (VALCEA)"
	,
	"VOICESTII DIN VALE (VALCEA)"
	,
	"VOICULEASA (VALCEA)"
	,
	"VOINEASA (VALCEA)"
	,
	"VOINESITA (VALCEA)"
	,
	"VULPUESTI (VALCEA)"
	,
	"ZARNENI (VALCEA)"
	,
	"ZARNESTI (VALCEA)"
	,
	"ZATRENI (VALCEA)"
	,
	"ZATRENII DE SUS (VALCEA)"
	,
	"ZAVIDENI (VALCEA)"
	,
	"ZAVOIENI (VALCEA)"
	,
	"ZGUBEA (VALCEA)"
	,
	"ZLATAREI (VALCEA)"
	,
	"ZMEURATU (VALCEA)"
	,
	"1 DECEMBRIE (VASLUI)"
	,
	"ALBESTI (VASLUI)"
	,
	"ALBESTI (DELESTI) (VASLUI)"
	,
	"ALBINA (VASLUI)"
	,
	"ALBITA (VASLUI)"
	,
	"ALEXANDRU VLAHUTA (VASLUI)"
	,
	"ARMASENI (BACESTI) (VASLUI)"
	,
	"ARMASENI (BUNESTI-AVERESTI) (VASLUI)"
	,
	"ARMASOAIA (VASLUI)"
	,
	"ARSITA (VASLUI)"
	,
	"ARSURA (VASLUI)"
	,
	"AVERESTI (VASLUI)"
	,
	"AVRAMESTI (VASLUI)"
	,
	"BABUSA (VASLUI)"
	,
	"BABUTA (VASLUI)"
	,
	"BACANI (VASLUI)"
	,
	"BACAOANI (VASLUI)"
	,
	"BACESTI (VASLUI)"
	,
	"BADEANA (VASLUI)"
	,
	"BAHNARI (VASLUI)"
	,
	"BAILE DRANCENI (VASLUI)"
	,
	"BALESTI (VASLUI)"
	,
	"BALTATENI (VASLUI)"
	,
	"BALTATI (VASLUI)"
	,
	"BALTENI (VASLUI)"
	,
	"BALTENI-DEAL (VASLUI)"
	,
	"BANCA (VASLUI)"
	,
	"BANCESTI (VASLUI)"
	,
	"BARBOSI (VASLUI)"
	,
	"BARLAD (VASLUI)"
	,
	"BARLALESTI (VASLUI)"
	,
	"BARTALUS-MOCANI (VASLUI)"
	,
	"BARTALUS-RAZESI (VASLUI)"
	,
	"BARZESTI (VASLUI)"
	,
	"BEJENESTI (VASLUI)"
	,
	"BELCESTI (VASLUI)"
	,
	"BELZENI (VASLUI)"
	,
	"BENESTI (VASLUI)"
	,
	"BEREASA (VASLUI)"
	,
	"BEREZENI (VASLUI)"
	,
	"BLAGESTI (VASLUI)"
	,
	"BLESCA (VASLUI)"
	,
	"BOBESTI (VASLUI)"
	,
	"BOGDANA (VASLUI)"
	,
	"BOGDANA-VOLOSENI (VASLUI)"
	,
	"BOGDANESTI (VASLUI)"
	,
	"BOGDANESTI (FALCIU) (VASLUI)"
	,
	"BOGDANITA (VASLUI)"
	,
	"BOGESTI (VASLUI)"
	,
	"BOLATI (VASLUI)"
	,
	"BORODESTI (VASLUI)"
	,
	"BOTESTI (VASLUI)"
	,
	"BOTOAIA (VASLUI)"
	,
	"BOTOI (VASLUI)"
	,
	"BOUSORI (VASLUI)"
	,
	"BOZIA (VASLUI)"
	,
	"BRADESTI (VASLUI)"
	,
	"BRAHASOAIA (VASLUI)"
	,
	"BRODOC (VASLUI)"
	,
	"BROSCOSESTI (VASLUI)"
	,
	"BROSTENI (VASLUI)"
	,
	"BUDA (ALEXANDRU VLAHUTA) (VASLUI)"
	,
	"BUDA (BOGDANESTI) (VASLUI)"
	,
	"BUDA (OSESTI) (VASLUI)"
	,
	"BUDESTI (VASLUI)"
	,
	"BUDU CANTEMIR (VASLUI)"
	,
	"BUHAIESTI (VASLUI)"
	,
	"BULBOACA (VASLUI)"
	,
	"BUMBATA (VASLUI)"
	,
	"BUNESTI (VASLUI)"
	,
	"BUNESTI-AVERESTI (VASLUI)"
	,
	"BURSUCI (VASLUI)"
	,
	"BUSCATA (VASLUI)"
	,
	"BUTUCARIA (VASLUI)"
	,
	"CALIMANESTI (VASLUI)"
	,
	"CALUGARENI (VASLUI)"
	,
	"CANTALARESTI (VASLUI)"
	,
	"CAPOTESTI (VASLUI)"
	,
	"CAPUSNENI (VASLUI)"
	,
	"CARJA (VASLUI)"
	,
	"CARJOANI (VASLUI)"
	,
	"CARTIBASI (VASLUI)"
	,
	"CAZANESTI (VASLUI)"
	,
	"CEPESTI (VASLUI)"
	,
	"CETATUIA (VASLUI)"
	,
	"CHERSACOSU (VASLUI)"
	,
	"CHETRESTI (VASLUI)"
	,
	"CHETROSU (VASLUI)"
	,
	"CHILIENI (VASLUI)"
	,
	"CHIRCESTI (VASLUI)"
	,
	"CHITCANI (VASLUI)"
	,
	"CHITOC (VASLUI)"
	,
	"CIOATELE (VASLUI)"
	,
	"CIOCANI (VASLUI)"
	,
	"CIOFENI (VASLUI)"
	,
	"CIORTOLOM (VASLUI)"
	,
	"CIUPERCA (VASLUI)"
	,
	"CODAESTI (VASLUI)"
	,
	"CODRENI (VASLUI)"
	,
	"CONDREA (VASLUI)"
	,
	"COPACEANA (VASLUI)"
	,
	"CORBU (VASLUI)"
	,
	"CORNI-ALBESTI (VASLUI)"
	,
	"COROBANESTI (VASLUI)"
	,
	"CORODESTI (VASLUI)"
	,
	"COROIESTI (VASLUI)"
	,
	"COROIESTI (BOGDANITA) (VASLUI)"
	,
	"COROIESTII DE SUS (VASLUI)"
	,
	"COROIU (VASLUI)"
	,
	"COSCA (VASLUI)"
	,
	"COSESTI (VASLUI)"
	,
	"COSTESTI (VASLUI)"
	,
	"COTIC (VASLUI)"
	,
	"COZMESTI (VASLUI)"
	,
	"CRACIUNESTI (VASLUI)"
	,
	"CRANG (VASLUI)"
	,
	"CRANGU NOU (VASLUI)"
	,
	"CRASNA (VASLUI)"
	,
	"CRASNASENI (VASLUI)"
	,
	"CRETESTI (VASLUI)"
	,
	"CRETESTII DE SUS (VASLUI)"
	,
	"CRISTESTI (VASLUI)"
	,
	"CRIVESTI (VASLUI)"
	,
	"CUJBA (VASLUI)"
	,
	"CURSESTI-DEAL (VASLUI)"
	,
	"CURSESTI-VALE (VASLUI)"
	,
	"CURTENI (VASLUI)"
	,
	"DANESTI (VASLUI)"
	,
	"DAVIDESTI (VASLUI)"
	,
	"DEALU MARE (VASLUI)"
	,
	"DEALU SECARII (VASLUI)"
	,
	"DELEA (VASLUI)"
	,
	"DELENI (VASLUI)"
	,
	"DELENI (HOCENI) (VASLUI)"
	,
	"DELESTI (VASLUI)"
	,
	"DIMITRIE CANTEMIR (VASLUI)"
	,
	"DINGA (VASLUI)"
	,
	"DOAGELE (VASLUI)"
	,
	"DOBROSLOVESTI (VASLUI)"
	,
	"DOCANEASA (VASLUI)"
	,
	"DOCANI (VASLUI)"
	,
	"DODESTI (VASLUI)"
	,
	"DRAGESTI (VASLUI)"
	,
	"DRAGOMANESTI (VASLUI)"
	,
	"DRAGOMIRESTI (VASLUI)"
	,
	"DRANCENI (VASLUI)"
	,
	"DRAXENI (VASLUI)"
	,
	"DRUJESTI (VASLUI)"
	,
	"DUDA (VASLUI)"
	,
	"DUDA-EPURENI (VASLUI)"
	,
	"DUMASCA (VASLUI)"
	,
	"DUMBRAVENI (VASLUI)"
	,
	"DUMESTI (VASLUI)"
	,
	"DUMESTII VECHI (VASLUI)"
	,
	"EMIL RACOVITA (VASLUI)"
	,
	"EPURENI (VASLUI)"
	,
	"EPURENI (DUDA-EPURENI) (VASLUI)"
	,
	"FALCIU (VASLUI)"
	,
	"FANTANA BLANARULUI (VASLUI)"
	,
	"FANTANELE (VASLUI)"
	,
	"FASTACI (VASLUI)"
	,
	"FEDESTI (VASLUI)"
	,
	"FERESTI (VASLUI)"
	,
	"FLORENI (VASLUI)"
	,
	"FLORESTI (VASLUI)"
	,
	"FOCSA (VASLUI)"
	,
	"FOCSEASCA (VASLUI)"
	,
	"FRASINU (VASLUI)"
	,
	"FRUNTISENI (VASLUI)"
	,
	"FULGU (VASLUI)"
	,
	"FUNDATURA (ARSURA) (VASLUI)"
	,
	"FUNDATURA (DELESTI) (VASLUI)"
	,
	"FUNDATURA MARE (VASLUI)"
	,
	"FUNDATURA MICA (VASLUI)"
	,
	"FUNDU VAII (LIPOVAT) (VASLUI)"
	,
	"FUNDU VAII (POIENESTI) (VASLUI)"
	,
	"GAGESTI (VASLUI)"
	,
	"GALTESTI (VASLUI)"
	,
	"GANESTI (VASLUI)"
	,
	"GARA BANCA (VASLUI)"
	,
	"GARA DOCANEASA (VASLUI)"
	,
	"GARA ROSIESTI (VASLUI)"
	,
	"GARA TALASMAN (VASLUI)"
	,
	"GARCENI (VASLUI)"
	,
	"GARDESTI (VASLUI)"
	,
	"GAVANU (VASLUI)"
	,
	"GHERGHELEU (VASLUI)"
	,
	"GHERGHESTI (VASLUI)"
	,
	"GHERMANESTI (BANCA) (VASLUI)"
	,
	"GHERMANESTI (DRANCENI) (VASLUI)"
	,
	"GHICANI (VASLUI)"
	,
	"GHIREASCA (VASLUI)"
	,
	"GIURCANI (VASLUI)"
	,
	"GIURGESTI (VASLUI)"
	,
	"GLODENI (VASLUI)"
	,
	"GRAJDENI (VASLUI)"
	,
	"GRIVITA (VASLUI)"
	,
	"GRUMEZOAIA (VASLUI)"
	,
	"GUGESTI (VASLUI)"
	,
	"GURA ALBESTI (VASLUI)"
	,
	"GURA IDRICI (VASLUI)"
	,
	"GURA VAII (VASLUI)"
	,
	"GUSITEI (VASLUI)"
	,
	"HALARESTI (VASLUI)"
	,
	"HALTA DODESTI (VASLUI)"
	,
	"HARSOVA (VASLUI)"
	,
	"HARSOVENI (VASLUI)"
	,
	"HOCENI (VASLUI)"
	,
	"HORDILA (VASLUI)"
	,
	"HORDILESTI (VASLUI)"
	,
	"HORGA (VASLUI)"
	,
	"HOROIATA (VASLUI)"
	,
	"HREASCA (VASLUI)"
	,
	"HUC (VASLUI)"
	,
	"HUPCA (VASLUI)"
	,
	"HURDUGI (VASLUI)"
	,
	"HUSI (VASLUI)"
	,
	"IANA (VASLUI)"
	,
	"IAZ (VASLUI)"
	,
	"IBANESTI (VASLUI)"
	,
	"IDRICI (VASLUI)"
	,
	"IEZER (VASLUI)"
	,
	"IEZEREL (VASLUI)"
	,
	"IGESTI (VASLUI)"
	,
	"IVANESTI (VASLUI)"
	,
	"IVANESTI (PADURENI) (VASLUI)"
	,
	"IVESTI (VASLUI)"
	,
	"JIGALIA (VASLUI)"
	,
	"LACU BABEI (VASLUI)"
	,
	"LALESTI (VASLUI)"
	,
	"LATESTI (VASLUI)"
	,
	"LAZA (VASLUI)"
	,
	"LAZU (VASLUI)"
	,
	"LEOSTI (PADURENI) (VASLUI)"
	,
	"LEOSTI (TATARANI) (VASLUI)"
	,
	"LIPOVAT (VASLUI)"
	,
	"LUNCA (VASLUI)"
	,
	"LUNCA BANULUI (VASLUI)"
	,
	"LUNCA VECHE (VASLUI)"
	,
	"LUPESTI (VASLUI)"
	,
	"MACRESTI (REBRICEA) (VASLUI)"
	,
	"MACRESTI (ZAPODENI) (VASLUI)"
	,
	"MALAIESTI (VASLUI)"
	,
	"MALUSTENI (VASLUI)"
	,
	"MANASTIREA (DELESTI) (VASLUI)"
	,
	"MANASTIREA (MALUSTENI) (VASLUI)"
	,
	"MANJESTI (VASLUI)"
	,
	"MANTU (VASLUI)"
	,
	"MANZATESTI (VASLUI)"
	,
	"MANZATI (VASLUI)"
	,
	"MARASENI (VASLUI)"
	,
	"MARASESTI (VASLUI)"
	,
	"MASCUREI (VASLUI)"
	,
	"MICLESTI (VASLUI)"
	,
	"MICLESTI (BANCA) (VASLUI)"
	,
	"MIHAIL KOGALNICEANU (VASLUI)"
	,
	"MIRCESTI (VASLUI)"
	,
	"MIRENI (VASLUI)"
	,
	"MITOC (VASLUI)"
	,
	"MOARA DOMNEASCA (VASLUI)"
	,
	"MOARA GRECILOR (VASLUI)"
	,
	"MORARENI (VASLUI)"
	,
	"MORENI (VASLUI)"
	,
	"MOVILENI (VASLUI)"
	,
	"MUNTENESTI (VASLUI)"
	,
	"MUNTENII DE JOS (VASLUI)"
	,
	"MUNTENII DE SUS (VASLUI)"
	,
	"MURGENI (VASLUI)"
	,
	"MUSATA (VASLUI)"
	,
	"NEGRESTI (VASLUI)"
	,
	"OBARSENI (VINDEREI) (VASLUI)"
	,
	"OBARSENI (VOINESTI) (VASLUI)"
	,
	"OBARSENII LINGURARI (VASLUI)"
	,
	"ODAIA BOGDANA (VASLUI)"
	,
	"ODAIA BURSUCANI (VASLUI)"
	,
	"OLTENESTI (VASLUI)"
	,
	"OPRISITA (VASLUI)"
	,
	"ORGOIESTI (VASLUI)"
	,
	"OSESTI (VASLUI)"
	,
	"OTELENI (VASLUI)"
	,
	"OTETOAIA (VASLUI)"
	,
	"PACURARESTI (VASLUI)"
	,
	"PADURENI (VASLUI)"
	,
	"PADURENI (OSESTI) (VASLUI)"
	,
	"PAHNA (VASLUI)"
	,
	"PAHNESTI (VASLUI)"
	,
	"PALTINIS (VASLUI)"
	,
	"PARPANITA (VASLUI)"
	,
	"PARVESTI (VASLUI)"
	,
	"PEICANI (VASLUI)"
	,
	"PERIENI (VASLUI)"
	,
	"PLOPENI (VASLUI)"
	,
	"PLOPI (VASLUI)"
	,
	"PLOPOASA (VASLUI)"
	,
	"PLOTONESTI (VASLUI)"
	,
	"POCHIDIA (VASLUI)"
	,
	"PODENI (VASLUI)"
	,
	"PODU OPRII (VASLUI)"
	,
	"PODU PETRIS (VASLUI)"
	,
	"POGANA (VASLUI)"
	,
	"POGANESTI (VASLUI)"
	,
	"POGONESTI (VASLUI)"
	,
	"POIANA (VASLUI)"
	,
	"POIANA LUI ALEXA (VASLUI)"
	,
	"POIANA PIETREI (VASLUI)"
	,
	"POIENESTI (VASLUI)"
	,
	"POIENESTI-DEAL (VASLUI)"
	,
	"POLOCIN (VASLUI)"
	,
	"POPENI (GAGESTI) (VASLUI)"
	,
	"POPENI (ZORLENI) (VASLUI)"
	,
	"POPESTI (DRAGOMIRESTI) (VASLUI)"
	,
	"POPESTI (MICLESTI) (VASLUI)"
	,
	"PORTARI (VASLUI)"
	,
	"POSTA ELAN (VASLUI)"
	,
	"PRIBESTI (VASLUI)"
	,
	"PROTOPOPESTI (VASLUI)"
	,
	"PUIESTI (VASLUI)"
	,
	"PUNGESTI (VASLUI)"
	,
	"PUNTISENI (VASLUI)"
	,
	"PUSCASI (VASLUI)"
	,
	"PUTU OLARULUI (VASLUI)"
	,
	"RACOVA (VASLUI)"
	,
	"RACOVITA (VASLUI)"
	,
	"RADAESTI (VASLUI)"
	,
	"RADENI (VASLUI)"
	,
	"RADESTI (VASLUI)"
	,
	"RADUCANI (VASLUI)"
	,
	"RADUIESTI (VASLUI)"
	,
	"RAFAILA (VASLUI)"
	,
	"RAIU (VASLUI)"
	,
	"RANCENI (VASLUI)"
	,
	"RANZESTI (VASLUI)"
	,
	"RAPSA (VASLUI)"
	,
	"RASCANI (DANESTI) (VASLUI)"
	,
	"RASCANI (SULETEA) (VASLUI)"
	,
	"RASESTI (VASLUI)"
	,
	"RASNITA (VASLUI)"
	,
	"RATESU CUZEI (VASLUI)"
	,
	"REBRICEA (VASLUI)"
	,
	"RECEA (VASLUI)"
	,
	"REDIU (HOCENI) (VASLUI)"
	,
	"REDIU (ROSIESTI) (VASLUI)"
	,
	"REDIU (VASLUI) (VASLUI)"
	,
	"REDIU GALIAN (VASLUI)"
	,
	"ROSIESTI (VASLUI)"
	,
	"ROSIORI (VASLUI)"
	,
	"ROTARI (VASLUI)"
	,
	"RUGARIA (VASLUI)"
	,
	"RUSCA (VASLUI)"
	,
	"RUSI (VASLUI)"
	,
	"SALCENI (VASLUI)"
	,
	"SALCIOARA (VASLUI)"
	,
	"SARATENI (VASLUI)"
	,
	"SARATU (VASLUI)"
	,
	"SARBI (VASLUI)"
	,
	"SASOVA (VASLUI)"
	,
	"SATU NOU (BANCA) (VASLUI)"
	,
	"SATU NOU (BEREZENI) (VASLUI)"
	,
	"SATU NOU (CRETESTI) (VASLUI)"
	,
	"SATU NOU (SOLESTI) (VASLUI)"
	,
	"SATU NOU (TANACU) (VASLUI)"
	,
	"SATU NOU (TUTOVA) (VASLUI)"
	,
	"SAUCA (VASLUI)"
	,
	"SCHINENI (VASLUI)"
	,
	"SCHINETEA (VASLUI)"
	,
	"SCHITU (VASLUI)"
	,
	"SECUIA (VASLUI)"
	,
	"SEMENEA (VASLUI)"
	,
	"SERBOTESTI (VASLUI)"
	,
	"SILISTEA (IANA) (VASLUI)"
	,
	"SILISTEA (PUNGESTI) (VASLUI)"
	,
	"SILISTEA (TODIRESTI) (VASLUI)"
	,
	"SIMILA (VASLUI)"
	,
	"SIMILISOARA (VASLUI)"
	,
	"SIPENI (VASLUI)"
	,
	"SISCANI (VASLUI)"
	,
	"SLOBOZIA (VASLUI)"
	,
	"SOCI (VASLUI)"
	,
	"SOFIENI (VASLUI)"
	,
	"SOFRONESTI (VASLUI)"
	,
	"SOLESTI (VASLUI)"
	,
	"SOPARLENI (VASLUI)"
	,
	"STANCASENI (VASLUI)"
	,
	"STANILESTI (VASLUI)"
	,
	"STEFAN CEL MARE (VASLUI)"
	,
	"STEJARU (VASLUI)"
	,
	"STIOBORANI (VASLUI)"
	,
	"STOISESTI (VASLUI)"
	,
	"STRAMTURA-MITOC (VASLUI)"
	,
	"STROIESTI (VASLUI)"
	,
	"STUHULET (VASLUI)"
	,
	"SUCEVENI (VASLUI)"
	,
	"SULETEA (VASLUI)"
	,
	"SUSENI (VASLUI)"
	,
	"TABALAIESTI (VASLUI)"
	,
	"TACUTA (VASLUI)"
	,
	"TALPIGENI (VASLUI)"
	,
	"TANACU (VASLUI)"
	,
	"TARZII (VASLUI)"
	,
	"TATARANI (VASLUI)"
	,
	"TATARANI (DANESTI) (VASLUI)"
	,
	"TATOMIRESTI (VASLUI)"
	,
	"TEISORU (VASLUI)"
	,
	"TELEJNA (VASLUI)"
	,
	"TIBANESTII BUHLII (VASLUI)"
	,
	"TIFU (VASLUI)"
	,
	"TODIRENI (VASLUI)"
	,
	"TODIRESTI (VASLUI)"
	,
	"TOMESTI (VASLUI)"
	,
	"TOMSA (VASLUI)"
	,
	"TOPORASTI (VASLUI)"
	,
	"TRESTIANA (VASLUI)"
	,
	"TROHAN (VASLUI)"
	,
	"TUFESTII DE JOS (VASLUI)"
	,
	"TULESTI (VASLUI)"
	,
	"TUNSESTI (VASLUI)"
	,
	"TUPILATI (VASLUI)"
	,
	"TUTCANI (VASLUI)"
	,
	"TUTOVA (VASLUI)"
	,
	"ULEA (VASLUI)"
	,
	"UNCESTI (VASLUI)"
	,
	"UNTESTI (VASLUI)"
	,
	"URDESTI (VASLUI)"
	,
	"URICARI (VASLUI)"
	,
	"URLATI (VASLUI)"
	,
	"URSOAIA (VASLUI)"
	,
	"VADURILE (VASLUI)"
	,
	"VALCELE (VASLUI)"
	,
	"VALEA GRECULUI (VASLUI)"
	,
	"VALEA LUI BOSIE (VASLUI)"
	,
	"VALEA LUI DARIE (VASLUI)"
	,
	"VALEA LUNGA (VASLUI)"
	,
	"VALEA LUPULUI (VASLUI)"
	,
	"VALEA MARE (DUMESTI) (VASLUI)"
	,
	"VALEA MARE (IVANESTI) (VASLUI)"
	,
	"VALEA MARE (NEGRESTI) (VASLUI)"
	,
	"VALEA OANEI (VASLUI)"
	,
	"VALEA POPII (VASLUI)"
	,
	"VALEA SEACA (VASLUI)"
	,
	"VALEA SILISTEI (VASLUI)"
	,
	"VALEA TARGULUI (VASLUI)"
	,
	"VALENI (VASLUI)"
	,
	"VALENI (PADURENI) (VASLUI)"
	,
	"VALENI (VIISOARA) (VASLUI)"
	,
	"VASLUI (VASLUI)"
	,
	"VERDES (VASLUI)"
	,
	"VETRISOAIA (VASLUI)"
	,
	"VIISOARA (VASLUI)"
	,
	"VIISOARA (TODIRESTI) (VASLUI)"
	,
	"VIISOARA (VASLUI) (VASLUI)"
	,
	"VILTOTESTI (VASLUI)"
	,
	"VINDEREI (VASLUI)"
	,
	"VINETESTI (VASLUI)"
	,
	"VISINARI (VASLUI)"
	,
	"VIZURENI (VASLUI)"
	,
	"VLADESTI (VASLUI)"
	,
	"VLADIA (VASLUI)"
	,
	"VOINESTI (VASLUI)"
	,
	"VOINESTI (VULTURESTI) (VASLUI)"
	,
	"VOVRIESTI (VASLUI)"
	,
	"VULPASENI (VASLUI)"
	,
	"VULTURESTI (VASLUI)"
	,
	"VUTCANI (VASLUI)"
	,
	"ZAPODENI (VASLUI)"
	,
	"ZGURA (VASLUI)"
	,
	"ZIZINCA (VASLUI)"
	,
	"ZORLENI (VASLUI)"
	,
	"ADJUD (VRANCEA)"
	,
	"ADJUDU VECHI (VRANCEA)"
	,
	"ALEXANDRU VLAHUTA (VRANCEA)"
	,
	"ANDREIASU DE JOS (VRANCEA)"
	,
	"ANDREIASU DE SUS (VRANCEA)"
	,
	"ANGHELESTI (VRANCEA)"
	,
	"ARGEA (VRANCEA)"
	,
	"ARMENI (VRANCEA)"
	,
	"ARSITA (VRANCEA)"
	,
	"ARVA (VRANCEA)"
	,
	"BAHNELE (VRANCEA)"
	,
	"BALANESTI (VRANCEA)"
	,
	"BALESTI (VRANCEA)"
	,
	"BALTA RATEI (VRANCEA)"
	,
	"BARSESTI (VRANCEA)"
	,
	"BATCARI (VRANCEA)"
	,
	"BATINESTI (VRANCEA)"
	,
	"BECIU (VRANCEA)"
	,
	"BELCIUGELE (VRANCEA)"
	,
	"BICESTII DE JOS (VRANCEA)"
	,
	"BICESTII DE SUS (VRANCEA)"
	,
	"BICHESTI (VRANCEA)"
	,
	"BILIESTI (VRANCEA)"
	,
	"BIZIGHESTI (VRANCEA)"
	,
	"BLIDARI (CARLIGELE) (VRANCEA)"
	,
	"BLIDARI (DUMITRESTI) (VRANCEA)"
	,
	"BODESTI (VRANCEA)"
	,
	"BOGHESTI (VRANCEA)"
	,
	"BOGHESTII DE SUS (VRANCEA)"
	,
	"BOGZA (VRANCEA)"
	,
	"BOLOTESTI (VRANCEA)"
	,
	"BONTESTI (VRANCEA)"
	,
	"BORDEASCA NOUA (VRANCEA)"
	,
	"BORDEASCA VECHE (VRANCEA)"
	,
	"BORDESTI (VRANCEA)"
	,
	"BORDESTII DE JOS (VRANCEA)"
	,
	"BOTARLAU (VRANCEA)"
	,
	"BRADACESTI (VRANCEA)"
	,
	"BRADETU (VRANCEA)"
	,
	"BROSTENI (VRANCEA)"
	,
	"BUDA (VRANCEA)"
	,
	"BUDESTI (VRANCEA)"
	,
	"BURCA (VRANCEA)"
	,
	"BURCIOAIA (VRANCEA)"
	,
	"CAIATA (VRANCEA)"
	,
	"CALIENII NOI (VRANCEA)"
	,
	"CALIENII VECHI (VRANCEA)"
	,
	"CALIMANEASA (VRANCEA)"
	,
	"CALIMANESTI (VRANCEA)"
	,
	"CAMPINEANCA (VRANCEA)"
	,
	"CAMPURI (VRANCEA)"
	,
	"CANDESTI (VRANCEA)"
	,
	"CARLIGELE (VRANCEA)"
	,
	"CARSOCHESTI-CORABITA (VRANCEA)"
	,
	"CATAUTI (VRANCEA)"
	,
	"CEARDAC (VRANCEA)"
	,
	"CERBU (VRANCEA)"
	,
	"CHIOJDENI (VRANCEA)"
	,
	"CHIRICANI (VRANCEA)"
	,
	"CHITCANI (VRANCEA)"
	,
	"CIOLANESTI (VRANCEA)"
	,
	"CIORANI (VRANCEA)"
	,
	"CIORASTI (VRANCEA)"
	,
	"CIUSLEA (VRANCEA)"
	,
	"CLIPICESTI (VRANCEA)"
	,
	"COCOSARI (VRANCEA)"
	,
	"CODRESTI (VRANCEA)"
	,
	"COLACU (VRANCEA)"
	,
	"COPACESTI (VRANCEA)"
	,
	"CORBITA (VRANCEA)"
	,
	"CORNETU (VRANCEA)"
	,
	"COROTENI (VRANCEA)"
	,
	"COSTISA (HOMOCEA) (VRANCEA)"
	,
	"COSTISA (TANASOAIA) (VRANCEA)"
	,
	"COSTISA DE SUS (VRANCEA)"
	,
	"COTESTI (VRANCEA)"
	,
	"COVRAG (VRANCEA)"
	,
	"COZA (VRANCEA)"
	,
	"CRUCEA DE JOS (VRANCEA)"
	,
	"CRUCEA DE SUS (VRANCEA)"
	,
	"DALHAUTI (VRANCEA)"
	,
	"DEALU CUCULUI (VRANCEA)"
	,
	"DEALU LUNG (VRANCEA)"
	,
	"DEALU SARII (VRANCEA)"
	,
	"DIOCHETI-REDIU (VRANCEA)"
	,
	"DOAGA (VRANCEA)"
	,
	"DOMNESTI-SAT (VRANCEA)"
	,
	"DOMNESTI-TARG (VRANCEA)"
	,
	"DRAGOSLOVENI (DUMBRAVENI) (VRANCEA)"
	,
	"DRAGOSLOVENI (SOVEJA) (VRANCEA)"
	,
	"DUMBRAVA (PANCIU) (VRANCEA)"
	,
	"DUMBRAVA (POIANA CRISTEI) (VRANCEA)"
	,
	"DUMBRAVENI (VRANCEA)"
	,
	"DUMITRESTI (VRANCEA)"
	,
	"DUMITRESTII DE SUS (VRANCEA)"
	,
	"DUMITRESTII-FATA (VRANCEA)"
	,
	"DUPA MAGURA (VRANCEA)"
	,
	"FAGETU (VRANCEA)"
	,
	"FARAOANELE (VRANCEA)"
	,
	"FARCAS (VRANCEA)"
	,
	"FAUREI (VRANCEA)"
	,
	"FELDIOARA (VRANCEA)"
	,
	"FETESTI (VRANCEA)"
	,
	"FETIG (VRANCEA)"
	,
	"FITIONESTI (VRANCEA)"
	,
	"FOCSANI (VRANCEA)"
	,
	"FRECATEI (VRANCEA)"
	,
	"GAGESTI (VRANCEA)"
	,
	"GALBENI (VRANCEA)"
	,
	"GALOIESTI (VRANCEA)"
	,
	"GAROAFA (VRANCEA)"
	,
	"GHEBARI (VRANCEA)"
	,
	"GHIMICESTI (VRANCEA)"
	,
	"GOGOIU (VRANCEA)"
	,
	"GOLESTI (VRANCEA)"
	,
	"GOLESTII DE SUS (VRANCEA)"
	,
	"GOLOGANU (VRANCEA)"
	,
	"GRESU (VRANCEA)"
	,
	"GROAPA TUFEI (VRANCEA)"
	,
	"GUGESTI (VRANCEA)"
	,
	"GURA CALITEI (VRANCEA)"
	,
	"GURA VAII (VRANCEA)"
	,
	"HANGULESTI (VRANCEA)"
	,
	"HARET (VRANCEA)"
	,
	"HAULISCA (VRANCEA)"
	,
	"HOLBANESTI (VRANCEA)"
	,
	"HOMOCEA (VRANCEA)"
	,
	"HOTARU (VRANCEA)"
	,
	"IGESTI (VRANCEA)"
	,
	"IRESTI (VRANCEA)"
	,
	"IUGANI (VRANCEA)"
	,
	"IVANCESTI (VRANCEA)"
	,
	"IZVOARELE (VRANCEA)"
	,
	"JARISTEA (VRANCEA)"
	,
	"JGHEABURI (VRANCEA)"
	,
	"JILISTE (VRANCEA)"
	,
	"JITIA (VRANCEA)"
	,
	"JITIA DE JOS (VRANCEA)"
	,
	"JORASTI (VRANCEA)"
	,
	"LACU LUI BABAN (VRANCEA)"
	,
	"LAMOTESTI (VRANCEA)"
	,
	"LARGASENI (VRANCEA)"
	,
	"LASTUNI (VRANCEA)"
	,
	"LEPSA (VRANCEA)"
	,
	"LESPEZI (VRANCEA)"
	,
	"LIESTI (VRANCEA)"
	,
	"LIVADA (VRANCEA)"
	,
	"LIVEZILE (VRANCEA)"
	,
	"LOJNITA (VRANCEA)"
	,
	"LUNCILE (VRANCEA)"
	,
	"LUPOAIA (VRANCEA)"
	,
	"MAGURA (VRANCEA)"
	,
	"MAHRIU (VRANCEA)"
	,
	"MAICANESTI (VRANCEA)"
	,
	"MALURI (VRANCEA)"
	,
	"MANASTIOARA (VRANCEA)"
	,
	"MANDRESTI-MOLDOVA (VRANCEA)"
	,
	"MANDRESTI-MUNTENI (VRANCEA)"
	,
	"MARACINI (VRANCEA)"
	,
	"MARASESTI (VRANCEA)"
	,
	"MARASTI (VRANCEA)"
	,
	"MARTINESTI (VRANCEA)"
	,
	"MATACINA (VRANCEA)"
	,
	"MERA (VRANCEA)"
	,
	"MESTEACANU (VRANCEA)"
	,
	"MIHALCENI (VRANCEA)"
	,
	"MILCOVEL (VRANCEA)"
	,
	"MILCOVUL (VRANCEA)"
	,
	"MIRCESTII NOI (VRANCEA)"
	,
	"MIRCESTII VECHI (VRANCEA)"
	,
	"MODRUZENI (VRANCEA)"
	,
	"MORARESTI (VRANCEA)"
	,
	"MOTNAU (VRANCEA)"
	,
	"MOVILITA (VRANCEA)"
	,
	"MUNCEI (VRANCEA)"
	,
	"MUNCELU (VRANCEA)"
	,
	"NANESTI (VRANCEA)"
	,
	"NANESTI (TANASOAIA) (VRANCEA)"
	,
	"NARUJA (VRANCEA)"
	,
	"NECULELE (VRANCEA)"
	,
	"NEGRILESTI (VRANCEA)"
	,
	"NEICU (VRANCEA)"
	,
	"NEREJU (VRANCEA)"
	,
	"NEREJU MIC (VRANCEA)"
	,
	"NISTORESTI (VRANCEA)"
	,
	"OBREJITA (VRANCEA)"
	,
	"OCHESESTI (VRANCEA)"
	,
	"ODOBASCA (VRANCEA)"
	,
	"ODOBESTI (VRANCEA)"
	,
	"OLARENI (VRANCEA)"
	,
	"OLESESTI (VRANCEA)"
	,
	"OLTENI (VRANCEA)"
	,
	"OREAVU (VRANCEA)"
	,
	"PADURENI (JARISTEA) (VRANCEA)"
	,
	"PADURENI (MARASESTI) (VRANCEA)"
	,
	"PADURENI (TAMBOESTI) (VRANCEA)"
	,
	"PALTIN (VRANCEA)"
	,
	"PANCIU (VRANCEA)"
	,
	"PATRASCANI (VRANCEA)"
	,
	"PAULESTI (VRANCEA)"
	,
	"PAUNESTI (VRANCEA)"
	,
	"PAVALARI (VRANCEA)"
	,
	"PETREANU (VRANCEA)"
	,
	"PETRESTI (VRANCEA)"
	,
	"PIETROASA (BOLOTESTI) (VRANCEA)"
	,
	"PIETROASA (CAMPINEANCA) (VRANCEA)"
	,
	"PIETROASA (TAMBOESTI) (VRANCEA)"
	,
	"PIETROASA (VARTESCOIU) (VRANCEA)"
	,
	"PISCU RADULUI (VRANCEA)"
	,
	"PISCU REGHIULUI (VRANCEA)"
	,
	"PITULUSA (VRANCEA)"
	,
	"PLACINTENI (VRANCEA)"
	,
	"PLESESTI (VRANCEA)"
	,
	"PLOPU (VRANCEA)"
	,
	"PLOSCUTENI (VRANCEA)"
	,
	"PLOSTINA (VRANCEA)"
	,
	"PODU LACULUI (VRANCEA)"
	,
	"PODU NARUJEI (VRANCEA)"
	,
	"PODU SCHIOPULUI (VRANCEA)"
	,
	"PODU STOICA (VRANCEA)"
	,
	"PODURI (VRANCEA)"
	,
	"PODURILE (VRANCEA)"
	,
	"POENILE (VRANCEA)"
	,
	"POIANA (VRANCEA)"
	,
	"POIANA CRISTEI (VRANCEA)"
	,
	"POIANA STOICHII (VRANCEA)"
	,
	"POIENITA (VRANCEA)"
	,
	"POPESTI (VRANCEA)"
	,
	"PRAHUDA (VRANCEA)"
	,
	"PRECISTANU (VRANCEA)"
	,
	"PRISACA (VRANCEA)"
	,
	"PRISECANI (VRANCEA)"
	,
	"PUFESTI (VRANCEA)"
	,
	"PUTNA (VRANCEA)"
	,
	"RACHITASU (VRANCEA)"
	,
	"RACHITOSU (VRANCEA)"
	,
	"RACOASA (VRANCEA)"
	,
	"RADACINESTI (VRANCEA)"
	,
	"RADULESTI (VRANCEA)"
	,
	"RAIUTI (VRANCEA)"
	,
	"RAMNICEANCA (VRANCEA)"
	,
	"RAMNICENI (VRANCEA)"
	,
	"RASCA (VRANCEA)"
	,
	"RASTOACA (VRANCEA)"
	,
	"REBEGARI (VRANCEA)"
	,
	"REGHIU (VRANCEA)"
	,
	"REPEDEA (VRANCEA)"
	,
	"ROMANESTI (VRANCEA)"
	,
	"ROSCARI (VRANCEA)"
	,
	"ROSIOARA (VRANCEA)"
	,
	"ROTILESTII MARI (VRANCEA)"
	,
	"ROTILESTII MICI (VRANCEA)"
	,
	"RUCARENI (VRANCEA)"
	,
	"RUGET (VRANCEA)"
	,
	"RUGINESTI (VRANCEA)"
	,
	"SAHASTRU (VRANCEA)"
	,
	"SALCIA NOUA (VRANCEA)"
	,
	"SALCIA VECHE (VRANCEA)"
	,
	"SARBI (VRANCEA)"
	,
	"SATU NOU (CIORASTI) (VRANCEA)"
	,
	"SATU NOU (PANCIU) (VRANCEA)"
	,
	"SCAFARI (VRANCEA)"
	,
	"SCANTEIA (VRANCEA)"
	,
	"SECIU (VRANCEA)"
	,
	"SERBANESTI (VRANCEA)"
	,
	"SERBESTI (VRANCEA)"
	,
	"SIHLEA (VRANCEA)"
	,
	"SIMINOC (VRANCEA)"
	,
	"SINDRILARI (VRANCEA)"
	,
	"SIRETU (VRANCEA)"
	,
	"SISCANI (VRANCEA)"
	,
	"SLIMNIC (VRANCEA)"
	,
	"SLOBOZIA BOTESTI (VRANCEA)"
	,
	"SLOBOZIA BRADULUI (VRANCEA)"
	,
	"SLOBOZIA CIORASTI (VRANCEA)"
	,
	"SOTARCARI (VRANCEA)"
	,
	"SOVEJA (VRANCEA)"
	,
	"SPATAREASA (VRANCEA)"
	,
	"SPINESTI (VRANCEA)"
	,
	"SPULBER (VRANCEA)"
	,
	"STRAJESCU (VRANCEA)"
	,
	"STRAOANE (VRANCEA)"
	,
	"STUPINA (VRANCEA)"
	,
	"SURAIA (VRANCEA)"
	,
	"TABUCESTI (VRANCEA)"
	,
	"TAMBOESTI (VRANCEA)"
	,
	"TANASARI (VRANCEA)"
	,
	"TANASOAIA (VRANCEA)"
	,
	"TARATU (VRANCEA)"
	,
	"TATARANU (VRANCEA)"
	,
	"TATARU (VRANCEA)"
	,
	"TEPA (VRANCEA)"
	,
	"TERCHESTI (VRANCEA)"
	,
	"TICHIRIS (VRANCEA)"
	,
	"TIFESTI (VRANCEA)"
	,
	"TINOASA (VRANCEA)"
	,
	"TIPAU (VRANCEA)"
	,
	"TISITA (VRANCEA)"
	,
	"TITILA (VRANCEA)"
	,
	"TOJANII DE JOS (VRANCEA)"
	,
	"TOJANII DE SUS (VRANCEA)"
	,
	"TOPESTI (VRANCEA)"
	,
	"TRESTIA (VRANCEA)"
	,
	"TRESTIENI (VRANCEA)"
	,
	"TROTUSANU (VRANCEA)"
	,
	"TULBUREA (VRANCEA)"
	,
	"TULNICI (VRANCEA)"
	,
	"TUTU (VRANCEA)"
	,
	"UNGURENI (VRANCEA)"
	,
	"UNIREA (VRANCEA)"
	,
	"URECHESTI (VRANCEA)"
	,
	"URSOAIA (VRANCEA)"
	,
	"VADU ROSCA (VRANCEA)"
	,
	"VAJAITOAREA (VRANCEA)"
	,
	"VALCANI (VRANCEA)"
	,
	"VALCELE (VRANCEA)"
	,
	"VALCELELE (VRANCEA)"
	,
	"VALEA BECIULUI (VRANCEA)"
	,
	"VALEA COTESTI (VRANCEA)"
	,
	"VALEA MICA (VRANCEA)"
	,
	"VALEA MILCOVULUI (VRANCEA)"
	,
	"VALEA NEAGRA (VRANCEA)"
	,
	"VALEA SARII (VRANCEA)"
	,
	"VALENI (MOVILITA) (VRANCEA)"
	,
	"VALENI (RUGINESTI) (VRANCEA)"
	,
	"VALENI (STRAOANE) (VRANCEA)"
	,
	"VANATORI (VRANCEA)"
	,
	"VARNITA (VRANCEA)"
	,
	"VARSATURA (VRANCEA)"
	,
	"VARTESCOIU (VRANCEA)"
	,
	"VERDEA (VRANCEA)"
	,
	"VETRESTI-HERASTRAU (VRANCEA)"
	,
	"VIDRA (VRANCEA)"
	,
	"VIISOARA (PAUNESTI) (VRANCEA)"
	,
	"VIISOARA (VIDRA) (VRANCEA)"
	,
	"VINTILEASCA (VRANCEA)"
	,
	"VITANESTI (VRANCEA)"
	,
	"VITANESTII DE SUB MAGURA (VRANCEA)"
	,
	"VIZANTEA MANASTIREASCA (VRANCEA)"
	,
	"VIZANTEA RAZASEASCA (VRANCEA)"
	,
	"VIZANTEA-LIVEZI (VRANCEA)"
	,
	"VLADNICU DE JOS (VRANCEA)"
	,
	"VLADNICU DE SUS (VRANCEA)"
	,
	"VOETIN (VRANCEA)"
	,
	"VOLOSCANI (VRANCEA)"
	,
	"VRANCIOAIA (VRANCEA)"
	,
	"VULCANEASA (VRANCEA)"
	,
	"VULTURU (VRANCEA)"
	,
	"RESITA (CARAS SEVERIN)"
	,
	"NECUNOSCUT (ALBA)"
	,
	"CIBA (MURES)"
	,
	"NECUNOSCUT (ARAD)"
	,
	"SANVASII (MURES)"
	,
	"RADULESTI (IALOMITA)"
	,
	"NECUNOSCUT (ARGES)"
	,
	"NICOLESTI (MURES)"
	,
	"NECUNOSCUT (BACAU)"
	,
	"FANTANELE (IASI)"
	,
	"NECUNOSCUT (BIHOR)"
	,
	"ZAGREB (ZAGREB)"
	,
	"NECUNOSCUT (BISTRITA NASAUD)"
	,
	"NECUNOSCUT (BOTOSANI)"
	,
	"NECUNOSCUT (BRASOV)"
	,
	"NECUNOSCUT (BRAILA)"
	,
	"NECUNOSCUT (BUZAU)"
	,
	"NECUNOSCUT (CARAS SEVERIN)"
	,
	"NECUNOSCUT (CLUJ)"
	,
	"NECUNOSCUT (CONSTANTA)"
	,
	"NECUNOSCUT (COVASNA)"
	,
	"NECUNOSCUT (DOLJ)"
	,
	"NECUNOSCUT (GALATI)"
	,
	"NECUNOSCUT (GORJ)"
	,
	"NECUNOSCUT (HARGHITA)"
	,
	"NECUNOSCUT (HUNEDOARA)"
	,
	"NECUNOSCUT (CALARASI)"
	,
	"NECUNOSCUT (IALOMITA)"
	,
	"NECUNOSCUT (IASI)"
	,
	"NECUNOSCUT (GIURGIU)"
	,
	"NECUNOSCUT (ILFOV)"
	,
	"NECUNOSCUT (MARAMURES)"
	,
	"NECUNOSCUT (MEHEDINTI)"
	,
	"NECUNOSCUT (MURES)"
	,
	"NECUNOSCUT (NEAMT)"
	,
	"NECUNOSCUT (OLT)"
	,
	"NECUNOSCUT (PRAHOVA)"
	,
	"NECUNOSCUT (SATU MARE)"
	,
	"NECUNOSCUT (SALAJ)"
	,
	"NECUNOSCUT (SIBIU)"
	,
	"NECUNOSCUT (SUCEAVA)"
	,
	"NECUNOSCUT (TELEORMAN)"
	,
	"NECUNOSCUT (TIMIS)"
	,
	"NECUNOSCUT (TULCEA)"
	,
	"NECUNOSCUT (VASLUI)"
	,
	"NECUNOSCUT (VALCEA)"
	,
	"NECUNOSCUT (VRANCEA)"
	,
	"NECUNOSCUT (BUCURESTI + ILFOV)"
	,
	"INCONNU (ROMANIA)"
	,
	"MITOCU DRAGOMIRNEI (SUCEAVA)"
	,
	"BISTRITA (BISTRITA NASAUD)"
	,
	"PIPERA (ILFOV)"
	,
	"CARACAL (DOLJ)"
	,
	"GEAMANU (ARGES)"
	,
	"PANDURI (IALOMITA)"
	,
	"LABUSESTI (ARGES)"
	,
	"GOESTI (DOLJ)"
	,
	"FRUMUSANI (ARAD)"
	,
	"ROTARESTI (ARGES)"
	,
	"FILIPESTI-CIRLIGI (BACAU)"
	,
	"VOIVOZI (BIHOR)"
	,
	"OVERSEU (VALCEA)"
	,
	"RUSCA-TEREGOVA (CARAS SEVERIN)"
	,
	"LIVADA (CLUJ)"
	,
	"VAMA BUZAULUI (COVASNA)"
	,
	"SIBISEL (HUNEDOARA)"
	,
	"CRIVESTI (IASI)"
	,
	"DRAGOMIRESTI (ILFOV)"
	,
	"MANECIU-GHIABA (PRAHOVA)"
	,
	"MARGINEA (SUCEAVA)"
	,
	"ZAVORISTEA (SUCEAVA)"
	,
	"MOLDOVA-SULITA (SUCEAVA)"
	,
	"SINTEL (ALBA)"
	,
	"STUPINI (BRASOV)"
	,
	"VERGULEASA (BUZAU)"
	,
	"VERGULEASA (PRAHOVA)"
	,
	"GARDA (ALBA)"
	,
	"BIBAN (MEHEDINTI)"
	,
	"BARLOGENI (MEHEDINTI)"
	,
	"HEMIENI (BACAU)"
	,
	"MANASTIOARA (SIRET) (SUCEAVA)"
	,
	"MOISA (SUCEAVA)"
	,
	"NEAGRA (SUCEAVA)"
	,
	"MARITEIA MICA (SUCEAVA)"
	,
	"MARITEI (SUCEAVA)"
	,
	"MAZANAESTI (SUCEAVA)"
	,
	"MANOLEA (SUCEAVA)"
	,
	"MANEUTI (SUCEAVA)"
	,
	"MIHAIESTI (SUCEAVA)"
	,
	"MESTECANIS (SUCEAVA)"
	,
	"MANASTIREA HUMORULUI (SUCEAVA)"
	,
	"MILISAUTI (SUCEAVA)"
	,
	"MITOCASI (SUCEAVA)"
	,
	"MOARA (SUCEAVA)"
	,
	"MOARA CARP (SUCEAVA)"
	,
	"MOARA NICA (SUCEAVA)"
	,
	"MOLDOVITA (SUCEAVA)"
	,
	"MUSENITA (SUCEAVA)"
	,
	"MERENI (SUCEAVA)"
	,
	"NEAGRA SARULUI (SUCEAVA)"
	,
	"MIHOVENI (SUCEAVA)"
	,
	"MANASTIOARA (UDESTI) (SUCEAVA)"
	,
	"MESTECENI (SUCEAVA)"
	,
	"MOVILENI (SUCEAVA)"
	,
	"MIRONU (SUCEAVA)"
	,
	"MOLID (SUCEAVA)"
	,
	"MERESTI (SUCEAVA)"
	,
	"FRUMUSANI (CALARASI)"
	,
	"BARAGANU (IALOMITA)"
	,
	"MURFATLAR (CONSTANTA)"
	,
	"CIOCARLIA DE JOS (CONSTANTA)"
	,
	"LIPIA MEREI (BUZAU)"
	,
	"LEMNIA DE JOS (COVASNA)"
	,
	"VALEA MARE STEFANESTI (ARGES)"
	,
	"COTOFENII DE JOS (DOLJ)"
	,
	"SARATA (BACAU)"
	,
	"CULMEA (CONSTANTA)"
	,
	"IMPORT RT (ALBA)"
	
]
